// (function() {

//   })();


(function() {

      var Lc = { exports: {} },
        Bn = {};
      var nh;
      function vp() {
        if (nh) return Bn;
        nh = 1;
        var r = Symbol.for('react.transitional.element'),
          u = Symbol.for('react.fragment');
        function f(s, o, h) {
          var m = null;
          if (
            (h !== void 0 && (m = '' + h),
            o.key !== void 0 && (m = '' + o.key),
            'key' in o)
          ) {
            h = {};
            for (var v in o) v !== 'key' && (h[v] = o[v]);
          } else h = o;
          return (
            (o = h.ref),
            {
              $$typeof: r,
              type: s,
              key: m,
              ref: o !== void 0 ? o : null,
              props: h,
            }
          );
        }
        return ((Bn.Fragment = u), (Bn.jsx = f), (Bn.jsxs = f), Bn);
      }
      var ih;
      function bp() {
        return (ih || ((ih = 1), (Lc.exports = vp())), Lc.exports);
      }
      var j = bp(),
        Uc = { exports: {} },
        Kn = {},
        Hc = { exports: {} },
        Bc = {};
      var uh;
      function Sp() {
        return (
          uh ||
            ((uh = 1),
            (function (r) {
              function u(z, U) {
                var Q = z.length;
                z.push(U);
                e: for (; 0 < Q;) {
                  var me = (Q - 1) >>> 1,
                    be = z[me];
                  if (0 < o(be, U)) ((z[me] = U), (z[Q] = be), (Q = me));
                  else break e;
                }
              }
              function f(z) {
                return z.length === 0 ? null : z[0];
              }
              function s(z) {
                if (z.length === 0) return null;
                var U = z[0],
                  Q = z.pop();
                if (Q !== U) {
                  z[0] = Q;
                  e: for (var me = 0, be = z.length, b = be >>> 1; me < b;) {
                    var C = 2 * (me + 1) - 1,
                      H = z[C],
                      G = C + 1,
                      W = z[G];
                    if (0 > o(H, Q))
                      G < be && 0 > o(W, H)
                        ? ((z[me] = W), (z[G] = Q), (me = G))
                        : ((z[me] = H), (z[C] = Q), (me = C));
                    else if (G < be && 0 > o(W, Q))
                      ((z[me] = W), (z[G] = Q), (me = G));
                    else break e;
                  }
                }
                return U;
              }
              function o(z, U) {
                var Q = z.sortIndex - U.sortIndex;
                return Q !== 0 ? Q : z.id - U.id;
              }
              if (
                ((r.unstable_now = void 0),
                typeof performance == 'object' &&
                  typeof performance.now == 'function')
              ) {
                var h = performance;
                r.unstable_now = function () {
                  return h.now();
                };
              } else {
                var m = Date,
                  v = m.now();
                r.unstable_now = function () {
                  return m.now() - v;
                };
              }
              var y = [],
                g = [],
                _ = 1,
                E = null,
                L = 3,
                q = !1,
                K = !1,
                B = !1,
                te = !1,
                P = typeof setTimeout == 'function' ? setTimeout : null,
                ae = typeof clearTimeout == 'function' ? clearTimeout : null,
                ge = typeof setImmediate < 'u' ? setImmediate : null;
              function ce(z) {
                for (var U = f(g); U !== null;) {
                  if (U.callback === null) s(g);
                  else if (U.startTime <= z)
                    (s(g), (U.sortIndex = U.expirationTime), u(y, U));
                  else break;
                  U = f(g);
                }
              }
              function Ne(z) {
                if (((B = !1), ce(z), !K))
                  if (f(y) !== null) ((K = !0), Ae || ((Ae = !0), oe()));
                  else {
                    var U = f(g);
                    U !== null && Xe(Ne, U.startTime - z);
                  }
              }
              var Ae = !1,
                X = -1,
                Ce = 5,
                $ = -1;
              function F() {
                return te ? !0 : !(r.unstable_now() - $ < Ce);
              }
              function fe() {
                if (((te = !1), Ae)) {
                  var z = r.unstable_now();
                  $ = z;
                  var U = !0;
                  try {
                    e: {
                      ((K = !1), B && ((B = !1), ae(X), (X = -1)), (q = !0));
                      var Q = L;
                      try {
                        t: {
                          for (
                            ce(z), E = f(y);
                            E !== null && !(E.expirationTime > z && F());
                          ) {
                            var me = E.callback;
                            if (typeof me == 'function') {
                              ((E.callback = null), (L = E.priorityLevel));
                              var be = me(E.expirationTime <= z);
                              if (
                                ((z = r.unstable_now()),
                                typeof be == 'function')
                              ) {
                                ((E.callback = be), ce(z), (U = !0));
                                break t;
                              }
                              (E === f(y) && s(y), ce(z));
                            } else s(y);
                            E = f(y);
                          }
                          if (E !== null) U = !0;
                          else {
                            var b = f(g);
                            (b !== null && Xe(Ne, b.startTime - z), (U = !1));
                          }
                        }
                        break e;
                      } finally {
                        ((E = null), (L = Q), (q = !1));
                      }
                      U = void 0;
                    }
                  } finally {
                    U ? oe() : (Ae = !1);
                  }
                }
              }
              var oe;
              if (typeof ge == 'function')
                oe = function () {
                  ge(fe);
                };
              else if (typeof MessageChannel < 'u') {
                var re = new MessageChannel(),
                  ze = re.port2;
                ((re.port1.onmessage = fe),
                  (oe = function () {
                    ze.postMessage(null);
                  }));
              } else
                oe = function () {
                  P(fe, 0);
                };
              function Xe(z, U) {
                X = P(function () {
                  z(r.unstable_now());
                }, U);
              }
              ((r.unstable_IdlePriority = 5),
                (r.unstable_ImmediatePriority = 1),
                (r.unstable_LowPriority = 4),
                (r.unstable_NormalPriority = 3),
                (r.unstable_Profiling = null),
                (r.unstable_UserBlockingPriority = 2),
                (r.unstable_cancelCallback = function (z) {
                  z.callback = null;
                }),
                (r.unstable_forceFrameRate = function (z) {
                  0 > z || 125 < z
                    ? console.error(
                        'forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported'
                      )
                    : (Ce = 0 < z ? Math.floor(1e3 / z) : 5);
                }),
                (r.unstable_getCurrentPriorityLevel = function () {
                  return L;
                }),
                (r.unstable_next = function (z) {
                  switch (L) {
                    case 1:
                    case 2:
                    case 3:
                      var U = 3;
                      break;
                    default:
                      U = L;
                  }
                  var Q = L;
                  L = U;
                  try {
                    return z();
                  } finally {
                    L = Q;
                  }
                }),
                (r.unstable_requestPaint = function () {
                  te = !0;
                }),
                (r.unstable_runWithPriority = function (z, U) {
                  switch (z) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                      break;
                    default:
                      z = 3;
                  }
                  var Q = L;
                  L = z;
                  try {
                    return U();
                  } finally {
                    L = Q;
                  }
                }),
                (r.unstable_scheduleCallback = function (z, U, Q) {
                  var me = r.unstable_now();
                  switch (
                    (typeof Q == 'object' && Q !== null
                      ? ((Q = Q.delay),
                        (Q = typeof Q == 'number' && 0 < Q ? me + Q : me))
                      : (Q = me),
                    z)
                  ) {
                    case 1:
                      var be = -1;
                      break;
                    case 2:
                      be = 250;
                      break;
                    case 5:
                      be = 1073741823;
                      break;
                    case 4:
                      be = 1e4;
                      break;
                    default:
                      be = 5e3;
                  }
                  return (
                    (be = Q + be),
                    (z = {
                      id: _++,
                      callback: U,
                      priorityLevel: z,
                      startTime: Q,
                      expirationTime: be,
                      sortIndex: -1,
                    }),
                    Q > me
                      ? ((z.sortIndex = Q),
                        u(g, z),
                        f(y) === null &&
                          z === f(g) &&
                          (B ? (ae(X), (X = -1)) : (B = !0), Xe(Ne, Q - me)))
                      : ((z.sortIndex = be),
                        u(y, z),
                        K || q || ((K = !0), Ae || ((Ae = !0), oe()))),
                    z
                  );
                }),
                (r.unstable_shouldYield = F),
                (r.unstable_wrapCallback = function (z) {
                  var U = L;
                  return function () {
                    var Q = L;
                    L = U;
                    try {
                      return z.apply(this, arguments);
                    } finally {
                      L = Q;
                    }
                  };
                }));
            })(Bc)),
          Bc
        );
      }
      var sh;
      function Ap() {
        return (sh || ((sh = 1), (Hc.exports = Sp())), Hc.exports);
      }
      var Kc = { exports: {} },
        k = {};
      var ch;
      function Ep() {
        if (ch) return k;
        ch = 1;
        var r = Symbol.for('react.transitional.element'),
          u = Symbol.for('react.portal'),
          f = Symbol.for('react.fragment'),
          s = Symbol.for('react.strict_mode'),
          o = Symbol.for('react.profiler'),
          h = Symbol.for('react.consumer'),
          m = Symbol.for('react.context'),
          v = Symbol.for('react.forward_ref'),
          y = Symbol.for('react.suspense'),
          g = Symbol.for('react.memo'),
          _ = Symbol.for('react.lazy'),
          E = Symbol.for('react.activity'),
          L = Symbol.iterator;
        function q(b) {
          return b === null || typeof b != 'object'
            ? null
            : ((b = (L && b[L]) || b['@@iterator']),
              typeof b == 'function' ? b : null);
        }
        var K = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          B = Object.assign,
          te = {};
        function P(b, C, H) {
          ((this.props = b),
            (this.context = C),
            (this.refs = te),
            (this.updater = H || K));
        }
        ((P.prototype.isReactComponent = {}),
          (P.prototype.setState = function (b, C) {
            if (typeof b != 'object' && typeof b != 'function' && b != null)
              throw Error(
                'takes an object of state variables to update or a function which returns an object of state variables.'
              );
            this.updater.enqueueSetState(this, b, C, 'setState');
          }),
          (P.prototype.forceUpdate = function (b) {
            this.updater.enqueueForceUpdate(this, b, 'forceUpdate');
          }));
        function ae() {}
        ae.prototype = P.prototype;
        function ge(b, C, H) {
          ((this.props = b),
            (this.context = C),
            (this.refs = te),
            (this.updater = H || K));
        }
        var ce = (ge.prototype = new ae());
        ((ce.constructor = ge),
          B(ce, P.prototype),
          (ce.isPureReactComponent = !0));
        var Ne = Array.isArray;
        function Ae() {}
        var X = { H: null, A: null, T: null, S: null },
          Ce = Object.prototype.hasOwnProperty;
        function $(b, C, H) {
          var G = H.ref;
          return {
            $$typeof: r,
            type: b,
            key: C,
            ref: G !== void 0 ? G : null,
            props: H,
          };
        }
        function F(b, C) {
          return $(b.type, C, b.props);
        }
        function fe(b) {
          return typeof b == 'object' && b !== null && b.$$typeof === r;
        }
        function oe(b) {
          var C = { '=': '=0', ':': '=2' };
          return (
            '$' +
            b.replace(/[=:]/g, function (H) {
              return C[H];
            })
          );
        }
        var re = /\/+/g;
        function ze(b, C) {
          return typeof b == 'object' && b !== null && b.key != null
            ? oe('' + b.key)
            : C.toString(36);
        }
        function Xe(b) {
          switch (b.status) {
            case 'fulfilled':
              return b.value;
            case 'rejected':
              throw b.reason;
            default:
              switch (
                (typeof b.status == 'string'
                  ? b.then(Ae, Ae)
                  : ((b.status = 'pending'),
                    b.then(
                      function (C) {
                        b.status === 'pending' &&
                          ((b.status = 'fulfilled'), (b.value = C));
                      },
                      function (C) {
                        b.status === 'pending' &&
                          ((b.status = 'rejected'), (b.reason = C));
                      }
                    )),
                b.status)
              ) {
                case 'fulfilled':
                  return b.value;
                case 'rejected':
                  throw b.reason;
              }
          }
          throw b;
        }
        function z(b, C, H, G, W) {
          var le = typeof b;
          (le === 'undefined' || le === 'boolean') && (b = null);
          var Se = !1;
          if (b === null) Se = !0;
          else
            switch (le) {
              case 'bigint':
              case 'string':
              case 'number':
                Se = !0;
                break;
              case 'object':
                switch (b.$$typeof) {
                  case r:
                  case u:
                    Se = !0;
                    break;
                  case _:
                    return ((Se = b._init), z(Se(b._payload), C, H, G, W));
                }
            }
          if (Se)
            return (
              (W = W(b)),
              (Se = G === '' ? '.' + ze(b, 0) : G),
              Ne(W)
                ? ((H = ''),
                  Se != null && (H = Se.replace(re, '$&/') + '/'),
                  z(W, C, H, '', function (wl) {
                    return wl;
                  }))
                : W != null &&
                  (fe(W) &&
                    (W = F(
                      W,
                      H +
                        (W.key == null || (b && b.key === W.key)
                          ? ''
                          : ('' + W.key).replace(re, '$&/') + '/') +
                        Se
                    )),
                  C.push(W)),
              1
            );
          Se = 0;
          var tt = G === '' ? '.' : G + ':';
          if (Ne(b))
            for (var He = 0; He < b.length; He++)
              ((G = b[He]), (le = tt + ze(G, He)), (Se += z(G, C, H, le, W)));
          else if (((He = q(b)), typeof He == 'function'))
            for (b = He.call(b), He = 0; !(G = b.next()).done;)
              ((G = G.value),
                (le = tt + ze(G, He++)),
                (Se += z(G, C, H, le, W)));
          else if (le === 'object') {
            if (typeof b.then == 'function') return z(Xe(b), C, H, G, W);
            throw (
              (C = String(b)),
              Error(
                'Objects are not valid as a React child (found: ' +
                  (C === '[object Object]'
                    ? 'object with keys {' + Object.keys(b).join(', ') + '}'
                    : C) +
                  '). If you meant to render a collection of children, use an array instead.'
              )
            );
          }
          return Se;
        }
        function U(b, C, H) {
          if (b == null) return b;
          var G = [],
            W = 0;
          return (
            z(b, G, '', '', function (le) {
              return C.call(H, le, W++);
            }),
            G
          );
        }
        function Q(b) {
          if (b._status === -1) {
            var C = b._result;
            ((C = C()),
              C.then(
                function (H) {
                  (b._status === 0 || b._status === -1) &&
                    ((b._status = 1), (b._result = H));
                },
                function (H) {
                  (b._status === 0 || b._status === -1) &&
                    ((b._status = 2), (b._result = H));
                }
              ),
              b._status === -1 && ((b._status = 0), (b._result = C)));
          }
          if (b._status === 1) return b._result.default;
          throw b._result;
        }
        var me =
            typeof reportError == 'function'
              ? reportError
              : function (b) {
                  if (
                    typeof window == 'object' &&
                    typeof window.ErrorEvent == 'function'
                  ) {
                    var C = new window.ErrorEvent('error', {
                      bubbles: !0,
                      cancelable: !0,
                      message:
                        typeof b == 'object' &&
                        b !== null &&
                        typeof b.message == 'string'
                          ? String(b.message)
                          : String(b),
                      error: b,
                    });
                    if (!window.dispatchEvent(C)) return;
                  } else if (
                    typeof process == 'object' &&
                    typeof process.emit == 'function'
                  ) {
                    process.emit('uncaughtException', b);
                    return;
                  }
                  console.error(b);
                },
          be = {
            map: U,
            forEach: function (b, C, H) {
              U(
                b,
                function () {
                  C.apply(this, arguments);
                },
                H
              );
            },
            count: function (b) {
              var C = 0;
              return (
                U(b, function () {
                  C++;
                }),
                C
              );
            },
            toArray: function (b) {
              return (
                U(b, function (C) {
                  return C;
                }) || []
              );
            },
            only: function (b) {
              if (!fe(b))
                throw Error(
                  'React.Children.only expected to receive a single React element child.'
                );
              return b;
            },
          };
        return (
          (k.Activity = E),
          (k.Children = be),
          (k.Component = P),
          (k.Fragment = f),
          (k.Profiler = o),
          (k.PureComponent = ge),
          (k.StrictMode = s),
          (k.Suspense = y),
          (k.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE =
            X),
          (k.__COMPILER_RUNTIME = {
            __proto__: null,
            c: function (b) {
              return X.H.useMemoCache(b);
            },
          }),
          (k.cache = function (b) {
            return function () {
              return b.apply(null, arguments);
            };
          }),
          (k.cacheSignal = function () {
            return null;
          }),
          (k.cloneElement = function (b, C, H) {
            if (b == null)
              throw Error(
                'The argument must be a React element, but you passed ' +
                  b +
                  '.'
              );
            var G = B({}, b.props),
              W = b.key;
            if (C != null)
              for (le in (C.key !== void 0 && (W = '' + C.key), C))
                !Ce.call(C, le) ||
                  le === 'key' ||
                  le === '__self' ||
                  le === '__source' ||
                  (le === 'ref' && C.ref === void 0) ||
                  (G[le] = C[le]);
            var le = arguments.length - 2;
            if (le === 1) G.children = H;
            else if (1 < le) {
              for (var Se = Array(le), tt = 0; tt < le; tt++)
                Se[tt] = arguments[tt + 2];
              G.children = Se;
            }
            return $(b.type, W, G);
          }),
          (k.createContext = function (b) {
            return (
              (b = {
                $$typeof: m,
                _currentValue: b,
                _currentValue2: b,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
              }),
              (b.Provider = b),
              (b.Consumer = { $$typeof: h, _context: b }),
              b
            );
          }),
          (k.createElement = function (b, C, H) {
            var G,
              W = {},
              le = null;
            if (C != null)
              for (G in (C.key !== void 0 && (le = '' + C.key), C))
                Ce.call(C, G) &&
                  G !== 'key' &&
                  G !== '__self' &&
                  G !== '__source' &&
                  (W[G] = C[G]);
            var Se = arguments.length - 2;
            if (Se === 1) W.children = H;
            else if (1 < Se) {
              for (var tt = Array(Se), He = 0; He < Se; He++)
                tt[He] = arguments[He + 2];
              W.children = tt;
            }
            if (b && b.defaultProps)
              for (G in ((Se = b.defaultProps), Se))
                W[G] === void 0 && (W[G] = Se[G]);
            return $(b, le, W);
          }),
          (k.createRef = function () {
            return { current: null };
          }),
          (k.forwardRef = function (b) {
            return { $$typeof: v, render: b };
          }),
          (k.isValidElement = fe),
          (k.lazy = function (b) {
            return {
              $$typeof: _,
              _payload: { _status: -1, _result: b },
              _init: Q,
            };
          }),
          (k.memo = function (b, C) {
            return { $$typeof: g, type: b, compare: C === void 0 ? null : C };
          }),
          (k.startTransition = function (b) {
            var C = X.T,
              H = {};
            X.T = H;
            try {
              var G = b(),
                W = X.S;
              (W !== null && W(H, G),
                typeof G == 'object' &&
                  G !== null &&
                  typeof G.then == 'function' &&
                  G.then(Ae, me));
            } catch (le) {
              me(le);
            } finally {
              (C !== null && H.types !== null && (C.types = H.types),
                (X.T = C));
            }
          }),
          (k.unstable_useCacheRefresh = function () {
            return X.H.useCacheRefresh();
          }),
          (k.use = function (b) {
            return X.H.use(b);
          }),
          (k.useActionState = function (b, C, H) {
            return X.H.useActionState(b, C, H);
          }),
          (k.useCallback = function (b, C) {
            return X.H.useCallback(b, C);
          }),
          (k.useContext = function (b) {
            return X.H.useContext(b);
          }),
          (k.useDebugValue = function () {}),
          (k.useDeferredValue = function (b, C) {
            return X.H.useDeferredValue(b, C);
          }),
          (k.useEffect = function (b, C) {
            return X.H.useEffect(b, C);
          }),
          (k.useEffectEvent = function (b) {
            return X.H.useEffectEvent(b);
          }),
          (k.useId = function () {
            return X.H.useId();
          }),
          (k.useImperativeHandle = function (b, C, H) {
            return X.H.useImperativeHandle(b, C, H);
          }),
          (k.useInsertionEffect = function (b, C) {
            return X.H.useInsertionEffect(b, C);
          }),
          (k.useLayoutEffect = function (b, C) {
            return X.H.useLayoutEffect(b, C);
          }),
          (k.useMemo = function (b, C) {
            return X.H.useMemo(b, C);
          }),
          (k.useOptimistic = function (b, C) {
            return X.H.useOptimistic(b, C);
          }),
          (k.useReducer = function (b, C, H) {
            return X.H.useReducer(b, C, H);
          }),
          (k.useRef = function (b) {
            return X.H.useRef(b);
          }),
          (k.useState = function (b) {
            return X.H.useState(b);
          }),
          (k.useSyncExternalStore = function (b, C, H) {
            return X.H.useSyncExternalStore(b, C, H);
          }),
          (k.useTransition = function () {
            return X.H.useTransition();
          }),
          (k.version = '19.2.0'),
          k
        );
      }
      var fh;
      function gu() {
        return (fh || ((fh = 1), (Kc.exports = Ep())), Kc.exports);
      }
      var qc = { exports: {} },
        et = {};
      var oh;
      function Tp() {
        if (oh) return et;
        oh = 1;
        var r = gu();
        function u(y) {
          var g = 'https://react.dev/errors/' + y;
          if (1 < arguments.length) {
            g += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var _ = 2; _ < arguments.length; _++)
              g += '&args[]=' + encodeURIComponent(arguments[_]);
          }
          return (
            'Minified React error #' +
            y +
            '; visit ' +
            g +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function f() {}
        var s = {
            d: {
              f,
              r: function () {
                throw Error(u(522));
              },
              D: f,
              C: f,
              L: f,
              m: f,
              X: f,
              S: f,
              M: f,
            },
            p: 0,
            findDOMNode: null,
          },
          o = Symbol.for('react.portal');
        function h(y, g, _) {
          var E =
            3 < arguments.length && arguments[3] !== void 0
              ? arguments[3]
              : null;
          return {
            $$typeof: o,
            key: E == null ? null : '' + E,
            children: y,
            containerInfo: g,
            implementation: _,
          };
        }
        var m =
          r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
        function v(y, g) {
          if (y === 'font') return '';
          if (typeof g == 'string') return g === 'use-credentials' ? g : '';
        }
        return (
          (et.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = s),
          (et.createPortal = function (y, g) {
            var _ =
              2 < arguments.length && arguments[2] !== void 0
                ? arguments[2]
                : null;
            if (
              !g ||
              (g.nodeType !== 1 && g.nodeType !== 9 && g.nodeType !== 11)
            )
              throw Error(u(299));
            return h(y, g, null, _);
          }),
          (et.flushSync = function (y) {
            var g = m.T,
              _ = s.p;
            try {
              if (((m.T = null), (s.p = 2), y)) return y();
            } finally {
              ((m.T = g), (s.p = _), s.d.f());
            }
          }),
          (et.preconnect = function (y, g) {
            typeof y == 'string' &&
              (g
                ? ((g = g.crossOrigin),
                  (g =
                    typeof g == 'string'
                      ? g === 'use-credentials'
                        ? g
                        : ''
                      : void 0))
                : (g = null),
              s.d.C(y, g));
          }),
          (et.prefetchDNS = function (y) {
            typeof y == 'string' && s.d.D(y);
          }),
          (et.preinit = function (y, g) {
            if (typeof y == 'string' && g && typeof g.as == 'string') {
              var _ = g.as,
                E = v(_, g.crossOrigin),
                L = typeof g.integrity == 'string' ? g.integrity : void 0,
                q =
                  typeof g.fetchPriority == 'string' ? g.fetchPriority : void 0;
              _ === 'style'
                ? s.d.S(
                    y,
                    typeof g.precedence == 'string' ? g.precedence : void 0,
                    { crossOrigin: E, integrity: L, fetchPriority: q }
                  )
                : _ === 'script' &&
                  s.d.X(y, {
                    crossOrigin: E,
                    integrity: L,
                    fetchPriority: q,
                    nonce: typeof g.nonce == 'string' ? g.nonce : void 0,
                  });
            }
          }),
          (et.preinitModule = function (y, g) {
            if (typeof y == 'string')
              if (typeof g == 'object' && g !== null) {
                if (g.as == null || g.as === 'script') {
                  var _ = v(g.as, g.crossOrigin);
                  s.d.M(y, {
                    crossOrigin: _,
                    integrity:
                      typeof g.integrity == 'string' ? g.integrity : void 0,
                    nonce: typeof g.nonce == 'string' ? g.nonce : void 0,
                  });
                }
              } else g == null && s.d.M(y);
          }),
          (et.preload = function (y, g) {
            if (
              typeof y == 'string' &&
              typeof g == 'object' &&
              g !== null &&
              typeof g.as == 'string'
            ) {
              var _ = g.as,
                E = v(_, g.crossOrigin);
              s.d.L(y, _, {
                crossOrigin: E,
                integrity:
                  typeof g.integrity == 'string' ? g.integrity : void 0,
                nonce: typeof g.nonce == 'string' ? g.nonce : void 0,
                type: typeof g.type == 'string' ? g.type : void 0,
                fetchPriority:
                  typeof g.fetchPriority == 'string' ? g.fetchPriority : void 0,
                referrerPolicy:
                  typeof g.referrerPolicy == 'string'
                    ? g.referrerPolicy
                    : void 0,
                imageSrcSet:
                  typeof g.imageSrcSet == 'string' ? g.imageSrcSet : void 0,
                imageSizes:
                  typeof g.imageSizes == 'string' ? g.imageSizes : void 0,
                media: typeof g.media == 'string' ? g.media : void 0,
              });
            }
          }),
          (et.preloadModule = function (y, g) {
            if (typeof y == 'string')
              if (g) {
                var _ = v(g.as, g.crossOrigin);
                s.d.m(y, {
                  as:
                    typeof g.as == 'string' && g.as !== 'script'
                      ? g.as
                      : void 0,
                  crossOrigin: _,
                  integrity:
                    typeof g.integrity == 'string' ? g.integrity : void 0,
                });
              } else s.d.m(y);
          }),
          (et.requestFormReset = function (y) {
            s.d.r(y);
          }),
          (et.unstable_batchedUpdates = function (y, g) {
            return y(g);
          }),
          (et.useFormState = function (y, g, _) {
            return m.H.useFormState(y, g, _);
          }),
          (et.useFormStatus = function () {
            return m.H.useHostTransitionStatus();
          }),
          (et.version = '19.2.0'),
          et
        );
      }
      var rh;
      function Op() {
        if (rh) return qc.exports;
        rh = 1;
        function r() {
          if (!(
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
          ))
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
            } catch (u) {
              console.error(u);
            }
        }
        return (r(), (qc.exports = Tp()), qc.exports);
      }
      var dh;
      function xp() {
        if (dh) return Kn;
        dh = 1;
        var r = Ap(),
          u = gu(),
          f = Op();
        function s(e) {
          var t = 'https://react.dev/errors/' + e;
          if (1 < arguments.length) {
            t += '?args[]=' + encodeURIComponent(arguments[1]);
            for (var a = 2; a < arguments.length; a++)
              t += '&args[]=' + encodeURIComponent(arguments[a]);
          }
          return (
            'Minified React error #' +
            e +
            '; visit ' +
            t +
            ' for the full message or use the non-minified dev environment for full errors and additional helpful warnings.'
          );
        }
        function o(e) {
          return !(
            !e ||
            (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11)
          );
        }
        function h(e) {
          var t = e,
            a = e;
          if (e.alternate) for (; t.return;) t = t.return;
          else {
            e = t;
            do
              ((t = e),
                (t.flags & 4098) !== 0 && (a = t.return),
                (e = t.return));
            while (e);
          }
          return t.tag === 3 ? a : null;
        }
        function m(e) {
          if (e.tag === 13) {
            var t = e.memoizedState;
            if (
              (t === null &&
                ((e = e.alternate), e !== null && (t = e.memoizedState)),
              t !== null)
            )
              return t.dehydrated;
          }
          return null;
        }
        function v(e) {
          if (e.tag === 31) {
            var t = e.memoizedState;
            if (
              (t === null &&
                ((e = e.alternate), e !== null && (t = e.memoizedState)),
              t !== null)
            )
              return t.dehydrated;
          }
          return null;
        }
        function y(e) {
          if (h(e) !== e) throw Error(s(188));
        }
        function g(e) {
          var t = e.alternate;
          if (!t) {
            if (((t = h(e)), t === null)) throw Error(s(188));
            return t !== e ? null : e;
          }
          for (var a = e, l = t; ;) {
            var n = a.return;
            if (n === null) break;
            var i = n.alternate;
            if (i === null) {
              if (((l = n.return), l !== null)) {
                a = l;
                continue;
              }
              break;
            }
            if (n.child === i.child) {
              for (i = n.child; i;) {
                if (i === a) return (y(n), e);
                if (i === l) return (y(n), t);
                i = i.sibling;
              }
              throw Error(s(188));
            }
            if (a.return !== l.return) ((a = n), (l = i));
            else {
              for (var c = !1, d = n.child; d;) {
                if (d === a) {
                  ((c = !0), (a = n), (l = i));
                  break;
                }
                if (d === l) {
                  ((c = !0), (l = n), (a = i));
                  break;
                }
                d = d.sibling;
              }
              if (!c) {
                for (d = i.child; d;) {
                  if (d === a) {
                    ((c = !0), (a = i), (l = n));
                    break;
                  }
                  if (d === l) {
                    ((c = !0), (l = i), (a = n));
                    break;
                  }
                  d = d.sibling;
                }
                if (!c) throw Error(s(189));
              }
            }
            if (a.alternate !== l) throw Error(s(190));
          }
          if (a.tag !== 3) throw Error(s(188));
          return a.stateNode.current === a ? e : t;
        }
        function _(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e;
          for (e = e.child; e !== null;) {
            if (((t = _(e)), t !== null)) return t;
            e = e.sibling;
          }
          return null;
        }
        var E = Object.assign,
          L = Symbol.for('react.element'),
          q = Symbol.for('react.transitional.element'),
          K = Symbol.for('react.portal'),
          B = Symbol.for('react.fragment'),
          te = Symbol.for('react.strict_mode'),
          P = Symbol.for('react.profiler'),
          ae = Symbol.for('react.consumer'),
          ge = Symbol.for('react.context'),
          ce = Symbol.for('react.forward_ref'),
          Ne = Symbol.for('react.suspense'),
          Ae = Symbol.for('react.suspense_list'),
          X = Symbol.for('react.memo'),
          Ce = Symbol.for('react.lazy'),
          $ = Symbol.for('react.activity'),
          F = Symbol.for('react.memo_cache_sentinel'),
          fe = Symbol.iterator;
        function oe(e) {
          return e === null || typeof e != 'object'
            ? null
            : ((e = (fe && e[fe]) || e['@@iterator']),
              typeof e == 'function' ? e : null);
        }
        var re = Symbol.for('react.client.reference');
        function ze(e) {
          if (e == null) return null;
          if (typeof e == 'function')
            return e.$$typeof === re ? null : e.displayName || e.name || null;
          if (typeof e == 'string') return e;
          switch (e) {
            case B:
              return 'Fragment';
            case P:
              return 'Profiler';
            case te:
              return 'StrictMode';
            case Ne:
              return 'Suspense';
            case Ae:
              return 'SuspenseList';
            case $:
              return 'Activity';
          }
          if (typeof e == 'object')
            switch (e.$$typeof) {
              case K:
                return 'Portal';
              case ge:
                return e.displayName || 'Context';
              case ae:
                return (e._context.displayName || 'Context') + '.Consumer';
              case ce:
                var t = e.render;
                return (
                  (e = e.displayName),
                  e ||
                    ((e = t.displayName || t.name || ''),
                    (e = e !== '' ? 'ForwardRef(' + e + ')' : 'ForwardRef')),
                  e
                );
              case X:
                return (
                  (t = e.displayName || null),
                  t !== null ? t : ze(e.type) || 'Memo'
                );
              case Ce:
                ((t = e._payload), (e = e._init));
                try {
                  return ze(e(t));
                } catch {}
            }
          return null;
        }
        var Xe = Array.isArray,
          z = u.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          U = f.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
          Q = { pending: !1, data: null, method: null, action: null },
          me = [],
          be = -1;
        function b(e) {
          return { current: e };
        }
        function C(e) {
          0 > be || ((e.current = me[be]), (me[be] = null), be--);
        }
        function H(e, t) {
          (be++, (me[be] = e.current), (e.current = t));
        }
        var G = b(null),
          W = b(null),
          le = b(null),
          Se = b(null);
        function tt(e, t) {
          switch ((H(le, t), H(W, e), H(G, null), t.nodeType)) {
            case 9:
            case 11:
              e = (e = t.documentElement) && (e = e.namespaceURI) ? zd(e) : 0;
              break;
            default:
              if (((e = t.tagName), (t = t.namespaceURI)))
                ((t = zd(t)), (e = _d(t, e)));
              else
                switch (e) {
                  case 'svg':
                    e = 1;
                    break;
                  case 'math':
                    e = 2;
                    break;
                  default:
                    e = 0;
                }
          }
          (C(G), H(G, e));
        }
        function He() {
          (C(G), C(W), C(le));
        }
        function wl(e) {
          e.memoizedState !== null && H(Se, e);
          var t = G.current,
            a = _d(t, e.type);
          t !== a && (H(W, e), H(G, a));
        }
        function wn(e) {
          (W.current === e && (C(G), C(W)),
            Se.current === e && (C(Se), (jn._currentValue = Q)));
        }
        var pu, tf;
        function ja(e) {
          if (pu === void 0)
            try {
              throw Error();
            } catch (a) {
              var t = a.stack.trim().match(/\n( *(at )?)/);
              ((pu = (t && t[1]) || ''),
                (tf =
                  -1 <
                  a.stack.indexOf(`
    at`)
                    ? ' (<anonymous>)'
                    : -1 < a.stack.indexOf('@')
                      ? '@unknown:0:0'
                      : ''));
            }
          return (
            `
` +
            pu +
            e +
            tf
          );
        }
        var yu = !1;
        function vu(e, t) {
          if (!e || yu) return '';
          yu = !0;
          var a = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            var l = {
              DetermineComponentFrameRoot: function () {
                try {
                  if (t) {
                    var R = function () {
                      throw Error();
                    };
                    if (
                      (Object.defineProperty(R.prototype, 'props', {
                        set: function () {
                          throw Error();
                        },
                      }),
                      typeof Reflect == 'object' && Reflect.construct)
                    ) {
                      try {
                        Reflect.construct(R, []);
                      } catch (M) {
                        var x = M;
                      }
                      Reflect.construct(e, [], R);
                    } else {
                      try {
                        R.call();
                      } catch (M) {
                        x = M;
                      }
                      e.call(R.prototype);
                    }
                  } else {
                    try {
                      throw Error();
                    } catch (M) {
                      x = M;
                    }
                    (R = e()) &&
                      typeof R.catch == 'function' &&
                      R.catch(function () {});
                  }
                } catch (M) {
                  if (M && x && typeof M.stack == 'string')
                    return [M.stack, x.stack];
                }
                return [null, null];
              },
            };
            l.DetermineComponentFrameRoot.displayName =
              'DetermineComponentFrameRoot';
            var n = Object.getOwnPropertyDescriptor(
              l.DetermineComponentFrameRoot,
              'name'
            );
            n &&
              n.configurable &&
              Object.defineProperty(l.DetermineComponentFrameRoot, 'name', {
                value: 'DetermineComponentFrameRoot',
              });
            var i = l.DetermineComponentFrameRoot(),
              c = i[0],
              d = i[1];
            if (c && d) {
              var p = c.split(`
`),
                O = d.split(`
`);
              for (
                n = l = 0;
                l < p.length && !p[l].includes('DetermineComponentFrameRoot');
              )
                l++;
              for (
                ;
                n < O.length && !O[n].includes('DetermineComponentFrameRoot');
              )
                n++;
              if (l === p.length || n === O.length)
                for (
                  l = p.length - 1, n = O.length - 1;
                  1 <= l && 0 <= n && p[l] !== O[n];
                )
                  n--;
              for (; 1 <= l && 0 <= n; l--, n--)
                if (p[l] !== O[n]) {
                  if (l !== 1 || n !== 1)
                    do
                      if ((l--, n--, 0 > n || p[l] !== O[n])) {
                        var N =
                          `
` + p[l].replace(' at new ', ' at ');
                        return (
                          e.displayName &&
                            N.includes('<anonymous>') &&
                            (N = N.replace('<anonymous>', e.displayName)),
                          N
                        );
                      }
                    while (1 <= l && 0 <= n);
                  break;
                }
            }
          } finally {
            ((yu = !1), (Error.prepareStackTrace = a));
          }
          return (a = e ? e.displayName || e.name : '') ? ja(a) : '';
        }
        function kh(e, t) {
          switch (e.tag) {
            case 26:
            case 27:
            case 5:
              return ja(e.type);
            case 16:
              return ja('Lazy');
            case 13:
              return e.child !== t && t !== null
                ? ja('Suspense Fallback')
                : ja('Suspense');
            case 19:
              return ja('SuspenseList');
            case 0:
            case 15:
              return vu(e.type, !1);
            case 11:
              return vu(e.type.render, !1);
            case 1:
              return vu(e.type, !0);
            case 31:
              return ja('Activity');
            default:
              return '';
          }
        }
        function af(e) {
          try {
            var t = '',
              a = null;
            do ((t += kh(e, a)), (a = e), (e = e.return));
            while (e);
            return t;
          } catch (l) {
            return (
              `
Error generating stack: ` +
              l.message +
              `
` +
              l.stack
            );
          }
        }
        var bu = Object.prototype.hasOwnProperty,
          Su = r.unstable_scheduleCallback,
          Au = r.unstable_cancelCallback,
          Fh = r.unstable_shouldYield,
          Wh = r.unstable_requestPaint,
          dt = r.unstable_now,
          Ih = r.unstable_getCurrentPriorityLevel,
          lf = r.unstable_ImmediatePriority,
          nf = r.unstable_UserBlockingPriority,
          Qn = r.unstable_NormalPriority,
          Ph = r.unstable_LowPriority,
          uf = r.unstable_IdlePriority,
          eg = r.log,
          tg = r.unstable_setDisableYieldValue,
          Ql = null,
          ht = null;
        function ca(e) {
          if (
            (typeof eg == 'function' && tg(e),
            ht && typeof ht.setStrictMode == 'function')
          )
            try {
              ht.setStrictMode(Ql, e);
            } catch {}
        }
        var gt = Math.clz32 ? Math.clz32 : ng,
          ag = Math.log,
          lg = Math.LN2;
        function ng(e) {
          return ((e >>>= 0), e === 0 ? 32 : (31 - ((ag(e) / lg) | 0)) | 0);
        }
        var Xn = 256,
          Zn = 262144,
          Jn = 4194304;
        function La(e) {
          var t = e & 42;
          if (t !== 0) return t;
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
              return 64;
            case 128:
              return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
              return e & 261888;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return e & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return e & 62914560;
            case 67108864:
              return 67108864;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 0;
            default:
              return e;
          }
        }
        function $n(e, t, a) {
          var l = e.pendingLanes;
          if (l === 0) return 0;
          var n = 0,
            i = e.suspendedLanes,
            c = e.pingedLanes;
          e = e.warmLanes;
          var d = l & 134217727;
          return (
            d !== 0
              ? ((l = d & ~i),
                l !== 0
                  ? (n = La(l))
                  : ((c &= d),
                    c !== 0
                      ? (n = La(c))
                      : a || ((a = d & ~e), a !== 0 && (n = La(a)))))
              : ((d = l & ~i),
                d !== 0
                  ? (n = La(d))
                  : c !== 0
                    ? (n = La(c))
                    : a || ((a = l & ~e), a !== 0 && (n = La(a)))),
            n === 0
              ? 0
              : t !== 0 &&
                  t !== n &&
                  (t & i) === 0 &&
                  ((i = n & -n),
                  (a = t & -t),
                  i >= a || (i === 32 && (a & 4194048) !== 0))
                ? t
                : n
          );
        }
        function Xl(e, t) {
          return (
            (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0
          );
        }
        function ig(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
              return t + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1;
            default:
              return -1;
          }
        }
        function sf() {
          var e = Jn;
          return ((Jn <<= 1), (Jn & 62914560) === 0 && (Jn = 4194304), e);
        }
        function Eu(e) {
          for (var t = [], a = 0; 31 > a; a++) t.push(e);
          return t;
        }
        function Zl(e, t) {
          ((e.pendingLanes |= t),
            t !== 268435456 &&
              ((e.suspendedLanes = 0), (e.pingedLanes = 0), (e.warmLanes = 0)));
        }
        function ug(e, t, a, l, n, i) {
          var c = e.pendingLanes;
          ((e.pendingLanes = a),
            (e.suspendedLanes = 0),
            (e.pingedLanes = 0),
            (e.warmLanes = 0),
            (e.expiredLanes &= a),
            (e.entangledLanes &= a),
            (e.errorRecoveryDisabledLanes &= a),
            (e.shellSuspendCounter = 0));
          var d = e.entanglements,
            p = e.expirationTimes,
            O = e.hiddenUpdates;
          for (a = c & ~a; 0 < a;) {
            var N = 31 - gt(a),
              R = 1 << N;
            ((d[N] = 0), (p[N] = -1));
            var x = O[N];
            if (x !== null)
              for (O[N] = null, N = 0; N < x.length; N++) {
                var M = x[N];
                M !== null && (M.lane &= -536870913);
              }
            a &= ~R;
          }
          (l !== 0 && cf(e, l, 0),
            i !== 0 &&
              n === 0 &&
              e.tag !== 0 &&
              (e.suspendedLanes |= i & ~(c & ~t)));
        }
        function cf(e, t, a) {
          ((e.pendingLanes |= t), (e.suspendedLanes &= ~t));
          var l = 31 - gt(t);
          ((e.entangledLanes |= t),
            (e.entanglements[l] =
              e.entanglements[l] | 1073741824 | (a & 261930)));
        }
        function ff(e, t) {
          var a = (e.entangledLanes |= t);
          for (e = e.entanglements; a;) {
            var l = 31 - gt(a),
              n = 1 << l;
            ((n & t) | (e[l] & t) && (e[l] |= t), (a &= ~n));
          }
        }
        function of(e, t) {
          var a = t & -t;
          return (
            (a = (a & 42) !== 0 ? 1 : Tu(a)),
            (a & (e.suspendedLanes | t)) !== 0 ? 0 : a
          );
        }
        function Tu(e) {
          switch (e) {
            case 2:
              e = 1;
              break;
            case 8:
              e = 4;
              break;
            case 32:
              e = 16;
              break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
              e = 128;
              break;
            case 268435456:
              e = 134217728;
              break;
            default:
              e = 0;
          }
          return e;
        }
        function Ou(e) {
          return (
            (e &= -e),
            2 < e ? (8 < e ? ((e & 134217727) !== 0 ? 32 : 268435456) : 8) : 2
          );
        }
        function rf() {
          var e = U.p;
          return e !== 0
            ? e
            : ((e = window.event), e === void 0 ? 32 : Wd(e.type));
        }
        function df(e, t) {
          var a = U.p;
          try {
            return ((U.p = e), t());
          } finally {
            U.p = a;
          }
        }
        var fa = Math.random().toString(36).slice(2),
          ke = '__reactFiber$' + fa,
          nt = '__reactProps$' + fa,
          al = '__reactContainer$' + fa,
          xu = '__reactEvents$' + fa,
          sg = '__reactListeners$' + fa,
          cg = '__reactHandles$' + fa,
          hf = '__reactResources$' + fa,
          Jl = '__reactMarker$' + fa;
        function Mu(e) {
          (delete e[ke],
            delete e[nt],
            delete e[xu],
            delete e[sg],
            delete e[cg]);
        }
        function ll(e) {
          var t = e[ke];
          if (t) return t;
          for (var a = e.parentNode; a;) {
            if ((t = a[al] || a[ke])) {
              if (
                ((a = t.alternate),
                t.child !== null || (a !== null && a.child !== null))
              )
                for (e = Ud(e); e !== null;) {
                  if ((a = e[ke])) return a;
                  e = Ud(e);
                }
              return t;
            }
            ((e = a), (a = e.parentNode));
          }
          return null;
        }
        function nl(e) {
          if ((e = e[ke] || e[al])) {
            var t = e.tag;
            if (
              t === 5 ||
              t === 6 ||
              t === 13 ||
              t === 31 ||
              t === 26 ||
              t === 27 ||
              t === 3
            )
              return e;
          }
          return null;
        }
        function $l(e) {
          var t = e.tag;
          if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
          throw Error(s(33));
        }
        function il(e) {
          var t = e[hf];
          return (
            t ||
              (t = e[hf] =
                { hoistableStyles: new Map(), hoistableScripts: new Map() }),
            t
          );
        }
        function Ze(e) {
          e[Jl] = !0;
        }
        var gf = new Set(),
          mf = {};
        function Ua(e, t) {
          (ul(e, t), ul(e + 'Capture', t));
        }
        function ul(e, t) {
          for (mf[e] = t, e = 0; e < t.length; e++) gf.add(t[e]);
        }
        var fg = RegExp(
            '^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$'
          ),
          pf = {},
          yf = {};
        function og(e) {
          return bu.call(yf, e)
            ? !0
            : bu.call(pf, e)
              ? !1
              : fg.test(e)
                ? (yf[e] = !0)
                : ((pf[e] = !0), !1);
        }
        function kn(e, t, a) {
          if (og(t))
            if (a === null) e.removeAttribute(t);
            else {
              switch (typeof a) {
                case 'undefined':
                case 'function':
                case 'symbol':
                  e.removeAttribute(t);
                  return;
                case 'boolean':
                  var l = t.toLowerCase().slice(0, 5);
                  if (l !== 'data-' && l !== 'aria-') {
                    e.removeAttribute(t);
                    return;
                  }
              }
              e.setAttribute(t, '' + a);
            }
        }
        function Fn(e, t, a) {
          if (a === null) e.removeAttribute(t);
          else {
            switch (typeof a) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(t);
                return;
            }
            e.setAttribute(t, '' + a);
          }
        }
        function Qt(e, t, a, l) {
          if (l === null) e.removeAttribute(a);
          else {
            switch (typeof l) {
              case 'undefined':
              case 'function':
              case 'symbol':
              case 'boolean':
                e.removeAttribute(a);
                return;
            }
            e.setAttributeNS(t, a, '' + l);
          }
        }
        function Et(e) {
          switch (typeof e) {
            case 'bigint':
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
              return e;
            case 'object':
              return e;
            default:
              return '';
          }
        }
        function vf(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            e.toLowerCase() === 'input' &&
            (t === 'checkbox' || t === 'radio')
          );
        }
        function rg(e, t, a) {
          var l = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
          if (
            !e.hasOwnProperty(t) &&
            typeof l < 'u' &&
            typeof l.get == 'function' &&
            typeof l.set == 'function'
          ) {
            var n = l.get,
              i = l.set;
            return (
              Object.defineProperty(e, t, {
                configurable: !0,
                get: function () {
                  return n.call(this);
                },
                set: function (c) {
                  ((a = '' + c), i.call(this, c));
                },
              }),
              Object.defineProperty(e, t, { enumerable: l.enumerable }),
              {
                getValue: function () {
                  return a;
                },
                setValue: function (c) {
                  a = '' + c;
                },
                stopTracking: function () {
                  ((e._valueTracker = null), delete e[t]);
                },
              }
            );
          }
        }
        function zu(e) {
          if (!e._valueTracker) {
            var t = vf(e) ? 'checked' : 'value';
            e._valueTracker = rg(e, t, '' + e[t]);
          }
        }
        function bf(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var a = t.getValue(),
            l = '';
          return (
            e && (l = vf(e) ? (e.checked ? 'true' : 'false') : e.value),
            (e = l),
            e !== a ? (t.setValue(e), !0) : !1
          );
        }
        function Wn(e) {
          if (
            ((e = e || (typeof document < 'u' ? document : void 0)),
            typeof e > 'u')
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch {
            return e.body;
          }
        }
        var dg = /[\n"\\]/g;
        function Tt(e) {
          return e.replace(dg, function (t) {
            return '\\' + t.charCodeAt(0).toString(16) + ' ';
          });
        }
        function _u(e, t, a, l, n, i, c, d) {
          ((e.name = ''),
            c != null &&
            typeof c != 'function' &&
            typeof c != 'symbol' &&
            typeof c != 'boolean'
              ? (e.type = c)
              : e.removeAttribute('type'),
            t != null
              ? c === 'number'
                ? ((t === 0 && e.value === '') || e.value != t) &&
                  (e.value = '' + Et(t))
                : e.value !== '' + Et(t) && (e.value = '' + Et(t))
              : (c !== 'submit' && c !== 'reset') || e.removeAttribute('value'),
            t != null
              ? Nu(e, c, Et(t))
              : a != null
                ? Nu(e, c, Et(a))
                : l != null && e.removeAttribute('value'),
            n == null && i != null && (e.defaultChecked = !!i),
            n != null &&
              (e.checked = n && typeof n != 'function' && typeof n != 'symbol'),
            d != null &&
            typeof d != 'function' &&
            typeof d != 'symbol' &&
            typeof d != 'boolean'
              ? (e.name = '' + Et(d))
              : e.removeAttribute('name'));
        }
        function Sf(e, t, a, l, n, i, c, d) {
          if (
            (i != null &&
              typeof i != 'function' &&
              typeof i != 'symbol' &&
              typeof i != 'boolean' &&
              (e.type = i),
            t != null || a != null)
          ) {
            if (!((i !== 'submit' && i !== 'reset') || t != null)) {
              zu(e);
              return;
            }
            ((a = a != null ? '' + Et(a) : ''),
              (t = t != null ? '' + Et(t) : a),
              d || t === e.value || (e.value = t),
              (e.defaultValue = t));
          }
          ((l = l ?? n),
            (l = typeof l != 'function' && typeof l != 'symbol' && !!l),
            (e.checked = d ? e.checked : !!l),
            (e.defaultChecked = !!l),
            c != null &&
              typeof c != 'function' &&
              typeof c != 'symbol' &&
              typeof c != 'boolean' &&
              (e.name = c),
            zu(e));
        }
        function Nu(e, t, a) {
          (t === 'number' && Wn(e.ownerDocument) === e) ||
            e.defaultValue === '' + a ||
            (e.defaultValue = '' + a);
        }
        function sl(e, t, a, l) {
          if (((e = e.options), t)) {
            t = {};
            for (var n = 0; n < a.length; n++) t['$' + a[n]] = !0;
            for (a = 0; a < e.length; a++)
              ((n = t.hasOwnProperty('$' + e[a].value)),
                e[a].selected !== n && (e[a].selected = n),
                n && l && (e[a].defaultSelected = !0));
          } else {
            for (a = '' + Et(a), t = null, n = 0; n < e.length; n++) {
              if (e[n].value === a) {
                ((e[n].selected = !0), l && (e[n].defaultSelected = !0));
                return;
              }
              t !== null || e[n].disabled || (t = e[n]);
            }
            t !== null && (t.selected = !0);
          }
        }
        function Af(e, t, a) {
          if (
            t != null &&
            ((t = '' + Et(t)), t !== e.value && (e.value = t), a == null)
          ) {
            e.defaultValue !== t && (e.defaultValue = t);
            return;
          }
          e.defaultValue = a != null ? '' + Et(a) : '';
        }
        function Ef(e, t, a, l) {
          if (t == null) {
            if (l != null) {
              if (a != null) throw Error(s(92));
              if (Xe(l)) {
                if (1 < l.length) throw Error(s(93));
                l = l[0];
              }
              a = l;
            }
            (a == null && (a = ''), (t = a));
          }
          ((a = Et(t)),
            (e.defaultValue = a),
            (l = e.textContent),
            l === a && l !== '' && l !== null && (e.value = l),
            zu(e));
        }
        function cl(e, t) {
          if (t) {
            var a = e.firstChild;
            if (a && a === e.lastChild && a.nodeType === 3) {
              a.nodeValue = t;
              return;
            }
          }
          e.textContent = t;
        }
        var hg = new Set(
          'animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp'.split(
            ' '
          )
        );
        function Tf(e, t, a) {
          var l = t.indexOf('--') === 0;
          a == null || typeof a == 'boolean' || a === ''
            ? l
              ? e.setProperty(t, '')
              : t === 'float'
                ? (e.cssFloat = '')
                : (e[t] = '')
            : l
              ? e.setProperty(t, a)
              : typeof a != 'number' || a === 0 || hg.has(t)
                ? t === 'float'
                  ? (e.cssFloat = a)
                  : (e[t] = ('' + a).trim())
                : (e[t] = a + 'px');
        }
        function Of(e, t, a) {
          if (t != null && typeof t != 'object') throw Error(s(62));
          if (((e = e.style), a != null)) {
            for (var l in a)
              !a.hasOwnProperty(l) ||
                (t != null && t.hasOwnProperty(l)) ||
                (l.indexOf('--') === 0
                  ? e.setProperty(l, '')
                  : l === 'float'
                    ? (e.cssFloat = '')
                    : (e[l] = ''));
            for (var n in t)
              ((l = t[n]), t.hasOwnProperty(n) && a[n] !== l && Tf(e, n, l));
          } else for (var i in t) t.hasOwnProperty(i) && Tf(e, i, t[i]);
        }
        function Cu(e) {
          if (e.indexOf('-') === -1) return !1;
          switch (e) {
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
              return !1;
            default:
              return !0;
          }
        }
        var gg = new Map([
            ['acceptCharset', 'accept-charset'],
            ['htmlFor', 'for'],
            ['httpEquiv', 'http-equiv'],
            ['crossOrigin', 'crossorigin'],
            ['accentHeight', 'accent-height'],
            ['alignmentBaseline', 'alignment-baseline'],
            ['arabicForm', 'arabic-form'],
            ['baselineShift', 'baseline-shift'],
            ['capHeight', 'cap-height'],
            ['clipPath', 'clip-path'],
            ['clipRule', 'clip-rule'],
            ['colorInterpolation', 'color-interpolation'],
            ['colorInterpolationFilters', 'color-interpolation-filters'],
            ['colorProfile', 'color-profile'],
            ['colorRendering', 'color-rendering'],
            ['dominantBaseline', 'dominant-baseline'],
            ['enableBackground', 'enable-background'],
            ['fillOpacity', 'fill-opacity'],
            ['fillRule', 'fill-rule'],
            ['floodColor', 'flood-color'],
            ['floodOpacity', 'flood-opacity'],
            ['fontFamily', 'font-family'],
            ['fontSize', 'font-size'],
            ['fontSizeAdjust', 'font-size-adjust'],
            ['fontStretch', 'font-stretch'],
            ['fontStyle', 'font-style'],
            ['fontVariant', 'font-variant'],
            ['fontWeight', 'font-weight'],
            ['glyphName', 'glyph-name'],
            ['glyphOrientationHorizontal', 'glyph-orientation-horizontal'],
            ['glyphOrientationVertical', 'glyph-orientation-vertical'],
            ['horizAdvX', 'horiz-adv-x'],
            ['horizOriginX', 'horiz-origin-x'],
            ['imageRendering', 'image-rendering'],
            ['letterSpacing', 'letter-spacing'],
            ['lightingColor', 'lighting-color'],
            ['markerEnd', 'marker-end'],
            ['markerMid', 'marker-mid'],
            ['markerStart', 'marker-start'],
            ['overlinePosition', 'overline-position'],
            ['overlineThickness', 'overline-thickness'],
            ['paintOrder', 'paint-order'],
            ['panose-1', 'panose-1'],
            ['pointerEvents', 'pointer-events'],
            ['renderingIntent', 'rendering-intent'],
            ['shapeRendering', 'shape-rendering'],
            ['stopColor', 'stop-color'],
            ['stopOpacity', 'stop-opacity'],
            ['strikethroughPosition', 'strikethrough-position'],
            ['strikethroughThickness', 'strikethrough-thickness'],
            ['strokeDasharray', 'stroke-dasharray'],
            ['strokeDashoffset', 'stroke-dashoffset'],
            ['strokeLinecap', 'stroke-linecap'],
            ['strokeLinejoin', 'stroke-linejoin'],
            ['strokeMiterlimit', 'stroke-miterlimit'],
            ['strokeOpacity', 'stroke-opacity'],
            ['strokeWidth', 'stroke-width'],
            ['textAnchor', 'text-anchor'],
            ['textDecoration', 'text-decoration'],
            ['textRendering', 'text-rendering'],
            ['transformOrigin', 'transform-origin'],
            ['underlinePosition', 'underline-position'],
            ['underlineThickness', 'underline-thickness'],
            ['unicodeBidi', 'unicode-bidi'],
            ['unicodeRange', 'unicode-range'],
            ['unitsPerEm', 'units-per-em'],
            ['vAlphabetic', 'v-alphabetic'],
            ['vHanging', 'v-hanging'],
            ['vIdeographic', 'v-ideographic'],
            ['vMathematical', 'v-mathematical'],
            ['vectorEffect', 'vector-effect'],
            ['vertAdvY', 'vert-adv-y'],
            ['vertOriginX', 'vert-origin-x'],
            ['vertOriginY', 'vert-origin-y'],
            ['wordSpacing', 'word-spacing'],
            ['writingMode', 'writing-mode'],
            ['xmlnsXlink', 'xmlns:xlink'],
            ['xHeight', 'x-height'],
          ]),
          mg =
            /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
        function In(e) {
          return mg.test('' + e)
            ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
            : e;
        }
        function Xt() {}
        var Du = null;
        function Ru(e) {
          return (
            (e = e.target || e.srcElement || window),
            e.correspondingUseElement && (e = e.correspondingUseElement),
            e.nodeType === 3 ? e.parentNode : e
          );
        }
        var fl = null,
          ol = null;
        function xf(e) {
          var t = nl(e);
          if (t && (e = t.stateNode)) {
            var a = e[nt] || null;
            e: switch (((e = t.stateNode), t.type)) {
              case 'input':
                if (
                  (_u(
                    e,
                    a.value,
                    a.defaultValue,
                    a.defaultValue,
                    a.checked,
                    a.defaultChecked,
                    a.type,
                    a.name
                  ),
                  (t = a.name),
                  a.type === 'radio' && t != null)
                ) {
                  for (a = e; a.parentNode;) a = a.parentNode;
                  for (
                    a = a.querySelectorAll(
                      'input[name="' + Tt('' + t) + '"][type="radio"]'
                    ),
                      t = 0;
                    t < a.length;
                    t++
                  ) {
                    var l = a[t];
                    if (l !== e && l.form === e.form) {
                      var n = l[nt] || null;
                      if (!n) throw Error(s(90));
                      _u(
                        l,
                        n.value,
                        n.defaultValue,
                        n.defaultValue,
                        n.checked,
                        n.defaultChecked,
                        n.type,
                        n.name
                      );
                    }
                  }
                  for (t = 0; t < a.length; t++)
                    ((l = a[t]), l.form === e.form && bf(l));
                }
                break e;
              case 'textarea':
                Af(e, a.value, a.defaultValue);
                break e;
              case 'select':
                ((t = a.value), t != null && sl(e, !!a.multiple, t, !1));
            }
          }
        }
        var ju = !1;
        function Mf(e, t, a) {
          if (ju) return e(t, a);
          ju = !0;
          try {
            var l = e(t);
            return l;
          } finally {
            if (
              ((ju = !1),
              (fl !== null || ol !== null) &&
                (qi(), fl && ((t = fl), (e = ol), (ol = fl = null), xf(t), e)))
            )
              for (t = 0; t < e.length; t++) xf(e[t]);
          }
        }
        function kl(e, t) {
          var a = e.stateNode;
          if (a === null) return null;
          var l = a[nt] || null;
          if (l === null) return null;
          a = l[t];
          e: switch (t) {
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
              ((l = !l.disabled) ||
                ((e = e.type),
                (l = !(
                  e === 'button' ||
                  e === 'input' ||
                  e === 'select' ||
                  e === 'textarea'
                ))),
                (e = !l));
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (a && typeof a != 'function') throw Error(s(231, t, typeof a));
          return a;
        }
        var Zt = !(
            typeof window > 'u' ||
            typeof window.document > 'u' ||
            typeof window.document.createElement > 'u'
          ),
          Lu = !1;
        if (Zt)
          try {
            var Fl = {};
            (Object.defineProperty(Fl, 'passive', {
              get: function () {
                Lu = !0;
              },
            }),
              window.addEventListener('test', Fl, Fl),
              window.removeEventListener('test', Fl, Fl));
          } catch {
            Lu = !1;
          }
        var oa = null,
          Uu = null,
          Pn = null;
        function zf() {
          if (Pn) return Pn;
          var e,
            t = Uu,
            a = t.length,
            l,
            n = 'value' in oa ? oa.value : oa.textContent,
            i = n.length;
          for (e = 0; e < a && t[e] === n[e]; e++);
          var c = a - e;
          for (l = 1; l <= c && t[a - l] === n[i - l]; l++);
          return (Pn = n.slice(e, 1 < l ? 1 - l : void 0));
        }
        function ei(e) {
          var t = e.keyCode;
          return (
            'charCode' in e
              ? ((e = e.charCode), e === 0 && t === 13 && (e = 13))
              : (e = t),
            e === 10 && (e = 13),
            32 <= e || e === 13 ? e : 0
          );
        }
        function ti() {
          return !0;
        }
        function _f() {
          return !1;
        }
        function it(e) {
          function t(a, l, n, i, c) {
            ((this._reactName = a),
              (this._targetInst = n),
              (this.type = l),
              (this.nativeEvent = i),
              (this.target = c),
              (this.currentTarget = null));
            for (var d in e)
              e.hasOwnProperty(d) && ((a = e[d]), (this[d] = a ? a(i) : i[d]));
            return (
              (this.isDefaultPrevented = (
                i.defaultPrevented != null
                  ? i.defaultPrevented
                  : i.returnValue === !1
              )
                ? ti
                : _f),
              (this.isPropagationStopped = _f),
              this
            );
          }
          return (
            E(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var a = this.nativeEvent;
                a &&
                  (a.preventDefault
                    ? a.preventDefault()
                    : typeof a.returnValue != 'unknown' && (a.returnValue = !1),
                  (this.isDefaultPrevented = ti));
              },
              stopPropagation: function () {
                var a = this.nativeEvent;
                a &&
                  (a.stopPropagation
                    ? a.stopPropagation()
                    : typeof a.cancelBubble != 'unknown' &&
                      (a.cancelBubble = !0),
                  (this.isPropagationStopped = ti));
              },
              persist: function () {},
              isPersistent: ti,
            }),
            t
          );
        }
        var Ha = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          ai = it(Ha),
          Wl = E({}, Ha, { view: 0, detail: 0 }),
          pg = it(Wl),
          Hu,
          Bu,
          Il,
          li = E({}, Wl, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: qu,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return e.relatedTarget === void 0
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return 'movementX' in e
                ? e.movementX
                : (e !== Il &&
                    (Il && e.type === 'mousemove'
                      ? ((Hu = e.screenX - Il.screenX),
                        (Bu = e.screenY - Il.screenY))
                      : (Bu = Hu = 0),
                    (Il = e)),
                  Hu);
            },
            movementY: function (e) {
              return 'movementY' in e ? e.movementY : Bu;
            },
          }),
          Nf = it(li),
          yg = E({}, li, { dataTransfer: 0 }),
          vg = it(yg),
          bg = E({}, Wl, { relatedTarget: 0 }),
          Ku = it(bg),
          Sg = E({}, Ha, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0,
          }),
          Ag = it(Sg),
          Eg = E({}, Ha, {
            clipboardData: function (e) {
              return 'clipboardData' in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          Tg = it(Eg),
          Og = E({}, Ha, { data: 0 }),
          Cf = it(Og),
          xg = {
            Esc: 'Escape',
            Spacebar: ' ',
            Left: 'ArrowLeft',
            Up: 'ArrowUp',
            Right: 'ArrowRight',
            Down: 'ArrowDown',
            Del: 'Delete',
            Win: 'OS',
            Menu: 'ContextMenu',
            Apps: 'ContextMenu',
            Scroll: 'ScrollLock',
            MozPrintableKey: 'Unidentified',
          },
          Mg = {
            8: 'Backspace',
            9: 'Tab',
            12: 'Clear',
            13: 'Enter',
            16: 'Shift',
            17: 'Control',
            18: 'Alt',
            19: 'Pause',
            20: 'CapsLock',
            27: 'Escape',
            32: ' ',
            33: 'PageUp',
            34: 'PageDown',
            35: 'End',
            36: 'Home',
            37: 'ArrowLeft',
            38: 'ArrowUp',
            39: 'ArrowRight',
            40: 'ArrowDown',
            45: 'Insert',
            46: 'Delete',
            112: 'F1',
            113: 'F2',
            114: 'F3',
            115: 'F4',
            116: 'F5',
            117: 'F6',
            118: 'F7',
            119: 'F8',
            120: 'F9',
            121: 'F10',
            122: 'F11',
            123: 'F12',
            144: 'NumLock',
            145: 'ScrollLock',
            224: 'Meta',
          },
          zg = {
            Alt: 'altKey',
            Control: 'ctrlKey',
            Meta: 'metaKey',
            Shift: 'shiftKey',
          };
        function _g(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : (e = zg[e])
              ? !!t[e]
              : !1;
        }
        function qu() {
          return _g;
        }
        var Ng = E({}, Wl, {
            key: function (e) {
              if (e.key) {
                var t = xg[e.key] || e.key;
                if (t !== 'Unidentified') return t;
              }
              return e.type === 'keypress'
                ? ((e = ei(e)), e === 13 ? 'Enter' : String.fromCharCode(e))
                : e.type === 'keydown' || e.type === 'keyup'
                  ? Mg[e.keyCode] || 'Unidentified'
                  : '';
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: qu,
            charCode: function (e) {
              return e.type === 'keypress' ? ei(e) : 0;
            },
            keyCode: function (e) {
              return e.type === 'keydown' || e.type === 'keyup' ? e.keyCode : 0;
            },
            which: function (e) {
              return e.type === 'keypress'
                ? ei(e)
                : e.type === 'keydown' || e.type === 'keyup'
                  ? e.keyCode
                  : 0;
            },
          }),
          Cg = it(Ng),
          Dg = E({}, li, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0,
          }),
          Df = it(Dg),
          Rg = E({}, Wl, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: qu,
          }),
          jg = it(Rg),
          Lg = E({}, Ha, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
          Ug = it(Lg),
          Hg = E({}, li, {
            deltaX: function (e) {
              return 'deltaX' in e
                ? e.deltaX
                : 'wheelDeltaX' in e
                  ? -e.wheelDeltaX
                  : 0;
            },
            deltaY: function (e) {
              return 'deltaY' in e
                ? e.deltaY
                : 'wheelDeltaY' in e
                  ? -e.wheelDeltaY
                  : 'wheelDelta' in e
                    ? -e.wheelDelta
                    : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Bg = it(Hg),
          Kg = E({}, Ha, { newState: 0, oldState: 0 }),
          qg = it(Kg),
          Gg = [9, 13, 27, 32],
          Gu = Zt && 'CompositionEvent' in window,
          Pl = null;
        Zt && 'documentMode' in document && (Pl = document.documentMode);
        var Yg = Zt && 'TextEvent' in window && !Pl,
          Rf = Zt && (!Gu || (Pl && 8 < Pl && 11 >= Pl)),
          jf = ' ',
          Lf = !1;
        function Uf(e, t) {
          switch (e) {
            case 'keyup':
              return Gg.indexOf(t.keyCode) !== -1;
            case 'keydown':
              return t.keyCode !== 229;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
              return !0;
            default:
              return !1;
          }
        }
        function Hf(e) {
          return (
            (e = e.detail),
            typeof e == 'object' && 'data' in e ? e.data : null
          );
        }
        var rl = !1;
        function Vg(e, t) {
          switch (e) {
            case 'compositionend':
              return Hf(t);
            case 'keypress':
              return t.which !== 32 ? null : ((Lf = !0), jf);
            case 'textInput':
              return ((e = t.data), e === jf && Lf ? null : e);
            default:
              return null;
          }
        }
        function wg(e, t) {
          if (rl)
            return e === 'compositionend' || (!Gu && Uf(e, t))
              ? ((e = zf()), (Pn = Uu = oa = null), (rl = !1), e)
              : null;
          switch (e) {
            case 'paste':
              return null;
            case 'keypress':
              if (
                !(t.ctrlKey || t.altKey || t.metaKey) ||
                (t.ctrlKey && t.altKey)
              ) {
                if (t.char && 1 < t.char.length) return t.char;
                if (t.which) return String.fromCharCode(t.which);
              }
              return null;
            case 'compositionend':
              return Rf && t.locale !== 'ko' ? null : t.data;
            default:
              return null;
          }
        }
        var Qg = {
          color: !0,
          date: !0,
          datetime: !0,
          'datetime-local': !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0,
        };
        function Bf(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return t === 'input' ? !!Qg[e.type] : t === 'textarea';
        }
        function Kf(e, t, a, l) {
          (fl ? (ol ? ol.push(l) : (ol = [l])) : (fl = l),
            (t = Zi(t, 'onChange')),
            0 < t.length &&
              ((a = new ai('onChange', 'change', null, a, l)),
              e.push({ event: a, listeners: t })));
        }
        var en = null,
          tn = null;
        function Xg(e) {
          Ad(e, 0);
        }
        function ni(e) {
          var t = $l(e);
          if (bf(t)) return e;
        }
        function qf(e, t) {
          if (e === 'change') return t;
        }
        var Gf = !1;
        if (Zt) {
          var Yu;
          if (Zt) {
            var Vu = 'oninput' in document;
            if (!Vu) {
              var Yf = document.createElement('div');
              (Yf.setAttribute('oninput', 'return;'),
                (Vu = typeof Yf.oninput == 'function'));
            }
            Yu = Vu;
          } else Yu = !1;
          Gf = Yu && (!document.documentMode || 9 < document.documentMode);
        }
        function Vf() {
          en && (en.detachEvent('onpropertychange', wf), (tn = en = null));
        }
        function wf(e) {
          if (e.propertyName === 'value' && ni(tn)) {
            var t = [];
            (Kf(t, tn, e, Ru(e)), Mf(Xg, t));
          }
        }
        function Zg(e, t, a) {
          e === 'focusin'
            ? (Vf(), (en = t), (tn = a), en.attachEvent('onpropertychange', wf))
            : e === 'focusout' && Vf();
        }
        function Jg(e) {
          if (e === 'selectionchange' || e === 'keyup' || e === 'keydown')
            return ni(tn);
        }
        function $g(e, t) {
          if (e === 'click') return ni(t);
        }
        function kg(e, t) {
          if (e === 'input' || e === 'change') return ni(t);
        }
        function Fg(e, t) {
          return (
            (e === t && (e !== 0 || 1 / e === 1 / t)) || (e !== e && t !== t)
          );
        }
        var mt = typeof Object.is == 'function' ? Object.is : Fg;
        function an(e, t) {
          if (mt(e, t)) return !0;
          if (
            typeof e != 'object' ||
            e === null ||
            typeof t != 'object' ||
            t === null
          )
            return !1;
          var a = Object.keys(e),
            l = Object.keys(t);
          if (a.length !== l.length) return !1;
          for (l = 0; l < a.length; l++) {
            var n = a[l];
            if (!bu.call(t, n) || !mt(e[n], t[n])) return !1;
          }
          return !0;
        }
        function Qf(e) {
          for (; e && e.firstChild;) e = e.firstChild;
          return e;
        }
        function Xf(e, t) {
          var a = Qf(e);
          e = 0;
          for (var l; a;) {
            if (a.nodeType === 3) {
              if (((l = e + a.textContent.length), e <= t && l >= t))
                return { node: a, offset: t - e };
              e = l;
            }
            e: {
              for (; a;) {
                if (a.nextSibling) {
                  a = a.nextSibling;
                  break e;
                }
                a = a.parentNode;
              }
              a = void 0;
            }
            a = Qf(a);
          }
        }
        function Zf(e, t) {
          return e && t
            ? e === t
              ? !0
              : e && e.nodeType === 3
                ? !1
                : t && t.nodeType === 3
                  ? Zf(e, t.parentNode)
                  : 'contains' in e
                    ? e.contains(t)
                    : e.compareDocumentPosition
                      ? !!(e.compareDocumentPosition(t) & 16)
                      : !1
            : !1;
        }
        function Jf(e) {
          e =
            e != null &&
            e.ownerDocument != null &&
            e.ownerDocument.defaultView != null
              ? e.ownerDocument.defaultView
              : window;
          for (var t = Wn(e.document); t instanceof e.HTMLIFrameElement;) {
            try {
              var a = typeof t.contentWindow.location.href == 'string';
            } catch {
              a = !1;
            }
            if (a) e = t.contentWindow;
            else break;
            t = Wn(e.document);
          }
          return t;
        }
        function wu(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            ((t === 'input' &&
              (e.type === 'text' ||
                e.type === 'search' ||
                e.type === 'tel' ||
                e.type === 'url' ||
                e.type === 'password')) ||
              t === 'textarea' ||
              e.contentEditable === 'true')
          );
        }
        var Wg =
            Zt && 'documentMode' in document && 11 >= document.documentMode,
          dl = null,
          Qu = null,
          ln = null,
          Xu = !1;
        function $f(e, t, a) {
          var l =
            a.window === a
              ? a.document
              : a.nodeType === 9
                ? a
                : a.ownerDocument;
          Xu ||
            dl == null ||
            dl !== Wn(l) ||
            ((l = dl),
            'selectionStart' in l && wu(l)
              ? (l = { start: l.selectionStart, end: l.selectionEnd })
              : ((l = (
                  (l.ownerDocument && l.ownerDocument.defaultView) ||
                  window
                ).getSelection()),
                (l = {
                  anchorNode: l.anchorNode,
                  anchorOffset: l.anchorOffset,
                  focusNode: l.focusNode,
                  focusOffset: l.focusOffset,
                })),
            (ln && an(ln, l)) ||
              ((ln = l),
              (l = Zi(Qu, 'onSelect')),
              0 < l.length &&
                ((t = new ai('onSelect', 'select', null, t, a)),
                e.push({ event: t, listeners: l }),
                (t.target = dl))));
        }
        function Ba(e, t) {
          var a = {};
          return (
            (a[e.toLowerCase()] = t.toLowerCase()),
            (a['Webkit' + e] = 'webkit' + t),
            (a['Moz' + e] = 'moz' + t),
            a
          );
        }
        var hl = {
            animationend: Ba('Animation', 'AnimationEnd'),
            animationiteration: Ba('Animation', 'AnimationIteration'),
            animationstart: Ba('Animation', 'AnimationStart'),
            transitionrun: Ba('Transition', 'TransitionRun'),
            transitionstart: Ba('Transition', 'TransitionStart'),
            transitioncancel: Ba('Transition', 'TransitionCancel'),
            transitionend: Ba('Transition', 'TransitionEnd'),
          },
          Zu = {},
          kf = {};
        Zt &&
          ((kf = document.createElement('div').style),
          'AnimationEvent' in window ||
            (delete hl.animationend.animation,
            delete hl.animationiteration.animation,
            delete hl.animationstart.animation),
          'TransitionEvent' in window || delete hl.transitionend.transition);
        function Ka(e) {
          if (Zu[e]) return Zu[e];
          if (!hl[e]) return e;
          var t = hl[e],
            a;
          for (a in t)
            if (t.hasOwnProperty(a) && a in kf) return (Zu[e] = t[a]);
          return e;
        }
        var Ff = Ka('animationend'),
          Wf = Ka('animationiteration'),
          If = Ka('animationstart'),
          Ig = Ka('transitionrun'),
          Pg = Ka('transitionstart'),
          em = Ka('transitioncancel'),
          Pf = Ka('transitionend'),
          eo = new Map(),
          Ju =
            'abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel'.split(
              ' '
            );
        Ju.push('scrollEnd');
        function Ut(e, t) {
          (eo.set(e, t), Ua(t, [e]));
        }
        var ii =
            typeof reportError == 'function'
              ? reportError
              : function (e) {
                  if (
                    typeof window == 'object' &&
                    typeof window.ErrorEvent == 'function'
                  ) {
                    var t = new window.ErrorEvent('error', {
                      bubbles: !0,
                      cancelable: !0,
                      message:
                        typeof e == 'object' &&
                        e !== null &&
                        typeof e.message == 'string'
                          ? String(e.message)
                          : String(e),
                      error: e,
                    });
                    if (!window.dispatchEvent(t)) return;
                  } else if (
                    typeof process == 'object' &&
                    typeof process.emit == 'function'
                  ) {
                    process.emit('uncaughtException', e);
                    return;
                  }
                  console.error(e);
                },
          Ot = [],
          gl = 0,
          $u = 0;
        function ui() {
          for (var e = gl, t = ($u = gl = 0); t < e;) {
            var a = Ot[t];
            Ot[t++] = null;
            var l = Ot[t];
            Ot[t++] = null;
            var n = Ot[t];
            Ot[t++] = null;
            var i = Ot[t];
            if (((Ot[t++] = null), l !== null && n !== null)) {
              var c = l.pending;
              (c === null ? (n.next = n) : ((n.next = c.next), (c.next = n)),
                (l.pending = n));
            }
            i !== 0 && to(a, n, i);
          }
        }
        function si(e, t, a, l) {
          ((Ot[gl++] = e),
            (Ot[gl++] = t),
            (Ot[gl++] = a),
            (Ot[gl++] = l),
            ($u |= l),
            (e.lanes |= l),
            (e = e.alternate),
            e !== null && (e.lanes |= l));
        }
        function ku(e, t, a, l) {
          return (si(e, t, a, l), ci(e));
        }
        function qa(e, t) {
          return (si(e, null, null, t), ci(e));
        }
        function to(e, t, a) {
          e.lanes |= a;
          var l = e.alternate;
          l !== null && (l.lanes |= a);
          for (var n = !1, i = e.return; i !== null;)
            ((i.childLanes |= a),
              (l = i.alternate),
              l !== null && (l.childLanes |= a),
              i.tag === 22 &&
                ((e = i.stateNode),
                e === null || e._visibility & 1 || (n = !0)),
              (e = i),
              (i = i.return));
          return e.tag === 3
            ? ((i = e.stateNode),
              n &&
                t !== null &&
                ((n = 31 - gt(a)),
                (e = i.hiddenUpdates),
                (l = e[n]),
                l === null ? (e[n] = [t]) : l.push(t),
                (t.lane = a | 536870912)),
              i)
            : null;
        }
        function ci(e) {
          if (50 < Mn) throw ((Mn = 0), (nc = null), Error(s(185)));
          for (var t = e.return; t !== null;) ((e = t), (t = e.return));
          return e.tag === 3 ? e.stateNode : null;
        }
        var ml = {};
        function tm(e, t, a, l) {
          ((this.tag = e),
            (this.key = a),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.refCleanup = this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = l),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null));
        }
        function pt(e, t, a, l) {
          return new tm(e, t, a, l);
        }
        function Fu(e) {
          return ((e = e.prototype), !(!e || !e.isReactComponent));
        }
        function Jt(e, t) {
          var a = e.alternate;
          return (
            a === null
              ? ((a = pt(e.tag, t, e.key, e.mode)),
                (a.elementType = e.elementType),
                (a.type = e.type),
                (a.stateNode = e.stateNode),
                (a.alternate = e),
                (e.alternate = a))
              : ((a.pendingProps = t),
                (a.type = e.type),
                (a.flags = 0),
                (a.subtreeFlags = 0),
                (a.deletions = null)),
            (a.flags = e.flags & 65011712),
            (a.childLanes = e.childLanes),
            (a.lanes = e.lanes),
            (a.child = e.child),
            (a.memoizedProps = e.memoizedProps),
            (a.memoizedState = e.memoizedState),
            (a.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (a.dependencies =
              t === null
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (a.sibling = e.sibling),
            (a.index = e.index),
            (a.ref = e.ref),
            (a.refCleanup = e.refCleanup),
            a
          );
        }
        function ao(e, t) {
          e.flags &= 65011714;
          var a = e.alternate;
          return (
            a === null
              ? ((e.childLanes = 0),
                (e.lanes = t),
                (e.child = null),
                (e.subtreeFlags = 0),
                (e.memoizedProps = null),
                (e.memoizedState = null),
                (e.updateQueue = null),
                (e.dependencies = null),
                (e.stateNode = null))
              : ((e.childLanes = a.childLanes),
                (e.lanes = a.lanes),
                (e.child = a.child),
                (e.subtreeFlags = 0),
                (e.deletions = null),
                (e.memoizedProps = a.memoizedProps),
                (e.memoizedState = a.memoizedState),
                (e.updateQueue = a.updateQueue),
                (e.type = a.type),
                (t = a.dependencies),
                (e.dependencies =
                  t === null
                    ? null
                    : { lanes: t.lanes, firstContext: t.firstContext })),
            e
          );
        }
        function fi(e, t, a, l, n, i) {
          var c = 0;
          if (((l = e), typeof e == 'function')) Fu(e) && (c = 1);
          else if (typeof e == 'string')
            c = up(e, a, G.current)
              ? 26
              : e === 'html' || e === 'head' || e === 'body'
                ? 27
                : 5;
          else
            e: switch (e) {
              case $:
                return (
                  (e = pt(31, a, t, n)),
                  (e.elementType = $),
                  (e.lanes = i),
                  e
                );
              case B:
                return Ga(a.children, n, i, t);
              case te:
                ((c = 8), (n |= 24));
                break;
              case P:
                return (
                  (e = pt(12, a, t, n | 2)),
                  (e.elementType = P),
                  (e.lanes = i),
                  e
                );
              case Ne:
                return (
                  (e = pt(13, a, t, n)),
                  (e.elementType = Ne),
                  (e.lanes = i),
                  e
                );
              case Ae:
                return (
                  (e = pt(19, a, t, n)),
                  (e.elementType = Ae),
                  (e.lanes = i),
                  e
                );
              default:
                if (typeof e == 'object' && e !== null)
                  switch (e.$$typeof) {
                    case ge:
                      c = 10;
                      break e;
                    case ae:
                      c = 9;
                      break e;
                    case ce:
                      c = 11;
                      break e;
                    case X:
                      c = 14;
                      break e;
                    case Ce:
                      ((c = 16), (l = null));
                      break e;
                  }
                ((c = 29),
                  (a = Error(s(130, e === null ? 'null' : typeof e, ''))),
                  (l = null));
            }
          return (
            (t = pt(c, a, t, n)),
            (t.elementType = e),
            (t.type = l),
            (t.lanes = i),
            t
          );
        }
        function Ga(e, t, a, l) {
          return ((e = pt(7, e, l, t)), (e.lanes = a), e);
        }
        function Wu(e, t, a) {
          return ((e = pt(6, e, null, t)), (e.lanes = a), e);
        }
        function lo(e) {
          var t = pt(18, null, null, 0);
          return ((t.stateNode = e), t);
        }
        function Iu(e, t, a) {
          return (
            (t = pt(4, e.children !== null ? e.children : [], e.key, t)),
            (t.lanes = a),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        var no = new WeakMap();
        function xt(e, t) {
          if (typeof e == 'object' && e !== null) {
            var a = no.get(e);
            return a !== void 0
              ? a
              : ((t = { value: e, source: t, stack: af(t) }), no.set(e, t), t);
          }
          return { value: e, source: t, stack: af(t) };
        }
        var pl = [],
          yl = 0,
          oi = null,
          nn = 0,
          Mt = [],
          zt = 0,
          ra = null,
          qt = 1,
          Gt = '';
        function $t(e, t) {
          ((pl[yl++] = nn), (pl[yl++] = oi), (oi = e), (nn = t));
        }
        function io(e, t, a) {
          ((Mt[zt++] = qt), (Mt[zt++] = Gt), (Mt[zt++] = ra), (ra = e));
          var l = qt;
          e = Gt;
          var n = 32 - gt(l) - 1;
          ((l &= ~(1 << n)), (a += 1));
          var i = 32 - gt(t) + n;
          if (30 < i) {
            var c = n - (n % 5);
            ((i = (l & ((1 << c) - 1)).toString(32)),
              (l >>= c),
              (n -= c),
              (qt = (1 << (32 - gt(t) + n)) | (a << n) | l),
              (Gt = i + e));
          } else ((qt = (1 << i) | (a << n) | l), (Gt = e));
        }
        function Pu(e) {
          e.return !== null && ($t(e, 1), io(e, 1, 0));
        }
        function es(e) {
          for (; e === oi;)
            ((oi = pl[--yl]),
              (pl[yl] = null),
              (nn = pl[--yl]),
              (pl[yl] = null));
          for (; e === ra;)
            ((ra = Mt[--zt]),
              (Mt[zt] = null),
              (Gt = Mt[--zt]),
              (Mt[zt] = null),
              (qt = Mt[--zt]),
              (Mt[zt] = null));
        }
        function uo(e, t) {
          ((Mt[zt++] = qt),
            (Mt[zt++] = Gt),
            (Mt[zt++] = ra),
            (qt = t.id),
            (Gt = t.overflow),
            (ra = e));
        }
        var Fe = null,
          De = null,
          de = !1,
          da = null,
          _t = !1,
          ts = Error(s(519));
        function ha(e) {
          var t = Error(
            s(
              418,
              1 < arguments.length && arguments[1] !== void 0 && arguments[1]
                ? 'text'
                : 'HTML',
              ''
            )
          );
          throw (un(xt(t, e)), ts);
        }
        function so(e) {
          var t = e.stateNode,
            a = e.type,
            l = e.memoizedProps;
          switch (((t[ke] = e), (t[nt] = l), a)) {
            case 'dialog':
              (ie('cancel', t), ie('close', t));
              break;
            case 'iframe':
            case 'object':
            case 'embed':
              ie('load', t);
              break;
            case 'video':
            case 'audio':
              for (a = 0; a < _n.length; a++) ie(_n[a], t);
              break;
            case 'source':
              ie('error', t);
              break;
            case 'img':
            case 'image':
            case 'link':
              (ie('error', t), ie('load', t));
              break;
            case 'details':
              ie('toggle', t);
              break;
            case 'input':
              (ie('invalid', t),
                Sf(
                  t,
                  l.value,
                  l.defaultValue,
                  l.checked,
                  l.defaultChecked,
                  l.type,
                  l.name,
                  !0
                ));
              break;
            case 'select':
              ie('invalid', t);
              break;
            case 'textarea':
              (ie('invalid', t), Ef(t, l.value, l.defaultValue, l.children));
          }
          ((a = l.children),
            (typeof a != 'string' &&
              typeof a != 'number' &&
              typeof a != 'bigint') ||
            t.textContent === '' + a ||
            l.suppressHydrationWarning === !0 ||
            xd(t.textContent, a)
              ? (l.popover != null && (ie('beforetoggle', t), ie('toggle', t)),
                l.onScroll != null && ie('scroll', t),
                l.onScrollEnd != null && ie('scrollend', t),
                l.onClick != null && (t.onclick = Xt),
                (t = !0))
              : (t = !1),
            t || ha(e, !0));
        }
        function co(e) {
          for (Fe = e.return; Fe;)
            switch (Fe.tag) {
              case 5:
              case 31:
              case 13:
                _t = !1;
                return;
              case 27:
              case 3:
                _t = !0;
                return;
              default:
                Fe = Fe.return;
            }
        }
        function vl(e) {
          if (e !== Fe) return !1;
          if (!de) return (co(e), (de = !0), !1);
          var t = e.tag,
            a;
          if (
            ((a = t !== 3 && t !== 27) &&
              ((a = t === 5) &&
                ((a = e.type),
                (a =
                  !(a !== 'form' && a !== 'button') ||
                  bc(e.type, e.memoizedProps))),
              (a = !a)),
            a && De && ha(e),
            co(e),
            t === 13)
          ) {
            if (
              ((e = e.memoizedState),
              (e = e !== null ? e.dehydrated : null),
              !e)
            )
              throw Error(s(317));
            De = Ld(e);
          } else if (t === 31) {
            if (
              ((e = e.memoizedState),
              (e = e !== null ? e.dehydrated : null),
              !e)
            )
              throw Error(s(317));
            De = Ld(e);
          } else
            t === 27
              ? ((t = De),
                za(e.type) ? ((e = Oc), (Oc = null), (De = e)) : (De = t))
              : (De = Fe ? Ct(e.stateNode.nextSibling) : null);
          return !0;
        }
        function Ya() {
          ((De = Fe = null), (de = !1));
        }
        function as() {
          var e = da;
          return (
            e !== null &&
              (ft === null ? (ft = e) : ft.push.apply(ft, e), (da = null)),
            e
          );
        }
        function un(e) {
          da === null ? (da = [e]) : da.push(e);
        }
        var ls = b(null),
          Va = null,
          kt = null;
        function ga(e, t, a) {
          (H(ls, t._currentValue), (t._currentValue = a));
        }
        function Ft(e) {
          ((e._currentValue = ls.current), C(ls));
        }
        function ns(e, t, a) {
          for (; e !== null;) {
            var l = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), l !== null && (l.childLanes |= t))
                : l !== null && (l.childLanes & t) !== t && (l.childLanes |= t),
              e === a)
            )
              break;
            e = e.return;
          }
        }
        function is(e, t, a, l) {
          var n = e.child;
          for (n !== null && (n.return = e); n !== null;) {
            var i = n.dependencies;
            if (i !== null) {
              var c = n.child;
              i = i.firstContext;
              e: for (; i !== null;) {
                var d = i;
                i = n;
                for (var p = 0; p < t.length; p++)
                  if (d.context === t[p]) {
                    ((i.lanes |= a),
                      (d = i.alternate),
                      d !== null && (d.lanes |= a),
                      ns(i.return, a, e),
                      l || (c = null));
                    break e;
                  }
                i = d.next;
              }
            } else if (n.tag === 18) {
              if (((c = n.return), c === null)) throw Error(s(341));
              ((c.lanes |= a),
                (i = c.alternate),
                i !== null && (i.lanes |= a),
                ns(c, a, e),
                (c = null));
            } else c = n.child;
            if (c !== null) c.return = n;
            else
              for (c = n; c !== null;) {
                if (c === e) {
                  c = null;
                  break;
                }
                if (((n = c.sibling), n !== null)) {
                  ((n.return = c.return), (c = n));
                  break;
                }
                c = c.return;
              }
            n = c;
          }
        }
        function bl(e, t, a, l) {
          e = null;
          for (var n = t, i = !1; n !== null;) {
            if (!i) {
              if ((n.flags & 524288) !== 0) i = !0;
              else if ((n.flags & 262144) !== 0) break;
            }
            if (n.tag === 10) {
              var c = n.alternate;
              if (c === null) throw Error(s(387));
              if (((c = c.memoizedProps), c !== null)) {
                var d = n.type;
                mt(n.pendingProps.value, c.value) ||
                  (e !== null ? e.push(d) : (e = [d]));
              }
            } else if (n === Se.current) {
              if (((c = n.alternate), c === null)) throw Error(s(387));
              c.memoizedState.memoizedState !== n.memoizedState.memoizedState &&
                (e !== null ? e.push(jn) : (e = [jn]));
            }
            n = n.return;
          }
          (e !== null && is(t, e, a, l), (t.flags |= 262144));
        }
        function ri(e) {
          for (e = e.firstContext; e !== null;) {
            if (!mt(e.context._currentValue, e.memoizedValue)) return !0;
            e = e.next;
          }
          return !1;
        }
        function wa(e) {
          ((Va = e),
            (kt = null),
            (e = e.dependencies),
            e !== null && (e.firstContext = null));
        }
        function We(e) {
          return fo(Va, e);
        }
        function di(e, t) {
          return (Va === null && wa(e), fo(e, t));
        }
        function fo(e, t) {
          var a = t._currentValue;
          if (
            ((t = { context: t, memoizedValue: a, next: null }), kt === null)
          ) {
            if (e === null) throw Error(s(308));
            ((kt = t),
              (e.dependencies = { lanes: 0, firstContext: t }),
              (e.flags |= 524288));
          } else kt = kt.next = t;
          return a;
        }
        var am =
            typeof AbortController < 'u'
              ? AbortController
              : function () {
                  var e = [],
                    t = (this.signal = {
                      aborted: !1,
                      addEventListener: function (a, l) {
                        e.push(l);
                      },
                    });
                  this.abort = function () {
                    ((t.aborted = !0),
                      e.forEach(function (a) {
                        return a();
                      }));
                  };
                },
          lm = r.unstable_scheduleCallback,
          nm = r.unstable_NormalPriority,
          Ge = {
            $$typeof: ge,
            Consumer: null,
            Provider: null,
            _currentValue: null,
            _currentValue2: null,
            _threadCount: 0,
          };
        function us() {
          return { controller: new am(), data: new Map(), refCount: 0 };
        }
        function sn(e) {
          (e.refCount--,
            e.refCount === 0 &&
              lm(nm, function () {
                e.controller.abort();
              }));
        }
        var cn = null,
          ss = 0,
          Sl = 0,
          Al = null;
        function im(e, t) {
          if (cn === null) {
            var a = (cn = []);
            ((ss = 0),
              (Sl = oc()),
              (Al = {
                status: 'pending',
                value: void 0,
                then: function (l) {
                  a.push(l);
                },
              }));
          }
          return (ss++, t.then(oo, oo), t);
        }
        function oo() {
          if (--ss === 0 && cn !== null) {
            Al !== null && (Al.status = 'fulfilled');
            var e = cn;
            ((cn = null), (Sl = 0), (Al = null));
            for (var t = 0; t < e.length; t++) (0, e[t])();
          }
        }
        function um(e, t) {
          var a = [],
            l = {
              status: 'pending',
              value: null,
              reason: null,
              then: function (n) {
                a.push(n);
              },
            };
          return (
            e.then(
              function () {
                ((l.status = 'fulfilled'), (l.value = t));
                for (var n = 0; n < a.length; n++) (0, a[n])(t);
              },
              function (n) {
                for (
                  l.status = 'rejected', l.reason = n, n = 0;
                  n < a.length;
                  n++
                )
                  (0, a[n])(void 0);
              }
            ),
            l
          );
        }
        var ro = z.S;
        z.S = function (e, t) {
          ((kr = dt()),
            typeof t == 'object' &&
              t !== null &&
              typeof t.then == 'function' &&
              im(e, t),
            ro !== null && ro(e, t));
        };
        var Qa = b(null);
        function cs() {
          var e = Qa.current;
          return e !== null ? e : _e.pooledCache;
        }
        function hi(e, t) {
          t === null ? H(Qa, Qa.current) : H(Qa, t.pool);
        }
        function ho() {
          var e = cs();
          return e === null ? null : { parent: Ge._currentValue, pool: e };
        }
        var El = Error(s(460)),
          fs = Error(s(474)),
          gi = Error(s(542)),
          mi = { then: function () {} };
        function go(e) {
          return ((e = e.status), e === 'fulfilled' || e === 'rejected');
        }
        function mo(e, t, a) {
          switch (
            ((a = e[a]),
            a === void 0 ? e.push(t) : a !== t && (t.then(Xt, Xt), (t = a)),
            t.status)
          ) {
            case 'fulfilled':
              return t.value;
            case 'rejected':
              throw ((e = t.reason), yo(e), e);
            default:
              if (typeof t.status == 'string') t.then(Xt, Xt);
              else {
                if (((e = _e), e !== null && 100 < e.shellSuspendCounter))
                  throw Error(s(482));
                ((e = t),
                  (e.status = 'pending'),
                  e.then(
                    function (l) {
                      if (t.status === 'pending') {
                        var n = t;
                        ((n.status = 'fulfilled'), (n.value = l));
                      }
                    },
                    function (l) {
                      if (t.status === 'pending') {
                        var n = t;
                        ((n.status = 'rejected'), (n.reason = l));
                      }
                    }
                  ));
              }
              switch (t.status) {
                case 'fulfilled':
                  return t.value;
                case 'rejected':
                  throw ((e = t.reason), yo(e), e);
              }
              throw ((Za = t), El);
          }
        }
        function Xa(e) {
          try {
            var t = e._init;
            return t(e._payload);
          } catch (a) {
            throw a !== null &&
              typeof a == 'object' &&
              typeof a.then == 'function'
              ? ((Za = a), El)
              : a;
          }
        }
        var Za = null;
        function po() {
          if (Za === null) throw Error(s(459));
          var e = Za;
          return ((Za = null), e);
        }
        function yo(e) {
          if (e === El || e === gi) throw Error(s(483));
        }
        var Tl = null,
          fn = 0;
        function pi(e) {
          var t = fn;
          return ((fn += 1), Tl === null && (Tl = []), mo(Tl, e, t));
        }
        function on(e, t) {
          ((t = t.props.ref), (e.ref = t !== void 0 ? t : null));
        }
        function yi(e, t) {
          throw t.$$typeof === L
            ? Error(s(525))
            : ((e = Object.prototype.toString.call(t)),
              Error(
                s(
                  31,
                  e === '[object Object]'
                    ? 'object with keys {' + Object.keys(t).join(', ') + '}'
                    : e
                )
              ));
        }
        function vo(e) {
          function t(A, S) {
            if (e) {
              var T = A.deletions;
              T === null ? ((A.deletions = [S]), (A.flags |= 16)) : T.push(S);
            }
          }
          function a(A, S) {
            if (!e) return null;
            for (; S !== null;) (t(A, S), (S = S.sibling));
            return null;
          }
          function l(A) {
            for (var S = new Map(); A !== null;)
              (A.key !== null ? S.set(A.key, A) : S.set(A.index, A),
                (A = A.sibling));
            return S;
          }
          function n(A, S) {
            return ((A = Jt(A, S)), (A.index = 0), (A.sibling = null), A);
          }
          function i(A, S, T) {
            return (
              (A.index = T),
              e
                ? ((T = A.alternate),
                  T !== null
                    ? ((T = T.index), T < S ? ((A.flags |= 67108866), S) : T)
                    : ((A.flags |= 67108866), S))
                : ((A.flags |= 1048576), S)
            );
          }
          function c(A) {
            return (e && A.alternate === null && (A.flags |= 67108866), A);
          }
          function d(A, S, T, D) {
            return S === null || S.tag !== 6
              ? ((S = Wu(T, A.mode, D)), (S.return = A), S)
              : ((S = n(S, T)), (S.return = A), S);
          }
          function p(A, S, T, D) {
            var w = T.type;
            return w === B
              ? N(A, S, T.props.children, D, T.key)
              : S !== null &&
                  (S.elementType === w ||
                    (typeof w == 'object' &&
                      w !== null &&
                      w.$$typeof === Ce &&
                      Xa(w) === S.type))
                ? ((S = n(S, T.props)), on(S, T), (S.return = A), S)
                : ((S = fi(T.type, T.key, T.props, null, A.mode, D)),
                  on(S, T),
                  (S.return = A),
                  S);
          }
          function O(A, S, T, D) {
            return S === null ||
              S.tag !== 4 ||
              S.stateNode.containerInfo !== T.containerInfo ||
              S.stateNode.implementation !== T.implementation
              ? ((S = Iu(T, A.mode, D)), (S.return = A), S)
              : ((S = n(S, T.children || [])), (S.return = A), S);
          }
          function N(A, S, T, D, w) {
            return S === null || S.tag !== 7
              ? ((S = Ga(T, A.mode, D, w)), (S.return = A), S)
              : ((S = n(S, T)), (S.return = A), S);
          }
          function R(A, S, T) {
            if (
              (typeof S == 'string' && S !== '') ||
              typeof S == 'number' ||
              typeof S == 'bigint'
            )
              return ((S = Wu('' + S, A.mode, T)), (S.return = A), S);
            if (typeof S == 'object' && S !== null) {
              switch (S.$$typeof) {
                case q:
                  return (
                    (T = fi(S.type, S.key, S.props, null, A.mode, T)),
                    on(T, S),
                    (T.return = A),
                    T
                  );
                case K:
                  return ((S = Iu(S, A.mode, T)), (S.return = A), S);
                case Ce:
                  return ((S = Xa(S)), R(A, S, T));
              }
              if (Xe(S) || oe(S))
                return ((S = Ga(S, A.mode, T, null)), (S.return = A), S);
              if (typeof S.then == 'function') return R(A, pi(S), T);
              if (S.$$typeof === ge) return R(A, di(A, S), T);
              yi(A, S);
            }
            return null;
          }
          function x(A, S, T, D) {
            var w = S !== null ? S.key : null;
            if (
              (typeof T == 'string' && T !== '') ||
              typeof T == 'number' ||
              typeof T == 'bigint'
            )
              return w !== null ? null : d(A, S, '' + T, D);
            if (typeof T == 'object' && T !== null) {
              switch (T.$$typeof) {
                case q:
                  return T.key === w ? p(A, S, T, D) : null;
                case K:
                  return T.key === w ? O(A, S, T, D) : null;
                case Ce:
                  return ((T = Xa(T)), x(A, S, T, D));
              }
              if (Xe(T) || oe(T))
                return w !== null ? null : N(A, S, T, D, null);
              if (typeof T.then == 'function') return x(A, S, pi(T), D);
              if (T.$$typeof === ge) return x(A, S, di(A, T), D);
              yi(A, T);
            }
            return null;
          }
          function M(A, S, T, D, w) {
            if (
              (typeof D == 'string' && D !== '') ||
              typeof D == 'number' ||
              typeof D == 'bigint'
            )
              return ((A = A.get(T) || null), d(S, A, '' + D, w));
            if (typeof D == 'object' && D !== null) {
              switch (D.$$typeof) {
                case q:
                  return (
                    (A = A.get(D.key === null ? T : D.key) || null),
                    p(S, A, D, w)
                  );
                case K:
                  return (
                    (A = A.get(D.key === null ? T : D.key) || null),
                    O(S, A, D, w)
                  );
                case Ce:
                  return ((D = Xa(D)), M(A, S, T, D, w));
              }
              if (Xe(D) || oe(D))
                return ((A = A.get(T) || null), N(S, A, D, w, null));
              if (typeof D.then == 'function') return M(A, S, T, pi(D), w);
              if (D.$$typeof === ge) return M(A, S, T, di(S, D), w);
              yi(S, D);
            }
            return null;
          }
          function Y(A, S, T, D) {
            for (
              var w = null, pe = null, V = S, ee = (S = 0), se = null;
              V !== null && ee < T.length;
              ee++
            ) {
              V.index > ee ? ((se = V), (V = null)) : (se = V.sibling);
              var ye = x(A, V, T[ee], D);
              if (ye === null) {
                V === null && (V = se);
                break;
              }
              (e && V && ye.alternate === null && t(A, V),
                (S = i(ye, S, ee)),
                pe === null ? (w = ye) : (pe.sibling = ye),
                (pe = ye),
                (V = se));
            }
            if (ee === T.length) return (a(A, V), de && $t(A, ee), w);
            if (V === null) {
              for (; ee < T.length; ee++)
                ((V = R(A, T[ee], D)),
                  V !== null &&
                    ((S = i(V, S, ee)),
                    pe === null ? (w = V) : (pe.sibling = V),
                    (pe = V)));
              return (de && $t(A, ee), w);
            }
            for (V = l(V); ee < T.length; ee++)
              ((se = M(V, A, ee, T[ee], D)),
                se !== null &&
                  (e &&
                    se.alternate !== null &&
                    V.delete(se.key === null ? ee : se.key),
                  (S = i(se, S, ee)),
                  pe === null ? (w = se) : (pe.sibling = se),
                  (pe = se)));
            return (
              e &&
                V.forEach(function (Ra) {
                  return t(A, Ra);
                }),
              de && $t(A, ee),
              w
            );
          }
          function Z(A, S, T, D) {
            if (T == null) throw Error(s(151));
            for (
              var w = null,
                pe = null,
                V = S,
                ee = (S = 0),
                se = null,
                ye = T.next();
              V !== null && !ye.done;
              ee++, ye = T.next()
            ) {
              V.index > ee ? ((se = V), (V = null)) : (se = V.sibling);
              var Ra = x(A, V, ye.value, D);
              if (Ra === null) {
                V === null && (V = se);
                break;
              }
              (e && V && Ra.alternate === null && t(A, V),
                (S = i(Ra, S, ee)),
                pe === null ? (w = Ra) : (pe.sibling = Ra),
                (pe = Ra),
                (V = se));
            }
            if (ye.done) return (a(A, V), de && $t(A, ee), w);
            if (V === null) {
              for (; !ye.done; ee++, ye = T.next())
                ((ye = R(A, ye.value, D)),
                  ye !== null &&
                    ((S = i(ye, S, ee)),
                    pe === null ? (w = ye) : (pe.sibling = ye),
                    (pe = ye)));
              return (de && $t(A, ee), w);
            }
            for (V = l(V); !ye.done; ee++, ye = T.next())
              ((ye = M(V, A, ee, ye.value, D)),
                ye !== null &&
                  (e &&
                    ye.alternate !== null &&
                    V.delete(ye.key === null ? ee : ye.key),
                  (S = i(ye, S, ee)),
                  pe === null ? (w = ye) : (pe.sibling = ye),
                  (pe = ye)));
            return (
              e &&
                V.forEach(function (yp) {
                  return t(A, yp);
                }),
              de && $t(A, ee),
              w
            );
          }
          function Me(A, S, T, D) {
            if (
              (typeof T == 'object' &&
                T !== null &&
                T.type === B &&
                T.key === null &&
                (T = T.props.children),
              typeof T == 'object' && T !== null)
            ) {
              switch (T.$$typeof) {
                case q:
                  e: {
                    for (var w = T.key; S !== null;) {
                      if (S.key === w) {
                        if (((w = T.type), w === B)) {
                          if (S.tag === 7) {
                            (a(A, S.sibling),
                              (D = n(S, T.props.children)),
                              (D.return = A),
                              (A = D));
                            break e;
                          }
                        } else if (
                          S.elementType === w ||
                          (typeof w == 'object' &&
                            w !== null &&
                            w.$$typeof === Ce &&
                            Xa(w) === S.type)
                        ) {
                          (a(A, S.sibling),
                            (D = n(S, T.props)),
                            on(D, T),
                            (D.return = A),
                            (A = D));
                          break e;
                        }
                        a(A, S);
                        break;
                      } else t(A, S);
                      S = S.sibling;
                    }
                    T.type === B
                      ? ((D = Ga(T.props.children, A.mode, D, T.key)),
                        (D.return = A),
                        (A = D))
                      : ((D = fi(T.type, T.key, T.props, null, A.mode, D)),
                        on(D, T),
                        (D.return = A),
                        (A = D));
                  }
                  return c(A);
                case K:
                  e: {
                    for (w = T.key; S !== null;) {
                      if (S.key === w)
                        if (
                          S.tag === 4 &&
                          S.stateNode.containerInfo === T.containerInfo &&
                          S.stateNode.implementation === T.implementation
                        ) {
                          (a(A, S.sibling),
                            (D = n(S, T.children || [])),
                            (D.return = A),
                            (A = D));
                          break e;
                        } else {
                          a(A, S);
                          break;
                        }
                      else t(A, S);
                      S = S.sibling;
                    }
                    ((D = Iu(T, A.mode, D)), (D.return = A), (A = D));
                  }
                  return c(A);
                case Ce:
                  return ((T = Xa(T)), Me(A, S, T, D));
              }
              if (Xe(T)) return Y(A, S, T, D);
              if (oe(T)) {
                if (((w = oe(T)), typeof w != 'function')) throw Error(s(150));
                return ((T = w.call(T)), Z(A, S, T, D));
              }
              if (typeof T.then == 'function') return Me(A, S, pi(T), D);
              if (T.$$typeof === ge) return Me(A, S, di(A, T), D);
              yi(A, T);
            }
            return (typeof T == 'string' && T !== '') ||
              typeof T == 'number' ||
              typeof T == 'bigint'
              ? ((T = '' + T),
                S !== null && S.tag === 6
                  ? (a(A, S.sibling), (D = n(S, T)), (D.return = A), (A = D))
                  : (a(A, S), (D = Wu(T, A.mode, D)), (D.return = A), (A = D)),
                c(A))
              : a(A, S);
          }
          return function (A, S, T, D) {
            try {
              fn = 0;
              var w = Me(A, S, T, D);
              return ((Tl = null), w);
            } catch (V) {
              if (V === El || V === gi) throw V;
              var pe = pt(29, V, null, A.mode);
              return ((pe.lanes = D), (pe.return = A), pe);
            } finally {
            }
          };
        }
        var Ja = vo(!0),
          bo = vo(!1),
          ma = !1;
        function os(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, lanes: 0, hiddenCallbacks: null },
            callbacks: null,
          };
        }
        function rs(e, t) {
          ((e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                callbacks: null,
              }));
        }
        function pa(e) {
          return { lane: e, tag: 0, payload: null, callback: null, next: null };
        }
        function ya(e, t, a) {
          var l = e.updateQueue;
          if (l === null) return null;
          if (((l = l.shared), (ve & 2) !== 0)) {
            var n = l.pending;
            return (
              n === null ? (t.next = t) : ((t.next = n.next), (n.next = t)),
              (l.pending = t),
              (t = ci(e)),
              to(e, null, a),
              t
            );
          }
          return (si(e, l, t, a), ci(e));
        }
        function rn(e, t, a) {
          if (
            ((t = t.updateQueue),
            t !== null && ((t = t.shared), (a & 4194048) !== 0))
          ) {
            var l = t.lanes;
            ((l &= e.pendingLanes), (a |= l), (t.lanes = a), ff(e, a));
          }
        }
        function ds(e, t) {
          var a = e.updateQueue,
            l = e.alternate;
          if (l !== null && ((l = l.updateQueue), a === l)) {
            var n = null,
              i = null;
            if (((a = a.firstBaseUpdate), a !== null)) {
              do {
                var c = {
                  lane: a.lane,
                  tag: a.tag,
                  payload: a.payload,
                  callback: null,
                  next: null,
                };
                (i === null ? (n = i = c) : (i = i.next = c), (a = a.next));
              } while (a !== null);
              i === null ? (n = i = t) : (i = i.next = t);
            } else n = i = t;
            ((a = {
              baseState: l.baseState,
              firstBaseUpdate: n,
              lastBaseUpdate: i,
              shared: l.shared,
              callbacks: l.callbacks,
            }),
              (e.updateQueue = a));
            return;
          }
          ((e = a.lastBaseUpdate),
            e === null ? (a.firstBaseUpdate = t) : (e.next = t),
            (a.lastBaseUpdate = t));
        }
        var hs = !1;
        function dn() {
          if (hs) {
            var e = Al;
            if (e !== null) throw e;
          }
        }
        function hn(e, t, a, l) {
          hs = !1;
          var n = e.updateQueue;
          ma = !1;
          var i = n.firstBaseUpdate,
            c = n.lastBaseUpdate,
            d = n.shared.pending;
          if (d !== null) {
            n.shared.pending = null;
            var p = d,
              O = p.next;
            ((p.next = null), c === null ? (i = O) : (c.next = O), (c = p));
            var N = e.alternate;
            N !== null &&
              ((N = N.updateQueue),
              (d = N.lastBaseUpdate),
              d !== c &&
                (d === null ? (N.firstBaseUpdate = O) : (d.next = O),
                (N.lastBaseUpdate = p)));
          }
          if (i !== null) {
            var R = n.baseState;
            ((c = 0), (N = O = p = null), (d = i));
            do {
              var x = d.lane & -536870913,
                M = x !== d.lane;
              if (M ? (ue & x) === x : (l & x) === x) {
                (x !== 0 && x === Sl && (hs = !0),
                  N !== null &&
                    (N = N.next =
                      {
                        lane: 0,
                        tag: d.tag,
                        payload: d.payload,
                        callback: null,
                        next: null,
                      }));
                e: {
                  var Y = e,
                    Z = d;
                  x = t;
                  var Me = a;
                  switch (Z.tag) {
                    case 1:
                      if (((Y = Z.payload), typeof Y == 'function')) {
                        R = Y.call(Me, R, x);
                        break e;
                      }
                      R = Y;
                      break e;
                    case 3:
                      Y.flags = (Y.flags & -65537) | 128;
                    case 0:
                      if (
                        ((Y = Z.payload),
                        (x = typeof Y == 'function' ? Y.call(Me, R, x) : Y),
                        x == null)
                      )
                        break e;
                      R = E({}, R, x);
                      break e;
                    case 2:
                      ma = !0;
                  }
                }
                ((x = d.callback),
                  x !== null &&
                    ((e.flags |= 64),
                    M && (e.flags |= 8192),
                    (M = n.callbacks),
                    M === null ? (n.callbacks = [x]) : M.push(x)));
              } else
                ((M = {
                  lane: x,
                  tag: d.tag,
                  payload: d.payload,
                  callback: d.callback,
                  next: null,
                }),
                  N === null ? ((O = N = M), (p = R)) : (N = N.next = M),
                  (c |= x));
              if (((d = d.next), d === null)) {
                if (((d = n.shared.pending), d === null)) break;
                ((M = d),
                  (d = M.next),
                  (M.next = null),
                  (n.lastBaseUpdate = M),
                  (n.shared.pending = null));
              }
            } while (!0);
            (N === null && (p = R),
              (n.baseState = p),
              (n.firstBaseUpdate = O),
              (n.lastBaseUpdate = N),
              i === null && (n.shared.lanes = 0),
              (Ea |= c),
              (e.lanes = c),
              (e.memoizedState = R));
          }
        }
        function So(e, t) {
          if (typeof e != 'function') throw Error(s(191, e));
          e.call(t);
        }
        function Ao(e, t) {
          var a = e.callbacks;
          if (a !== null)
            for (e.callbacks = null, e = 0; e < a.length; e++) So(a[e], t);
        }
        var Ol = b(null),
          vi = b(0);
        function Eo(e, t) {
          ((e = ia), H(vi, e), H(Ol, t), (ia = e | t.baseLanes));
        }
        function gs() {
          (H(vi, ia), H(Ol, Ol.current));
        }
        function ms() {
          ((ia = vi.current), C(Ol), C(vi));
        }
        var yt = b(null),
          Nt = null;
        function va(e) {
          var t = e.alternate;
          (H(Be, Be.current & 1),
            H(yt, e),
            Nt === null &&
              (t === null || Ol.current !== null || t.memoizedState !== null) &&
              (Nt = e));
        }
        function ps(e) {
          (H(Be, Be.current), H(yt, e), Nt === null && (Nt = e));
        }
        function To(e) {
          e.tag === 22
            ? (H(Be, Be.current), H(yt, e), Nt === null && (Nt = e))
            : ba();
        }
        function ba() {
          (H(Be, Be.current), H(yt, yt.current));
        }
        function vt(e) {
          (C(yt), Nt === e && (Nt = null), C(Be));
        }
        var Be = b(0);
        function bi(e) {
          for (var t = e; t !== null;) {
            if (t.tag === 13) {
              var a = t.memoizedState;
              if (
                a !== null &&
                ((a = a.dehydrated), a === null || Ec(a) || Tc(a))
              )
                return t;
            } else if (
              t.tag === 19 &&
              (t.memoizedProps.revealOrder === 'forwards' ||
                t.memoizedProps.revealOrder === 'backwards' ||
                t.memoizedProps.revealOrder === 'unstable_legacy-backwards' ||
                t.memoizedProps.revealOrder === 'together')
            ) {
              if ((t.flags & 128) !== 0) return t;
            } else if (t.child !== null) {
              ((t.child.return = t), (t = t.child));
              continue;
            }
            if (t === e) break;
            for (; t.sibling === null;) {
              if (t.return === null || t.return === e) return null;
              t = t.return;
            }
            ((t.sibling.return = t.return), (t = t.sibling));
          }
          return null;
        }
        var Wt = 0,
          I = null,
          Oe = null,
          Ye = null,
          Si = !1,
          xl = !1,
          $a = !1,
          Ai = 0,
          gn = 0,
          Ml = null,
          sm = 0;
        function Le() {
          throw Error(s(321));
        }
        function ys(e, t) {
          if (t === null) return !1;
          for (var a = 0; a < t.length && a < e.length; a++)
            if (!mt(e[a], t[a])) return !1;
          return !0;
        }
        function vs(e, t, a, l, n, i) {
          return (
            (Wt = i),
            (I = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (z.H = e === null || e.memoizedState === null ? ur : js),
            ($a = !1),
            (i = a(l, n)),
            ($a = !1),
            xl && (i = xo(t, a, l, n)),
            Oo(e),
            i
          );
        }
        function Oo(e) {
          z.H = yn;
          var t = Oe !== null && Oe.next !== null;
          if (
            ((Wt = 0),
            (Ye = Oe = I = null),
            (Si = !1),
            (gn = 0),
            (Ml = null),
            t)
          )
            throw Error(s(300));
          e === null ||
            Ve ||
            ((e = e.dependencies), e !== null && ri(e) && (Ve = !0));
        }
        function xo(e, t, a, l) {
          I = e;
          var n = 0;
          do {
            if ((xl && (Ml = null), (gn = 0), (xl = !1), 25 <= n))
              throw Error(s(301));
            if (((n += 1), (Ye = Oe = null), e.updateQueue != null)) {
              var i = e.updateQueue;
              ((i.lastEffect = null),
                (i.events = null),
                (i.stores = null),
                i.memoCache != null && (i.memoCache.index = 0));
            }
            ((z.H = sr), (i = t(a, l)));
          } while (xl);
          return i;
        }
        function cm() {
          var e = z.H,
            t = e.useState()[0];
          return (
            (t = typeof t.then == 'function' ? mn(t) : t),
            (e = e.useState()[0]),
            (Oe !== null ? Oe.memoizedState : null) !== e && (I.flags |= 1024),
            t
          );
        }
        function bs() {
          var e = Ai !== 0;
          return ((Ai = 0), e);
        }
        function Ss(e, t, a) {
          ((t.updateQueue = e.updateQueue),
            (t.flags &= -2053),
            (e.lanes &= ~a));
        }
        function As(e) {
          if (Si) {
            for (e = e.memoizedState; e !== null;) {
              var t = e.queue;
              (t !== null && (t.pending = null), (e = e.next));
            }
            Si = !1;
          }
          ((Wt = 0),
            (Ye = Oe = I = null),
            (xl = !1),
            (gn = Ai = 0),
            (Ml = null));
        }
        function at() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            Ye === null ? (I.memoizedState = Ye = e) : (Ye = Ye.next = e),
            Ye
          );
        }
        function Ke() {
          if (Oe === null) {
            var e = I.alternate;
            e = e !== null ? e.memoizedState : null;
          } else e = Oe.next;
          var t = Ye === null ? I.memoizedState : Ye.next;
          if (t !== null) ((Ye = t), (Oe = e));
          else {
            if (e === null)
              throw I.alternate === null ? Error(s(467)) : Error(s(310));
            ((Oe = e),
              (e = {
                memoizedState: Oe.memoizedState,
                baseState: Oe.baseState,
                baseQueue: Oe.baseQueue,
                queue: Oe.queue,
                next: null,
              }),
              Ye === null ? (I.memoizedState = Ye = e) : (Ye = Ye.next = e));
          }
          return Ye;
        }
        function Ei() {
          return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null,
          };
        }
        function mn(e) {
          var t = gn;
          return (
            (gn += 1),
            Ml === null && (Ml = []),
            (e = mo(Ml, e, t)),
            (t = I),
            (Ye === null ? t.memoizedState : Ye.next) === null &&
              ((t = t.alternate),
              (z.H = t === null || t.memoizedState === null ? ur : js)),
            e
          );
        }
        function Ti(e) {
          if (e !== null && typeof e == 'object') {
            if (typeof e.then == 'function') return mn(e);
            if (e.$$typeof === ge) return We(e);
          }
          throw Error(s(438, String(e)));
        }
        function Es(e) {
          var t = null,
            a = I.updateQueue;
          if ((a !== null && (t = a.memoCache), t == null)) {
            var l = I.alternate;
            l !== null &&
              ((l = l.updateQueue),
              l !== null &&
                ((l = l.memoCache),
                l != null &&
                  (t = {
                    data: l.data.map(function (n) {
                      return n.slice();
                    }),
                    index: 0,
                  })));
          }
          if (
            (t == null && (t = { data: [], index: 0 }),
            a === null && ((a = Ei()), (I.updateQueue = a)),
            (a.memoCache = t),
            (a = t.data[t.index]),
            a === void 0)
          )
            for (a = t.data[t.index] = Array(e), l = 0; l < e; l++) a[l] = F;
          return (t.index++, a);
        }
        function It(e, t) {
          return typeof t == 'function' ? t(e) : t;
        }
        function Oi(e) {
          var t = Ke();
          return Ts(t, Oe, e);
        }
        function Ts(e, t, a) {
          var l = e.queue;
          if (l === null) throw Error(s(311));
          l.lastRenderedReducer = a;
          var n = e.baseQueue,
            i = l.pending;
          if (i !== null) {
            if (n !== null) {
              var c = n.next;
              ((n.next = i.next), (i.next = c));
            }
            ((t.baseQueue = n = i), (l.pending = null));
          }
          if (((i = e.baseState), n === null)) e.memoizedState = i;
          else {
            t = n.next;
            var d = (c = null),
              p = null,
              O = t,
              N = !1;
            do {
              var R = O.lane & -536870913;
              if (R !== O.lane ? (ue & R) === R : (Wt & R) === R) {
                var x = O.revertLane;
                if (x === 0)
                  (p !== null &&
                    (p = p.next =
                      {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: O.action,
                        hasEagerState: O.hasEagerState,
                        eagerState: O.eagerState,
                        next: null,
                      }),
                    R === Sl && (N = !0));
                else if ((Wt & x) === x) {
                  ((O = O.next), x === Sl && (N = !0));
                  continue;
                } else
                  ((R = {
                    lane: 0,
                    revertLane: O.revertLane,
                    gesture: null,
                    action: O.action,
                    hasEagerState: O.hasEagerState,
                    eagerState: O.eagerState,
                    next: null,
                  }),
                    p === null ? ((d = p = R), (c = i)) : (p = p.next = R),
                    (I.lanes |= x),
                    (Ea |= x));
                ((R = O.action),
                  $a && a(i, R),
                  (i = O.hasEagerState ? O.eagerState : a(i, R)));
              } else
                ((x = {
                  lane: R,
                  revertLane: O.revertLane,
                  gesture: O.gesture,
                  action: O.action,
                  hasEagerState: O.hasEagerState,
                  eagerState: O.eagerState,
                  next: null,
                }),
                  p === null ? ((d = p = x), (c = i)) : (p = p.next = x),
                  (I.lanes |= R),
                  (Ea |= R));
              O = O.next;
            } while (O !== null && O !== t);
            if (
              (p === null ? (c = i) : (p.next = d),
              !mt(i, e.memoizedState) &&
                ((Ve = !0), N && ((a = Al), a !== null)))
            )
              throw a;
            ((e.memoizedState = i),
              (e.baseState = c),
              (e.baseQueue = p),
              (l.lastRenderedState = i));
          }
          return (n === null && (l.lanes = 0), [e.memoizedState, l.dispatch]);
        }
        function Os(e) {
          var t = Ke(),
            a = t.queue;
          if (a === null) throw Error(s(311));
          a.lastRenderedReducer = e;
          var l = a.dispatch,
            n = a.pending,
            i = t.memoizedState;
          if (n !== null) {
            a.pending = null;
            var c = (n = n.next);
            do ((i = e(i, c.action)), (c = c.next));
            while (c !== n);
            (mt(i, t.memoizedState) || (Ve = !0),
              (t.memoizedState = i),
              t.baseQueue === null && (t.baseState = i),
              (a.lastRenderedState = i));
          }
          return [i, l];
        }
        function Mo(e, t, a) {
          var l = I,
            n = Ke(),
            i = de;
          if (i) {
            if (a === void 0) throw Error(s(407));
            a = a();
          } else a = t();
          var c = !mt((Oe || n).memoizedState, a);
          if (
            (c && ((n.memoizedState = a), (Ve = !0)),
            (n = n.queue),
            zs(No.bind(null, l, n, e), [e]),
            n.getSnapshot !== t ||
              c ||
              (Ye !== null && Ye.memoizedState.tag & 1))
          ) {
            if (
              ((l.flags |= 2048),
              zl(9, { destroy: void 0 }, _o.bind(null, l, n, a, t), null),
              _e === null)
            )
              throw Error(s(349));
            i || (Wt & 127) !== 0 || zo(l, t, a);
          }
          return a;
        }
        function zo(e, t, a) {
          ((e.flags |= 16384),
            (e = { getSnapshot: t, value: a }),
            (t = I.updateQueue),
            t === null
              ? ((t = Ei()), (I.updateQueue = t), (t.stores = [e]))
              : ((a = t.stores), a === null ? (t.stores = [e]) : a.push(e)));
        }
        function _o(e, t, a, l) {
          ((t.value = a), (t.getSnapshot = l), Co(t) && Do(e));
        }
        function No(e, t, a) {
          return a(function () {
            Co(t) && Do(e);
          });
        }
        function Co(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var a = t();
            return !mt(e, a);
          } catch {
            return !0;
          }
        }
        function Do(e) {
          var t = qa(e, 2);
          t !== null && ot(t, e, 2);
        }
        function xs(e) {
          var t = at();
          if (typeof e == 'function') {
            var a = e;
            if (((e = a()), $a)) {
              ca(!0);
              try {
                a();
              } finally {
                ca(!1);
              }
            }
          }
          return (
            (t.memoizedState = t.baseState = e),
            (t.queue = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: It,
              lastRenderedState: e,
            }),
            t
          );
        }
        function Ro(e, t, a, l) {
          return (
            (e.baseState = a),
            Ts(e, Oe, typeof l == 'function' ? l : It)
          );
        }
        function fm(e, t, a, l, n) {
          if (zi(e)) throw Error(s(485));
          if (((e = t.action), e !== null)) {
            var i = {
              payload: n,
              action: e,
              next: null,
              isTransition: !0,
              status: 'pending',
              value: null,
              reason: null,
              listeners: [],
              then: function (c) {
                i.listeners.push(c);
              },
            };
            (z.T !== null ? a(!0) : (i.isTransition = !1),
              l(i),
              (a = t.pending),
              a === null
                ? ((i.next = t.pending = i), jo(t, i))
                : ((i.next = a.next), (t.pending = a.next = i)));
          }
        }
        function jo(e, t) {
          var a = t.action,
            l = t.payload,
            n = e.state;
          if (t.isTransition) {
            var i = z.T,
              c = {};
            z.T = c;
            try {
              var d = a(n, l),
                p = z.S;
              (p !== null && p(c, d), Lo(e, t, d));
            } catch (O) {
              Ms(e, t, O);
            } finally {
              (i !== null && c.types !== null && (i.types = c.types),
                (z.T = i));
            }
          } else
            try {
              ((i = a(n, l)), Lo(e, t, i));
            } catch (O) {
              Ms(e, t, O);
            }
        }
        function Lo(e, t, a) {
          a !== null && typeof a == 'object' && typeof a.then == 'function'
            ? a.then(
                function (l) {
                  Uo(e, t, l);
                },
                function (l) {
                  return Ms(e, t, l);
                }
              )
            : Uo(e, t, a);
        }
        function Uo(e, t, a) {
          ((t.status = 'fulfilled'),
            (t.value = a),
            Ho(t),
            (e.state = a),
            (t = e.pending),
            t !== null &&
              ((a = t.next),
              a === t
                ? (e.pending = null)
                : ((a = a.next), (t.next = a), jo(e, a))));
        }
        function Ms(e, t, a) {
          var l = e.pending;
          if (((e.pending = null), l !== null)) {
            l = l.next;
            do ((t.status = 'rejected'), (t.reason = a), Ho(t), (t = t.next));
            while (t !== l);
          }
          e.action = null;
        }
        function Ho(e) {
          e = e.listeners;
          for (var t = 0; t < e.length; t++) (0, e[t])();
        }
        function Bo(e, t) {
          return t;
        }
        function Ko(e, t) {
          if (de) {
            var a = _e.formState;
            if (a !== null) {
              e: {
                var l = I;
                if (de) {
                  if (De) {
                    t: {
                      for (var n = De, i = _t; n.nodeType !== 8;) {
                        if (!i) {
                          n = null;
                          break t;
                        }
                        if (((n = Ct(n.nextSibling)), n === null)) {
                          n = null;
                          break t;
                        }
                      }
                      ((i = n.data), (n = i === 'F!' || i === 'F' ? n : null));
                    }
                    if (n) {
                      ((De = Ct(n.nextSibling)), (l = n.data === 'F!'));
                      break e;
                    }
                  }
                  ha(l);
                }
                l = !1;
              }
              l && (t = a[0]);
            }
          }
          return (
            (a = at()),
            (a.memoizedState = a.baseState = t),
            (l = {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Bo,
              lastRenderedState: t,
            }),
            (a.queue = l),
            (a = lr.bind(null, I, l)),
            (l.dispatch = a),
            (l = xs(!1)),
            (i = Rs.bind(null, I, !1, l.queue)),
            (l = at()),
            (n = { state: t, dispatch: null, action: e, pending: null }),
            (l.queue = n),
            (a = fm.bind(null, I, n, i, a)),
            (n.dispatch = a),
            (l.memoizedState = e),
            [t, a, !1]
          );
        }
        function qo(e) {
          var t = Ke();
          return Go(t, Oe, e);
        }
        function Go(e, t, a) {
          if (
            ((t = Ts(e, t, Bo)[0]),
            (e = Oi(It)[0]),
            typeof t == 'object' && t !== null && typeof t.then == 'function')
          )
            try {
              var l = mn(t);
            } catch (c) {
              throw c === El ? gi : c;
            }
          else l = t;
          t = Ke();
          var n = t.queue,
            i = n.dispatch;
          return (
            a !== t.memoizedState &&
              ((I.flags |= 2048),
              zl(9, { destroy: void 0 }, om.bind(null, n, a), null)),
            [l, i, e]
          );
        }
        function om(e, t) {
          e.action = t;
        }
        function Yo(e) {
          var t = Ke(),
            a = Oe;
          if (a !== null) return Go(t, a, e);
          (Ke(), (t = t.memoizedState), (a = Ke()));
          var l = a.queue.dispatch;
          return ((a.memoizedState = e), [t, l, !1]);
        }
        function zl(e, t, a, l) {
          return (
            (e = { tag: e, create: a, deps: l, inst: t, next: null }),
            (t = I.updateQueue),
            t === null && ((t = Ei()), (I.updateQueue = t)),
            (a = t.lastEffect),
            a === null
              ? (t.lastEffect = e.next = e)
              : ((l = a.next), (a.next = e), (e.next = l), (t.lastEffect = e)),
            e
          );
        }
        function Vo() {
          return Ke().memoizedState;
        }
        function xi(e, t, a, l) {
          var n = at();
          ((I.flags |= e),
            (n.memoizedState = zl(
              1 | t,
              { destroy: void 0 },
              a,
              l === void 0 ? null : l
            )));
        }
        function Mi(e, t, a, l) {
          var n = Ke();
          l = l === void 0 ? null : l;
          var i = n.memoizedState.inst;
          Oe !== null && l !== null && ys(l, Oe.memoizedState.deps)
            ? (n.memoizedState = zl(t, i, a, l))
            : ((I.flags |= e), (n.memoizedState = zl(1 | t, i, a, l)));
        }
        function wo(e, t) {
          xi(8390656, 8, e, t);
        }
        function zs(e, t) {
          Mi(2048, 8, e, t);
        }
        function rm(e) {
          I.flags |= 4;
          var t = I.updateQueue;
          if (t === null) ((t = Ei()), (I.updateQueue = t), (t.events = [e]));
          else {
            var a = t.events;
            a === null ? (t.events = [e]) : a.push(e);
          }
        }
        function Qo(e) {
          var t = Ke().memoizedState;
          return (
            rm({ ref: t, nextImpl: e }),
            function () {
              if ((ve & 2) !== 0) throw Error(s(440));
              return t.impl.apply(void 0, arguments);
            }
          );
        }
        function Xo(e, t) {
          return Mi(4, 2, e, t);
        }
        function Zo(e, t) {
          return Mi(4, 4, e, t);
        }
        function Jo(e, t) {
          if (typeof t == 'function') {
            e = e();
            var a = t(e);
            return function () {
              typeof a == 'function' ? a() : t(null);
            };
          }
          if (t != null)
            return (
              (e = e()),
              (t.current = e),
              function () {
                t.current = null;
              }
            );
        }
        function $o(e, t, a) {
          ((a = a != null ? a.concat([e]) : null),
            Mi(4, 4, Jo.bind(null, t, e), a));
        }
        function _s() {}
        function ko(e, t) {
          var a = Ke();
          t = t === void 0 ? null : t;
          var l = a.memoizedState;
          return t !== null && ys(t, l[1])
            ? l[0]
            : ((a.memoizedState = [e, t]), e);
        }
        function Fo(e, t) {
          var a = Ke();
          t = t === void 0 ? null : t;
          var l = a.memoizedState;
          if (t !== null && ys(t, l[1])) return l[0];
          if (((l = e()), $a)) {
            ca(!0);
            try {
              e();
            } finally {
              ca(!1);
            }
          }
          return ((a.memoizedState = [l, t]), l);
        }
        function Ns(e, t, a) {
          return a === void 0 ||
            ((Wt & 1073741824) !== 0 && (ue & 261930) === 0)
            ? (e.memoizedState = t)
            : ((e.memoizedState = a), (e = Wr()), (I.lanes |= e), (Ea |= e), a);
        }
        function Wo(e, t, a, l) {
          return mt(a, t)
            ? a
            : Ol.current !== null
              ? ((e = Ns(e, a, l)), mt(e, t) || (Ve = !0), e)
              : (Wt & 42) === 0 ||
                  ((Wt & 1073741824) !== 0 && (ue & 261930) === 0)
                ? ((Ve = !0), (e.memoizedState = a))
                : ((e = Wr()), (I.lanes |= e), (Ea |= e), t);
        }
        function Io(e, t, a, l, n) {
          var i = U.p;
          U.p = i !== 0 && 8 > i ? i : 8;
          var c = z.T,
            d = {};
          ((z.T = d), Rs(e, !1, t, a));
          try {
            var p = n(),
              O = z.S;
            if (
              (O !== null && O(d, p),
              p !== null && typeof p == 'object' && typeof p.then == 'function')
            ) {
              var N = um(p, l);
              pn(e, t, N, At());
            } else pn(e, t, l, At());
          } catch (R) {
            pn(
              e,
              t,
              { then: function () {}, status: 'rejected', reason: R },
              At()
            );
          } finally {
            ((U.p = i),
              c !== null && d.types !== null && (c.types = d.types),
              (z.T = c));
          }
        }
        function dm() {}
        function Cs(e, t, a, l) {
          if (e.tag !== 5) throw Error(s(476));
          var n = Po(e).queue;
          Io(
            e,
            n,
            t,
            Q,
            a === null
              ? dm
              : function () {
                  return (er(e), a(l));
                }
          );
        }
        function Po(e) {
          var t = e.memoizedState;
          if (t !== null) return t;
          t = {
            memoizedState: Q,
            baseState: Q,
            baseQueue: null,
            queue: {
              pending: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: It,
              lastRenderedState: Q,
            },
            next: null,
          };
          var a = {};
          return (
            (t.next = {
              memoizedState: a,
              baseState: a,
              baseQueue: null,
              queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: It,
                lastRenderedState: a,
              },
              next: null,
            }),
            (e.memoizedState = t),
            (e = e.alternate),
            e !== null && (e.memoizedState = t),
            t
          );
        }
        function er(e) {
          var t = Po(e);
          (t.next === null && (t = e.alternate.memoizedState),
            pn(e, t.next.queue, {}, At()));
        }
        function Ds() {
          return We(jn);
        }
        function tr() {
          return Ke().memoizedState;
        }
        function ar() {
          return Ke().memoizedState;
        }
        function hm(e) {
          for (var t = e.return; t !== null;) {
            switch (t.tag) {
              case 24:
              case 3:
                var a = At();
                e = pa(a);
                var l = ya(t, e, a);
                (l !== null && (ot(l, t, a), rn(l, t, a)),
                  (t = { cache: us() }),
                  (e.payload = t));
                return;
            }
            t = t.return;
          }
        }
        function gm(e, t, a) {
          var l = At();
          ((a = {
            lane: l,
            revertLane: 0,
            gesture: null,
            action: a,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            zi(e)
              ? nr(t, a)
              : ((a = ku(e, t, a, l)),
                a !== null && (ot(a, e, l), ir(a, t, l))));
        }
        function lr(e, t, a) {
          var l = At();
          pn(e, t, a, l);
        }
        function pn(e, t, a, l) {
          var n = {
            lane: l,
            revertLane: 0,
            gesture: null,
            action: a,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          };
          if (zi(e)) nr(t, n);
          else {
            var i = e.alternate;
            if (
              e.lanes === 0 &&
              (i === null || i.lanes === 0) &&
              ((i = t.lastRenderedReducer), i !== null)
            )
              try {
                var c = t.lastRenderedState,
                  d = i(c, a);
                if (((n.hasEagerState = !0), (n.eagerState = d), mt(d, c)))
                  return (si(e, t, n, 0), _e === null && ui(), !1);
              } catch {
              } finally {
              }
            if (((a = ku(e, t, n, l)), a !== null))
              return (ot(a, e, l), ir(a, t, l), !0);
          }
          return !1;
        }
        function Rs(e, t, a, l) {
          if (
            ((l = {
              lane: 2,
              revertLane: oc(),
              gesture: null,
              action: l,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            }),
            zi(e))
          ) {
            if (t) throw Error(s(479));
          } else ((t = ku(e, a, l, 2)), t !== null && ot(t, e, 2));
        }
        function zi(e) {
          var t = e.alternate;
          return e === I || (t !== null && t === I);
        }
        function nr(e, t) {
          xl = Si = !0;
          var a = e.pending;
          (a === null ? (t.next = t) : ((t.next = a.next), (a.next = t)),
            (e.pending = t));
        }
        function ir(e, t, a) {
          if ((a & 4194048) !== 0) {
            var l = t.lanes;
            ((l &= e.pendingLanes), (a |= l), (t.lanes = a), ff(e, a));
          }
        }
        var yn = {
          readContext: We,
          use: Ti,
          useCallback: Le,
          useContext: Le,
          useEffect: Le,
          useImperativeHandle: Le,
          useLayoutEffect: Le,
          useInsertionEffect: Le,
          useMemo: Le,
          useReducer: Le,
          useRef: Le,
          useState: Le,
          useDebugValue: Le,
          useDeferredValue: Le,
          useTransition: Le,
          useSyncExternalStore: Le,
          useId: Le,
          useHostTransitionStatus: Le,
          useFormState: Le,
          useActionState: Le,
          useOptimistic: Le,
          useMemoCache: Le,
          useCacheRefresh: Le,
        };
        yn.useEffectEvent = Le;
        var ur = {
            readContext: We,
            use: Ti,
            useCallback: function (e, t) {
              return ((at().memoizedState = [e, t === void 0 ? null : t]), e);
            },
            useContext: We,
            useEffect: wo,
            useImperativeHandle: function (e, t, a) {
              ((a = a != null ? a.concat([e]) : null),
                xi(4194308, 4, Jo.bind(null, t, e), a));
            },
            useLayoutEffect: function (e, t) {
              return xi(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              xi(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var a = at();
              t = t === void 0 ? null : t;
              var l = e();
              if ($a) {
                ca(!0);
                try {
                  e();
                } finally {
                  ca(!1);
                }
              }
              return ((a.memoizedState = [l, t]), l);
            },
            useReducer: function (e, t, a) {
              var l = at();
              if (a !== void 0) {
                var n = a(t);
                if ($a) {
                  ca(!0);
                  try {
                    a(t);
                  } finally {
                    ca(!1);
                  }
                }
              } else n = t;
              return (
                (l.memoizedState = l.baseState = n),
                (e = {
                  pending: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: n,
                }),
                (l.queue = e),
                (e = e.dispatch = gm.bind(null, I, e)),
                [l.memoizedState, e]
              );
            },
            useRef: function (e) {
              var t = at();
              return ((e = { current: e }), (t.memoizedState = e));
            },
            useState: function (e) {
              e = xs(e);
              var t = e.queue,
                a = lr.bind(null, I, t);
              return ((t.dispatch = a), [e.memoizedState, a]);
            },
            useDebugValue: _s,
            useDeferredValue: function (e, t) {
              var a = at();
              return Ns(a, e, t);
            },
            useTransition: function () {
              var e = xs(!1);
              return (
                (e = Io.bind(null, I, e.queue, !0, !1)),
                (at().memoizedState = e),
                [!1, e]
              );
            },
            useSyncExternalStore: function (e, t, a) {
              var l = I,
                n = at();
              if (de) {
                if (a === void 0) throw Error(s(407));
                a = a();
              } else {
                if (((a = t()), _e === null)) throw Error(s(349));
                (ue & 127) !== 0 || zo(l, t, a);
              }
              n.memoizedState = a;
              var i = { value: a, getSnapshot: t };
              return (
                (n.queue = i),
                wo(No.bind(null, l, i, e), [e]),
                (l.flags |= 2048),
                zl(9, { destroy: void 0 }, _o.bind(null, l, i, a, t), null),
                a
              );
            },
            useId: function () {
              var e = at(),
                t = _e.identifierPrefix;
              if (de) {
                var a = Gt,
                  l = qt;
                ((a = (l & ~(1 << (32 - gt(l) - 1))).toString(32) + a),
                  (t = '_' + t + 'R_' + a),
                  (a = Ai++),
                  0 < a && (t += 'H' + a.toString(32)),
                  (t += '_'));
              } else ((a = sm++), (t = '_' + t + 'r_' + a.toString(32) + '_'));
              return (e.memoizedState = t);
            },
            useHostTransitionStatus: Ds,
            useFormState: Ko,
            useActionState: Ko,
            useOptimistic: function (e) {
              var t = at();
              t.memoizedState = t.baseState = e;
              var a = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null,
              };
              return (
                (t.queue = a),
                (t = Rs.bind(null, I, !0, a)),
                (a.dispatch = t),
                [e, t]
              );
            },
            useMemoCache: Es,
            useCacheRefresh: function () {
              return (at().memoizedState = hm.bind(null, I));
            },
            useEffectEvent: function (e) {
              var t = at(),
                a = { impl: e };
              return (
                (t.memoizedState = a),
                function () {
                  if ((ve & 2) !== 0) throw Error(s(440));
                  return a.impl.apply(void 0, arguments);
                }
              );
            },
          },
          js = {
            readContext: We,
            use: Ti,
            useCallback: ko,
            useContext: We,
            useEffect: zs,
            useImperativeHandle: $o,
            useInsertionEffect: Xo,
            useLayoutEffect: Zo,
            useMemo: Fo,
            useReducer: Oi,
            useRef: Vo,
            useState: function () {
              return Oi(It);
            },
            useDebugValue: _s,
            useDeferredValue: function (e, t) {
              var a = Ke();
              return Wo(a, Oe.memoizedState, e, t);
            },
            useTransition: function () {
              var e = Oi(It)[0],
                t = Ke().memoizedState;
              return [typeof e == 'boolean' ? e : mn(e), t];
            },
            useSyncExternalStore: Mo,
            useId: tr,
            useHostTransitionStatus: Ds,
            useFormState: qo,
            useActionState: qo,
            useOptimistic: function (e, t) {
              var a = Ke();
              return Ro(a, Oe, e, t);
            },
            useMemoCache: Es,
            useCacheRefresh: ar,
          };
        js.useEffectEvent = Qo;
        var sr = {
          readContext: We,
          use: Ti,
          useCallback: ko,
          useContext: We,
          useEffect: zs,
          useImperativeHandle: $o,
          useInsertionEffect: Xo,
          useLayoutEffect: Zo,
          useMemo: Fo,
          useReducer: Os,
          useRef: Vo,
          useState: function () {
            return Os(It);
          },
          useDebugValue: _s,
          useDeferredValue: function (e, t) {
            var a = Ke();
            return Oe === null ? Ns(a, e, t) : Wo(a, Oe.memoizedState, e, t);
          },
          useTransition: function () {
            var e = Os(It)[0],
              t = Ke().memoizedState;
            return [typeof e == 'boolean' ? e : mn(e), t];
          },
          useSyncExternalStore: Mo,
          useId: tr,
          useHostTransitionStatus: Ds,
          useFormState: Yo,
          useActionState: Yo,
          useOptimistic: function (e, t) {
            var a = Ke();
            return Oe !== null
              ? Ro(a, Oe, e, t)
              : ((a.baseState = e), [e, a.queue.dispatch]);
          },
          useMemoCache: Es,
          useCacheRefresh: ar,
        };
        sr.useEffectEvent = Qo;
        function Ls(e, t, a, l) {
          ((t = e.memoizedState),
            (a = a(l, t)),
            (a = a == null ? t : E({}, t, a)),
            (e.memoizedState = a),
            e.lanes === 0 && (e.updateQueue.baseState = a));
        }
        var Us = {
          enqueueSetState: function (e, t, a) {
            e = e._reactInternals;
            var l = At(),
              n = pa(l);
            ((n.payload = t),
              a != null && (n.callback = a),
              (t = ya(e, n, l)),
              t !== null && (ot(t, e, l), rn(t, e, l)));
          },
          enqueueReplaceState: function (e, t, a) {
            e = e._reactInternals;
            var l = At(),
              n = pa(l);
            ((n.tag = 1),
              (n.payload = t),
              a != null && (n.callback = a),
              (t = ya(e, n, l)),
              t !== null && (ot(t, e, l), rn(t, e, l)));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var a = At(),
              l = pa(a);
            ((l.tag = 2),
              t != null && (l.callback = t),
              (t = ya(e, l, a)),
              t !== null && (ot(t, e, a), rn(t, e, a)));
          },
        };
        function cr(e, t, a, l, n, i, c) {
          return (
            (e = e.stateNode),
            typeof e.shouldComponentUpdate == 'function'
              ? e.shouldComponentUpdate(l, i, c)
              : t.prototype && t.prototype.isPureReactComponent
                ? !an(a, l) || !an(n, i)
                : !0
          );
        }
        function fr(e, t, a, l) {
          ((e = t.state),
            typeof t.componentWillReceiveProps == 'function' &&
              t.componentWillReceiveProps(a, l),
            typeof t.UNSAFE_componentWillReceiveProps == 'function' &&
              t.UNSAFE_componentWillReceiveProps(a, l),
            t.state !== e && Us.enqueueReplaceState(t, t.state, null));
        }
        function ka(e, t) {
          var a = t;
          if ('ref' in t) {
            a = {};
            for (var l in t) l !== 'ref' && (a[l] = t[l]);
          }
          if ((e = e.defaultProps)) {
            a === t && (a = E({}, a));
            for (var n in e) a[n] === void 0 && (a[n] = e[n]);
          }
          return a;
        }
        function or(e) {
          ii(e);
        }
        function rr(e) {
          console.error(e);
        }
        function dr(e) {
          ii(e);
        }
        function _i(e, t) {
          try {
            var a = e.onUncaughtError;
            a(t.value, { componentStack: t.stack });
          } catch (l) {
            setTimeout(function () {
              throw l;
            });
          }
        }
        function hr(e, t, a) {
          try {
            var l = e.onCaughtError;
            l(a.value, {
              componentStack: a.stack,
              errorBoundary: t.tag === 1 ? t.stateNode : null,
            });
          } catch (n) {
            setTimeout(function () {
              throw n;
            });
          }
        }
        function Hs(e, t, a) {
          return (
            (a = pa(a)),
            (a.tag = 3),
            (a.payload = { element: null }),
            (a.callback = function () {
              _i(e, t);
            }),
            a
          );
        }
        function gr(e) {
          return ((e = pa(e)), (e.tag = 3), e);
        }
        function mr(e, t, a, l) {
          var n = a.type.getDerivedStateFromError;
          if (typeof n == 'function') {
            var i = l.value;
            ((e.payload = function () {
              return n(i);
            }),
              (e.callback = function () {
                hr(t, a, l);
              }));
          }
          var c = a.stateNode;
          c !== null &&
            typeof c.componentDidCatch == 'function' &&
            (e.callback = function () {
              (hr(t, a, l),
                typeof n != 'function' &&
                  (Ta === null ? (Ta = new Set([this])) : Ta.add(this)));
              var d = l.stack;
              this.componentDidCatch(l.value, {
                componentStack: d !== null ? d : '',
              });
            });
        }
        function mm(e, t, a, l, n) {
          if (
            ((a.flags |= 32768),
            l !== null && typeof l == 'object' && typeof l.then == 'function')
          ) {
            if (
              ((t = a.alternate),
              t !== null && bl(t, a, n, !0),
              (a = yt.current),
              a !== null)
            ) {
              switch (a.tag) {
                case 31:
                case 13:
                  return (
                    Nt === null
                      ? Gi()
                      : a.alternate === null && Ue === 0 && (Ue = 3),
                    (a.flags &= -257),
                    (a.flags |= 65536),
                    (a.lanes = n),
                    l === mi
                      ? (a.flags |= 16384)
                      : ((t = a.updateQueue),
                        t === null ? (a.updateQueue = new Set([l])) : t.add(l),
                        sc(e, l, n)),
                    !1
                  );
                case 22:
                  return (
                    (a.flags |= 65536),
                    l === mi
                      ? (a.flags |= 16384)
                      : ((t = a.updateQueue),
                        t === null
                          ? ((t = {
                              transitions: null,
                              markerInstances: null,
                              retryQueue: new Set([l]),
                            }),
                            (a.updateQueue = t))
                          : ((a = t.retryQueue),
                            a === null
                              ? (t.retryQueue = new Set([l]))
                              : a.add(l)),
                        sc(e, l, n)),
                    !1
                  );
              }
              throw Error(s(435, a.tag));
            }
            return (sc(e, l, n), Gi(), !1);
          }
          if (de)
            return (
              (t = yt.current),
              t !== null
                ? ((t.flags & 65536) === 0 && (t.flags |= 256),
                  (t.flags |= 65536),
                  (t.lanes = n),
                  l !== ts && ((e = Error(s(422), { cause: l })), un(xt(e, a))))
                : (l !== ts &&
                    ((t = Error(s(423), { cause: l })), un(xt(t, a))),
                  (e = e.current.alternate),
                  (e.flags |= 65536),
                  (n &= -n),
                  (e.lanes |= n),
                  (l = xt(l, a)),
                  (n = Hs(e.stateNode, l, n)),
                  ds(e, n),
                  Ue !== 4 && (Ue = 2)),
              !1
            );
          var i = Error(s(520), { cause: l });
          if (
            ((i = xt(i, a)),
            xn === null ? (xn = [i]) : xn.push(i),
            Ue !== 4 && (Ue = 2),
            t === null)
          )
            return !0;
          ((l = xt(l, a)), (a = t));
          do {
            switch (a.tag) {
              case 3:
                return (
                  (a.flags |= 65536),
                  (e = n & -n),
                  (a.lanes |= e),
                  (e = Hs(a.stateNode, l, e)),
                  ds(a, e),
                  !1
                );
              case 1:
                if (
                  ((t = a.type),
                  (i = a.stateNode),
                  (a.flags & 128) === 0 &&
                    (typeof t.getDerivedStateFromError == 'function' ||
                      (i !== null &&
                        typeof i.componentDidCatch == 'function' &&
                        (Ta === null || !Ta.has(i)))))
                )
                  return (
                    (a.flags |= 65536),
                    (n &= -n),
                    (a.lanes |= n),
                    (n = gr(n)),
                    mr(n, e, a, l),
                    ds(a, n),
                    !1
                  );
            }
            a = a.return;
          } while (a !== null);
          return !1;
        }
        var Bs = Error(s(461)),
          Ve = !1;
        function Ie(e, t, a, l) {
          t.child = e === null ? bo(t, null, a, l) : Ja(t, e.child, a, l);
        }
        function pr(e, t, a, l, n) {
          a = a.render;
          var i = t.ref;
          if ('ref' in l) {
            var c = {};
            for (var d in l) d !== 'ref' && (c[d] = l[d]);
          } else c = l;
          return (
            wa(t),
            (l = vs(e, t, a, c, i, n)),
            (d = bs()),
            e !== null && !Ve
              ? (Ss(e, t, n), Pt(e, t, n))
              : (de && d && Pu(t), (t.flags |= 1), Ie(e, t, l, n), t.child)
          );
        }
        function yr(e, t, a, l, n) {
          if (e === null) {
            var i = a.type;
            return typeof i == 'function' &&
              !Fu(i) &&
              i.defaultProps === void 0 &&
              a.compare === null
              ? ((t.tag = 15), (t.type = i), vr(e, t, i, l, n))
              : ((e = fi(a.type, null, l, t, t.mode, n)),
                (e.ref = t.ref),
                (e.return = t),
                (t.child = e));
          }
          if (((i = e.child), !Xs(e, n))) {
            var c = i.memoizedProps;
            if (
              ((a = a.compare),
              (a = a !== null ? a : an),
              a(c, l) && e.ref === t.ref)
            )
              return Pt(e, t, n);
          }
          return (
            (t.flags |= 1),
            (e = Jt(i, l)),
            (e.ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function vr(e, t, a, l, n) {
          if (e !== null) {
            var i = e.memoizedProps;
            if (an(i, l) && e.ref === t.ref)
              if (((Ve = !1), (t.pendingProps = l = i), Xs(e, n)))
                (e.flags & 131072) !== 0 && (Ve = !0);
              else return ((t.lanes = e.lanes), Pt(e, t, n));
          }
          return Ks(e, t, a, l, n);
        }
        function br(e, t, a, l) {
          var n = l.children,
            i = e !== null ? e.memoizedState : null;
          if (
            (e === null &&
              t.stateNode === null &&
              (t.stateNode = {
                _visibility: 1,
                _pendingMarkers: null,
                _retryCache: null,
                _transitions: null,
              }),
            l.mode === 'hidden')
          ) {
            if ((t.flags & 128) !== 0) {
              if (((i = i !== null ? i.baseLanes | a : a), e !== null)) {
                for (l = t.child = e.child, n = 0; l !== null;)
                  ((n = n | l.lanes | l.childLanes), (l = l.sibling));
                l = n & ~i;
              } else ((l = 0), (t.child = null));
              return Sr(e, t, i, a, l);
            }
            if ((a & 536870912) !== 0)
              ((t.memoizedState = { baseLanes: 0, cachePool: null }),
                e !== null && hi(t, i !== null ? i.cachePool : null),
                i !== null ? Eo(t, i) : gs(),
                To(t));
            else
              return (
                (l = t.lanes = 536870912),
                Sr(e, t, i !== null ? i.baseLanes | a : a, a, l)
              );
          } else
            i !== null
              ? (hi(t, i.cachePool), Eo(t, i), ba(), (t.memoizedState = null))
              : (e !== null && hi(t, null), gs(), ba());
          return (Ie(e, t, n, a), t.child);
        }
        function vn(e, t) {
          return (
            (e !== null && e.tag === 22) ||
              t.stateNode !== null ||
              (t.stateNode = {
                _visibility: 1,
                _pendingMarkers: null,
                _retryCache: null,
                _transitions: null,
              }),
            t.sibling
          );
        }
        function Sr(e, t, a, l, n) {
          var i = cs();
          return (
            (i = i === null ? null : { parent: Ge._currentValue, pool: i }),
            (t.memoizedState = { baseLanes: a, cachePool: i }),
            e !== null && hi(t, null),
            gs(),
            To(t),
            e !== null && bl(e, t, l, !0),
            (t.childLanes = n),
            null
          );
        }
        function Ni(e, t) {
          return (
            (t = Di({ mode: t.mode, children: t.children }, e.mode)),
            (t.ref = e.ref),
            (e.child = t),
            (t.return = e),
            t
          );
        }
        function Ar(e, t, a) {
          return (
            Ja(t, e.child, null, a),
            (e = Ni(t, t.pendingProps)),
            (e.flags |= 2),
            vt(t),
            (t.memoizedState = null),
            e
          );
        }
        function pm(e, t, a) {
          var l = t.pendingProps,
            n = (t.flags & 128) !== 0;
          if (((t.flags &= -129), e === null)) {
            if (de) {
              if (l.mode === 'hidden')
                return ((e = Ni(t, l)), (t.lanes = 536870912), vn(null, e));
              if (
                (ps(t),
                (e = De)
                  ? ((e = jd(e, _t)),
                    (e = e !== null && e.data === '&' ? e : null),
                    e !== null &&
                      ((t.memoizedState = {
                        dehydrated: e,
                        treeContext:
                          ra !== null ? { id: qt, overflow: Gt } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      (a = lo(e)),
                      (a.return = t),
                      (t.child = a),
                      (Fe = t),
                      (De = null)))
                  : (e = null),
                e === null)
              )
                throw ha(t);
              return ((t.lanes = 536870912), null);
            }
            return Ni(t, l);
          }
          var i = e.memoizedState;
          if (i !== null) {
            var c = i.dehydrated;
            if ((ps(t), n))
              if (t.flags & 256) ((t.flags &= -257), (t = Ar(e, t, a)));
              else if (t.memoizedState !== null)
                ((t.child = e.child), (t.flags |= 128), (t = null));
              else throw Error(s(558));
            else if (
              (Ve || bl(e, t, a, !1), (n = (a & e.childLanes) !== 0), Ve || n)
            ) {
              if (
                ((l = _e),
                l !== null && ((c = of(l, a)), c !== 0 && c !== i.retryLane))
              )
                throw ((i.retryLane = c), qa(e, c), ot(l, e, c), Bs);
              (Gi(), (t = Ar(e, t, a)));
            } else
              ((e = i.treeContext),
                (De = Ct(c.nextSibling)),
                (Fe = t),
                (de = !0),
                (da = null),
                (_t = !1),
                e !== null && uo(t, e),
                (t = Ni(t, l)),
                (t.flags |= 4096));
            return t;
          }
          return (
            (e = Jt(e.child, { mode: l.mode, children: l.children })),
            (e.ref = t.ref),
            (t.child = e),
            (e.return = t),
            e
          );
        }
        function Ci(e, t) {
          var a = t.ref;
          if (a === null) e !== null && e.ref !== null && (t.flags |= 4194816);
          else {
            if (typeof a != 'function' && typeof a != 'object')
              throw Error(s(284));
            (e === null || e.ref !== a) && (t.flags |= 4194816);
          }
        }
        function Ks(e, t, a, l, n) {
          return (
            wa(t),
            (a = vs(e, t, a, l, void 0, n)),
            (l = bs()),
            e !== null && !Ve
              ? (Ss(e, t, n), Pt(e, t, n))
              : (de && l && Pu(t), (t.flags |= 1), Ie(e, t, a, n), t.child)
          );
        }
        function Er(e, t, a, l, n, i) {
          return (
            wa(t),
            (t.updateQueue = null),
            (a = xo(t, l, a, n)),
            Oo(e),
            (l = bs()),
            e !== null && !Ve
              ? (Ss(e, t, i), Pt(e, t, i))
              : (de && l && Pu(t), (t.flags |= 1), Ie(e, t, a, i), t.child)
          );
        }
        function Tr(e, t, a, l, n) {
          if ((wa(t), t.stateNode === null)) {
            var i = ml,
              c = a.contextType;
            (typeof c == 'object' && c !== null && (i = We(c)),
              (i = new a(l, i)),
              (t.memoizedState =
                i.state !== null && i.state !== void 0 ? i.state : null),
              (i.updater = Us),
              (t.stateNode = i),
              (i._reactInternals = t),
              (i = t.stateNode),
              (i.props = l),
              (i.state = t.memoizedState),
              (i.refs = {}),
              os(t),
              (c = a.contextType),
              (i.context = typeof c == 'object' && c !== null ? We(c) : ml),
              (i.state = t.memoizedState),
              (c = a.getDerivedStateFromProps),
              typeof c == 'function' &&
                (Ls(t, a, c, l), (i.state = t.memoizedState)),
              typeof a.getDerivedStateFromProps == 'function' ||
                typeof i.getSnapshotBeforeUpdate == 'function' ||
                (typeof i.UNSAFE_componentWillMount != 'function' &&
                  typeof i.componentWillMount != 'function') ||
                ((c = i.state),
                typeof i.componentWillMount == 'function' &&
                  i.componentWillMount(),
                typeof i.UNSAFE_componentWillMount == 'function' &&
                  i.UNSAFE_componentWillMount(),
                c !== i.state && Us.enqueueReplaceState(i, i.state, null),
                hn(t, l, i, n),
                dn(),
                (i.state = t.memoizedState)),
              typeof i.componentDidMount == 'function' && (t.flags |= 4194308),
              (l = !0));
          } else if (e === null) {
            i = t.stateNode;
            var d = t.memoizedProps,
              p = ka(a, d);
            i.props = p;
            var O = i.context,
              N = a.contextType;
            ((c = ml), typeof N == 'object' && N !== null && (c = We(N)));
            var R = a.getDerivedStateFromProps;
            ((N =
              typeof R == 'function' ||
              typeof i.getSnapshotBeforeUpdate == 'function'),
              (d = t.pendingProps !== d),
              N ||
                (typeof i.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof i.componentWillReceiveProps != 'function') ||
                ((d || O !== c) && fr(t, i, l, c)),
              (ma = !1));
            var x = t.memoizedState;
            ((i.state = x),
              hn(t, l, i, n),
              dn(),
              (O = t.memoizedState),
              d || x !== O || ma
                ? (typeof R == 'function' &&
                    (Ls(t, a, R, l), (O = t.memoizedState)),
                  (p = ma || cr(t, a, p, l, x, O, c))
                    ? (N ||
                        (typeof i.UNSAFE_componentWillMount != 'function' &&
                          typeof i.componentWillMount != 'function') ||
                        (typeof i.componentWillMount == 'function' &&
                          i.componentWillMount(),
                        typeof i.UNSAFE_componentWillMount == 'function' &&
                          i.UNSAFE_componentWillMount()),
                      typeof i.componentDidMount == 'function' &&
                        (t.flags |= 4194308))
                    : (typeof i.componentDidMount == 'function' &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = l),
                      (t.memoizedState = O)),
                  (i.props = l),
                  (i.state = O),
                  (i.context = c),
                  (l = p))
                : (typeof i.componentDidMount == 'function' &&
                    (t.flags |= 4194308),
                  (l = !1)));
          } else {
            ((i = t.stateNode),
              rs(e, t),
              (c = t.memoizedProps),
              (N = ka(a, c)),
              (i.props = N),
              (R = t.pendingProps),
              (x = i.context),
              (O = a.contextType),
              (p = ml),
              typeof O == 'object' && O !== null && (p = We(O)),
              (d = a.getDerivedStateFromProps),
              (O =
                typeof d == 'function' ||
                typeof i.getSnapshotBeforeUpdate == 'function') ||
                (typeof i.UNSAFE_componentWillReceiveProps != 'function' &&
                  typeof i.componentWillReceiveProps != 'function') ||
                ((c !== R || x !== p) && fr(t, i, l, p)),
              (ma = !1),
              (x = t.memoizedState),
              (i.state = x),
              hn(t, l, i, n),
              dn());
            var M = t.memoizedState;
            c !== R ||
            x !== M ||
            ma ||
            (e !== null && e.dependencies !== null && ri(e.dependencies))
              ? (typeof d == 'function' &&
                  (Ls(t, a, d, l), (M = t.memoizedState)),
                (N =
                  ma ||
                  cr(t, a, N, l, x, M, p) ||
                  (e !== null && e.dependencies !== null && ri(e.dependencies)))
                  ? (O ||
                      (typeof i.UNSAFE_componentWillUpdate != 'function' &&
                        typeof i.componentWillUpdate != 'function') ||
                      (typeof i.componentWillUpdate == 'function' &&
                        i.componentWillUpdate(l, M, p),
                      typeof i.UNSAFE_componentWillUpdate == 'function' &&
                        i.UNSAFE_componentWillUpdate(l, M, p)),
                    typeof i.componentDidUpdate == 'function' && (t.flags |= 4),
                    typeof i.getSnapshotBeforeUpdate == 'function' &&
                      (t.flags |= 1024))
                  : (typeof i.componentDidUpdate != 'function' ||
                      (c === e.memoizedProps && x === e.memoizedState) ||
                      (t.flags |= 4),
                    typeof i.getSnapshotBeforeUpdate != 'function' ||
                      (c === e.memoizedProps && x === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = l),
                    (t.memoizedState = M)),
                (i.props = l),
                (i.state = M),
                (i.context = p),
                (l = N))
              : (typeof i.componentDidUpdate != 'function' ||
                  (c === e.memoizedProps && x === e.memoizedState) ||
                  (t.flags |= 4),
                typeof i.getSnapshotBeforeUpdate != 'function' ||
                  (c === e.memoizedProps && x === e.memoizedState) ||
                  (t.flags |= 1024),
                (l = !1));
          }
          return (
            (i = l),
            Ci(e, t),
            (l = (t.flags & 128) !== 0),
            i || l
              ? ((i = t.stateNode),
                (a =
                  l && typeof a.getDerivedStateFromError != 'function'
                    ? null
                    : i.render()),
                (t.flags |= 1),
                e !== null && l
                  ? ((t.child = Ja(t, e.child, null, n)),
                    (t.child = Ja(t, null, a, n)))
                  : Ie(e, t, a, n),
                (t.memoizedState = i.state),
                (e = t.child))
              : (e = Pt(e, t, n)),
            e
          );
        }
        function Or(e, t, a, l) {
          return (Ya(), (t.flags |= 256), Ie(e, t, a, l), t.child);
        }
        var qs = {
          dehydrated: null,
          treeContext: null,
          retryLane: 0,
          hydrationErrors: null,
        };
        function Gs(e) {
          return { baseLanes: e, cachePool: ho() };
        }
        function Ys(e, t, a) {
          return ((e = e !== null ? e.childLanes & ~a : 0), t && (e |= St), e);
        }
        function xr(e, t, a) {
          var l = t.pendingProps,
            n = !1,
            i = (t.flags & 128) !== 0,
            c;
          if (
            ((c = i) ||
              (c =
                e !== null && e.memoizedState === null
                  ? !1
                  : (Be.current & 2) !== 0),
            c && ((n = !0), (t.flags &= -129)),
            (c = (t.flags & 32) !== 0),
            (t.flags &= -33),
            e === null)
          ) {
            if (de) {
              if (
                (n ? va(t) : ba(),
                (e = De)
                  ? ((e = jd(e, _t)),
                    (e = e !== null && e.data !== '&' ? e : null),
                    e !== null &&
                      ((t.memoizedState = {
                        dehydrated: e,
                        treeContext:
                          ra !== null ? { id: qt, overflow: Gt } : null,
                        retryLane: 536870912,
                        hydrationErrors: null,
                      }),
                      (a = lo(e)),
                      (a.return = t),
                      (t.child = a),
                      (Fe = t),
                      (De = null)))
                  : (e = null),
                e === null)
              )
                throw ha(t);
              return (Tc(e) ? (t.lanes = 32) : (t.lanes = 536870912), null);
            }
            var d = l.children;
            return (
              (l = l.fallback),
              n
                ? (ba(),
                  (n = t.mode),
                  (d = Di({ mode: 'hidden', children: d }, n)),
                  (l = Ga(l, n, a, null)),
                  (d.return = t),
                  (l.return = t),
                  (d.sibling = l),
                  (t.child = d),
                  (l = t.child),
                  (l.memoizedState = Gs(a)),
                  (l.childLanes = Ys(e, c, a)),
                  (t.memoizedState = qs),
                  vn(null, l))
                : (va(t), Vs(t, d))
            );
          }
          var p = e.memoizedState;
          if (p !== null && ((d = p.dehydrated), d !== null)) {
            if (i)
              t.flags & 256
                ? (va(t), (t.flags &= -257), (t = ws(e, t, a)))
                : t.memoizedState !== null
                  ? (ba(), (t.child = e.child), (t.flags |= 128), (t = null))
                  : (ba(),
                    (d = l.fallback),
                    (n = t.mode),
                    (l = Di({ mode: 'visible', children: l.children }, n)),
                    (d = Ga(d, n, a, null)),
                    (d.flags |= 2),
                    (l.return = t),
                    (d.return = t),
                    (l.sibling = d),
                    (t.child = l),
                    Ja(t, e.child, null, a),
                    (l = t.child),
                    (l.memoizedState = Gs(a)),
                    (l.childLanes = Ys(e, c, a)),
                    (t.memoizedState = qs),
                    (t = vn(null, l)));
            else if ((va(t), Tc(d))) {
              if (((c = d.nextSibling && d.nextSibling.dataset), c))
                var O = c.dgst;
              ((c = O),
                (l = Error(s(419))),
                (l.stack = ''),
                (l.digest = c),
                un({ value: l, source: null, stack: null }),
                (t = ws(e, t, a)));
            } else if (
              (Ve || bl(e, t, a, !1), (c = (a & e.childLanes) !== 0), Ve || c)
            ) {
              if (
                ((c = _e),
                c !== null && ((l = of(c, a)), l !== 0 && l !== p.retryLane))
              )
                throw ((p.retryLane = l), qa(e, l), ot(c, e, l), Bs);
              (Ec(d) || Gi(), (t = ws(e, t, a)));
            } else
              Ec(d)
                ? ((t.flags |= 192), (t.child = e.child), (t = null))
                : ((e = p.treeContext),
                  (De = Ct(d.nextSibling)),
                  (Fe = t),
                  (de = !0),
                  (da = null),
                  (_t = !1),
                  e !== null && uo(t, e),
                  (t = Vs(t, l.children)),
                  (t.flags |= 4096));
            return t;
          }
          return n
            ? (ba(),
              (d = l.fallback),
              (n = t.mode),
              (p = e.child),
              (O = p.sibling),
              (l = Jt(p, { mode: 'hidden', children: l.children })),
              (l.subtreeFlags = p.subtreeFlags & 65011712),
              O !== null
                ? (d = Jt(O, d))
                : ((d = Ga(d, n, a, null)), (d.flags |= 2)),
              (d.return = t),
              (l.return = t),
              (l.sibling = d),
              (t.child = l),
              vn(null, l),
              (l = t.child),
              (d = e.child.memoizedState),
              d === null
                ? (d = Gs(a))
                : ((n = d.cachePool),
                  n !== null
                    ? ((p = Ge._currentValue),
                      (n = n.parent !== p ? { parent: p, pool: p } : n))
                    : (n = ho()),
                  (d = { baseLanes: d.baseLanes | a, cachePool: n })),
              (l.memoizedState = d),
              (l.childLanes = Ys(e, c, a)),
              (t.memoizedState = qs),
              vn(e.child, l))
            : (va(t),
              (a = e.child),
              (e = a.sibling),
              (a = Jt(a, { mode: 'visible', children: l.children })),
              (a.return = t),
              (a.sibling = null),
              e !== null &&
                ((c = t.deletions),
                c === null
                  ? ((t.deletions = [e]), (t.flags |= 16))
                  : c.push(e)),
              (t.child = a),
              (t.memoizedState = null),
              a);
        }
        function Vs(e, t) {
          return (
            (t = Di({ mode: 'visible', children: t }, e.mode)),
            (t.return = e),
            (e.child = t)
          );
        }
        function Di(e, t) {
          return ((e = pt(22, e, null, t)), (e.lanes = 0), e);
        }
        function ws(e, t, a) {
          return (
            Ja(t, e.child, null, a),
            (e = Vs(t, t.pendingProps.children)),
            (e.flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Mr(e, t, a) {
          e.lanes |= t;
          var l = e.alternate;
          (l !== null && (l.lanes |= t), ns(e.return, t, a));
        }
        function Qs(e, t, a, l, n, i) {
          var c = e.memoizedState;
          c === null
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: l,
                tail: a,
                tailMode: n,
                treeForkCount: i,
              })
            : ((c.isBackwards = t),
              (c.rendering = null),
              (c.renderingStartTime = 0),
              (c.last = l),
              (c.tail = a),
              (c.tailMode = n),
              (c.treeForkCount = i));
        }
        function zr(e, t, a) {
          var l = t.pendingProps,
            n = l.revealOrder,
            i = l.tail;
          l = l.children;
          var c = Be.current,
            d = (c & 2) !== 0;
          if (
            (d ? ((c = (c & 1) | 2), (t.flags |= 128)) : (c &= 1),
            H(Be, c),
            Ie(e, t, l, a),
            (l = de ? nn : 0),
            !d && e !== null && (e.flags & 128) !== 0)
          )
            e: for (e = t.child; e !== null;) {
              if (e.tag === 13) e.memoizedState !== null && Mr(e, a, t);
              else if (e.tag === 19) Mr(e, a, t);
              else if (e.child !== null) {
                ((e.child.return = e), (e = e.child));
                continue;
              }
              if (e === t) break e;
              for (; e.sibling === null;) {
                if (e.return === null || e.return === t) break e;
                e = e.return;
              }
              ((e.sibling.return = e.return), (e = e.sibling));
            }
          switch (n) {
            case 'forwards':
              for (a = t.child, n = null; a !== null;)
                ((e = a.alternate),
                  e !== null && bi(e) === null && (n = a),
                  (a = a.sibling));
              ((a = n),
                a === null
                  ? ((n = t.child), (t.child = null))
                  : ((n = a.sibling), (a.sibling = null)),
                Qs(t, !1, n, a, i, l));
              break;
            case 'backwards':
            case 'unstable_legacy-backwards':
              for (a = null, n = t.child, t.child = null; n !== null;) {
                if (((e = n.alternate), e !== null && bi(e) === null)) {
                  t.child = n;
                  break;
                }
                ((e = n.sibling), (n.sibling = a), (a = n), (n = e));
              }
              Qs(t, !0, a, null, i, l);
              break;
            case 'together':
              Qs(t, !1, null, null, void 0, l);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function Pt(e, t, a) {
          if (
            (e !== null && (t.dependencies = e.dependencies),
            (Ea |= t.lanes),
            (a & t.childLanes) === 0)
          )
            if (e !== null) {
              if ((bl(e, t, a, !1), (a & t.childLanes) === 0)) return null;
            } else return null;
          if (e !== null && t.child !== e.child) throw Error(s(153));
          if (t.child !== null) {
            for (
              e = t.child, a = Jt(e, e.pendingProps), t.child = a, a.return = t;
              e.sibling !== null;
            )
              ((e = e.sibling),
                (a = a.sibling = Jt(e, e.pendingProps)),
                (a.return = t));
            a.sibling = null;
          }
          return t.child;
        }
        function Xs(e, t) {
          return (e.lanes & t) !== 0
            ? !0
            : ((e = e.dependencies), !!(e !== null && ri(e)));
        }
        function ym(e, t, a) {
          switch (t.tag) {
            case 3:
              (tt(t, t.stateNode.containerInfo),
                ga(t, Ge, e.memoizedState.cache),
                Ya());
              break;
            case 27:
            case 5:
              wl(t);
              break;
            case 4:
              tt(t, t.stateNode.containerInfo);
              break;
            case 10:
              ga(t, t.type, t.memoizedProps.value);
              break;
            case 31:
              if (t.memoizedState !== null)
                return ((t.flags |= 128), ps(t), null);
              break;
            case 13:
              var l = t.memoizedState;
              if (l !== null)
                return l.dehydrated !== null
                  ? (va(t), (t.flags |= 128), null)
                  : (a & t.child.childLanes) !== 0
                    ? xr(e, t, a)
                    : (va(t), (e = Pt(e, t, a)), e !== null ? e.sibling : null);
              va(t);
              break;
            case 19:
              var n = (e.flags & 128) !== 0;
              if (
                ((l = (a & t.childLanes) !== 0),
                l || (bl(e, t, a, !1), (l = (a & t.childLanes) !== 0)),
                n)
              ) {
                if (l) return zr(e, t, a);
                t.flags |= 128;
              }
              if (
                ((n = t.memoizedState),
                n !== null &&
                  ((n.rendering = null),
                  (n.tail = null),
                  (n.lastEffect = null)),
                H(Be, Be.current),
                l)
              )
                break;
              return null;
            case 22:
              return ((t.lanes = 0), br(e, t, a, t.pendingProps));
            case 24:
              ga(t, Ge, e.memoizedState.cache);
          }
          return Pt(e, t, a);
        }
        function _r(e, t, a) {
          if (e !== null)
            if (e.memoizedProps !== t.pendingProps) Ve = !0;
            else {
              if (!Xs(e, a) && (t.flags & 128) === 0)
                return ((Ve = !1), ym(e, t, a));
              Ve = (e.flags & 131072) !== 0;
            }
          else
            ((Ve = !1), de && (t.flags & 1048576) !== 0 && io(t, nn, t.index));
          switch (((t.lanes = 0), t.tag)) {
            case 16:
              e: {
                var l = t.pendingProps;
                if (
                  ((e = Xa(t.elementType)),
                  (t.type = e),
                  typeof e == 'function')
                )
                  Fu(e)
                    ? ((l = ka(e, l)), (t.tag = 1), (t = Tr(null, t, e, l, a)))
                    : ((t.tag = 0), (t = Ks(null, t, e, l, a)));
                else {
                  if (e != null) {
                    var n = e.$$typeof;
                    if (n === ce) {
                      ((t.tag = 11), (t = pr(null, t, e, l, a)));
                      break e;
                    } else if (n === X) {
                      ((t.tag = 14), (t = yr(null, t, e, l, a)));
                      break e;
                    }
                  }
                  throw ((t = ze(e) || e), Error(s(306, t, '')));
                }
              }
              return t;
            case 0:
              return Ks(e, t, t.type, t.pendingProps, a);
            case 1:
              return (
                (l = t.type),
                (n = ka(l, t.pendingProps)),
                Tr(e, t, l, n, a)
              );
            case 3:
              e: {
                if ((tt(t, t.stateNode.containerInfo), e === null))
                  throw Error(s(387));
                l = t.pendingProps;
                var i = t.memoizedState;
                ((n = i.element), rs(e, t), hn(t, l, null, a));
                var c = t.memoizedState;
                if (
                  ((l = c.cache),
                  ga(t, Ge, l),
                  l !== i.cache && is(t, [Ge], a, !0),
                  dn(),
                  (l = c.element),
                  i.isDehydrated)
                )
                  if (
                    ((i = { element: l, isDehydrated: !1, cache: c.cache }),
                    (t.updateQueue.baseState = i),
                    (t.memoizedState = i),
                    t.flags & 256)
                  ) {
                    t = Or(e, t, l, a);
                    break e;
                  } else if (l !== n) {
                    ((n = xt(Error(s(424)), t)), un(n), (t = Or(e, t, l, a)));
                    break e;
                  } else {
                    switch (((e = t.stateNode.containerInfo), e.nodeType)) {
                      case 9:
                        e = e.body;
                        break;
                      default:
                        e = e.nodeName === 'HTML' ? e.ownerDocument.body : e;
                    }
                    for (
                      De = Ct(e.firstChild),
                        Fe = t,
                        de = !0,
                        da = null,
                        _t = !0,
                        a = bo(t, null, l, a),
                        t.child = a;
                      a;
                    )
                      ((a.flags = (a.flags & -3) | 4096), (a = a.sibling));
                  }
                else {
                  if ((Ya(), l === n)) {
                    t = Pt(e, t, a);
                    break e;
                  }
                  Ie(e, t, l, a);
                }
                t = t.child;
              }
              return t;
            case 26:
              return (
                Ci(e, t),
                e === null
                  ? (a = qd(t.type, null, t.pendingProps, null))
                    ? (t.memoizedState = a)
                    : de ||
                      ((a = t.type),
                      (e = t.pendingProps),
                      (l = Ji(le.current).createElement(a)),
                      (l[ke] = t),
                      (l[nt] = e),
                      Pe(l, a, e),
                      Ze(l),
                      (t.stateNode = l))
                  : (t.memoizedState = qd(
                      t.type,
                      e.memoizedProps,
                      t.pendingProps,
                      e.memoizedState
                    )),
                null
              );
            case 27:
              return (
                wl(t),
                e === null &&
                  de &&
                  ((l = t.stateNode = Hd(t.type, t.pendingProps, le.current)),
                  (Fe = t),
                  (_t = !0),
                  (n = De),
                  za(t.type) ? ((Oc = n), (De = Ct(l.firstChild))) : (De = n)),
                Ie(e, t, t.pendingProps.children, a),
                Ci(e, t),
                e === null && (t.flags |= 4194304),
                t.child
              );
            case 5:
              return (
                e === null &&
                  de &&
                  ((n = l = De) &&
                    ((l = Jm(l, t.type, t.pendingProps, _t)),
                    l !== null
                      ? ((t.stateNode = l),
                        (Fe = t),
                        (De = Ct(l.firstChild)),
                        (_t = !1),
                        (n = !0))
                      : (n = !1)),
                  n || ha(t)),
                wl(t),
                (n = t.type),
                (i = t.pendingProps),
                (c = e !== null ? e.memoizedProps : null),
                (l = i.children),
                bc(n, i)
                  ? (l = null)
                  : c !== null && bc(n, c) && (t.flags |= 32),
                t.memoizedState !== null &&
                  ((n = vs(e, t, cm, null, null, a)), (jn._currentValue = n)),
                Ci(e, t),
                Ie(e, t, l, a),
                t.child
              );
            case 6:
              return (
                e === null &&
                  de &&
                  ((e = a = De) &&
                    ((a = $m(a, t.pendingProps, _t)),
                    a !== null
                      ? ((t.stateNode = a), (Fe = t), (De = null), (e = !0))
                      : (e = !1)),
                  e || ha(t)),
                null
              );
            case 13:
              return xr(e, t, a);
            case 4:
              return (
                tt(t, t.stateNode.containerInfo),
                (l = t.pendingProps),
                e === null ? (t.child = Ja(t, null, l, a)) : Ie(e, t, l, a),
                t.child
              );
            case 11:
              return pr(e, t, t.type, t.pendingProps, a);
            case 7:
              return (Ie(e, t, t.pendingProps, a), t.child);
            case 8:
              return (Ie(e, t, t.pendingProps.children, a), t.child);
            case 12:
              return (Ie(e, t, t.pendingProps.children, a), t.child);
            case 10:
              return (
                (l = t.pendingProps),
                ga(t, t.type, l.value),
                Ie(e, t, l.children, a),
                t.child
              );
            case 9:
              return (
                (n = t.type._context),
                (l = t.pendingProps.children),
                wa(t),
                (n = We(n)),
                (l = l(n)),
                (t.flags |= 1),
                Ie(e, t, l, a),
                t.child
              );
            case 14:
              return yr(e, t, t.type, t.pendingProps, a);
            case 15:
              return vr(e, t, t.type, t.pendingProps, a);
            case 19:
              return zr(e, t, a);
            case 31:
              return pm(e, t, a);
            case 22:
              return br(e, t, a, t.pendingProps);
            case 24:
              return (
                wa(t),
                (l = We(Ge)),
                e === null
                  ? ((n = cs()),
                    n === null &&
                      ((n = _e),
                      (i = us()),
                      (n.pooledCache = i),
                      i.refCount++,
                      i !== null && (n.pooledCacheLanes |= a),
                      (n = i)),
                    (t.memoizedState = { parent: l, cache: n }),
                    os(t),
                    ga(t, Ge, n))
                  : ((e.lanes & a) !== 0 &&
                      (rs(e, t), hn(t, null, null, a), dn()),
                    (n = e.memoizedState),
                    (i = t.memoizedState),
                    n.parent !== l
                      ? ((n = { parent: l, cache: l }),
                        (t.memoizedState = n),
                        t.lanes === 0 &&
                          (t.memoizedState = t.updateQueue.baseState = n),
                        ga(t, Ge, l))
                      : ((l = i.cache),
                        ga(t, Ge, l),
                        l !== n.cache && is(t, [Ge], a, !0))),
                Ie(e, t, t.pendingProps.children, a),
                t.child
              );
            case 29:
              throw t.pendingProps;
          }
          throw Error(s(156, t.tag));
        }
        function ea(e) {
          e.flags |= 4;
        }
        function Zs(e, t, a, l, n) {
          if (((t = (e.mode & 32) !== 0) && (t = !1), t)) {
            if (((e.flags |= 16777216), (n & 335544128) === n))
              if (e.stateNode.complete) e.flags |= 8192;
              else if (td()) e.flags |= 8192;
              else throw ((Za = mi), fs);
          } else e.flags &= -16777217;
        }
        function Nr(e, t) {
          if (t.type !== 'stylesheet' || (t.state.loading & 4) !== 0)
            e.flags &= -16777217;
          else if (((e.flags |= 16777216), !Qd(t)))
            if (td()) e.flags |= 8192;
            else throw ((Za = mi), fs);
        }
        function Ri(e, t) {
          (t !== null && (e.flags |= 4),
            e.flags & 16384 &&
              ((t = e.tag !== 22 ? sf() : 536870912),
              (e.lanes |= t),
              (Dl |= t)));
        }
        function bn(e, t) {
          if (!de)
            switch (e.tailMode) {
              case 'hidden':
                t = e.tail;
                for (var a = null; t !== null;)
                  (t.alternate !== null && (a = t), (t = t.sibling));
                a === null ? (e.tail = null) : (a.sibling = null);
                break;
              case 'collapsed':
                a = e.tail;
                for (var l = null; a !== null;)
                  (a.alternate !== null && (l = a), (a = a.sibling));
                l === null
                  ? t || e.tail === null
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (l.sibling = null);
            }
        }
        function Re(e) {
          var t = e.alternate !== null && e.alternate.child === e.child,
            a = 0,
            l = 0;
          if (t)
            for (var n = e.child; n !== null;)
              ((a |= n.lanes | n.childLanes),
                (l |= n.subtreeFlags & 65011712),
                (l |= n.flags & 65011712),
                (n.return = e),
                (n = n.sibling));
          else
            for (n = e.child; n !== null;)
              ((a |= n.lanes | n.childLanes),
                (l |= n.subtreeFlags),
                (l |= n.flags),
                (n.return = e),
                (n = n.sibling));
          return ((e.subtreeFlags |= l), (e.childLanes = a), t);
        }
        function vm(e, t, a) {
          var l = t.pendingProps;
          switch ((es(t), t.tag)) {
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return (Re(t), null);
            case 1:
              return (Re(t), null);
            case 3:
              return (
                (a = t.stateNode),
                (l = null),
                e !== null && (l = e.memoizedState.cache),
                t.memoizedState.cache !== l && (t.flags |= 2048),
                Ft(Ge),
                He(),
                a.pendingContext &&
                  ((a.context = a.pendingContext), (a.pendingContext = null)),
                (e === null || e.child === null) &&
                  (vl(t)
                    ? ea(t)
                    : e === null ||
                      (e.memoizedState.isDehydrated && (t.flags & 256) === 0) ||
                      ((t.flags |= 1024), as())),
                Re(t),
                null
              );
            case 26:
              var n = t.type,
                i = t.memoizedState;
              return (
                e === null
                  ? (ea(t),
                    i !== null
                      ? (Re(t), Nr(t, i))
                      : (Re(t), Zs(t, n, null, l, a)))
                  : i
                    ? i !== e.memoizedState
                      ? (ea(t), Re(t), Nr(t, i))
                      : (Re(t), (t.flags &= -16777217))
                    : ((e = e.memoizedProps),
                      e !== l && ea(t),
                      Re(t),
                      Zs(t, n, e, l, a)),
                null
              );
            case 27:
              if (
                (wn(t),
                (a = le.current),
                (n = t.type),
                e !== null && t.stateNode != null)
              )
                e.memoizedProps !== l && ea(t);
              else {
                if (!l) {
                  if (t.stateNode === null) throw Error(s(166));
                  return (Re(t), null);
                }
                ((e = G.current),
                  vl(t)
                    ? so(t)
                    : ((e = Hd(n, l, a)), (t.stateNode = e), ea(t)));
              }
              return (Re(t), null);
            case 5:
              if ((wn(t), (n = t.type), e !== null && t.stateNode != null))
                e.memoizedProps !== l && ea(t);
              else {
                if (!l) {
                  if (t.stateNode === null) throw Error(s(166));
                  return (Re(t), null);
                }
                if (((i = G.current), vl(t))) so(t);
                else {
                  var c = Ji(le.current);
                  switch (i) {
                    case 1:
                      i = c.createElementNS('http://www.w3.org/2000/svg', n);
                      break;
                    case 2:
                      i = c.createElementNS(
                        'http://www.w3.org/1998/Math/MathML',
                        n
                      );
                      break;
                    default:
                      switch (n) {
                        case 'svg':
                          i = c.createElementNS(
                            'http://www.w3.org/2000/svg',
                            n
                          );
                          break;
                        case 'math':
                          i = c.createElementNS(
                            'http://www.w3.org/1998/Math/MathML',
                            n
                          );
                          break;
                        case 'script':
                          ((i = c.createElement('div')),
                            (i.innerHTML = '<script><\/script>'),
                            (i = i.removeChild(i.firstChild)));
                          break;
                        case 'select':
                          ((i =
                            typeof l.is == 'string'
                              ? c.createElement('select', { is: l.is })
                              : c.createElement('select')),
                            l.multiple
                              ? (i.multiple = !0)
                              : l.size && (i.size = l.size));
                          break;
                        default:
                          i =
                            typeof l.is == 'string'
                              ? c.createElement(n, { is: l.is })
                              : c.createElement(n);
                      }
                  }
                  ((i[ke] = t), (i[nt] = l));
                  e: for (c = t.child; c !== null;) {
                    if (c.tag === 5 || c.tag === 6) i.appendChild(c.stateNode);
                    else if (c.tag !== 4 && c.tag !== 27 && c.child !== null) {
                      ((c.child.return = c), (c = c.child));
                      continue;
                    }
                    if (c === t) break e;
                    for (; c.sibling === null;) {
                      if (c.return === null || c.return === t) break e;
                      c = c.return;
                    }
                    ((c.sibling.return = c.return), (c = c.sibling));
                  }
                  t.stateNode = i;
                  e: switch ((Pe(i, n, l), n)) {
                    case 'button':
                    case 'input':
                    case 'select':
                    case 'textarea':
                      l = !!l.autoFocus;
                      break e;
                    case 'img':
                      l = !0;
                      break e;
                    default:
                      l = !1;
                  }
                  l && ea(t);
                }
              }
              return (
                Re(t),
                Zs(
                  t,
                  t.type,
                  e === null ? null : e.memoizedProps,
                  t.pendingProps,
                  a
                ),
                null
              );
            case 6:
              if (e && t.stateNode != null) e.memoizedProps !== l && ea(t);
              else {
                if (typeof l != 'string' && t.stateNode === null)
                  throw Error(s(166));
                if (((e = le.current), vl(t))) {
                  if (
                    ((e = t.stateNode),
                    (a = t.memoizedProps),
                    (l = null),
                    (n = Fe),
                    n !== null)
                  )
                    switch (n.tag) {
                      case 27:
                      case 5:
                        l = n.memoizedProps;
                    }
                  ((e[ke] = t),
                    (e = !!(
                      e.nodeValue === a ||
                      (l !== null && l.suppressHydrationWarning === !0) ||
                      xd(e.nodeValue, a)
                    )),
                    e || ha(t, !0));
                } else
                  ((e = Ji(e).createTextNode(l)),
                    (e[ke] = t),
                    (t.stateNode = e));
              }
              return (Re(t), null);
            case 31:
              if (
                ((a = t.memoizedState), e === null || e.memoizedState !== null)
              ) {
                if (((l = vl(t)), a !== null)) {
                  if (e === null) {
                    if (!l) throw Error(s(318));
                    if (
                      ((e = t.memoizedState),
                      (e = e !== null ? e.dehydrated : null),
                      !e)
                    )
                      throw Error(s(557));
                    e[ke] = t;
                  } else
                    (Ya(),
                      (t.flags & 128) === 0 && (t.memoizedState = null),
                      (t.flags |= 4));
                  (Re(t), (e = !1));
                } else
                  ((a = as()),
                    e !== null &&
                      e.memoizedState !== null &&
                      (e.memoizedState.hydrationErrors = a),
                    (e = !0));
                if (!e) return t.flags & 256 ? (vt(t), t) : (vt(t), null);
                if ((t.flags & 128) !== 0) throw Error(s(558));
              }
              return (Re(t), null);
            case 13:
              if (
                ((l = t.memoizedState),
                e === null ||
                  (e.memoizedState !== null &&
                    e.memoizedState.dehydrated !== null))
              ) {
                if (((n = vl(t)), l !== null && l.dehydrated !== null)) {
                  if (e === null) {
                    if (!n) throw Error(s(318));
                    if (
                      ((n = t.memoizedState),
                      (n = n !== null ? n.dehydrated : null),
                      !n)
                    )
                      throw Error(s(317));
                    n[ke] = t;
                  } else
                    (Ya(),
                      (t.flags & 128) === 0 && (t.memoizedState = null),
                      (t.flags |= 4));
                  (Re(t), (n = !1));
                } else
                  ((n = as()),
                    e !== null &&
                      e.memoizedState !== null &&
                      (e.memoizedState.hydrationErrors = n),
                    (n = !0));
                if (!n) return t.flags & 256 ? (vt(t), t) : (vt(t), null);
              }
              return (
                vt(t),
                (t.flags & 128) !== 0
                  ? ((t.lanes = a), t)
                  : ((a = l !== null),
                    (e = e !== null && e.memoizedState !== null),
                    a &&
                      ((l = t.child),
                      (n = null),
                      l.alternate !== null &&
                        l.alternate.memoizedState !== null &&
                        l.alternate.memoizedState.cachePool !== null &&
                        (n = l.alternate.memoizedState.cachePool.pool),
                      (i = null),
                      l.memoizedState !== null &&
                        l.memoizedState.cachePool !== null &&
                        (i = l.memoizedState.cachePool.pool),
                      i !== n && (l.flags |= 2048)),
                    a !== e && a && (t.child.flags |= 8192),
                    Ri(t, t.updateQueue),
                    Re(t),
                    null)
              );
            case 4:
              return (
                He(),
                e === null && gc(t.stateNode.containerInfo),
                Re(t),
                null
              );
            case 10:
              return (Ft(t.type), Re(t), null);
            case 19:
              if ((C(Be), (l = t.memoizedState), l === null))
                return (Re(t), null);
              if (((n = (t.flags & 128) !== 0), (i = l.rendering), i === null))
                if (n) bn(l, !1);
                else {
                  if (Ue !== 0 || (e !== null && (e.flags & 128) !== 0))
                    for (e = t.child; e !== null;) {
                      if (((i = bi(e)), i !== null)) {
                        for (
                          t.flags |= 128,
                            bn(l, !1),
                            e = i.updateQueue,
                            t.updateQueue = e,
                            Ri(t, e),
                            t.subtreeFlags = 0,
                            e = a,
                            a = t.child;
                          a !== null;
                        )
                          (ao(a, e), (a = a.sibling));
                        return (
                          H(Be, (Be.current & 1) | 2),
                          de && $t(t, l.treeForkCount),
                          t.child
                        );
                      }
                      e = e.sibling;
                    }
                  l.tail !== null &&
                    dt() > Bi &&
                    ((t.flags |= 128),
                    (n = !0),
                    bn(l, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!n)
                  if (((e = bi(i)), e !== null)) {
                    if (
                      ((t.flags |= 128),
                      (n = !0),
                      (e = e.updateQueue),
                      (t.updateQueue = e),
                      Ri(t, e),
                      bn(l, !0),
                      l.tail === null &&
                        l.tailMode === 'hidden' &&
                        !i.alternate &&
                        !de)
                    )
                      return (Re(t), null);
                  } else
                    2 * dt() - l.renderingStartTime > Bi &&
                      a !== 536870912 &&
                      ((t.flags |= 128),
                      (n = !0),
                      bn(l, !1),
                      (t.lanes = 4194304));
                l.isBackwards
                  ? ((i.sibling = t.child), (t.child = i))
                  : ((e = l.last),
                    e !== null ? (e.sibling = i) : (t.child = i),
                    (l.last = i));
              }
              return l.tail !== null
                ? ((e = l.tail),
                  (l.rendering = e),
                  (l.tail = e.sibling),
                  (l.renderingStartTime = dt()),
                  (e.sibling = null),
                  (a = Be.current),
                  H(Be, n ? (a & 1) | 2 : a & 1),
                  de && $t(t, l.treeForkCount),
                  e)
                : (Re(t), null);
            case 22:
            case 23:
              return (
                vt(t),
                ms(),
                (l = t.memoizedState !== null),
                e !== null
                  ? (e.memoizedState !== null) !== l && (t.flags |= 8192)
                  : l && (t.flags |= 8192),
                l
                  ? (a & 536870912) !== 0 &&
                    (t.flags & 128) === 0 &&
                    (Re(t), t.subtreeFlags & 6 && (t.flags |= 8192))
                  : Re(t),
                (a = t.updateQueue),
                a !== null && Ri(t, a.retryQueue),
                (a = null),
                e !== null &&
                  e.memoizedState !== null &&
                  e.memoizedState.cachePool !== null &&
                  (a = e.memoizedState.cachePool.pool),
                (l = null),
                t.memoizedState !== null &&
                  t.memoizedState.cachePool !== null &&
                  (l = t.memoizedState.cachePool.pool),
                l !== a && (t.flags |= 2048),
                e !== null && C(Qa),
                null
              );
            case 24:
              return (
                (a = null),
                e !== null && (a = e.memoizedState.cache),
                t.memoizedState.cache !== a && (t.flags |= 2048),
                Ft(Ge),
                Re(t),
                null
              );
            case 25:
              return null;
            case 30:
              return null;
          }
          throw Error(s(156, t.tag));
        }
        function bm(e, t) {
          switch ((es(t), t.tag)) {
            case 1:
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 3:
              return (
                Ft(Ge),
                He(),
                (e = t.flags),
                (e & 65536) !== 0 && (e & 128) === 0
                  ? ((t.flags = (e & -65537) | 128), t)
                  : null
              );
            case 26:
            case 27:
            case 5:
              return (wn(t), null);
            case 31:
              if (t.memoizedState !== null) {
                if ((vt(t), t.alternate === null)) throw Error(s(340));
                Ya();
              }
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 13:
              if (
                (vt(t),
                (e = t.memoizedState),
                e !== null && e.dehydrated !== null)
              ) {
                if (t.alternate === null) throw Error(s(340));
                Ya();
              }
              return (
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 19:
              return (C(Be), null);
            case 4:
              return (He(), null);
            case 10:
              return (Ft(t.type), null);
            case 22:
            case 23:
              return (
                vt(t),
                ms(),
                e !== null && C(Qa),
                (e = t.flags),
                e & 65536 ? ((t.flags = (e & -65537) | 128), t) : null
              );
            case 24:
              return (Ft(Ge), null);
            case 25:
              return null;
            default:
              return null;
          }
        }
        function Cr(e, t) {
          switch ((es(t), t.tag)) {
            case 3:
              (Ft(Ge), He());
              break;
            case 26:
            case 27:
            case 5:
              wn(t);
              break;
            case 4:
              He();
              break;
            case 31:
              t.memoizedState !== null && vt(t);
              break;
            case 13:
              vt(t);
              break;
            case 19:
              C(Be);
              break;
            case 10:
              Ft(t.type);
              break;
            case 22:
            case 23:
              (vt(t), ms(), e !== null && C(Qa));
              break;
            case 24:
              Ft(Ge);
          }
        }
        function Sn(e, t) {
          try {
            var a = t.updateQueue,
              l = a !== null ? a.lastEffect : null;
            if (l !== null) {
              var n = l.next;
              a = n;
              do {
                if ((a.tag & e) === e) {
                  l = void 0;
                  var i = a.create,
                    c = a.inst;
                  ((l = i()), (c.destroy = l));
                }
                a = a.next;
              } while (a !== n);
            }
          } catch (d) {
            Te(t, t.return, d);
          }
        }
        function Sa(e, t, a) {
          try {
            var l = t.updateQueue,
              n = l !== null ? l.lastEffect : null;
            if (n !== null) {
              var i = n.next;
              l = i;
              do {
                if ((l.tag & e) === e) {
                  var c = l.inst,
                    d = c.destroy;
                  if (d !== void 0) {
                    ((c.destroy = void 0), (n = t));
                    var p = a,
                      O = d;
                    try {
                      O();
                    } catch (N) {
                      Te(n, p, N);
                    }
                  }
                }
                l = l.next;
              } while (l !== i);
            }
          } catch (N) {
            Te(t, t.return, N);
          }
        }
        function Dr(e) {
          var t = e.updateQueue;
          if (t !== null) {
            var a = e.stateNode;
            try {
              Ao(t, a);
            } catch (l) {
              Te(e, e.return, l);
            }
          }
        }
        function Rr(e, t, a) {
          ((a.props = ka(e.type, e.memoizedProps)),
            (a.state = e.memoizedState));
          try {
            a.componentWillUnmount();
          } catch (l) {
            Te(e, t, l);
          }
        }
        function An(e, t) {
          try {
            var a = e.ref;
            if (a !== null) {
              switch (e.tag) {
                case 26:
                case 27:
                case 5:
                  var l = e.stateNode;
                  break;
                case 30:
                  l = e.stateNode;
                  break;
                default:
                  l = e.stateNode;
              }
              typeof a == 'function' ? (e.refCleanup = a(l)) : (a.current = l);
            }
          } catch (n) {
            Te(e, t, n);
          }
        }
        function Yt(e, t) {
          var a = e.ref,
            l = e.refCleanup;
          if (a !== null)
            if (typeof l == 'function')
              try {
                l();
              } catch (n) {
                Te(e, t, n);
              } finally {
                ((e.refCleanup = null),
                  (e = e.alternate),
                  e != null && (e.refCleanup = null));
              }
            else if (typeof a == 'function')
              try {
                a(null);
              } catch (n) {
                Te(e, t, n);
              }
            else a.current = null;
        }
        function jr(e) {
          var t = e.type,
            a = e.memoizedProps,
            l = e.stateNode;
          try {
            e: switch (t) {
              case 'button':
              case 'input':
              case 'select':
              case 'textarea':
                a.autoFocus && l.focus();
                break e;
              case 'img':
                a.src ? (l.src = a.src) : a.srcSet && (l.srcset = a.srcSet);
            }
          } catch (n) {
            Te(e, e.return, n);
          }
        }
        function Js(e, t, a) {
          try {
            var l = e.stateNode;
            (Ym(l, e.type, a, t), (l[nt] = t));
          } catch (n) {
            Te(e, e.return, n);
          }
        }
        function Lr(e) {
          return (
            e.tag === 5 ||
            e.tag === 3 ||
            e.tag === 26 ||
            (e.tag === 27 && za(e.type)) ||
            e.tag === 4
          );
        }
        function $s(e) {
          e: for (;;) {
            for (; e.sibling === null;) {
              if (e.return === null || Lr(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              e.tag !== 5 && e.tag !== 6 && e.tag !== 18;
            ) {
              if (
                (e.tag === 27 && za(e.type)) ||
                e.flags & 2 ||
                e.child === null ||
                e.tag === 4
              )
                continue e;
              ((e.child.return = e), (e = e.child));
            }
            if (!(e.flags & 2)) return e.stateNode;
          }
        }
        function ks(e, t, a) {
          var l = e.tag;
          if (l === 5 || l === 6)
            ((e = e.stateNode),
              t
                ? (a.nodeType === 9
                    ? a.body
                    : a.nodeName === 'HTML'
                      ? a.ownerDocument.body
                      : a
                  ).insertBefore(e, t)
                : ((t =
                    a.nodeType === 9
                      ? a.body
                      : a.nodeName === 'HTML'
                        ? a.ownerDocument.body
                        : a),
                  t.appendChild(e),
                  (a = a._reactRootContainer),
                  a != null || t.onclick !== null || (t.onclick = Xt)));
          else if (
            l !== 4 &&
            (l === 27 && za(e.type) && ((a = e.stateNode), (t = null)),
            (e = e.child),
            e !== null)
          )
            for (ks(e, t, a), e = e.sibling; e !== null;)
              (ks(e, t, a), (e = e.sibling));
        }
        function ji(e, t, a) {
          var l = e.tag;
          if (l === 5 || l === 6)
            ((e = e.stateNode), t ? a.insertBefore(e, t) : a.appendChild(e));
          else if (
            l !== 4 &&
            (l === 27 && za(e.type) && (a = e.stateNode),
            (e = e.child),
            e !== null)
          )
            for (ji(e, t, a), e = e.sibling; e !== null;)
              (ji(e, t, a), (e = e.sibling));
        }
        function Ur(e) {
          var t = e.stateNode,
            a = e.memoizedProps;
          try {
            for (var l = e.type, n = t.attributes; n.length;)
              t.removeAttributeNode(n[0]);
            (Pe(t, l, a), (t[ke] = e), (t[nt] = a));
          } catch (i) {
            Te(e, e.return, i);
          }
        }
        var ta = !1,
          we = !1,
          Fs = !1,
          Hr = typeof WeakSet == 'function' ? WeakSet : Set,
          Je = null;
        function Sm(e, t) {
          if (((e = e.containerInfo), (yc = eu), (e = Jf(e)), wu(e))) {
            if ('selectionStart' in e)
              var a = { start: e.selectionStart, end: e.selectionEnd };
            else {
              a = ((a = e.ownerDocument) && a.defaultView) || window;
              var l = a.getSelection && a.getSelection();
              if (l && l.rangeCount !== 0) {
                a = l.anchorNode;
                var n = l.anchorOffset,
                  i = l.focusNode;
                l = l.focusOffset;
                var c = 0,
                  d = -1,
                  p = -1,
                  O = 0,
                  N = 0,
                  R = e,
                  x = null;
                e: for (;;) {
                  for (
                    var M;
                    R !== a || (n !== 0 && R.nodeType !== 3) || (d = c + n),
                      R !== i || (l !== 0 && R.nodeType !== 3) || (p = c + l),
                      R.nodeType === 3 && (c += R.nodeValue.length),
                      (M = R.firstChild) !== null;
                  )
                    ((x = R), (R = M));
                  for (;;) {
                    if (R === e) break e;
                    if (
                      (x === a && ++O === n && (d = c),
                      x === i && ++N === l && (p = c),
                      (M = R.nextSibling) !== null)
                    )
                      break;
                    ((R = x), (x = R.parentNode));
                  }
                  R = M;
                }
                a = d === -1 || p === -1 ? null : { start: d, end: p };
              } else a = null;
            }
            a = a || { start: 0, end: 0 };
          } else a = null;
          for (
            vc = { focusedElem: e, selectionRange: a }, eu = !1, Je = t;
            Je !== null;
          )
            if (
              ((t = Je),
              (e = t.child),
              (t.subtreeFlags & 1028) !== 0 && e !== null)
            )
              ((e.return = t), (Je = e));
            else
              for (; Je !== null;) {
                switch (((t = Je), (i = t.alternate), (e = t.flags), t.tag)) {
                  case 0:
                    if (
                      (e & 4) !== 0 &&
                      ((e = t.updateQueue),
                      (e = e !== null ? e.events : null),
                      e !== null)
                    )
                      for (a = 0; a < e.length; a++)
                        ((n = e[a]), (n.ref.impl = n.nextImpl));
                    break;
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if ((e & 1024) !== 0 && i !== null) {
                      ((e = void 0),
                        (a = t),
                        (n = i.memoizedProps),
                        (i = i.memoizedState),
                        (l = a.stateNode));
                      try {
                        var Y = ka(a.type, n);
                        ((e = l.getSnapshotBeforeUpdate(Y, i)),
                          (l.__reactInternalSnapshotBeforeUpdate = e));
                      } catch (Z) {
                        Te(a, a.return, Z);
                      }
                    }
                    break;
                  case 3:
                    if ((e & 1024) !== 0) {
                      if (
                        ((e = t.stateNode.containerInfo),
                        (a = e.nodeType),
                        a === 9)
                      )
                        Ac(e);
                      else if (a === 1)
                        switch (e.nodeName) {
                          case 'HEAD':
                          case 'HTML':
                          case 'BODY':
                            Ac(e);
                            break;
                          default:
                            e.textContent = '';
                        }
                    }
                    break;
                  case 5:
                  case 26:
                  case 27:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    if ((e & 1024) !== 0) throw Error(s(163));
                }
                if (((e = t.sibling), e !== null)) {
                  ((e.return = t.return), (Je = e));
                  break;
                }
                Je = t.return;
              }
        }
        function Br(e, t, a) {
          var l = a.flags;
          switch (a.tag) {
            case 0:
            case 11:
            case 15:
              (la(e, a), l & 4 && Sn(5, a));
              break;
            case 1:
              if ((la(e, a), l & 4))
                if (((e = a.stateNode), t === null))
                  try {
                    e.componentDidMount();
                  } catch (c) {
                    Te(a, a.return, c);
                  }
                else {
                  var n = ka(a.type, t.memoizedProps);
                  t = t.memoizedState;
                  try {
                    e.componentDidUpdate(
                      n,
                      t,
                      e.__reactInternalSnapshotBeforeUpdate
                    );
                  } catch (c) {
                    Te(a, a.return, c);
                  }
                }
              (l & 64 && Dr(a), l & 512 && An(a, a.return));
              break;
            case 3:
              if ((la(e, a), l & 64 && ((e = a.updateQueue), e !== null))) {
                if (((t = null), a.child !== null))
                  switch (a.child.tag) {
                    case 27:
                    case 5:
                      t = a.child.stateNode;
                      break;
                    case 1:
                      t = a.child.stateNode;
                  }
                try {
                  Ao(e, t);
                } catch (c) {
                  Te(a, a.return, c);
                }
              }
              break;
            case 27:
              t === null && l & 4 && Ur(a);
            case 26:
            case 5:
              (la(e, a),
                t === null && l & 4 && jr(a),
                l & 512 && An(a, a.return));
              break;
            case 12:
              la(e, a);
              break;
            case 31:
              (la(e, a), l & 4 && Gr(e, a));
              break;
            case 13:
              (la(e, a),
                l & 4 && Yr(e, a),
                l & 64 &&
                  ((e = a.memoizedState),
                  e !== null &&
                    ((e = e.dehydrated),
                    e !== null && ((a = Nm.bind(null, a)), km(e, a)))));
              break;
            case 22:
              if (((l = a.memoizedState !== null || ta), !l)) {
                ((t = (t !== null && t.memoizedState !== null) || we),
                  (n = ta));
                var i = we;
                ((ta = l),
                  (we = t) && !i
                    ? na(e, a, (a.subtreeFlags & 8772) !== 0)
                    : la(e, a),
                  (ta = n),
                  (we = i));
              }
              break;
            case 30:
              break;
            default:
              la(e, a);
          }
        }
        function Kr(e) {
          var t = e.alternate;
          (t !== null && ((e.alternate = null), Kr(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            e.tag === 5 && ((t = e.stateNode), t !== null && Mu(t)),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null));
        }
        var je = null,
          ut = !1;
        function aa(e, t, a) {
          for (a = a.child; a !== null;) (qr(e, t, a), (a = a.sibling));
        }
        function qr(e, t, a) {
          if (ht && typeof ht.onCommitFiberUnmount == 'function')
            try {
              ht.onCommitFiberUnmount(Ql, a);
            } catch {}
          switch (a.tag) {
            case 26:
              (we || Yt(a, t),
                aa(e, t, a),
                a.memoizedState
                  ? a.memoizedState.count--
                  : a.stateNode &&
                    ((a = a.stateNode), a.parentNode.removeChild(a)));
              break;
            case 27:
              we || Yt(a, t);
              var l = je,
                n = ut;
              (za(a.type) && ((je = a.stateNode), (ut = !1)),
                aa(e, t, a),
                Cn(a.stateNode),
                (je = l),
                (ut = n));
              break;
            case 5:
              we || Yt(a, t);
            case 6:
              if (
                ((l = je),
                (n = ut),
                (je = null),
                aa(e, t, a),
                (je = l),
                (ut = n),
                je !== null)
              )
                if (ut)
                  try {
                    (je.nodeType === 9
                      ? je.body
                      : je.nodeName === 'HTML'
                        ? je.ownerDocument.body
                        : je
                    ).removeChild(a.stateNode);
                  } catch (i) {
                    Te(a, t, i);
                  }
                else
                  try {
                    je.removeChild(a.stateNode);
                  } catch (i) {
                    Te(a, t, i);
                  }
              break;
            case 18:
              je !== null &&
                (ut
                  ? ((e = je),
                    Dd(
                      e.nodeType === 9
                        ? e.body
                        : e.nodeName === 'HTML'
                          ? e.ownerDocument.body
                          : e,
                      a.stateNode
                    ),
                    ql(e))
                  : Dd(je, a.stateNode));
              break;
            case 4:
              ((l = je),
                (n = ut),
                (je = a.stateNode.containerInfo),
                (ut = !0),
                aa(e, t, a),
                (je = l),
                (ut = n));
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              (Sa(2, a, t), we || Sa(4, a, t), aa(e, t, a));
              break;
            case 1:
              (we ||
                (Yt(a, t),
                (l = a.stateNode),
                typeof l.componentWillUnmount == 'function' && Rr(a, t, l)),
                aa(e, t, a));
              break;
            case 21:
              aa(e, t, a);
              break;
            case 22:
              ((we = (l = we) || a.memoizedState !== null),
                aa(e, t, a),
                (we = l));
              break;
            default:
              aa(e, t, a);
          }
        }
        function Gr(e, t) {
          if (
            t.memoizedState === null &&
            ((e = t.alternate),
            e !== null && ((e = e.memoizedState), e !== null))
          ) {
            e = e.dehydrated;
            try {
              ql(e);
            } catch (a) {
              Te(t, t.return, a);
            }
          }
        }
        function Yr(e, t) {
          if (
            t.memoizedState === null &&
            ((e = t.alternate),
            e !== null &&
              ((e = e.memoizedState),
              e !== null && ((e = e.dehydrated), e !== null)))
          )
            try {
              ql(e);
            } catch (a) {
              Te(t, t.return, a);
            }
        }
        function Am(e) {
          switch (e.tag) {
            case 31:
            case 13:
            case 19:
              var t = e.stateNode;
              return (t === null && (t = e.stateNode = new Hr()), t);
            case 22:
              return (
                (e = e.stateNode),
                (t = e._retryCache),
                t === null && (t = e._retryCache = new Hr()),
                t
              );
            default:
              throw Error(s(435, e.tag));
          }
        }
        function Li(e, t) {
          var a = Am(e);
          t.forEach(function (l) {
            if (!a.has(l)) {
              a.add(l);
              var n = Cm.bind(null, e, l);
              l.then(n, n);
            }
          });
        }
        function st(e, t) {
          var a = t.deletions;
          if (a !== null)
            for (var l = 0; l < a.length; l++) {
              var n = a[l],
                i = e,
                c = t,
                d = c;
              e: for (; d !== null;) {
                switch (d.tag) {
                  case 27:
                    if (za(d.type)) {
                      ((je = d.stateNode), (ut = !1));
                      break e;
                    }
                    break;
                  case 5:
                    ((je = d.stateNode), (ut = !1));
                    break e;
                  case 3:
                  case 4:
                    ((je = d.stateNode.containerInfo), (ut = !0));
                    break e;
                }
                d = d.return;
              }
              if (je === null) throw Error(s(160));
              (qr(i, c, n),
                (je = null),
                (ut = !1),
                (i = n.alternate),
                i !== null && (i.return = null),
                (n.return = null));
            }
          if (t.subtreeFlags & 13886)
            for (t = t.child; t !== null;) (Vr(t, e), (t = t.sibling));
        }
        var Ht = null;
        function Vr(e, t) {
          var a = e.alternate,
            l = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              (st(t, e),
                ct(e),
                l & 4 && (Sa(3, e, e.return), Sn(3, e), Sa(5, e, e.return)));
              break;
            case 1:
              (st(t, e),
                ct(e),
                l & 512 && (we || a === null || Yt(a, a.return)),
                l & 64 &&
                  ta &&
                  ((e = e.updateQueue),
                  e !== null &&
                    ((l = e.callbacks),
                    l !== null &&
                      ((a = e.shared.hiddenCallbacks),
                      (e.shared.hiddenCallbacks =
                        a === null ? l : a.concat(l))))));
              break;
            case 26:
              var n = Ht;
              if (
                (st(t, e),
                ct(e),
                l & 512 && (we || a === null || Yt(a, a.return)),
                l & 4)
              ) {
                var i = a !== null ? a.memoizedState : null;
                if (((l = e.memoizedState), a === null))
                  if (l === null)
                    if (e.stateNode === null) {
                      e: {
                        ((l = e.type),
                          (a = e.memoizedProps),
                          (n = n.ownerDocument || n));
                        t: switch (l) {
                          case 'title':
                            ((i = n.getElementsByTagName('title')[0]),
                              (!i ||
                                i[Jl] ||
                                i[ke] ||
                                i.namespaceURI ===
                                  'http://www.w3.org/2000/svg' ||
                                i.hasAttribute('itemprop')) &&
                                ((i = n.createElement(l)),
                                n.head.insertBefore(
                                  i,
                                  n.querySelector('head > title')
                                )),
                              Pe(i, l, a),
                              (i[ke] = e),
                              Ze(i),
                              (l = i));
                            break e;
                          case 'link':
                            var c = Vd('link', 'href', n).get(
                              l + (a.href || '')
                            );
                            if (c) {
                              for (var d = 0; d < c.length; d++)
                                if (
                                  ((i = c[d]),
                                  i.getAttribute('href') ===
                                    (a.href == null || a.href === ''
                                      ? null
                                      : a.href) &&
                                    i.getAttribute('rel') ===
                                      (a.rel == null ? null : a.rel) &&
                                    i.getAttribute('title') ===
                                      (a.title == null ? null : a.title) &&
                                    i.getAttribute('crossorigin') ===
                                      (a.crossOrigin == null
                                        ? null
                                        : a.crossOrigin))
                                ) {
                                  c.splice(d, 1);
                                  break t;
                                }
                            }
                            ((i = n.createElement(l)),
                              Pe(i, l, a),
                              n.head.appendChild(i));
                            break;
                          case 'meta':
                            if (
                              (c = Vd('meta', 'content', n).get(
                                l + (a.content || '')
                              ))
                            ) {
                              for (d = 0; d < c.length; d++)
                                if (
                                  ((i = c[d]),
                                  i.getAttribute('content') ===
                                    (a.content == null
                                      ? null
                                      : '' + a.content) &&
                                    i.getAttribute('name') ===
                                      (a.name == null ? null : a.name) &&
                                    i.getAttribute('property') ===
                                      (a.property == null
                                        ? null
                                        : a.property) &&
                                    i.getAttribute('http-equiv') ===
                                      (a.httpEquiv == null
                                        ? null
                                        : a.httpEquiv) &&
                                    i.getAttribute('charset') ===
                                      (a.charSet == null ? null : a.charSet))
                                ) {
                                  c.splice(d, 1);
                                  break t;
                                }
                            }
                            ((i = n.createElement(l)),
                              Pe(i, l, a),
                              n.head.appendChild(i));
                            break;
                          default:
                            throw Error(s(468, l));
                        }
                        ((i[ke] = e), Ze(i), (l = i));
                      }
                      e.stateNode = l;
                    } else wd(n, e.type, e.stateNode);
                  else e.stateNode = Yd(n, l, e.memoizedProps);
                else
                  i !== l
                    ? (i === null
                        ? a.stateNode !== null &&
                          ((a = a.stateNode), a.parentNode.removeChild(a))
                        : i.count--,
                      l === null
                        ? wd(n, e.type, e.stateNode)
                        : Yd(n, l, e.memoizedProps))
                    : l === null &&
                      e.stateNode !== null &&
                      Js(e, e.memoizedProps, a.memoizedProps);
              }
              break;
            case 27:
              (st(t, e),
                ct(e),
                l & 512 && (we || a === null || Yt(a, a.return)),
                a !== null && l & 4 && Js(e, e.memoizedProps, a.memoizedProps));
              break;
            case 5:
              if (
                (st(t, e),
                ct(e),
                l & 512 && (we || a === null || Yt(a, a.return)),
                e.flags & 32)
              ) {
                n = e.stateNode;
                try {
                  cl(n, '');
                } catch (Y) {
                  Te(e, e.return, Y);
                }
              }
              (l & 4 &&
                e.stateNode != null &&
                ((n = e.memoizedProps),
                Js(e, n, a !== null ? a.memoizedProps : n)),
                l & 1024 && (Fs = !0));
              break;
            case 6:
              if ((st(t, e), ct(e), l & 4)) {
                if (e.stateNode === null) throw Error(s(162));
                ((l = e.memoizedProps), (a = e.stateNode));
                try {
                  a.nodeValue = l;
                } catch (Y) {
                  Te(e, e.return, Y);
                }
              }
              break;
            case 3:
              if (
                ((Fi = null),
                (n = Ht),
                (Ht = $i(t.containerInfo)),
                st(t, e),
                (Ht = n),
                ct(e),
                l & 4 && a !== null && a.memoizedState.isDehydrated)
              )
                try {
                  ql(t.containerInfo);
                } catch (Y) {
                  Te(e, e.return, Y);
                }
              Fs && ((Fs = !1), wr(e));
              break;
            case 4:
              ((l = Ht),
                (Ht = $i(e.stateNode.containerInfo)),
                st(t, e),
                ct(e),
                (Ht = l));
              break;
            case 12:
              (st(t, e), ct(e));
              break;
            case 31:
              (st(t, e),
                ct(e),
                l & 4 &&
                  ((l = e.updateQueue),
                  l !== null && ((e.updateQueue = null), Li(e, l))));
              break;
            case 13:
              (st(t, e),
                ct(e),
                e.child.flags & 8192 &&
                  (e.memoizedState !== null) !=
                    (a !== null && a.memoizedState !== null) &&
                  (Hi = dt()),
                l & 4 &&
                  ((l = e.updateQueue),
                  l !== null && ((e.updateQueue = null), Li(e, l))));
              break;
            case 22:
              n = e.memoizedState !== null;
              var p = a !== null && a.memoizedState !== null,
                O = ta,
                N = we;
              if (
                ((ta = O || n),
                (we = N || p),
                st(t, e),
                (we = N),
                (ta = O),
                ct(e),
                l & 8192)
              )
                e: for (
                  t = e.stateNode,
                    t._visibility = n ? t._visibility & -2 : t._visibility | 1,
                    n && (a === null || p || ta || we || Fa(e)),
                    a = null,
                    t = e;
                  ;
                ) {
                  if (t.tag === 5 || t.tag === 26) {
                    if (a === null) {
                      p = a = t;
                      try {
                        if (((i = p.stateNode), n))
                          ((c = i.style),
                            typeof c.setProperty == 'function'
                              ? c.setProperty('display', 'none', 'important')
                              : (c.display = 'none'));
                        else {
                          d = p.stateNode;
                          var R = p.memoizedProps.style,
                            x =
                              R != null && R.hasOwnProperty('display')
                                ? R.display
                                : null;
                          d.style.display =
                            x == null || typeof x == 'boolean'
                              ? ''
                              : ('' + x).trim();
                        }
                      } catch (Y) {
                        Te(p, p.return, Y);
                      }
                    }
                  } else if (t.tag === 6) {
                    if (a === null) {
                      p = t;
                      try {
                        p.stateNode.nodeValue = n ? '' : p.memoizedProps;
                      } catch (Y) {
                        Te(p, p.return, Y);
                      }
                    }
                  } else if (t.tag === 18) {
                    if (a === null) {
                      p = t;
                      try {
                        var M = p.stateNode;
                        n ? Rd(M, !0) : Rd(p.stateNode, !1);
                      } catch (Y) {
                        Te(p, p.return, Y);
                      }
                    }
                  } else if (
                    ((t.tag !== 22 && t.tag !== 23) ||
                      t.memoizedState === null ||
                      t === e) &&
                    t.child !== null
                  ) {
                    ((t.child.return = t), (t = t.child));
                    continue;
                  }
                  if (t === e) break e;
                  for (; t.sibling === null;) {
                    if (t.return === null || t.return === e) break e;
                    (a === t && (a = null), (t = t.return));
                  }
                  (a === t && (a = null),
                    (t.sibling.return = t.return),
                    (t = t.sibling));
                }
              l & 4 &&
                ((l = e.updateQueue),
                l !== null &&
                  ((a = l.retryQueue),
                  a !== null && ((l.retryQueue = null), Li(e, a))));
              break;
            case 19:
              (st(t, e),
                ct(e),
                l & 4 &&
                  ((l = e.updateQueue),
                  l !== null && ((e.updateQueue = null), Li(e, l))));
              break;
            case 30:
              break;
            case 21:
              break;
            default:
              (st(t, e), ct(e));
          }
        }
        function ct(e) {
          var t = e.flags;
          if (t & 2) {
            try {
              for (var a, l = e.return; l !== null;) {
                if (Lr(l)) {
                  a = l;
                  break;
                }
                l = l.return;
              }
              if (a == null) throw Error(s(160));
              switch (a.tag) {
                case 27:
                  var n = a.stateNode,
                    i = $s(e);
                  ji(e, i, n);
                  break;
                case 5:
                  var c = a.stateNode;
                  a.flags & 32 && (cl(c, ''), (a.flags &= -33));
                  var d = $s(e);
                  ji(e, d, c);
                  break;
                case 3:
                case 4:
                  var p = a.stateNode.containerInfo,
                    O = $s(e);
                  ks(e, O, p);
                  break;
                default:
                  throw Error(s(161));
              }
            } catch (N) {
              Te(e, e.return, N);
            }
            e.flags &= -3;
          }
          t & 4096 && (e.flags &= -4097);
        }
        function wr(e) {
          if (e.subtreeFlags & 1024)
            for (e = e.child; e !== null;) {
              var t = e;
              (wr(t),
                t.tag === 5 && t.flags & 1024 && t.stateNode.reset(),
                (e = e.sibling));
            }
        }
        function la(e, t) {
          if (t.subtreeFlags & 8772)
            for (t = t.child; t !== null;)
              (Br(e, t.alternate, t), (t = t.sibling));
        }
        function Fa(e) {
          for (e = e.child; e !== null;) {
            var t = e;
            switch (t.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                (Sa(4, t, t.return), Fa(t));
                break;
              case 1:
                Yt(t, t.return);
                var a = t.stateNode;
                (typeof a.componentWillUnmount == 'function' &&
                  Rr(t, t.return, a),
                  Fa(t));
                break;
              case 27:
                Cn(t.stateNode);
              case 26:
              case 5:
                (Yt(t, t.return), Fa(t));
                break;
              case 22:
                t.memoizedState === null && Fa(t);
                break;
              case 30:
                Fa(t);
                break;
              default:
                Fa(t);
            }
            e = e.sibling;
          }
        }
        function na(e, t, a) {
          for (
            a = a && (t.subtreeFlags & 8772) !== 0, t = t.child;
            t !== null;
          ) {
            var l = t.alternate,
              n = e,
              i = t,
              c = i.flags;
            switch (i.tag) {
              case 0:
              case 11:
              case 15:
                (na(n, i, a), Sn(4, i));
                break;
              case 1:
                if (
                  (na(n, i, a),
                  (l = i),
                  (n = l.stateNode),
                  typeof n.componentDidMount == 'function')
                )
                  try {
                    n.componentDidMount();
                  } catch (O) {
                    Te(l, l.return, O);
                  }
                if (((l = i), (n = l.updateQueue), n !== null)) {
                  var d = l.stateNode;
                  try {
                    var p = n.shared.hiddenCallbacks;
                    if (p !== null)
                      for (
                        n.shared.hiddenCallbacks = null, n = 0;
                        n < p.length;
                        n++
                      )
                        So(p[n], d);
                  } catch (O) {
                    Te(l, l.return, O);
                  }
                }
                (a && c & 64 && Dr(i), An(i, i.return));
                break;
              case 27:
                Ur(i);
              case 26:
              case 5:
                (na(n, i, a),
                  a && l === null && c & 4 && jr(i),
                  An(i, i.return));
                break;
              case 12:
                na(n, i, a);
                break;
              case 31:
                (na(n, i, a), a && c & 4 && Gr(n, i));
                break;
              case 13:
                (na(n, i, a), a && c & 4 && Yr(n, i));
                break;
              case 22:
                (i.memoizedState === null && na(n, i, a), An(i, i.return));
                break;
              case 30:
                break;
              default:
                na(n, i, a);
            }
            t = t.sibling;
          }
        }
        function Ws(e, t) {
          var a = null;
          (e !== null &&
            e.memoizedState !== null &&
            e.memoizedState.cachePool !== null &&
            (a = e.memoizedState.cachePool.pool),
            (e = null),
            t.memoizedState !== null &&
              t.memoizedState.cachePool !== null &&
              (e = t.memoizedState.cachePool.pool),
            e !== a && (e != null && e.refCount++, a != null && sn(a)));
        }
        function Is(e, t) {
          ((e = null),
            t.alternate !== null && (e = t.alternate.memoizedState.cache),
            (t = t.memoizedState.cache),
            t !== e && (t.refCount++, e != null && sn(e)));
        }
        function Bt(e, t, a, l) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null;) (Qr(e, t, a, l), (t = t.sibling));
        }
        function Qr(e, t, a, l) {
          var n = t.flags;
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              (Bt(e, t, a, l), n & 2048 && Sn(9, t));
              break;
            case 1:
              Bt(e, t, a, l);
              break;
            case 3:
              (Bt(e, t, a, l),
                n & 2048 &&
                  ((e = null),
                  t.alternate !== null && (e = t.alternate.memoizedState.cache),
                  (t = t.memoizedState.cache),
                  t !== e && (t.refCount++, e != null && sn(e))));
              break;
            case 12:
              if (n & 2048) {
                (Bt(e, t, a, l), (e = t.stateNode));
                try {
                  var i = t.memoizedProps,
                    c = i.id,
                    d = i.onPostCommit;
                  typeof d == 'function' &&
                    d(
                      c,
                      t.alternate === null ? 'mount' : 'update',
                      e.passiveEffectDuration,
                      -0
                    );
                } catch (p) {
                  Te(t, t.return, p);
                }
              } else Bt(e, t, a, l);
              break;
            case 31:
              Bt(e, t, a, l);
              break;
            case 13:
              Bt(e, t, a, l);
              break;
            case 23:
              break;
            case 22:
              ((i = t.stateNode),
                (c = t.alternate),
                t.memoizedState !== null
                  ? i._visibility & 2
                    ? Bt(e, t, a, l)
                    : En(e, t)
                  : i._visibility & 2
                    ? Bt(e, t, a, l)
                    : ((i._visibility |= 2),
                      _l(e, t, a, l, (t.subtreeFlags & 10256) !== 0 || !1)),
                n & 2048 && Ws(c, t));
              break;
            case 24:
              (Bt(e, t, a, l), n & 2048 && Is(t.alternate, t));
              break;
            default:
              Bt(e, t, a, l);
          }
        }
        function _l(e, t, a, l, n) {
          for (
            n = n && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child;
            t !== null;
          ) {
            var i = e,
              c = t,
              d = a,
              p = l,
              O = c.flags;
            switch (c.tag) {
              case 0:
              case 11:
              case 15:
                (_l(i, c, d, p, n), Sn(8, c));
                break;
              case 23:
                break;
              case 22:
                var N = c.stateNode;
                (c.memoizedState !== null
                  ? N._visibility & 2
                    ? _l(i, c, d, p, n)
                    : En(i, c)
                  : ((N._visibility |= 2), _l(i, c, d, p, n)),
                  n && O & 2048 && Ws(c.alternate, c));
                break;
              case 24:
                (_l(i, c, d, p, n), n && O & 2048 && Is(c.alternate, c));
                break;
              default:
                _l(i, c, d, p, n);
            }
            t = t.sibling;
          }
        }
        function En(e, t) {
          if (t.subtreeFlags & 10256)
            for (t = t.child; t !== null;) {
              var a = e,
                l = t,
                n = l.flags;
              switch (l.tag) {
                case 22:
                  (En(a, l), n & 2048 && Ws(l.alternate, l));
                  break;
                case 24:
                  (En(a, l), n & 2048 && Is(l.alternate, l));
                  break;
                default:
                  En(a, l);
              }
              t = t.sibling;
            }
        }
        var Tn = 8192;
        function Nl(e, t, a) {
          if (e.subtreeFlags & Tn)
            for (e = e.child; e !== null;) (Xr(e, t, a), (e = e.sibling));
        }
        function Xr(e, t, a) {
          switch (e.tag) {
            case 26:
              (Nl(e, t, a),
                e.flags & Tn &&
                  e.memoizedState !== null &&
                  sp(a, Ht, e.memoizedState, e.memoizedProps));
              break;
            case 5:
              Nl(e, t, a);
              break;
            case 3:
            case 4:
              var l = Ht;
              ((Ht = $i(e.stateNode.containerInfo)), Nl(e, t, a), (Ht = l));
              break;
            case 22:
              e.memoizedState === null &&
                ((l = e.alternate),
                l !== null && l.memoizedState !== null
                  ? ((l = Tn), (Tn = 16777216), Nl(e, t, a), (Tn = l))
                  : Nl(e, t, a));
              break;
            default:
              Nl(e, t, a);
          }
        }
        function Zr(e) {
          var t = e.alternate;
          if (t !== null && ((e = t.child), e !== null)) {
            t.child = null;
            do ((t = e.sibling), (e.sibling = null), (e = t));
            while (e !== null);
          }
        }
        function On(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var a = 0; a < t.length; a++) {
                var l = t[a];
                ((Je = l), $r(l, e));
              }
            Zr(e);
          }
          if (e.subtreeFlags & 10256)
            for (e = e.child; e !== null;) (Jr(e), (e = e.sibling));
        }
        function Jr(e) {
          switch (e.tag) {
            case 0:
            case 11:
            case 15:
              (On(e), e.flags & 2048 && Sa(9, e, e.return));
              break;
            case 3:
              On(e);
              break;
            case 12:
              On(e);
              break;
            case 22:
              var t = e.stateNode;
              e.memoizedState !== null &&
              t._visibility & 2 &&
              (e.return === null || e.return.tag !== 13)
                ? ((t._visibility &= -3), Ui(e))
                : On(e);
              break;
            default:
              On(e);
          }
        }
        function Ui(e) {
          var t = e.deletions;
          if ((e.flags & 16) !== 0) {
            if (t !== null)
              for (var a = 0; a < t.length; a++) {
                var l = t[a];
                ((Je = l), $r(l, e));
              }
            Zr(e);
          }
          for (e = e.child; e !== null;) {
            switch (((t = e), t.tag)) {
              case 0:
              case 11:
              case 15:
                (Sa(8, t, t.return), Ui(t));
                break;
              case 22:
                ((a = t.stateNode),
                  a._visibility & 2 && ((a._visibility &= -3), Ui(t)));
                break;
              default:
                Ui(t);
            }
            e = e.sibling;
          }
        }
        function $r(e, t) {
          for (; Je !== null;) {
            var a = Je;
            switch (a.tag) {
              case 0:
              case 11:
              case 15:
                Sa(8, a, t);
                break;
              case 23:
              case 22:
                if (
                  a.memoizedState !== null &&
                  a.memoizedState.cachePool !== null
                ) {
                  var l = a.memoizedState.cachePool.pool;
                  l != null && l.refCount++;
                }
                break;
              case 24:
                sn(a.memoizedState.cache);
            }
            if (((l = a.child), l !== null)) ((l.return = a), (Je = l));
            else
              e: for (a = e; Je !== null;) {
                l = Je;
                var n = l.sibling,
                  i = l.return;
                if ((Kr(l), l === a)) {
                  Je = null;
                  break e;
                }
                if (n !== null) {
                  ((n.return = i), (Je = n));
                  break e;
                }
                Je = i;
              }
          }
        }
        var Em = {
            getCacheForType: function (e) {
              var t = We(Ge),
                a = t.data.get(e);
              return (a === void 0 && ((a = e()), t.data.set(e, a)), a);
            },
            cacheSignal: function () {
              return We(Ge).controller.signal;
            },
          },
          Tm = typeof WeakMap == 'function' ? WeakMap : Map,
          ve = 0,
          _e = null,
          ne = null,
          ue = 0,
          Ee = 0,
          bt = null,
          Aa = !1,
          Cl = !1,
          Ps = !1,
          ia = 0,
          Ue = 0,
          Ea = 0,
          Wa = 0,
          ec = 0,
          St = 0,
          Dl = 0,
          xn = null,
          ft = null,
          tc = !1,
          Hi = 0,
          kr = 0,
          Bi = 1 / 0,
          Ki = null,
          Ta = null,
          Qe = 0,
          Oa = null,
          Rl = null,
          ua = 0,
          ac = 0,
          lc = null,
          Fr = null,
          Mn = 0,
          nc = null;
        function At() {
          return (ve & 2) !== 0 && ue !== 0
            ? ue & -ue
            : z.T !== null
              ? oc()
              : rf();
        }
        function Wr() {
          if (St === 0)
            if ((ue & 536870912) === 0 || de) {
              var e = Zn;
              ((Zn <<= 1), (Zn & 3932160) === 0 && (Zn = 262144), (St = e));
            } else St = 536870912;
          return ((e = yt.current), e !== null && (e.flags |= 32), St);
        }
        function ot(e, t, a) {
          (((e === _e && (Ee === 2 || Ee === 9)) ||
            e.cancelPendingCommit !== null) &&
            (jl(e, 0), xa(e, ue, St, !1)),
            Zl(e, a),
            ((ve & 2) === 0 || e !== _e) &&
              (e === _e &&
                ((ve & 2) === 0 && (Wa |= a), Ue === 4 && xa(e, ue, St, !1)),
              Vt(e)));
        }
        function Ir(e, t, a) {
          if ((ve & 6) !== 0) throw Error(s(327));
          var l =
              (!a && (t & 127) === 0 && (t & e.expiredLanes) === 0) || Xl(e, t),
            n = l ? Mm(e, t) : uc(e, t, !0),
            i = l;
          do {
            if (n === 0) {
              Cl && !l && xa(e, t, 0, !1);
              break;
            } else {
              if (((a = e.current.alternate), i && !Om(a))) {
                ((n = uc(e, t, !1)), (i = !1));
                continue;
              }
              if (n === 2) {
                if (((i = t), e.errorRecoveryDisabledLanes & i)) var c = 0;
                else
                  ((c = e.pendingLanes & -536870913),
                    (c = c !== 0 ? c : c & 536870912 ? 536870912 : 0));
                if (c !== 0) {
                  t = c;
                  e: {
                    var d = e;
                    n = xn;
                    var p = d.current.memoizedState.isDehydrated;
                    if (
                      (p && (jl(d, c).flags |= 256),
                      (c = uc(d, c, !1)),
                      c !== 2)
                    ) {
                      if (Ps && !p) {
                        ((d.errorRecoveryDisabledLanes |= i),
                          (Wa |= i),
                          (n = 4));
                        break e;
                      }
                      ((i = ft),
                        (ft = n),
                        i !== null &&
                          (ft === null ? (ft = i) : ft.push.apply(ft, i)));
                    }
                    n = c;
                  }
                  if (((i = !1), n !== 2)) continue;
                }
              }
              if (n === 1) {
                (jl(e, 0), xa(e, t, 0, !0));
                break;
              }
              e: {
                switch (((l = e), (i = n), i)) {
                  case 0:
                  case 1:
                    throw Error(s(345));
                  case 4:
                    if ((t & 4194048) !== t) break;
                  case 6:
                    xa(l, t, St, !Aa);
                    break e;
                  case 2:
                    ft = null;
                    break;
                  case 3:
                  case 5:
                    break;
                  default:
                    throw Error(s(329));
                }
                if ((t & 62914560) === t && ((n = Hi + 300 - dt()), 10 < n)) {
                  if ((xa(l, t, St, !Aa), $n(l, 0, !0) !== 0)) break e;
                  ((ua = t),
                    (l.timeoutHandle = Nd(
                      Pr.bind(
                        null,
                        l,
                        a,
                        ft,
                        Ki,
                        tc,
                        t,
                        St,
                        Wa,
                        Dl,
                        Aa,
                        i,
                        'Throttled',
                        -0,
                        0
                      ),
                      n
                    )));
                  break e;
                }
                Pr(l, a, ft, Ki, tc, t, St, Wa, Dl, Aa, i, null, -0, 0);
              }
            }
            break;
          } while (!0);
          Vt(e);
        }
        function Pr(e, t, a, l, n, i, c, d, p, O, N, R, x, M) {
          if (
            ((e.timeoutHandle = -1),
            (R = t.subtreeFlags),
            R & 8192 || (R & 16785408) === 16785408)
          ) {
            ((R = {
              stylesheets: null,
              count: 0,
              imgCount: 0,
              imgBytes: 0,
              suspenseyImages: [],
              waitingForImages: !0,
              waitingForViewTransition: !1,
              unsuspend: Xt,
            }),
              Xr(t, i, R));
            var Y =
              (i & 62914560) === i
                ? Hi - dt()
                : (i & 4194048) === i
                  ? kr - dt()
                  : 0;
            if (((Y = cp(R, Y)), Y !== null)) {
              ((ua = i),
                (e.cancelPendingCommit = Y(
                  sd.bind(null, e, t, i, a, l, n, c, d, p, N, R, null, x, M)
                )),
                xa(e, i, c, !O));
              return;
            }
          }
          sd(e, t, i, a, l, n, c, d, p);
        }
        function Om(e) {
          for (var t = e; ;) {
            var a = t.tag;
            if (
              (a === 0 || a === 11 || a === 15) &&
              t.flags & 16384 &&
              ((a = t.updateQueue), a !== null && ((a = a.stores), a !== null))
            )
              for (var l = 0; l < a.length; l++) {
                var n = a[l],
                  i = n.getSnapshot;
                n = n.value;
                try {
                  if (!mt(i(), n)) return !1;
                } catch {
                  return !1;
                }
              }
            if (((a = t.child), t.subtreeFlags & 16384 && a !== null))
              ((a.return = t), (t = a));
            else {
              if (t === e) break;
              for (; t.sibling === null;) {
                if (t.return === null || t.return === e) return !0;
                t = t.return;
              }
              ((t.sibling.return = t.return), (t = t.sibling));
            }
          }
          return !0;
        }
        function xa(e, t, a, l) {
          ((t &= ~ec),
            (t &= ~Wa),
            (e.suspendedLanes |= t),
            (e.pingedLanes &= ~t),
            l && (e.warmLanes |= t),
            (l = e.expirationTimes));
          for (var n = t; 0 < n;) {
            var i = 31 - gt(n),
              c = 1 << i;
            ((l[i] = -1), (n &= ~c));
          }
          a !== 0 && cf(e, a, t);
        }
        function qi() {
          return (ve & 6) === 0 ? (zn(0), !1) : !0;
        }
        function ic() {
          if (ne !== null) {
            if (Ee === 0) var e = ne.return;
            else
              ((e = ne),
                (kt = Va = null),
                As(e),
                (Tl = null),
                (fn = 0),
                (e = ne));
            for (; e !== null;) (Cr(e.alternate, e), (e = e.return));
            ne = null;
          }
        }
        function jl(e, t) {
          var a = e.timeoutHandle;
          (a !== -1 && ((e.timeoutHandle = -1), Qm(a)),
            (a = e.cancelPendingCommit),
            a !== null && ((e.cancelPendingCommit = null), a()),
            (ua = 0),
            ic(),
            (_e = e),
            (ne = a = Jt(e.current, null)),
            (ue = t),
            (Ee = 0),
            (bt = null),
            (Aa = !1),
            (Cl = Xl(e, t)),
            (Ps = !1),
            (Dl = St = ec = Wa = Ea = Ue = 0),
            (ft = xn = null),
            (tc = !1),
            (t & 8) !== 0 && (t |= t & 32));
          var l = e.entangledLanes;
          if (l !== 0)
            for (e = e.entanglements, l &= t; 0 < l;) {
              var n = 31 - gt(l),
                i = 1 << n;
              ((t |= e[n]), (l &= ~i));
            }
          return ((ia = t), ui(), a);
        }
        function ed(e, t) {
          ((I = null),
            (z.H = yn),
            t === El || t === gi
              ? ((t = po()), (Ee = 3))
              : t === fs
                ? ((t = po()), (Ee = 4))
                : (Ee =
                    t === Bs
                      ? 8
                      : t !== null &&
                          typeof t == 'object' &&
                          typeof t.then == 'function'
                        ? 6
                        : 1),
            (bt = t),
            ne === null && ((Ue = 1), _i(e, xt(t, e.current))));
        }
        function td() {
          var e = yt.current;
          return e === null
            ? !0
            : (ue & 4194048) === ue
              ? Nt === null
              : (ue & 62914560) === ue || (ue & 536870912) !== 0
                ? e === Nt
                : !1;
        }
        function ad() {
          var e = z.H;
          return ((z.H = yn), e === null ? yn : e);
        }
        function ld() {
          var e = z.A;
          return ((z.A = Em), e);
        }
        function Gi() {
          ((Ue = 4),
            Aa || ((ue & 4194048) !== ue && yt.current !== null) || (Cl = !0),
            ((Ea & 134217727) === 0 && (Wa & 134217727) === 0) ||
              _e === null ||
              xa(_e, ue, St, !1));
        }
        function uc(e, t, a) {
          var l = ve;
          ve |= 2;
          var n = ad(),
            i = ld();
          ((_e !== e || ue !== t) && ((Ki = null), jl(e, t)), (t = !1));
          var c = Ue;
          e: do
            try {
              if (Ee !== 0 && ne !== null) {
                var d = ne,
                  p = bt;
                switch (Ee) {
                  case 8:
                    (ic(), (c = 6));
                    break e;
                  case 3:
                  case 2:
                  case 9:
                  case 6:
                    yt.current === null && (t = !0);
                    var O = Ee;
                    if (((Ee = 0), (bt = null), Ll(e, d, p, O), a && Cl)) {
                      c = 0;
                      break e;
                    }
                    break;
                  default:
                    ((O = Ee), (Ee = 0), (bt = null), Ll(e, d, p, O));
                }
              }
              (xm(), (c = Ue));
              break;
            } catch (N) {
              ed(e, N);
            }
          while (!0);
          return (
            t && e.shellSuspendCounter++,
            (kt = Va = null),
            (ve = l),
            (z.H = n),
            (z.A = i),
            ne === null && ((_e = null), (ue = 0), ui()),
            c
          );
        }
        function xm() {
          for (; ne !== null;) nd(ne);
        }
        function Mm(e, t) {
          var a = ve;
          ve |= 2;
          var l = ad(),
            n = ld();
          _e !== e || ue !== t
            ? ((Ki = null), (Bi = dt() + 500), jl(e, t))
            : (Cl = Xl(e, t));
          e: do
            try {
              if (Ee !== 0 && ne !== null) {
                t = ne;
                var i = bt;
                t: switch (Ee) {
                  case 1:
                    ((Ee = 0), (bt = null), Ll(e, t, i, 1));
                    break;
                  case 2:
                  case 9:
                    if (go(i)) {
                      ((Ee = 0), (bt = null), id(t));
                      break;
                    }
                    ((t = function () {
                      ((Ee !== 2 && Ee !== 9) || _e !== e || (Ee = 7), Vt(e));
                    }),
                      i.then(t, t));
                    break e;
                  case 3:
                    Ee = 7;
                    break e;
                  case 4:
                    Ee = 5;
                    break e;
                  case 7:
                    go(i)
                      ? ((Ee = 0), (bt = null), id(t))
                      : ((Ee = 0), (bt = null), Ll(e, t, i, 7));
                    break;
                  case 5:
                    var c = null;
                    switch (ne.tag) {
                      case 26:
                        c = ne.memoizedState;
                      case 5:
                      case 27:
                        var d = ne;
                        if (c ? Qd(c) : d.stateNode.complete) {
                          ((Ee = 0), (bt = null));
                          var p = d.sibling;
                          if (p !== null) ne = p;
                          else {
                            var O = d.return;
                            O !== null ? ((ne = O), Yi(O)) : (ne = null);
                          }
                          break t;
                        }
                    }
                    ((Ee = 0), (bt = null), Ll(e, t, i, 5));
                    break;
                  case 6:
                    ((Ee = 0), (bt = null), Ll(e, t, i, 6));
                    break;
                  case 8:
                    (ic(), (Ue = 6));
                    break e;
                  default:
                    throw Error(s(462));
                }
              }
              zm();
              break;
            } catch (N) {
              ed(e, N);
            }
          while (!0);
          return (
            (kt = Va = null),
            (z.H = l),
            (z.A = n),
            (ve = a),
            ne !== null ? 0 : ((_e = null), (ue = 0), ui(), Ue)
          );
        }
        function zm() {
          for (; ne !== null && !Fh();) nd(ne);
        }
        function nd(e) {
          var t = _r(e.alternate, e, ia);
          ((e.memoizedProps = e.pendingProps), t === null ? Yi(e) : (ne = t));
        }
        function id(e) {
          var t = e,
            a = t.alternate;
          switch (t.tag) {
            case 15:
            case 0:
              t = Er(a, t, t.pendingProps, t.type, void 0, ue);
              break;
            case 11:
              t = Er(a, t, t.pendingProps, t.type.render, t.ref, ue);
              break;
            case 5:
              As(t);
            default:
              (Cr(a, t), (t = ne = ao(t, ia)), (t = _r(a, t, ia)));
          }
          ((e.memoizedProps = e.pendingProps), t === null ? Yi(e) : (ne = t));
        }
        function Ll(e, t, a, l) {
          ((kt = Va = null), As(t), (Tl = null), (fn = 0));
          var n = t.return;
          try {
            if (mm(e, n, t, a, ue)) {
              ((Ue = 1), _i(e, xt(a, e.current)), (ne = null));
              return;
            }
          } catch (i) {
            if (n !== null) throw ((ne = n), i);
            ((Ue = 1), _i(e, xt(a, e.current)), (ne = null));
            return;
          }
          t.flags & 32768
            ? (de || l === 1
                ? (e = !0)
                : Cl || (ue & 536870912) !== 0
                  ? (e = !1)
                  : ((Aa = e = !0),
                    (l === 2 || l === 9 || l === 3 || l === 6) &&
                      ((l = yt.current),
                      l !== null && l.tag === 13 && (l.flags |= 16384))),
              ud(t, e))
            : Yi(t);
        }
        function Yi(e) {
          var t = e;
          do {
            if ((t.flags & 32768) !== 0) {
              ud(t, Aa);
              return;
            }
            e = t.return;
            var a = vm(t.alternate, t, ia);
            if (a !== null) {
              ne = a;
              return;
            }
            if (((t = t.sibling), t !== null)) {
              ne = t;
              return;
            }
            ne = t = e;
          } while (t !== null);
          Ue === 0 && (Ue = 5);
        }
        function ud(e, t) {
          do {
            var a = bm(e.alternate, e);
            if (a !== null) {
              ((a.flags &= 32767), (ne = a));
              return;
            }
            if (
              ((a = e.return),
              a !== null &&
                ((a.flags |= 32768),
                (a.subtreeFlags = 0),
                (a.deletions = null)),
              !t && ((e = e.sibling), e !== null))
            ) {
              ne = e;
              return;
            }
            ne = e = a;
          } while (e !== null);
          ((Ue = 6), (ne = null));
        }
        function sd(e, t, a, l, n, i, c, d, p) {
          e.cancelPendingCommit = null;
          do Vi();
          while (Qe !== 0);
          if ((ve & 6) !== 0) throw Error(s(327));
          if (t !== null) {
            if (t === e.current) throw Error(s(177));
            if (
              ((i = t.lanes | t.childLanes),
              (i |= $u),
              ug(e, a, i, c, d, p),
              e === _e && ((ne = _e = null), (ue = 0)),
              (Rl = t),
              (Oa = e),
              (ua = a),
              (ac = i),
              (lc = n),
              (Fr = l),
              (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
                ? ((e.callbackNode = null),
                  (e.callbackPriority = 0),
                  Dm(Qn, function () {
                    return (dd(), null);
                  }))
                : ((e.callbackNode = null), (e.callbackPriority = 0)),
              (l = (t.flags & 13878) !== 0),
              (t.subtreeFlags & 13878) !== 0 || l)
            ) {
              ((l = z.T),
                (z.T = null),
                (n = U.p),
                (U.p = 2),
                (c = ve),
                (ve |= 4));
              try {
                Sm(e, t);
              } finally {
                ((ve = c), (U.p = n), (z.T = l));
              }
            }
            ((Qe = 1), cd(), fd(), od());
          }
        }
        function cd() {
          if (Qe === 1) {
            Qe = 0;
            var e = Oa,
              t = Rl,
              a = (t.flags & 13878) !== 0;
            if ((t.subtreeFlags & 13878) !== 0 || a) {
              ((a = z.T), (z.T = null));
              var l = U.p;
              U.p = 2;
              var n = ve;
              ve |= 4;
              try {
                Vr(t, e);
                var i = vc,
                  c = Jf(e.containerInfo),
                  d = i.focusedElem,
                  p = i.selectionRange;
                if (
                  c !== d &&
                  d &&
                  d.ownerDocument &&
                  Zf(d.ownerDocument.documentElement, d)
                ) {
                  if (p !== null && wu(d)) {
                    var O = p.start,
                      N = p.end;
                    if ((N === void 0 && (N = O), 'selectionStart' in d))
                      ((d.selectionStart = O),
                        (d.selectionEnd = Math.min(N, d.value.length)));
                    else {
                      var R = d.ownerDocument || document,
                        x = (R && R.defaultView) || window;
                      if (x.getSelection) {
                        var M = x.getSelection(),
                          Y = d.textContent.length,
                          Z = Math.min(p.start, Y),
                          Me = p.end === void 0 ? Z : Math.min(p.end, Y);
                        !M.extend && Z > Me && ((c = Me), (Me = Z), (Z = c));
                        var A = Xf(d, Z),
                          S = Xf(d, Me);
                        if (
                          A &&
                          S &&
                          (M.rangeCount !== 1 ||
                            M.anchorNode !== A.node ||
                            M.anchorOffset !== A.offset ||
                            M.focusNode !== S.node ||
                            M.focusOffset !== S.offset)
                        ) {
                          var T = R.createRange();
                          (T.setStart(A.node, A.offset),
                            M.removeAllRanges(),
                            Z > Me
                              ? (M.addRange(T), M.extend(S.node, S.offset))
                              : (T.setEnd(S.node, S.offset), M.addRange(T)));
                        }
                      }
                    }
                  }
                  for (R = [], M = d; (M = M.parentNode);)
                    M.nodeType === 1 &&
                      R.push({
                        element: M,
                        left: M.scrollLeft,
                        top: M.scrollTop,
                      });
                  for (
                    typeof d.focus == 'function' && d.focus(), d = 0;
                    d < R.length;
                    d++
                  ) {
                    var D = R[d];
                    ((D.element.scrollLeft = D.left),
                      (D.element.scrollTop = D.top));
                  }
                }
                ((eu = !!yc), (vc = yc = null));
              } finally {
                ((ve = n), (U.p = l), (z.T = a));
              }
            }
            ((e.current = t), (Qe = 2));
          }
        }
        function fd() {
          if (Qe === 2) {
            Qe = 0;
            var e = Oa,
              t = Rl,
              a = (t.flags & 8772) !== 0;
            if ((t.subtreeFlags & 8772) !== 0 || a) {
              ((a = z.T), (z.T = null));
              var l = U.p;
              U.p = 2;
              var n = ve;
              ve |= 4;
              try {
                Br(e, t.alternate, t);
              } finally {
                ((ve = n), (U.p = l), (z.T = a));
              }
            }
            Qe = 3;
          }
        }
        function od() {
          if (Qe === 4 || Qe === 3) {
            ((Qe = 0), Wh());
            var e = Oa,
              t = Rl,
              a = ua,
              l = Fr;
            (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0
              ? (Qe = 5)
              : ((Qe = 0), (Rl = Oa = null), rd(e, e.pendingLanes));
            var n = e.pendingLanes;
            if (
              (n === 0 && (Ta = null),
              Ou(a),
              (t = t.stateNode),
              ht && typeof ht.onCommitFiberRoot == 'function')
            )
              try {
                ht.onCommitFiberRoot(
                  Ql,
                  t,
                  void 0,
                  (t.current.flags & 128) === 128
                );
              } catch {}
            if (l !== null) {
              ((t = z.T), (n = U.p), (U.p = 2), (z.T = null));
              try {
                for (var i = e.onRecoverableError, c = 0; c < l.length; c++) {
                  var d = l[c];
                  i(d.value, { componentStack: d.stack });
                }
              } finally {
                ((z.T = t), (U.p = n));
              }
            }
            ((ua & 3) !== 0 && Vi(),
              Vt(e),
              (n = e.pendingLanes),
              (a & 261930) !== 0 && (n & 42) !== 0
                ? e === nc
                  ? Mn++
                  : ((Mn = 0), (nc = e))
                : (Mn = 0),
              zn(0));
          }
        }
        function rd(e, t) {
          (e.pooledCacheLanes &= t) === 0 &&
            ((t = e.pooledCache), t != null && ((e.pooledCache = null), sn(t)));
        }
        function Vi() {
          return (cd(), fd(), od(), dd());
        }
        function dd() {
          if (Qe !== 5) return !1;
          var e = Oa,
            t = ac;
          ac = 0;
          var a = Ou(ua),
            l = z.T,
            n = U.p;
          try {
            ((U.p = 32 > a ? 32 : a), (z.T = null), (a = lc), (lc = null));
            var i = Oa,
              c = ua;
            if (((Qe = 0), (Rl = Oa = null), (ua = 0), (ve & 6) !== 0))
              throw Error(s(331));
            var d = ve;
            if (
              ((ve |= 4),
              Jr(i.current),
              Qr(i, i.current, c, a),
              (ve = d),
              zn(0),
              ht && typeof ht.onPostCommitFiberRoot == 'function')
            )
              try {
                ht.onPostCommitFiberRoot(Ql, i);
              } catch {}
            return !0;
          } finally {
            ((U.p = n), (z.T = l), rd(e, t));
          }
        }
        function hd(e, t, a) {
          ((t = xt(a, t)),
            (t = Hs(e.stateNode, t, 2)),
            (e = ya(e, t, 2)),
            e !== null && (Zl(e, 2), Vt(e)));
        }
        function Te(e, t, a) {
          if (e.tag === 3) hd(e, e, a);
          else
            for (; t !== null;) {
              if (t.tag === 3) {
                hd(t, e, a);
                break;
              } else if (t.tag === 1) {
                var l = t.stateNode;
                if (
                  typeof t.type.getDerivedStateFromError == 'function' ||
                  (typeof l.componentDidCatch == 'function' &&
                    (Ta === null || !Ta.has(l)))
                ) {
                  ((e = xt(a, e)),
                    (a = gr(2)),
                    (l = ya(t, a, 2)),
                    l !== null && (mr(a, l, t, e), Zl(l, 2), Vt(l)));
                  break;
                }
              }
              t = t.return;
            }
        }
        function sc(e, t, a) {
          var l = e.pingCache;
          if (l === null) {
            l = e.pingCache = new Tm();
            var n = new Set();
            l.set(t, n);
          } else
            ((n = l.get(t)), n === void 0 && ((n = new Set()), l.set(t, n)));
          n.has(a) ||
            ((Ps = !0), n.add(a), (e = _m.bind(null, e, t, a)), t.then(e, e));
        }
        function _m(e, t, a) {
          var l = e.pingCache;
          (l !== null && l.delete(t),
            (e.pingedLanes |= e.suspendedLanes & a),
            (e.warmLanes &= ~a),
            _e === e &&
              (ue & a) === a &&
              (Ue === 4 ||
              (Ue === 3 && (ue & 62914560) === ue && 300 > dt() - Hi)
                ? (ve & 2) === 0 && jl(e, 0)
                : (ec |= a),
              Dl === ue && (Dl = 0)),
            Vt(e));
        }
        function gd(e, t) {
          (t === 0 && (t = sf()),
            (e = qa(e, t)),
            e !== null && (Zl(e, t), Vt(e)));
        }
        function Nm(e) {
          var t = e.memoizedState,
            a = 0;
          (t !== null && (a = t.retryLane), gd(e, a));
        }
        function Cm(e, t) {
          var a = 0;
          switch (e.tag) {
            case 31:
            case 13:
              var l = e.stateNode,
                n = e.memoizedState;
              n !== null && (a = n.retryLane);
              break;
            case 19:
              l = e.stateNode;
              break;
            case 22:
              l = e.stateNode._retryCache;
              break;
            default:
              throw Error(s(314));
          }
          (l !== null && l.delete(t), gd(e, a));
        }
        function Dm(e, t) {
          return Su(e, t);
        }
        var wi = null,
          Ul = null,
          cc = !1,
          Qi = !1,
          fc = !1,
          Ma = 0;
        function Vt(e) {
          (e !== Ul &&
            e.next === null &&
            (Ul === null ? (wi = Ul = e) : (Ul = Ul.next = e)),
            (Qi = !0),
            cc || ((cc = !0), jm()));
        }
        function zn(e, t) {
          if (!fc && Qi) {
            fc = !0;
            do
              for (var a = !1, l = wi; l !== null;) {
                if (e !== 0) {
                  var n = l.pendingLanes;
                  if (n === 0) var i = 0;
                  else {
                    var c = l.suspendedLanes,
                      d = l.pingedLanes;
                    ((i = (1 << (31 - gt(42 | e) + 1)) - 1),
                      (i &= n & ~(c & ~d)),
                      (i =
                        i & 201326741 ? (i & 201326741) | 1 : i ? i | 2 : 0));
                  }
                  i !== 0 && ((a = !0), vd(l, i));
                } else
                  ((i = ue),
                    (i = $n(
                      l,
                      l === _e ? i : 0,
                      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
                    )),
                    (i & 3) === 0 || Xl(l, i) || ((a = !0), vd(l, i)));
                l = l.next;
              }
            while (a);
            fc = !1;
          }
        }
        function Rm() {
          md();
        }
        function md() {
          Qi = cc = !1;
          var e = 0;
          Ma !== 0 && wm() && (e = Ma);
          for (var t = dt(), a = null, l = wi; l !== null;) {
            var n = l.next,
              i = pd(l, t);
            (i === 0
              ? ((l.next = null),
                a === null ? (wi = n) : (a.next = n),
                n === null && (Ul = a))
              : ((a = l), (e !== 0 || (i & 3) !== 0) && (Qi = !0)),
              (l = n));
          }
          ((Qe !== 0 && Qe !== 5) || zn(e), Ma !== 0 && (Ma = 0));
        }
        function pd(e, t) {
          for (
            var a = e.suspendedLanes,
              l = e.pingedLanes,
              n = e.expirationTimes,
              i = e.pendingLanes & -62914561;
            0 < i;
          ) {
            var c = 31 - gt(i),
              d = 1 << c,
              p = n[c];
            (p === -1
              ? ((d & a) === 0 || (d & l) !== 0) && (n[c] = ig(d, t))
              : p <= t && (e.expiredLanes |= d),
              (i &= ~d));
          }
          if (
            ((t = _e),
            (a = ue),
            (a = $n(
              e,
              e === t ? a : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            (l = e.callbackNode),
            a === 0 ||
              (e === t && (Ee === 2 || Ee === 9)) ||
              e.cancelPendingCommit !== null)
          )
            return (
              l !== null && l !== null && Au(l),
              (e.callbackNode = null),
              (e.callbackPriority = 0)
            );
          if ((a & 3) === 0 || Xl(e, a)) {
            if (((t = a & -a), t === e.callbackPriority)) return t;
            switch ((l !== null && Au(l), Ou(a))) {
              case 2:
              case 8:
                a = nf;
                break;
              case 32:
                a = Qn;
                break;
              case 268435456:
                a = uf;
                break;
              default:
                a = Qn;
            }
            return (
              (l = yd.bind(null, e)),
              (a = Su(a, l)),
              (e.callbackPriority = t),
              (e.callbackNode = a),
              t
            );
          }
          return (
            l !== null && l !== null && Au(l),
            (e.callbackPriority = 2),
            (e.callbackNode = null),
            2
          );
        }
        function yd(e, t) {
          if (Qe !== 0 && Qe !== 5)
            return ((e.callbackNode = null), (e.callbackPriority = 0), null);
          var a = e.callbackNode;
          if (Vi() && e.callbackNode !== a) return null;
          var l = ue;
          return (
            (l = $n(
              e,
              e === _e ? l : 0,
              e.cancelPendingCommit !== null || e.timeoutHandle !== -1
            )),
            l === 0
              ? null
              : (Ir(e, l, t),
                pd(e, dt()),
                e.callbackNode != null && e.callbackNode === a
                  ? yd.bind(null, e)
                  : null)
          );
        }
        function vd(e, t) {
          if (Vi()) return null;
          Ir(e, t, !0);
        }
        function jm() {
          Xm(function () {
            (ve & 6) !== 0 ? Su(lf, Rm) : md();
          });
        }
        function oc() {
          if (Ma === 0) {
            var e = Sl;
            (e === 0 &&
              ((e = Xn), (Xn <<= 1), (Xn & 261888) === 0 && (Xn = 256)),
              (Ma = e));
          }
          return Ma;
        }
        function bd(e) {
          return e == null || typeof e == 'symbol' || typeof e == 'boolean'
            ? null
            : typeof e == 'function'
              ? e
              : In('' + e);
        }
        function Sd(e, t) {
          var a = t.ownerDocument.createElement('input');
          return (
            (a.name = t.name),
            (a.value = t.value),
            e.id && a.setAttribute('form', e.id),
            t.parentNode.insertBefore(a, t),
            (e = new FormData(e)),
            a.parentNode.removeChild(a),
            e
          );
        }
        function Lm(e, t, a, l, n) {
          if (t === 'submit' && a && a.stateNode === n) {
            var i = bd((n[nt] || null).action),
              c = l.submitter;
            c &&
              ((t = (t = c[nt] || null)
                ? bd(t.formAction)
                : c.getAttribute('formAction')),
              t !== null && ((i = t), (c = null)));
            var d = new ai('action', 'action', null, l, n);
            e.push({
              event: d,
              listeners: [
                {
                  instance: null,
                  listener: function () {
                    if (l.defaultPrevented) {
                      if (Ma !== 0) {
                        var p = c ? Sd(n, c) : new FormData(n);
                        Cs(
                          a,
                          { pending: !0, data: p, method: n.method, action: i },
                          null,
                          p
                        );
                      }
                    } else
                      typeof i == 'function' &&
                        (d.preventDefault(),
                        (p = c ? Sd(n, c) : new FormData(n)),
                        Cs(
                          a,
                          { pending: !0, data: p, method: n.method, action: i },
                          i,
                          p
                        ));
                  },
                  currentTarget: n,
                },
              ],
            });
          }
        }
        for (var rc = 0; rc < Ju.length; rc++) {
          var dc = Ju[rc],
            Um = dc.toLowerCase(),
            Hm = dc[0].toUpperCase() + dc.slice(1);
          Ut(Um, 'on' + Hm);
        }
        (Ut(Ff, 'onAnimationEnd'),
          Ut(Wf, 'onAnimationIteration'),
          Ut(If, 'onAnimationStart'),
          Ut('dblclick', 'onDoubleClick'),
          Ut('focusin', 'onFocus'),
          Ut('focusout', 'onBlur'),
          Ut(Ig, 'onTransitionRun'),
          Ut(Pg, 'onTransitionStart'),
          Ut(em, 'onTransitionCancel'),
          Ut(Pf, 'onTransitionEnd'),
          ul('onMouseEnter', ['mouseout', 'mouseover']),
          ul('onMouseLeave', ['mouseout', 'mouseover']),
          ul('onPointerEnter', ['pointerout', 'pointerover']),
          ul('onPointerLeave', ['pointerout', 'pointerover']),
          Ua(
            'onChange',
            'change click focusin focusout input keydown keyup selectionchange'.split(
              ' '
            )
          ),
          Ua(
            'onSelect',
            'focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange'.split(
              ' '
            )
          ),
          Ua('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste',
          ]),
          Ua(
            'onCompositionEnd',
            'compositionend focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          Ua(
            'onCompositionStart',
            'compositionstart focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ),
          Ua(
            'onCompositionUpdate',
            'compositionupdate focusout keydown keypress keyup mousedown'.split(
              ' '
            )
          ));
        var _n =
            'abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting'.split(
              ' '
            ),
          Bm = new Set(
            'beforetoggle cancel close invalid load scroll scrollend toggle'
              .split(' ')
              .concat(_n)
          );
        function Ad(e, t) {
          t = (t & 4) !== 0;
          for (var a = 0; a < e.length; a++) {
            var l = e[a],
              n = l.event;
            l = l.listeners;
            e: {
              var i = void 0;
              if (t)
                for (var c = l.length - 1; 0 <= c; c--) {
                  var d = l[c],
                    p = d.instance,
                    O = d.currentTarget;
                  if (((d = d.listener), p !== i && n.isPropagationStopped()))
                    break e;
                  ((i = d), (n.currentTarget = O));
                  try {
                    i(n);
                  } catch (N) {
                    ii(N);
                  }
                  ((n.currentTarget = null), (i = p));
                }
              else
                for (c = 0; c < l.length; c++) {
                  if (
                    ((d = l[c]),
                    (p = d.instance),
                    (O = d.currentTarget),
                    (d = d.listener),
                    p !== i && n.isPropagationStopped())
                  )
                    break e;
                  ((i = d), (n.currentTarget = O));
                  try {
                    i(n);
                  } catch (N) {
                    ii(N);
                  }
                  ((n.currentTarget = null), (i = p));
                }
            }
          }
        }
        function ie(e, t) {
          var a = t[xu];
          a === void 0 && (a = t[xu] = new Set());
          var l = e + '__bubble';
          a.has(l) || (Ed(t, e, 2, !1), a.add(l));
        }
        function hc(e, t, a) {
          var l = 0;
          (t && (l |= 4), Ed(a, e, l, t));
        }
        var Xi = '_reactListening' + Math.random().toString(36).slice(2);
        function gc(e) {
          if (!e[Xi]) {
            ((e[Xi] = !0),
              gf.forEach(function (a) {
                a !== 'selectionchange' &&
                  (Bm.has(a) || hc(a, !1, e), hc(a, !0, e));
              }));
            var t = e.nodeType === 9 ? e : e.ownerDocument;
            t === null || t[Xi] || ((t[Xi] = !0), hc('selectionchange', !1, t));
          }
        }
        function Ed(e, t, a, l) {
          switch (Wd(t)) {
            case 2:
              var n = rp;
              break;
            case 8:
              n = dp;
              break;
            default:
              n = Nc;
          }
          ((a = n.bind(null, t, a, e)),
            (n = void 0),
            !Lu ||
              (t !== 'touchstart' && t !== 'touchmove' && t !== 'wheel') ||
              (n = !0),
            l
              ? n !== void 0
                ? e.addEventListener(t, a, { capture: !0, passive: n })
                : e.addEventListener(t, a, !0)
              : n !== void 0
                ? e.addEventListener(t, a, { passive: n })
                : e.addEventListener(t, a, !1));
        }
        function mc(e, t, a, l, n) {
          var i = l;
          if ((t & 1) === 0 && (t & 2) === 0 && l !== null)
            e: for (;;) {
              if (l === null) return;
              var c = l.tag;
              if (c === 3 || c === 4) {
                var d = l.stateNode.containerInfo;
                if (d === n) break;
                if (c === 4)
                  for (c = l.return; c !== null;) {
                    var p = c.tag;
                    if ((p === 3 || p === 4) && c.stateNode.containerInfo === n)
                      return;
                    c = c.return;
                  }
                for (; d !== null;) {
                  if (((c = ll(d)), c === null)) return;
                  if (
                    ((p = c.tag), p === 5 || p === 6 || p === 26 || p === 27)
                  ) {
                    l = i = c;
                    continue e;
                  }
                  d = d.parentNode;
                }
              }
              l = l.return;
            }
          Mf(function () {
            var O = i,
              N = Ru(a),
              R = [];
            e: {
              var x = eo.get(e);
              if (x !== void 0) {
                var M = ai,
                  Y = e;
                switch (e) {
                  case 'keypress':
                    if (ei(a) === 0) break e;
                  case 'keydown':
                  case 'keyup':
                    M = Cg;
                    break;
                  case 'focusin':
                    ((Y = 'focus'), (M = Ku));
                    break;
                  case 'focusout':
                    ((Y = 'blur'), (M = Ku));
                    break;
                  case 'beforeblur':
                  case 'afterblur':
                    M = Ku;
                    break;
                  case 'click':
                    if (a.button === 2) break e;
                  case 'auxclick':
                  case 'dblclick':
                  case 'mousedown':
                  case 'mousemove':
                  case 'mouseup':
                  case 'mouseout':
                  case 'mouseover':
                  case 'contextmenu':
                    M = Nf;
                    break;
                  case 'drag':
                  case 'dragend':
                  case 'dragenter':
                  case 'dragexit':
                  case 'dragleave':
                  case 'dragover':
                  case 'dragstart':
                  case 'drop':
                    M = vg;
                    break;
                  case 'touchcancel':
                  case 'touchend':
                  case 'touchmove':
                  case 'touchstart':
                    M = jg;
                    break;
                  case Ff:
                  case Wf:
                  case If:
                    M = Ag;
                    break;
                  case Pf:
                    M = Ug;
                    break;
                  case 'scroll':
                  case 'scrollend':
                    M = pg;
                    break;
                  case 'wheel':
                    M = Bg;
                    break;
                  case 'copy':
                  case 'cut':
                  case 'paste':
                    M = Tg;
                    break;
                  case 'gotpointercapture':
                  case 'lostpointercapture':
                  case 'pointercancel':
                  case 'pointerdown':
                  case 'pointermove':
                  case 'pointerout':
                  case 'pointerover':
                  case 'pointerup':
                    M = Df;
                    break;
                  case 'toggle':
                  case 'beforetoggle':
                    M = qg;
                }
                var Z = (t & 4) !== 0,
                  Me = !Z && (e === 'scroll' || e === 'scrollend'),
                  A = Z ? (x !== null ? x + 'Capture' : null) : x;
                Z = [];
                for (var S = O, T; S !== null;) {
                  var D = S;
                  if (
                    ((T = D.stateNode),
                    (D = D.tag),
                    (D !== 5 && D !== 26 && D !== 27) ||
                      T === null ||
                      A === null ||
                      ((D = kl(S, A)), D != null && Z.push(Nn(S, D, T))),
                    Me)
                  )
                    break;
                  S = S.return;
                }
                0 < Z.length &&
                  ((x = new M(x, Y, null, a, N)),
                  R.push({ event: x, listeners: Z }));
              }
            }
            if ((t & 7) === 0) {
              e: {
                if (
                  ((x = e === 'mouseover' || e === 'pointerover'),
                  (M = e === 'mouseout' || e === 'pointerout'),
                  x &&
                    a !== Du &&
                    (Y = a.relatedTarget || a.fromElement) &&
                    (ll(Y) || Y[al]))
                )
                  break e;
                if (
                  (M || x) &&
                  ((x =
                    N.window === N
                      ? N
                      : (x = N.ownerDocument)
                        ? x.defaultView || x.parentWindow
                        : window),
                  M
                    ? ((Y = a.relatedTarget || a.toElement),
                      (M = O),
                      (Y = Y ? ll(Y) : null),
                      Y !== null &&
                        ((Me = h(Y)),
                        (Z = Y.tag),
                        Y !== Me || (Z !== 5 && Z !== 27 && Z !== 6)) &&
                        (Y = null))
                    : ((M = null), (Y = O)),
                  M !== Y)
                ) {
                  if (
                    ((Z = Nf),
                    (D = 'onMouseLeave'),
                    (A = 'onMouseEnter'),
                    (S = 'mouse'),
                    (e === 'pointerout' || e === 'pointerover') &&
                      ((Z = Df),
                      (D = 'onPointerLeave'),
                      (A = 'onPointerEnter'),
                      (S = 'pointer')),
                    (Me = M == null ? x : $l(M)),
                    (T = Y == null ? x : $l(Y)),
                    (x = new Z(D, S + 'leave', M, a, N)),
                    (x.target = Me),
                    (x.relatedTarget = T),
                    (D = null),
                    ll(N) === O &&
                      ((Z = new Z(A, S + 'enter', Y, a, N)),
                      (Z.target = T),
                      (Z.relatedTarget = Me),
                      (D = Z)),
                    (Me = D),
                    M && Y)
                  )
                    t: {
                      for (Z = Km, A = M, S = Y, T = 0, D = A; D; D = Z(D)) T++;
                      D = 0;
                      for (var w = S; w; w = Z(w)) D++;
                      for (; 0 < T - D;) ((A = Z(A)), T--);
                      for (; 0 < D - T;) ((S = Z(S)), D--);
                      for (; T--;) {
                        if (A === S || (S !== null && A === S.alternate)) {
                          Z = A;
                          break t;
                        }
                        ((A = Z(A)), (S = Z(S)));
                      }
                      Z = null;
                    }
                  else Z = null;
                  (M !== null && Td(R, x, M, Z, !1),
                    Y !== null && Me !== null && Td(R, Me, Y, Z, !0));
                }
              }
              e: {
                if (
                  ((x = O ? $l(O) : window),
                  (M = x.nodeName && x.nodeName.toLowerCase()),
                  M === 'select' || (M === 'input' && x.type === 'file'))
                )
                  var pe = qf;
                else if (Bf(x))
                  if (Gf) pe = kg;
                  else {
                    pe = Jg;
                    var V = Zg;
                  }
                else
                  ((M = x.nodeName),
                    !M ||
                    M.toLowerCase() !== 'input' ||
                    (x.type !== 'checkbox' && x.type !== 'radio')
                      ? O && Cu(O.elementType) && (pe = qf)
                      : (pe = $g));
                if (pe && (pe = pe(e, O))) {
                  Kf(R, pe, a, N);
                  break e;
                }
                (V && V(e, x, O),
                  e === 'focusout' &&
                    O &&
                    x.type === 'number' &&
                    O.memoizedProps.value != null &&
                    Nu(x, 'number', x.value));
              }
              switch (((V = O ? $l(O) : window), e)) {
                case 'focusin':
                  (Bf(V) || V.contentEditable === 'true') &&
                    ((dl = V), (Qu = O), (ln = null));
                  break;
                case 'focusout':
                  ln = Qu = dl = null;
                  break;
                case 'mousedown':
                  Xu = !0;
                  break;
                case 'contextmenu':
                case 'mouseup':
                case 'dragend':
                  ((Xu = !1), $f(R, a, N));
                  break;
                case 'selectionchange':
                  if (Wg) break;
                case 'keydown':
                case 'keyup':
                  $f(R, a, N);
              }
              var ee;
              if (Gu)
                e: {
                  switch (e) {
                    case 'compositionstart':
                      var se = 'onCompositionStart';
                      break e;
                    case 'compositionend':
                      se = 'onCompositionEnd';
                      break e;
                    case 'compositionupdate':
                      se = 'onCompositionUpdate';
                      break e;
                  }
                  se = void 0;
                }
              else
                rl
                  ? Uf(e, a) && (se = 'onCompositionEnd')
                  : e === 'keydown' &&
                    a.keyCode === 229 &&
                    (se = 'onCompositionStart');
              (se &&
                (Rf &&
                  a.locale !== 'ko' &&
                  (rl || se !== 'onCompositionStart'
                    ? se === 'onCompositionEnd' && rl && (ee = zf())
                    : ((oa = N),
                      (Uu = 'value' in oa ? oa.value : oa.textContent),
                      (rl = !0))),
                (V = Zi(O, se)),
                0 < V.length &&
                  ((se = new Cf(se, e, null, a, N)),
                  R.push({ event: se, listeners: V }),
                  ee
                    ? (se.data = ee)
                    : ((ee = Hf(a)), ee !== null && (se.data = ee)))),
                (ee = Yg ? Vg(e, a) : wg(e, a)) &&
                  ((se = Zi(O, 'onBeforeInput')),
                  0 < se.length &&
                    ((V = new Cf('onBeforeInput', 'beforeinput', null, a, N)),
                    R.push({ event: V, listeners: se }),
                    (V.data = ee))),
                Lm(R, e, O, a, N));
            }
            Ad(R, t);
          });
        }
        function Nn(e, t, a) {
          return { instance: e, listener: t, currentTarget: a };
        }
        function Zi(e, t) {
          for (var a = t + 'Capture', l = []; e !== null;) {
            var n = e,
              i = n.stateNode;
            if (
              ((n = n.tag),
              (n !== 5 && n !== 26 && n !== 27) ||
                i === null ||
                ((n = kl(e, a)),
                n != null && l.unshift(Nn(e, n, i)),
                (n = kl(e, t)),
                n != null && l.push(Nn(e, n, i))),
              e.tag === 3)
            )
              return l;
            e = e.return;
          }
          return [];
        }
        function Km(e) {
          if (e === null) return null;
          do e = e.return;
          while (e && e.tag !== 5 && e.tag !== 27);
          return e || null;
        }
        function Td(e, t, a, l, n) {
          for (var i = t._reactName, c = []; a !== null && a !== l;) {
            var d = a,
              p = d.alternate,
              O = d.stateNode;
            if (((d = d.tag), p !== null && p === l)) break;
            ((d !== 5 && d !== 26 && d !== 27) ||
              O === null ||
              ((p = O),
              n
                ? ((O = kl(a, i)), O != null && c.unshift(Nn(a, O, p)))
                : n || ((O = kl(a, i)), O != null && c.push(Nn(a, O, p)))),
              (a = a.return));
          }
          c.length !== 0 && e.push({ event: t, listeners: c });
        }
        var qm = /\r\n?/g,
          Gm = /\u0000|\uFFFD/g;
        function Od(e) {
          return (typeof e == 'string' ? e : '' + e)
            .replace(
              qm,
              `
`
            )
            .replace(Gm, '');
        }
        function xd(e, t) {
          return ((t = Od(t)), Od(e) === t);
        }
        function xe(e, t, a, l, n, i) {
          switch (a) {
            case 'children':
              typeof l == 'string'
                ? t === 'body' || (t === 'textarea' && l === '') || cl(e, l)
                : (typeof l == 'number' || typeof l == 'bigint') &&
                  t !== 'body' &&
                  cl(e, '' + l);
              break;
            case 'className':
              Fn(e, 'class', l);
              break;
            case 'tabIndex':
              Fn(e, 'tabindex', l);
              break;
            case 'dir':
            case 'role':
            case 'viewBox':
            case 'width':
            case 'height':
              Fn(e, a, l);
              break;
            case 'style':
              Of(e, l, i);
              break;
            case 'data':
              if (t !== 'object') {
                Fn(e, 'data', l);
                break;
              }
            case 'src':
            case 'href':
              if (l === '' && (t !== 'a' || a !== 'href')) {
                e.removeAttribute(a);
                break;
              }
              if (
                l == null ||
                typeof l == 'function' ||
                typeof l == 'symbol' ||
                typeof l == 'boolean'
              ) {
                e.removeAttribute(a);
                break;
              }
              ((l = In('' + l)), e.setAttribute(a, l));
              break;
            case 'action':
            case 'formAction':
              if (typeof l == 'function') {
                e.setAttribute(
                  a,
                  "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
                );
                break;
              } else
                typeof i == 'function' &&
                  (a === 'formAction'
                    ? (t !== 'input' && xe(e, t, 'name', n.name, n, null),
                      xe(e, t, 'formEncType', n.formEncType, n, null),
                      xe(e, t, 'formMethod', n.formMethod, n, null),
                      xe(e, t, 'formTarget', n.formTarget, n, null))
                    : (xe(e, t, 'encType', n.encType, n, null),
                      xe(e, t, 'method', n.method, n, null),
                      xe(e, t, 'target', n.target, n, null)));
              if (l == null || typeof l == 'symbol' || typeof l == 'boolean') {
                e.removeAttribute(a);
                break;
              }
              ((l = In('' + l)), e.setAttribute(a, l));
              break;
            case 'onClick':
              l != null && (e.onclick = Xt);
              break;
            case 'onScroll':
              l != null && ie('scroll', e);
              break;
            case 'onScrollEnd':
              l != null && ie('scrollend', e);
              break;
            case 'dangerouslySetInnerHTML':
              if (l != null) {
                if (typeof l != 'object' || !('__html' in l))
                  throw Error(s(61));
                if (((a = l.__html), a != null)) {
                  if (n.children != null) throw Error(s(60));
                  e.innerHTML = a;
                }
              }
              break;
            case 'multiple':
              e.multiple = l && typeof l != 'function' && typeof l != 'symbol';
              break;
            case 'muted':
              e.muted = l && typeof l != 'function' && typeof l != 'symbol';
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'defaultValue':
            case 'defaultChecked':
            case 'innerHTML':
            case 'ref':
              break;
            case 'autoFocus':
              break;
            case 'xlinkHref':
              if (
                l == null ||
                typeof l == 'function' ||
                typeof l == 'boolean' ||
                typeof l == 'symbol'
              ) {
                e.removeAttribute('xlink:href');
                break;
              }
              ((a = In('' + l)),
                e.setAttributeNS(
                  'http://www.w3.org/1999/xlink',
                  'xlink:href',
                  a
                ));
              break;
            case 'contentEditable':
            case 'spellCheck':
            case 'draggable':
            case 'value':
            case 'autoReverse':
            case 'externalResourcesRequired':
            case 'focusable':
            case 'preserveAlpha':
              l != null && typeof l != 'function' && typeof l != 'symbol'
                ? e.setAttribute(a, '' + l)
                : e.removeAttribute(a);
              break;
            case 'inert':
            case 'allowFullScreen':
            case 'async':
            case 'autoPlay':
            case 'controls':
            case 'default':
            case 'defer':
            case 'disabled':
            case 'disablePictureInPicture':
            case 'disableRemotePlayback':
            case 'formNoValidate':
            case 'hidden':
            case 'loop':
            case 'noModule':
            case 'noValidate':
            case 'open':
            case 'playsInline':
            case 'readOnly':
            case 'required':
            case 'reversed':
            case 'scoped':
            case 'seamless':
            case 'itemScope':
              l && typeof l != 'function' && typeof l != 'symbol'
                ? e.setAttribute(a, '')
                : e.removeAttribute(a);
              break;
            case 'capture':
            case 'download':
              l === !0
                ? e.setAttribute(a, '')
                : l !== !1 &&
                    l != null &&
                    typeof l != 'function' &&
                    typeof l != 'symbol'
                  ? e.setAttribute(a, l)
                  : e.removeAttribute(a);
              break;
            case 'cols':
            case 'rows':
            case 'size':
            case 'span':
              l != null &&
              typeof l != 'function' &&
              typeof l != 'symbol' &&
              !isNaN(l) &&
              1 <= l
                ? e.setAttribute(a, l)
                : e.removeAttribute(a);
              break;
            case 'rowSpan':
            case 'start':
              l == null ||
              typeof l == 'function' ||
              typeof l == 'symbol' ||
              isNaN(l)
                ? e.removeAttribute(a)
                : e.setAttribute(a, l);
              break;
            case 'popover':
              (ie('beforetoggle', e), ie('toggle', e), kn(e, 'popover', l));
              break;
            case 'xlinkActuate':
              Qt(e, 'http://www.w3.org/1999/xlink', 'xlink:actuate', l);
              break;
            case 'xlinkArcrole':
              Qt(e, 'http://www.w3.org/1999/xlink', 'xlink:arcrole', l);
              break;
            case 'xlinkRole':
              Qt(e, 'http://www.w3.org/1999/xlink', 'xlink:role', l);
              break;
            case 'xlinkShow':
              Qt(e, 'http://www.w3.org/1999/xlink', 'xlink:show', l);
              break;
            case 'xlinkTitle':
              Qt(e, 'http://www.w3.org/1999/xlink', 'xlink:title', l);
              break;
            case 'xlinkType':
              Qt(e, 'http://www.w3.org/1999/xlink', 'xlink:type', l);
              break;
            case 'xmlBase':
              Qt(e, 'http://www.w3.org/XML/1998/namespace', 'xml:base', l);
              break;
            case 'xmlLang':
              Qt(e, 'http://www.w3.org/XML/1998/namespace', 'xml:lang', l);
              break;
            case 'xmlSpace':
              Qt(e, 'http://www.w3.org/XML/1998/namespace', 'xml:space', l);
              break;
            case 'is':
              kn(e, 'is', l);
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              (!(2 < a.length) ||
                (a[0] !== 'o' && a[0] !== 'O') ||
                (a[1] !== 'n' && a[1] !== 'N')) &&
                ((a = gg.get(a) || a), kn(e, a, l));
          }
        }
        function pc(e, t, a, l, n, i) {
          switch (a) {
            case 'style':
              Of(e, l, i);
              break;
            case 'dangerouslySetInnerHTML':
              if (l != null) {
                if (typeof l != 'object' || !('__html' in l))
                  throw Error(s(61));
                if (((a = l.__html), a != null)) {
                  if (n.children != null) throw Error(s(60));
                  e.innerHTML = a;
                }
              }
              break;
            case 'children':
              typeof l == 'string'
                ? cl(e, l)
                : (typeof l == 'number' || typeof l == 'bigint') &&
                  cl(e, '' + l);
              break;
            case 'onScroll':
              l != null && ie('scroll', e);
              break;
            case 'onScrollEnd':
              l != null && ie('scrollend', e);
              break;
            case 'onClick':
              l != null && (e.onclick = Xt);
              break;
            case 'suppressContentEditableWarning':
            case 'suppressHydrationWarning':
            case 'innerHTML':
            case 'ref':
              break;
            case 'innerText':
            case 'textContent':
              break;
            default:
              if (!mf.hasOwnProperty(a))
                e: {
                  if (
                    a[0] === 'o' &&
                    a[1] === 'n' &&
                    ((n = a.endsWith('Capture')),
                    (t = a.slice(2, n ? a.length - 7 : void 0)),
                    (i = e[nt] || null),
                    (i = i != null ? i[a] : null),
                    typeof i == 'function' && e.removeEventListener(t, i, n),
                    typeof l == 'function')
                  ) {
                    (typeof i != 'function' &&
                      i !== null &&
                      (a in e
                        ? (e[a] = null)
                        : e.hasAttribute(a) && e.removeAttribute(a)),
                      e.addEventListener(t, l, n));
                    break e;
                  }
                  a in e
                    ? (e[a] = l)
                    : l === !0
                      ? e.setAttribute(a, '')
                      : kn(e, a, l);
                }
          }
        }
        function Pe(e, t, a) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'img':
              (ie('error', e), ie('load', e));
              var l = !1,
                n = !1,
                i;
              for (i in a)
                if (a.hasOwnProperty(i)) {
                  var c = a[i];
                  if (c != null)
                    switch (i) {
                      case 'src':
                        l = !0;
                        break;
                      case 'srcSet':
                        n = !0;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        throw Error(s(137, t));
                      default:
                        xe(e, t, i, c, a, null);
                    }
                }
              (n && xe(e, t, 'srcSet', a.srcSet, a, null),
                l && xe(e, t, 'src', a.src, a, null));
              return;
            case 'input':
              ie('invalid', e);
              var d = (i = c = n = null),
                p = null,
                O = null;
              for (l in a)
                if (a.hasOwnProperty(l)) {
                  var N = a[l];
                  if (N != null)
                    switch (l) {
                      case 'name':
                        n = N;
                        break;
                      case 'type':
                        c = N;
                        break;
                      case 'checked':
                        p = N;
                        break;
                      case 'defaultChecked':
                        O = N;
                        break;
                      case 'value':
                        i = N;
                        break;
                      case 'defaultValue':
                        d = N;
                        break;
                      case 'children':
                      case 'dangerouslySetInnerHTML':
                        if (N != null) throw Error(s(137, t));
                        break;
                      default:
                        xe(e, t, l, N, a, null);
                    }
                }
              Sf(e, i, d, p, O, c, n, !1);
              return;
            case 'select':
              (ie('invalid', e), (l = c = i = null));
              for (n in a)
                if (a.hasOwnProperty(n) && ((d = a[n]), d != null))
                  switch (n) {
                    case 'value':
                      i = d;
                      break;
                    case 'defaultValue':
                      c = d;
                      break;
                    case 'multiple':
                      l = d;
                    default:
                      xe(e, t, n, d, a, null);
                  }
              ((t = i),
                (a = c),
                (e.multiple = !!l),
                t != null ? sl(e, !!l, t, !1) : a != null && sl(e, !!l, a, !0));
              return;
            case 'textarea':
              (ie('invalid', e), (i = n = l = null));
              for (c in a)
                if (a.hasOwnProperty(c) && ((d = a[c]), d != null))
                  switch (c) {
                    case 'value':
                      l = d;
                      break;
                    case 'defaultValue':
                      n = d;
                      break;
                    case 'children':
                      i = d;
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (d != null) throw Error(s(91));
                      break;
                    default:
                      xe(e, t, c, d, a, null);
                  }
              Ef(e, l, n, i);
              return;
            case 'option':
              for (p in a)
                if (a.hasOwnProperty(p) && ((l = a[p]), l != null))
                  switch (p) {
                    case 'selected':
                      e.selected =
                        l && typeof l != 'function' && typeof l != 'symbol';
                      break;
                    default:
                      xe(e, t, p, l, a, null);
                  }
              return;
            case 'dialog':
              (ie('beforetoggle', e),
                ie('toggle', e),
                ie('cancel', e),
                ie('close', e));
              break;
            case 'iframe':
            case 'object':
              ie('load', e);
              break;
            case 'video':
            case 'audio':
              for (l = 0; l < _n.length; l++) ie(_n[l], e);
              break;
            case 'image':
              (ie('error', e), ie('load', e));
              break;
            case 'details':
              ie('toggle', e);
              break;
            case 'embed':
            case 'source':
            case 'link':
              (ie('error', e), ie('load', e));
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (O in a)
                if (a.hasOwnProperty(O) && ((l = a[O]), l != null))
                  switch (O) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      throw Error(s(137, t));
                    default:
                      xe(e, t, O, l, a, null);
                  }
              return;
            default:
              if (Cu(t)) {
                for (N in a)
                  a.hasOwnProperty(N) &&
                    ((l = a[N]), l !== void 0 && pc(e, t, N, l, a, void 0));
                return;
              }
          }
          for (d in a)
            a.hasOwnProperty(d) &&
              ((l = a[d]), l != null && xe(e, t, d, l, a, null));
        }
        function Ym(e, t, a, l) {
          switch (t) {
            case 'div':
            case 'span':
            case 'svg':
            case 'path':
            case 'a':
            case 'g':
            case 'p':
            case 'li':
              break;
            case 'input':
              var n = null,
                i = null,
                c = null,
                d = null,
                p = null,
                O = null,
                N = null;
              for (M in a) {
                var R = a[M];
                if (a.hasOwnProperty(M) && R != null)
                  switch (M) {
                    case 'checked':
                      break;
                    case 'value':
                      break;
                    case 'defaultValue':
                      p = R;
                    default:
                      l.hasOwnProperty(M) || xe(e, t, M, null, l, R);
                  }
              }
              for (var x in l) {
                var M = l[x];
                if (
                  ((R = a[x]), l.hasOwnProperty(x) && (M != null || R != null))
                )
                  switch (x) {
                    case 'type':
                      i = M;
                      break;
                    case 'name':
                      n = M;
                      break;
                    case 'checked':
                      O = M;
                      break;
                    case 'defaultChecked':
                      N = M;
                      break;
                    case 'value':
                      c = M;
                      break;
                    case 'defaultValue':
                      d = M;
                      break;
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (M != null) throw Error(s(137, t));
                      break;
                    default:
                      M !== R && xe(e, t, x, M, l, R);
                  }
              }
              _u(e, c, d, p, O, N, i, n);
              return;
            case 'select':
              M = c = d = x = null;
              for (i in a)
                if (((p = a[i]), a.hasOwnProperty(i) && p != null))
                  switch (i) {
                    case 'value':
                      break;
                    case 'multiple':
                      M = p;
                    default:
                      l.hasOwnProperty(i) || xe(e, t, i, null, l, p);
                  }
              for (n in l)
                if (
                  ((i = l[n]),
                  (p = a[n]),
                  l.hasOwnProperty(n) && (i != null || p != null))
                )
                  switch (n) {
                    case 'value':
                      x = i;
                      break;
                    case 'defaultValue':
                      d = i;
                      break;
                    case 'multiple':
                      c = i;
                    default:
                      i !== p && xe(e, t, n, i, l, p);
                  }
              ((t = d),
                (a = c),
                (l = M),
                x != null
                  ? sl(e, !!a, x, !1)
                  : !!l != !!a &&
                    (t != null
                      ? sl(e, !!a, t, !0)
                      : sl(e, !!a, a ? [] : '', !1)));
              return;
            case 'textarea':
              M = x = null;
              for (d in a)
                if (
                  ((n = a[d]),
                  a.hasOwnProperty(d) && n != null && !l.hasOwnProperty(d))
                )
                  switch (d) {
                    case 'value':
                      break;
                    case 'children':
                      break;
                    default:
                      xe(e, t, d, null, l, n);
                  }
              for (c in l)
                if (
                  ((n = l[c]),
                  (i = a[c]),
                  l.hasOwnProperty(c) && (n != null || i != null))
                )
                  switch (c) {
                    case 'value':
                      x = n;
                      break;
                    case 'defaultValue':
                      M = n;
                      break;
                    case 'children':
                      break;
                    case 'dangerouslySetInnerHTML':
                      if (n != null) throw Error(s(91));
                      break;
                    default:
                      n !== i && xe(e, t, c, n, l, i);
                  }
              Af(e, x, M);
              return;
            case 'option':
              for (var Y in a)
                if (
                  ((x = a[Y]),
                  a.hasOwnProperty(Y) && x != null && !l.hasOwnProperty(Y))
                )
                  switch (Y) {
                    case 'selected':
                      e.selected = !1;
                      break;
                    default:
                      xe(e, t, Y, null, l, x);
                  }
              for (p in l)
                if (
                  ((x = l[p]),
                  (M = a[p]),
                  l.hasOwnProperty(p) && x !== M && (x != null || M != null))
                )
                  switch (p) {
                    case 'selected':
                      e.selected =
                        x && typeof x != 'function' && typeof x != 'symbol';
                      break;
                    default:
                      xe(e, t, p, x, l, M);
                  }
              return;
            case 'img':
            case 'link':
            case 'area':
            case 'base':
            case 'br':
            case 'col':
            case 'embed':
            case 'hr':
            case 'keygen':
            case 'meta':
            case 'param':
            case 'source':
            case 'track':
            case 'wbr':
            case 'menuitem':
              for (var Z in a)
                ((x = a[Z]),
                  a.hasOwnProperty(Z) &&
                    x != null &&
                    !l.hasOwnProperty(Z) &&
                    xe(e, t, Z, null, l, x));
              for (O in l)
                if (
                  ((x = l[O]),
                  (M = a[O]),
                  l.hasOwnProperty(O) && x !== M && (x != null || M != null))
                )
                  switch (O) {
                    case 'children':
                    case 'dangerouslySetInnerHTML':
                      if (x != null) throw Error(s(137, t));
                      break;
                    default:
                      xe(e, t, O, x, l, M);
                  }
              return;
            default:
              if (Cu(t)) {
                for (var Me in a)
                  ((x = a[Me]),
                    a.hasOwnProperty(Me) &&
                      x !== void 0 &&
                      !l.hasOwnProperty(Me) &&
                      pc(e, t, Me, void 0, l, x));
                for (N in l)
                  ((x = l[N]),
                    (M = a[N]),
                    !l.hasOwnProperty(N) ||
                      x === M ||
                      (x === void 0 && M === void 0) ||
                      pc(e, t, N, x, l, M));
                return;
              }
          }
          for (var A in a)
            ((x = a[A]),
              a.hasOwnProperty(A) &&
                x != null &&
                !l.hasOwnProperty(A) &&
                xe(e, t, A, null, l, x));
          for (R in l)
            ((x = l[R]),
              (M = a[R]),
              !l.hasOwnProperty(R) ||
                x === M ||
                (x == null && M == null) ||
                xe(e, t, R, x, l, M));
        }
        function Md(e) {
          switch (e) {
            case 'css':
            case 'script':
            case 'font':
            case 'img':
            case 'image':
            case 'input':
            case 'link':
              return !0;
            default:
              return !1;
          }
        }
        function Vm() {
          if (typeof performance.getEntriesByType == 'function') {
            for (
              var e = 0,
                t = 0,
                a = performance.getEntriesByType('resource'),
                l = 0;
              l < a.length;
              l++
            ) {
              var n = a[l],
                i = n.transferSize,
                c = n.initiatorType,
                d = n.duration;
              if (i && d && Md(c)) {
                for (c = 0, d = n.responseEnd, l += 1; l < a.length; l++) {
                  var p = a[l],
                    O = p.startTime;
                  if (O > d) break;
                  var N = p.transferSize,
                    R = p.initiatorType;
                  N &&
                    Md(R) &&
                    ((p = p.responseEnd),
                    (c += N * (p < d ? 1 : (d - O) / (p - O))));
                }
                if (
                  (--l, (t += (8 * (i + c)) / (n.duration / 1e3)), e++, 10 < e)
                )
                  break;
              }
            }
            if (0 < e) return t / e / 1e6;
          }
          return navigator.connection &&
            ((e = navigator.connection.downlink), typeof e == 'number')
            ? e
            : 5;
        }
        var yc = null,
          vc = null;
        function Ji(e) {
          return e.nodeType === 9 ? e : e.ownerDocument;
        }
        function zd(e) {
          switch (e) {
            case 'http://www.w3.org/2000/svg':
              return 1;
            case 'http://www.w3.org/1998/Math/MathML':
              return 2;
            default:
              return 0;
          }
        }
        function _d(e, t) {
          if (e === 0)
            switch (t) {
              case 'svg':
                return 1;
              case 'math':
                return 2;
              default:
                return 0;
            }
          return e === 1 && t === 'foreignObject' ? 0 : e;
        }
        function bc(e, t) {
          return (
            e === 'textarea' ||
            e === 'noscript' ||
            typeof t.children == 'string' ||
            typeof t.children == 'number' ||
            typeof t.children == 'bigint' ||
            (typeof t.dangerouslySetInnerHTML == 'object' &&
              t.dangerouslySetInnerHTML !== null &&
              t.dangerouslySetInnerHTML.__html != null)
          );
        }
        var Sc = null;
        function wm() {
          var e = window.event;
          return e && e.type === 'popstate'
            ? e === Sc
              ? !1
              : ((Sc = e), !0)
            : ((Sc = null), !1);
        }
        var Nd = typeof setTimeout == 'function' ? setTimeout : void 0,
          Qm = typeof clearTimeout == 'function' ? clearTimeout : void 0,
          Cd = typeof Promise == 'function' ? Promise : void 0,
          Xm =
            typeof queueMicrotask == 'function'
              ? queueMicrotask
              : typeof Cd < 'u'
                ? function (e) {
                    return Cd.resolve(null).then(e).catch(Zm);
                  }
                : Nd;
        function Zm(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function za(e) {
          return e === 'head';
        }
        function Dd(e, t) {
          var a = t,
            l = 0;
          do {
            var n = a.nextSibling;
            if ((e.removeChild(a), n && n.nodeType === 8))
              if (((a = n.data), a === '/$' || a === '/&')) {
                if (l === 0) {
                  (e.removeChild(n), ql(t));
                  return;
                }
                l--;
              } else if (
                a === '$' ||
                a === '$?' ||
                a === '$~' ||
                a === '$!' ||
                a === '&'
              )
                l++;
              else if (a === 'html') Cn(e.ownerDocument.documentElement);
              else if (a === 'head') {
                ((a = e.ownerDocument.head), Cn(a));
                for (var i = a.firstChild; i;) {
                  var c = i.nextSibling,
                    d = i.nodeName;
                  (i[Jl] ||
                    d === 'SCRIPT' ||
                    d === 'STYLE' ||
                    (d === 'LINK' && i.rel.toLowerCase() === 'stylesheet') ||
                    a.removeChild(i),
                    (i = c));
                }
              } else a === 'body' && Cn(e.ownerDocument.body);
            a = n;
          } while (a);
          ql(t);
        }
        function Rd(e, t) {
          var a = e;
          e = 0;
          do {
            var l = a.nextSibling;
            if (
              (a.nodeType === 1
                ? t
                  ? ((a._stashedDisplay = a.style.display),
                    (a.style.display = 'none'))
                  : ((a.style.display = a._stashedDisplay || ''),
                    a.getAttribute('style') === '' &&
                      a.removeAttribute('style'))
                : a.nodeType === 3 &&
                  (t
                    ? ((a._stashedText = a.nodeValue), (a.nodeValue = ''))
                    : (a.nodeValue = a._stashedText || '')),
              l && l.nodeType === 8)
            )
              if (((a = l.data), a === '/$')) {
                if (e === 0) break;
                e--;
              } else
                (a !== '$' && a !== '$?' && a !== '$~' && a !== '$!') || e++;
            a = l;
          } while (a);
        }
        function Ac(e) {
          var t = e.firstChild;
          for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
            var a = t;
            switch (((t = t.nextSibling), a.nodeName)) {
              case 'HTML':
              case 'HEAD':
              case 'BODY':
                (Ac(a), Mu(a));
                continue;
              case 'SCRIPT':
              case 'STYLE':
                continue;
              case 'LINK':
                if (a.rel.toLowerCase() === 'stylesheet') continue;
            }
            e.removeChild(a);
          }
        }
        function Jm(e, t, a, l) {
          for (; e.nodeType === 1;) {
            var n = a;
            if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
              if (!l && (e.nodeName !== 'INPUT' || e.type !== 'hidden')) break;
            } else if (l) {
              if (!e[Jl])
                switch (t) {
                  case 'meta':
                    if (!e.hasAttribute('itemprop')) break;
                    return e;
                  case 'link':
                    if (
                      ((i = e.getAttribute('rel')),
                      i === 'stylesheet' && e.hasAttribute('data-precedence'))
                    )
                      break;
                    if (
                      i !== n.rel ||
                      e.getAttribute('href') !==
                        (n.href == null || n.href === '' ? null : n.href) ||
                      e.getAttribute('crossorigin') !==
                        (n.crossOrigin == null ? null : n.crossOrigin) ||
                      e.getAttribute('title') !==
                        (n.title == null ? null : n.title)
                    )
                      break;
                    return e;
                  case 'style':
                    if (e.hasAttribute('data-precedence')) break;
                    return e;
                  case 'script':
                    if (
                      ((i = e.getAttribute('src')),
                      (i !== (n.src == null ? null : n.src) ||
                        e.getAttribute('type') !==
                          (n.type == null ? null : n.type) ||
                        e.getAttribute('crossorigin') !==
                          (n.crossOrigin == null ? null : n.crossOrigin)) &&
                        i &&
                        e.hasAttribute('async') &&
                        !e.hasAttribute('itemprop'))
                    )
                      break;
                    return e;
                  default:
                    return e;
                }
            } else if (t === 'input' && e.type === 'hidden') {
              var i = n.name == null ? null : '' + n.name;
              if (n.type === 'hidden' && e.getAttribute('name') === i) return e;
            } else return e;
            if (((e = Ct(e.nextSibling)), e === null)) break;
          }
          return null;
        }
        function $m(e, t, a) {
          if (t === '') return null;
          for (; e.nodeType !== 3;)
            if (
              ((e.nodeType !== 1 ||
                e.nodeName !== 'INPUT' ||
                e.type !== 'hidden') &&
                !a) ||
              ((e = Ct(e.nextSibling)), e === null)
            )
              return null;
          return e;
        }
        function jd(e, t) {
          for (; e.nodeType !== 8;)
            if (
              ((e.nodeType !== 1 ||
                e.nodeName !== 'INPUT' ||
                e.type !== 'hidden') &&
                !t) ||
              ((e = Ct(e.nextSibling)), e === null)
            )
              return null;
          return e;
        }
        function Ec(e) {
          return e.data === '$?' || e.data === '$~';
        }
        function Tc(e) {
          return (
            e.data === '$!' ||
            (e.data === '$?' && e.ownerDocument.readyState !== 'loading')
          );
        }
        function km(e, t) {
          var a = e.ownerDocument;
          if (e.data === '$~') e._reactRetry = t;
          else if (e.data !== '$?' || a.readyState !== 'loading') t();
          else {
            var l = function () {
              (t(), a.removeEventListener('DOMContentLoaded', l));
            };
            (a.addEventListener('DOMContentLoaded', l), (e._reactRetry = l));
          }
        }
        function Ct(e) {
          for (; e != null; e = e.nextSibling) {
            var t = e.nodeType;
            if (t === 1 || t === 3) break;
            if (t === 8) {
              if (
                ((t = e.data),
                t === '$' ||
                  t === '$!' ||
                  t === '$?' ||
                  t === '$~' ||
                  t === '&' ||
                  t === 'F!' ||
                  t === 'F')
              )
                break;
              if (t === '/$' || t === '/&') return null;
            }
          }
          return e;
        }
        var Oc = null;
        function Ld(e) {
          e = e.nextSibling;
          for (var t = 0; e;) {
            if (e.nodeType === 8) {
              var a = e.data;
              if (a === '/$' || a === '/&') {
                if (t === 0) return Ct(e.nextSibling);
                t--;
              } else
                (a !== '$' &&
                  a !== '$!' &&
                  a !== '$?' &&
                  a !== '$~' &&
                  a !== '&') ||
                  t++;
            }
            e = e.nextSibling;
          }
          return null;
        }
        function Ud(e) {
          e = e.previousSibling;
          for (var t = 0; e;) {
            if (e.nodeType === 8) {
              var a = e.data;
              if (
                a === '$' ||
                a === '$!' ||
                a === '$?' ||
                a === '$~' ||
                a === '&'
              ) {
                if (t === 0) return e;
                t--;
              } else (a !== '/$' && a !== '/&') || t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        function Hd(e, t, a) {
          switch (((t = Ji(a)), e)) {
            case 'html':
              if (((e = t.documentElement), !e)) throw Error(s(452));
              return e;
            case 'head':
              if (((e = t.head), !e)) throw Error(s(453));
              return e;
            case 'body':
              if (((e = t.body), !e)) throw Error(s(454));
              return e;
            default:
              throw Error(s(451));
          }
        }
        function Cn(e) {
          for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
          Mu(e);
        }
        var Dt = new Map(),
          Bd = new Set();
        function $i(e) {
          return typeof e.getRootNode == 'function'
            ? e.getRootNode()
            : e.nodeType === 9
              ? e
              : e.ownerDocument;
        }
        var sa = U.d;
        U.d = { f: Fm, r: Wm, D: Im, C: Pm, L: ep, m: tp, X: lp, S: ap, M: np };
        function Fm() {
          var e = sa.f(),
            t = qi();
          return e || t;
        }
        function Wm(e) {
          var t = nl(e);
          t !== null && t.tag === 5 && t.type === 'form' ? er(t) : sa.r(e);
        }
        var Hl = typeof document > 'u' ? null : document;
        function Kd(e, t, a) {
          var l = Hl;
          if (l && typeof t == 'string' && t) {
            var n = Tt(t);
            ((n = 'link[rel="' + e + '"][href="' + n + '"]'),
              typeof a == 'string' && (n += '[crossorigin="' + a + '"]'),
              Bd.has(n) ||
                (Bd.add(n),
                (e = { rel: e, crossOrigin: a, href: t }),
                l.querySelector(n) === null &&
                  ((t = l.createElement('link')),
                  Pe(t, 'link', e),
                  Ze(t),
                  l.head.appendChild(t))));
          }
        }
        function Im(e) {
          (sa.D(e), Kd('dns-prefetch', e, null));
        }
        function Pm(e, t) {
          (sa.C(e, t), Kd('preconnect', e, t));
        }
        function ep(e, t, a) {
          sa.L(e, t, a);
          var l = Hl;
          if (l && e && t) {
            var n = 'link[rel="preload"][as="' + Tt(t) + '"]';
            t === 'image' && a && a.imageSrcSet
              ? ((n += '[imagesrcset="' + Tt(a.imageSrcSet) + '"]'),
                typeof a.imageSizes == 'string' &&
                  (n += '[imagesizes="' + Tt(a.imageSizes) + '"]'))
              : (n += '[href="' + Tt(e) + '"]');
            var i = n;
            switch (t) {
              case 'style':
                i = Bl(e);
                break;
              case 'script':
                i = Kl(e);
            }
            Dt.has(i) ||
              ((e = E(
                {
                  rel: 'preload',
                  href: t === 'image' && a && a.imageSrcSet ? void 0 : e,
                  as: t,
                },
                a
              )),
              Dt.set(i, e),
              l.querySelector(n) !== null ||
                (t === 'style' && l.querySelector(Dn(i))) ||
                (t === 'script' && l.querySelector(Rn(i))) ||
                ((t = l.createElement('link')),
                Pe(t, 'link', e),
                Ze(t),
                l.head.appendChild(t)));
          }
        }
        function tp(e, t) {
          sa.m(e, t);
          var a = Hl;
          if (a && e) {
            var l = t && typeof t.as == 'string' ? t.as : 'script',
              n =
                'link[rel="modulepreload"][as="' +
                Tt(l) +
                '"][href="' +
                Tt(e) +
                '"]',
              i = n;
            switch (l) {
              case 'audioworklet':
              case 'paintworklet':
              case 'serviceworker':
              case 'sharedworker':
              case 'worker':
              case 'script':
                i = Kl(e);
            }
            if (
              !Dt.has(i) &&
              ((e = E({ rel: 'modulepreload', href: e }, t)),
              Dt.set(i, e),
              a.querySelector(n) === null)
            ) {
              switch (l) {
                case 'audioworklet':
                case 'paintworklet':
                case 'serviceworker':
                case 'sharedworker':
                case 'worker':
                case 'script':
                  if (a.querySelector(Rn(i))) return;
              }
              ((l = a.createElement('link')),
                Pe(l, 'link', e),
                Ze(l),
                a.head.appendChild(l));
            }
          }
        }
        function ap(e, t, a) {
          sa.S(e, t, a);
          var l = Hl;
          if (l && e) {
            var n = il(l).hoistableStyles,
              i = Bl(e);
            t = t || 'default';
            var c = n.get(i);
            if (!c) {
              var d = { loading: 0, preload: null };
              if ((c = l.querySelector(Dn(i)))) d.loading = 5;
              else {
                ((e = E(
                  { rel: 'stylesheet', href: e, 'data-precedence': t },
                  a
                )),
                  (a = Dt.get(i)) && xc(e, a));
                var p = (c = l.createElement('link'));
                (Ze(p),
                  Pe(p, 'link', e),
                  (p._p = new Promise(function (O, N) {
                    ((p.onload = O), (p.onerror = N));
                  })),
                  p.addEventListener('load', function () {
                    d.loading |= 1;
                  }),
                  p.addEventListener('error', function () {
                    d.loading |= 2;
                  }),
                  (d.loading |= 4),
                  ki(c, t, l));
              }
              ((c = { type: 'stylesheet', instance: c, count: 1, state: d }),
                n.set(i, c));
            }
          }
        }
        function lp(e, t) {
          sa.X(e, t);
          var a = Hl;
          if (a && e) {
            var l = il(a).hoistableScripts,
              n = Kl(e),
              i = l.get(n);
            i ||
              ((i = a.querySelector(Rn(n))),
              i ||
                ((e = E({ src: e, async: !0 }, t)),
                (t = Dt.get(n)) && Mc(e, t),
                (i = a.createElement('script')),
                Ze(i),
                Pe(i, 'link', e),
                a.head.appendChild(i)),
              (i = { type: 'script', instance: i, count: 1, state: null }),
              l.set(n, i));
          }
        }
        function np(e, t) {
          sa.M(e, t);
          var a = Hl;
          if (a && e) {
            var l = il(a).hoistableScripts,
              n = Kl(e),
              i = l.get(n);
            i ||
              ((i = a.querySelector(Rn(n))),
              i ||
                ((e = E({ src: e, async: !0, type: 'module' }, t)),
                (t = Dt.get(n)) && Mc(e, t),
                (i = a.createElement('script')),
                Ze(i),
                Pe(i, 'link', e),
                a.head.appendChild(i)),
              (i = { type: 'script', instance: i, count: 1, state: null }),
              l.set(n, i));
          }
        }
        function qd(e, t, a, l) {
          var n = (n = le.current) ? $i(n) : null;
          if (!n) throw Error(s(446));
          switch (e) {
            case 'meta':
            case 'title':
              return null;
            case 'style':
              return typeof a.precedence == 'string' &&
                typeof a.href == 'string'
                ? ((t = Bl(a.href)),
                  (a = il(n).hoistableStyles),
                  (l = a.get(t)),
                  l ||
                    ((l = {
                      type: 'style',
                      instance: null,
                      count: 0,
                      state: null,
                    }),
                    a.set(t, l)),
                  l)
                : { type: 'void', instance: null, count: 0, state: null };
            case 'link':
              if (
                a.rel === 'stylesheet' &&
                typeof a.href == 'string' &&
                typeof a.precedence == 'string'
              ) {
                e = Bl(a.href);
                var i = il(n).hoistableStyles,
                  c = i.get(e);
                if (
                  (c ||
                    ((n = n.ownerDocument || n),
                    (c = {
                      type: 'stylesheet',
                      instance: null,
                      count: 0,
                      state: { loading: 0, preload: null },
                    }),
                    i.set(e, c),
                    (i = n.querySelector(Dn(e))) &&
                      !i._p &&
                      ((c.instance = i), (c.state.loading = 5)),
                    Dt.has(e) ||
                      ((a = {
                        rel: 'preload',
                        as: 'style',
                        href: a.href,
                        crossOrigin: a.crossOrigin,
                        integrity: a.integrity,
                        media: a.media,
                        hrefLang: a.hrefLang,
                        referrerPolicy: a.referrerPolicy,
                      }),
                      Dt.set(e, a),
                      i || ip(n, e, a, c.state))),
                  t && l === null)
                )
                  throw Error(s(528, ''));
                return c;
              }
              if (t && l !== null) throw Error(s(529, ''));
              return null;
            case 'script':
              return (
                (t = a.async),
                (a = a.src),
                typeof a == 'string' &&
                t &&
                typeof t != 'function' &&
                typeof t != 'symbol'
                  ? ((t = Kl(a)),
                    (a = il(n).hoistableScripts),
                    (l = a.get(t)),
                    l ||
                      ((l = {
                        type: 'script',
                        instance: null,
                        count: 0,
                        state: null,
                      }),
                      a.set(t, l)),
                    l)
                  : { type: 'void', instance: null, count: 0, state: null }
              );
            default:
              throw Error(s(444, e));
          }
        }
        function Bl(e) {
          return 'href="' + Tt(e) + '"';
        }
        function Dn(e) {
          return 'link[rel="stylesheet"][' + e + ']';
        }
        function Gd(e) {
          return E({}, e, {
            'data-precedence': e.precedence,
            precedence: null,
          });
        }
        function ip(e, t, a, l) {
          e.querySelector('link[rel="preload"][as="style"][' + t + ']')
            ? (l.loading = 1)
            : ((t = e.createElement('link')),
              (l.preload = t),
              t.addEventListener('load', function () {
                return (l.loading |= 1);
              }),
              t.addEventListener('error', function () {
                return (l.loading |= 2);
              }),
              Pe(t, 'link', a),
              Ze(t),
              e.head.appendChild(t));
        }
        function Kl(e) {
          return '[src="' + Tt(e) + '"]';
        }
        function Rn(e) {
          return 'script[async]' + e;
        }
        function Yd(e, t, a) {
          if ((t.count++, t.instance === null))
            switch (t.type) {
              case 'style':
                var l = e.querySelector(
                  'style[data-href~="' + Tt(a.href) + '"]'
                );
                if (l) return ((t.instance = l), Ze(l), l);
                var n = E({}, a, {
                  'data-href': a.href,
                  'data-precedence': a.precedence,
                  href: null,
                  precedence: null,
                });
                return (
                  (l = (e.ownerDocument || e).createElement('style')),
                  Ze(l),
                  Pe(l, 'style', n),
                  ki(l, a.precedence, e),
                  (t.instance = l)
                );
              case 'stylesheet':
                n = Bl(a.href);
                var i = e.querySelector(Dn(n));
                if (i)
                  return ((t.state.loading |= 4), (t.instance = i), Ze(i), i);
                ((l = Gd(a)),
                  (n = Dt.get(n)) && xc(l, n),
                  (i = (e.ownerDocument || e).createElement('link')),
                  Ze(i));
                var c = i;
                return (
                  (c._p = new Promise(function (d, p) {
                    ((c.onload = d), (c.onerror = p));
                  })),
                  Pe(i, 'link', l),
                  (t.state.loading |= 4),
                  ki(i, a.precedence, e),
                  (t.instance = i)
                );
              case 'script':
                return (
                  (i = Kl(a.src)),
                  (n = e.querySelector(Rn(i)))
                    ? ((t.instance = n), Ze(n), n)
                    : ((l = a),
                      (n = Dt.get(i)) && ((l = E({}, a)), Mc(l, n)),
                      (e = e.ownerDocument || e),
                      (n = e.createElement('script')),
                      Ze(n),
                      Pe(n, 'link', l),
                      e.head.appendChild(n),
                      (t.instance = n))
                );
              case 'void':
                return null;
              default:
                throw Error(s(443, t.type));
            }
          else
            t.type === 'stylesheet' &&
              (t.state.loading & 4) === 0 &&
              ((l = t.instance),
              (t.state.loading |= 4),
              ki(l, a.precedence, e));
          return t.instance;
        }
        function ki(e, t, a) {
          for (
            var l = a.querySelectorAll(
                'link[rel="stylesheet"][data-precedence],style[data-precedence]'
              ),
              n = l.length ? l[l.length - 1] : null,
              i = n,
              c = 0;
            c < l.length;
            c++
          ) {
            var d = l[c];
            if (d.dataset.precedence === t) i = d;
            else if (i !== n) break;
          }
          i
            ? i.parentNode.insertBefore(e, i.nextSibling)
            : ((t = a.nodeType === 9 ? a.head : a),
              t.insertBefore(e, t.firstChild));
        }
        function xc(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.title == null && (e.title = t.title));
        }
        function Mc(e, t) {
          (e.crossOrigin == null && (e.crossOrigin = t.crossOrigin),
            e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy),
            e.integrity == null && (e.integrity = t.integrity));
        }
        var Fi = null;
        function Vd(e, t, a) {
          if (Fi === null) {
            var l = new Map(),
              n = (Fi = new Map());
            n.set(a, l);
          } else
            ((n = Fi), (l = n.get(a)), l || ((l = new Map()), n.set(a, l)));
          if (l.has(e)) return l;
          for (
            l.set(e, null), a = a.getElementsByTagName(e), n = 0;
            n < a.length;
            n++
          ) {
            var i = a[n];
            if (
              !(
                i[Jl] ||
                i[ke] ||
                (e === 'link' && i.getAttribute('rel') === 'stylesheet')
              ) &&
              i.namespaceURI !== 'http://www.w3.org/2000/svg'
            ) {
              var c = i.getAttribute(t) || '';
              c = e + c;
              var d = l.get(c);
              d ? d.push(i) : l.set(c, [i]);
            }
          }
          return l;
        }
        function wd(e, t, a) {
          ((e = e.ownerDocument || e),
            e.head.insertBefore(
              a,
              t === 'title' ? e.querySelector('head > title') : null
            ));
        }
        function up(e, t, a) {
          if (a === 1 || t.itemProp != null) return !1;
          switch (e) {
            case 'meta':
            case 'title':
              return !0;
            case 'style':
              if (
                typeof t.precedence != 'string' ||
                typeof t.href != 'string' ||
                t.href === ''
              )
                break;
              return !0;
            case 'link':
              if (
                typeof t.rel != 'string' ||
                typeof t.href != 'string' ||
                t.href === '' ||
                t.onLoad ||
                t.onError
              )
                break;
              switch (t.rel) {
                case 'stylesheet':
                  return (
                    (e = t.disabled),
                    typeof t.precedence == 'string' && e == null
                  );
                default:
                  return !0;
              }
            case 'script':
              if (
                t.async &&
                typeof t.async != 'function' &&
                typeof t.async != 'symbol' &&
                !t.onLoad &&
                !t.onError &&
                t.src &&
                typeof t.src == 'string'
              )
                return !0;
          }
          return !1;
        }
        function Qd(e) {
          return !(e.type === 'stylesheet' && (e.state.loading & 3) === 0);
        }
        function sp(e, t, a, l) {
          if (
            a.type === 'stylesheet' &&
            (typeof l.media != 'string' ||
              matchMedia(l.media).matches !== !1) &&
            (a.state.loading & 4) === 0
          ) {
            if (a.instance === null) {
              var n = Bl(l.href),
                i = t.querySelector(Dn(n));
              if (i) {
                ((t = i._p),
                  t !== null &&
                    typeof t == 'object' &&
                    typeof t.then == 'function' &&
                    (e.count++, (e = Wi.bind(e)), t.then(e, e)),
                  (a.state.loading |= 4),
                  (a.instance = i),
                  Ze(i));
                return;
              }
              ((i = t.ownerDocument || t),
                (l = Gd(l)),
                (n = Dt.get(n)) && xc(l, n),
                (i = i.createElement('link')),
                Ze(i));
              var c = i;
              ((c._p = new Promise(function (d, p) {
                ((c.onload = d), (c.onerror = p));
              })),
                Pe(i, 'link', l),
                (a.instance = i));
            }
            (e.stylesheets === null && (e.stylesheets = new Map()),
              e.stylesheets.set(a, t),
              (t = a.state.preload) &&
                (a.state.loading & 3) === 0 &&
                (e.count++,
                (a = Wi.bind(e)),
                t.addEventListener('load', a),
                t.addEventListener('error', a)));
          }
        }
        var zc = 0;
        function cp(e, t) {
          return (
            e.stylesheets && e.count === 0 && Pi(e, e.stylesheets),
            0 < e.count || 0 < e.imgCount
              ? function (a) {
                  var l = setTimeout(function () {
                    if ((e.stylesheets && Pi(e, e.stylesheets), e.unsuspend)) {
                      var i = e.unsuspend;
                      ((e.unsuspend = null), i());
                    }
                  }, 6e4 + t);
                  0 < e.imgBytes && zc === 0 && (zc = 62500 * Vm());
                  var n = setTimeout(
                    function () {
                      if (
                        ((e.waitingForImages = !1),
                        e.count === 0 &&
                          (e.stylesheets && Pi(e, e.stylesheets), e.unsuspend))
                      ) {
                        var i = e.unsuspend;
                        ((e.unsuspend = null), i());
                      }
                    },
                    (e.imgBytes > zc ? 50 : 800) + t
                  );
                  return (
                    (e.unsuspend = a),
                    function () {
                      ((e.unsuspend = null), clearTimeout(l), clearTimeout(n));
                    }
                  );
                }
              : null
          );
        }
        function Wi() {
          if (
            (this.count--,
            this.count === 0 && (this.imgCount === 0 || !this.waitingForImages))
          ) {
            if (this.stylesheets) Pi(this, this.stylesheets);
            else if (this.unsuspend) {
              var e = this.unsuspend;
              ((this.unsuspend = null), e());
            }
          }
        }
        var Ii = null;
        function Pi(e, t) {
          ((e.stylesheets = null),
            e.unsuspend !== null &&
              (e.count++,
              (Ii = new Map()),
              t.forEach(fp, e),
              (Ii = null),
              Wi.call(e)));
        }
        function fp(e, t) {
          if (!(t.state.loading & 4)) {
            var a = Ii.get(e);
            if (a) var l = a.get(null);
            else {
              ((a = new Map()), Ii.set(e, a));
              for (
                var n = e.querySelectorAll(
                    'link[data-precedence],style[data-precedence]'
                  ),
                  i = 0;
                i < n.length;
                i++
              ) {
                var c = n[i];
                (c.nodeName === 'LINK' ||
                  c.getAttribute('media') !== 'not all') &&
                  (a.set(c.dataset.precedence, c), (l = c));
              }
              l && a.set(null, l);
            }
            ((n = t.instance),
              (c = n.getAttribute('data-precedence')),
              (i = a.get(c) || l),
              i === l && a.set(null, n),
              a.set(c, n),
              this.count++,
              (l = Wi.bind(this)),
              n.addEventListener('load', l),
              n.addEventListener('error', l),
              i
                ? i.parentNode.insertBefore(n, i.nextSibling)
                : ((e = e.nodeType === 9 ? e.head : e),
                  e.insertBefore(n, e.firstChild)),
              (t.state.loading |= 4));
          }
        }
        var jn = {
          $$typeof: ge,
          Provider: null,
          Consumer: null,
          _currentValue: Q,
          _currentValue2: Q,
          _threadCount: 0,
        };
        function op(e, t, a, l, n, i, c, d, p) {
          ((this.tag = 1),
            (this.containerInfo = e),
            (this.pingCache = this.current = this.pendingChildren = null),
            (this.timeoutHandle = -1),
            (this.callbackNode =
              this.next =
              this.pendingContext =
              this.context =
              this.cancelPendingCommit =
                null),
            (this.callbackPriority = 0),
            (this.expirationTimes = Eu(-1)),
            (this.entangledLanes =
              this.shellSuspendCounter =
              this.errorRecoveryDisabledLanes =
              this.expiredLanes =
              this.warmLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = Eu(0)),
            (this.hiddenUpdates = Eu(null)),
            (this.identifierPrefix = l),
            (this.onUncaughtError = n),
            (this.onCaughtError = i),
            (this.onRecoverableError = c),
            (this.pooledCache = null),
            (this.pooledCacheLanes = 0),
            (this.formState = p),
            (this.incompleteTransitions = new Map()));
        }
        function Xd(e, t, a, l, n, i, c, d, p, O, N, R) {
          return (
            (e = new op(e, t, a, c, p, O, N, R, d)),
            (t = 1),
            i === !0 && (t |= 24),
            (i = pt(3, null, null, t)),
            (e.current = i),
            (i.stateNode = e),
            (t = us()),
            t.refCount++,
            (e.pooledCache = t),
            t.refCount++,
            (i.memoizedState = { element: l, isDehydrated: a, cache: t }),
            os(i),
            e
          );
        }
        function Zd(e) {
          return e ? ((e = ml), e) : ml;
        }
        function Jd(e, t, a, l, n, i) {
          ((n = Zd(n)),
            l.context === null ? (l.context = n) : (l.pendingContext = n),
            (l = pa(t)),
            (l.payload = { element: a }),
            (i = i === void 0 ? null : i),
            i !== null && (l.callback = i),
            (a = ya(e, l, t)),
            a !== null && (ot(a, e, t), rn(a, e, t)));
        }
        function $d(e, t) {
          if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
            var a = e.retryLane;
            e.retryLane = a !== 0 && a < t ? a : t;
          }
        }
        function _c(e, t) {
          ($d(e, t), (e = e.alternate) && $d(e, t));
        }
        function kd(e) {
          if (e.tag === 13 || e.tag === 31) {
            var t = qa(e, 67108864);
            (t !== null && ot(t, e, 67108864), _c(e, 67108864));
          }
        }
        function Fd(e) {
          if (e.tag === 13 || e.tag === 31) {
            var t = At();
            t = Tu(t);
            var a = qa(e, t);
            (a !== null && ot(a, e, t), _c(e, t));
          }
        }
        var eu = !0;
        function rp(e, t, a, l) {
          var n = z.T;
          z.T = null;
          var i = U.p;
          try {
            ((U.p = 2), Nc(e, t, a, l));
          } finally {
            ((U.p = i), (z.T = n));
          }
        }
        function dp(e, t, a, l) {
          var n = z.T;
          z.T = null;
          var i = U.p;
          try {
            ((U.p = 8), Nc(e, t, a, l));
          } finally {
            ((U.p = i), (z.T = n));
          }
        }
        function Nc(e, t, a, l) {
          if (eu) {
            var n = Cc(l);
            if (n === null) (mc(e, t, l, tu, a), Id(e, l));
            else if (gp(n, e, t, a, l)) l.stopPropagation();
            else if ((Id(e, l), t & 4 && -1 < hp.indexOf(e))) {
              for (; n !== null;) {
                var i = nl(n);
                if (i !== null)
                  switch (i.tag) {
                    case 3:
                      if (
                        ((i = i.stateNode),
                        i.current.memoizedState.isDehydrated)
                      ) {
                        var c = La(i.pendingLanes);
                        if (c !== 0) {
                          var d = i;
                          for (d.pendingLanes |= 2, d.entangledLanes |= 2; c;) {
                            var p = 1 << (31 - gt(c));
                            ((d.entanglements[1] |= p), (c &= ~p));
                          }
                          (Vt(i), (ve & 6) === 0 && ((Bi = dt() + 500), zn(0)));
                        }
                      }
                      break;
                    case 31:
                    case 13:
                      ((d = qa(i, 2)),
                        d !== null && ot(d, i, 2),
                        qi(),
                        _c(i, 2));
                  }
                if (((i = Cc(l)), i === null && mc(e, t, l, tu, a), i === n))
                  break;
                n = i;
              }
              n !== null && l.stopPropagation();
            } else mc(e, t, l, null, a);
          }
        }
        function Cc(e) {
          return ((e = Ru(e)), Dc(e));
        }
        var tu = null;
        function Dc(e) {
          if (((tu = null), (e = ll(e)), e !== null)) {
            var t = h(e);
            if (t === null) e = null;
            else {
              var a = t.tag;
              if (a === 13) {
                if (((e = m(t)), e !== null)) return e;
                e = null;
              } else if (a === 31) {
                if (((e = v(t)), e !== null)) return e;
                e = null;
              } else if (a === 3) {
                if (t.stateNode.current.memoizedState.isDehydrated)
                  return t.tag === 3 ? t.stateNode.containerInfo : null;
                e = null;
              } else t !== e && (e = null);
            }
          }
          return ((tu = e), null);
        }
        function Wd(e) {
          switch (e) {
            case 'beforetoggle':
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'toggle':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            case 'beforeblur':
            case 'afterblur':
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
              return 2;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'touchmove':
            case 'wheel':
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
              return 8;
            case 'message':
              switch (Ih()) {
                case lf:
                  return 2;
                case nf:
                  return 8;
                case Qn:
                case Ph:
                  return 32;
                case uf:
                  return 268435456;
                default:
                  return 32;
              }
            default:
              return 32;
          }
        }
        var Rc = !1,
          _a = null,
          Na = null,
          Ca = null,
          Ln = new Map(),
          Un = new Map(),
          Da = [],
          hp =
            'mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset'.split(
              ' '
            );
        function Id(e, t) {
          switch (e) {
            case 'focusin':
            case 'focusout':
              _a = null;
              break;
            case 'dragenter':
            case 'dragleave':
              Na = null;
              break;
            case 'mouseover':
            case 'mouseout':
              Ca = null;
              break;
            case 'pointerover':
            case 'pointerout':
              Ln.delete(t.pointerId);
              break;
            case 'gotpointercapture':
            case 'lostpointercapture':
              Un.delete(t.pointerId);
          }
        }
        function Hn(e, t, a, l, n, i) {
          return e === null || e.nativeEvent !== i
            ? ((e = {
                blockedOn: t,
                domEventName: a,
                eventSystemFlags: l,
                nativeEvent: i,
                targetContainers: [n],
              }),
              t !== null && ((t = nl(t)), t !== null && kd(t)),
              e)
            : ((e.eventSystemFlags |= l),
              (t = e.targetContainers),
              n !== null && t.indexOf(n) === -1 && t.push(n),
              e);
        }
        function gp(e, t, a, l, n) {
          switch (t) {
            case 'focusin':
              return ((_a = Hn(_a, e, t, a, l, n)), !0);
            case 'dragenter':
              return ((Na = Hn(Na, e, t, a, l, n)), !0);
            case 'mouseover':
              return ((Ca = Hn(Ca, e, t, a, l, n)), !0);
            case 'pointerover':
              var i = n.pointerId;
              return (Ln.set(i, Hn(Ln.get(i) || null, e, t, a, l, n)), !0);
            case 'gotpointercapture':
              return (
                (i = n.pointerId),
                Un.set(i, Hn(Un.get(i) || null, e, t, a, l, n)),
                !0
              );
          }
          return !1;
        }
        function Pd(e) {
          var t = ll(e.target);
          if (t !== null) {
            var a = h(t);
            if (a !== null) {
              if (((t = a.tag), t === 13)) {
                if (((t = m(a)), t !== null)) {
                  ((e.blockedOn = t),
                    df(e.priority, function () {
                      Fd(a);
                    }));
                  return;
                }
              } else if (t === 31) {
                if (((t = v(a)), t !== null)) {
                  ((e.blockedOn = t),
                    df(e.priority, function () {
                      Fd(a);
                    }));
                  return;
                }
              } else if (
                t === 3 &&
                a.stateNode.current.memoizedState.isDehydrated
              ) {
                e.blockedOn = a.tag === 3 ? a.stateNode.containerInfo : null;
                return;
              }
            }
          }
          e.blockedOn = null;
        }
        function au(e) {
          if (e.blockedOn !== null) return !1;
          for (var t = e.targetContainers; 0 < t.length;) {
            var a = Cc(e.nativeEvent);
            if (a === null) {
              a = e.nativeEvent;
              var l = new a.constructor(a.type, a);
              ((Du = l), a.target.dispatchEvent(l), (Du = null));
            } else
              return ((t = nl(a)), t !== null && kd(t), (e.blockedOn = a), !1);
            t.shift();
          }
          return !0;
        }
        function eh(e, t, a) {
          au(e) && a.delete(t);
        }
        function mp() {
          ((Rc = !1),
            _a !== null && au(_a) && (_a = null),
            Na !== null && au(Na) && (Na = null),
            Ca !== null && au(Ca) && (Ca = null),
            Ln.forEach(eh),
            Un.forEach(eh));
        }
        function lu(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            Rc ||
              ((Rc = !0),
              r.unstable_scheduleCallback(r.unstable_NormalPriority, mp)));
        }
        var nu = null;
        function th(e) {
          nu !== e &&
            ((nu = e),
            r.unstable_scheduleCallback(r.unstable_NormalPriority, function () {
              nu === e && (nu = null);
              for (var t = 0; t < e.length; t += 3) {
                var a = e[t],
                  l = e[t + 1],
                  n = e[t + 2];
                if (typeof l != 'function') {
                  if (Dc(l || a) === null) continue;
                  break;
                }
                var i = nl(a);
                i !== null &&
                  (e.splice(t, 3),
                  (t -= 3),
                  Cs(
                    i,
                    { pending: !0, data: n, method: a.method, action: l },
                    l,
                    n
                  ));
              }
            }));
        }
        function ql(e) {
          function t(p) {
            return lu(p, e);
          }
          (_a !== null && lu(_a, e),
            Na !== null && lu(Na, e),
            Ca !== null && lu(Ca, e),
            Ln.forEach(t),
            Un.forEach(t));
          for (var a = 0; a < Da.length; a++) {
            var l = Da[a];
            l.blockedOn === e && (l.blockedOn = null);
          }
          for (; 0 < Da.length && ((a = Da[0]), a.blockedOn === null);)
            (Pd(a), a.blockedOn === null && Da.shift());
          if (((a = (e.ownerDocument || e).$$reactFormReplay), a != null))
            for (l = 0; l < a.length; l += 3) {
              var n = a[l],
                i = a[l + 1],
                c = n[nt] || null;
              if (typeof i == 'function') c || th(a);
              else if (c) {
                var d = null;
                if (i && i.hasAttribute('formAction')) {
                  if (((n = i), (c = i[nt] || null))) d = c.formAction;
                  else if (Dc(n) !== null) continue;
                } else d = c.action;
                (typeof d == 'function'
                  ? (a[l + 1] = d)
                  : (a.splice(l, 3), (l -= 3)),
                  th(a));
              }
            }
        }
        function ah() {
          function e(i) {
            i.canIntercept &&
              i.info === 'react-transition' &&
              i.intercept({
                handler: function () {
                  return new Promise(function (c) {
                    return (n = c);
                  });
                },
                focusReset: 'manual',
                scroll: 'manual',
              });
          }
          function t() {
            (n !== null && (n(), (n = null)), l || setTimeout(a, 20));
          }
          function a() {
            if (!l && !navigation.transition) {
              var i = navigation.currentEntry;
              i &&
                i.url != null &&
                navigation.navigate(i.url, {
                  state: i.getState(),
                  info: 'react-transition',
                  history: 'replace',
                });
            }
          }
          if (typeof navigation == 'object') {
            var l = !1,
              n = null;
            return (
              navigation.addEventListener('navigate', e),
              navigation.addEventListener('navigatesuccess', t),
              navigation.addEventListener('navigateerror', t),
              setTimeout(a, 100),
              function () {
                ((l = !0),
                  navigation.removeEventListener('navigate', e),
                  navigation.removeEventListener('navigatesuccess', t),
                  navigation.removeEventListener('navigateerror', t),
                  n !== null && (n(), (n = null)));
              }
            );
          }
        }
        function jc(e) {
          this._internalRoot = e;
        }
        ((iu.prototype.render = jc.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (t === null) throw Error(s(409));
            var a = t.current,
              l = At();
            Jd(a, l, e, t, null, null);
          }),
          (iu.prototype.unmount = jc.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (e !== null) {
                this._internalRoot = null;
                var t = e.containerInfo;
                (Jd(e.current, 2, null, e, null, null), qi(), (t[al] = null));
              }
            }));
        function iu(e) {
          this._internalRoot = e;
        }
        iu.prototype.unstable_scheduleHydration = function (e) {
          if (e) {
            var t = rf();
            e = { blockedOn: null, target: e, priority: t };
            for (
              var a = 0;
              a < Da.length && t !== 0 && t < Da[a].priority;
              a++
            );
            (Da.splice(a, 0, e), a === 0 && Pd(e));
          }
        };
        var lh = u.version;
        if (lh !== '19.2.0') throw Error(s(527, lh, '19.2.0'));
        U.findDOMNode = function (e) {
          var t = e._reactInternals;
          if (t === void 0)
            throw typeof e.render == 'function'
              ? Error(s(188))
              : ((e = Object.keys(e).join(',')), Error(s(268, e)));
          return (
            (e = g(t)),
            (e = e !== null ? _(e) : null),
            (e = e === null ? null : e.stateNode),
            e
          );
        };
        var pp = {
          bundleType: 0,
          version: '19.2.0',
          rendererPackageName: 'react-dom',
          currentDispatcherRef: z,
          reconcilerVersion: '19.2.0',
        };
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < 'u') {
          var uu = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!uu.isDisabled && uu.supportsFiber)
            try {
              ((Ql = uu.inject(pp)), (ht = uu));
            } catch {}
        }
        return (
          (Kn.createRoot = function (e, t) {
            if (!o(e)) throw Error(s(299));
            var a = !1,
              l = '',
              n = or,
              i = rr,
              c = dr;
            return (
              t != null &&
                (t.unstable_strictMode === !0 && (a = !0),
                t.identifierPrefix !== void 0 && (l = t.identifierPrefix),
                t.onUncaughtError !== void 0 && (n = t.onUncaughtError),
                t.onCaughtError !== void 0 && (i = t.onCaughtError),
                t.onRecoverableError !== void 0 && (c = t.onRecoverableError)),
              (t = Xd(e, 1, !1, null, null, a, l, null, n, i, c, ah)),
              (e[al] = t.current),
              gc(e),
              new jc(t)
            );
          }),
          (Kn.hydrateRoot = function (e, t, a) {
            if (!o(e)) throw Error(s(299));
            var l = !1,
              n = '',
              i = or,
              c = rr,
              d = dr,
              p = null;
            return (
              a != null &&
                (a.unstable_strictMode === !0 && (l = !0),
                a.identifierPrefix !== void 0 && (n = a.identifierPrefix),
                a.onUncaughtError !== void 0 && (i = a.onUncaughtError),
                a.onCaughtError !== void 0 && (c = a.onCaughtError),
                a.onRecoverableError !== void 0 && (d = a.onRecoverableError),
                a.formState !== void 0 && (p = a.formState)),
              (t = Xd(e, 1, !0, t, a ?? null, l, n, p, i, c, d, ah)),
              (t.context = Zd(null)),
              (a = t.current),
              (l = At()),
              (l = Tu(l)),
              (n = pa(l)),
              (n.callback = null),
              ya(a, n, l),
              (a = l),
              (t.current.lanes = a),
              Zl(t, a),
              Vt(t),
              (e[al] = t.current),
              gc(e),
              new iu(t)
            );
          }),
          (Kn.version = '19.2.0'),
          Kn
        );
      }
      var hh;
      function Mp() {
        if (hh) return Uc.exports;
        hh = 1;
        function r() {
          if (!(
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > 'u' ||
            typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != 'function'
          ))
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(r);
            } catch (u) {
              console.error(u);
            }
        }
        return (r(), (Uc.exports = xp()), Uc.exports);
      }
      var zp = Mp(),
        he = gu(),
        Gc = {};
      const J = r => typeof r == 'string',
        qn = () => {
          let r, u;
          const f = new Promise((s, o) => {
            ((r = s), (u = o));
          });
          return ((f.resolve = r), (f.reject = u), f);
        },
        gh = r => (r == null ? '' : '' + r),
        _p = (r, u, f) => {
          r.forEach(s => {
            u[s] && (f[s] = u[s]);
          });
        },
        Np = /###/g,
        mh = r => (r && r.indexOf('###') > -1 ? r.replace(Np, '.') : r),
        ph = r => !r || J(r),
        Gn = (r, u, f) => {
          const s = J(u) ? u.split('.') : u;
          let o = 0;
          for (; o < s.length - 1;) {
            if (ph(r)) return {};
            const h = mh(s[o]);
            (!r[h] && f && (r[h] = new f()),
              Object.prototype.hasOwnProperty.call(r, h)
                ? (r = r[h])
                : (r = {}),
              ++o);
          }
          return ph(r) ? {} : { obj: r, k: mh(s[o]) };
        },
        yh = (r, u, f) => {
          const { obj: s, k: o } = Gn(r, u, Object);
          if (s !== void 0 || u.length === 1) {
            s[o] = f;
            return;
          }
          let h = u[u.length - 1],
            m = u.slice(0, u.length - 1),
            v = Gn(r, m, Object);
          for (; v.obj === void 0 && m.length;)
            ((h = `${m[m.length - 1]}.${h}`),
              (m = m.slice(0, m.length - 1)),
              (v = Gn(r, m, Object)),
              v?.obj && typeof v.obj[`${v.k}.${h}`] < 'u' && (v.obj = void 0));
          v.obj[`${v.k}.${h}`] = f;
        },
        Cp = (r, u, f, s) => {
          const { obj: o, k: h } = Gn(r, u, Object);
          ((o[h] = o[h] || []), o[h].push(f));
        },
        ru = (r, u) => {
          const { obj: f, k: s } = Gn(r, u);
          if (f && Object.prototype.hasOwnProperty.call(f, s)) return f[s];
        },
        Dp = (r, u, f) => {
          const s = ru(r, f);
          return s !== void 0 ? s : ru(u, f);
        },
        Bh = (r, u, f) => {
          for (const s in u)
            s !== '__proto__' &&
              s !== 'constructor' &&
              (s in r
                ? J(r[s]) ||
                  r[s] instanceof String ||
                  J(u[s]) ||
                  u[s] instanceof String
                  ? f && (r[s] = u[s])
                  : Bh(r[s], u[s], f)
                : (r[s] = u[s]));
          return r;
        },
        Ia = r => r.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      var Rp = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
      };
      const jp = r => (J(r) ? r.replace(/[&<>"'\/]/g, u => Rp[u]) : r);
      class Lp {
        constructor(u) {
          ((this.capacity = u),
            (this.regExpMap = new Map()),
            (this.regExpQueue = []));
        }
        getRegExp(u) {
          const f = this.regExpMap.get(u);
          if (f !== void 0) return f;
          const s = new RegExp(u);
          return (
            this.regExpQueue.length === this.capacity &&
              this.regExpMap.delete(this.regExpQueue.shift()),
            this.regExpMap.set(u, s),
            this.regExpQueue.push(u),
            s
          );
        }
      }
      const Up = [' ', ',', '?', '!', ';'],
        Hp = new Lp(20),
        Bp = (r, u, f) => {
          ((u = u || ''), (f = f || ''));
          const s = Up.filter(m => u.indexOf(m) < 0 && f.indexOf(m) < 0);
          if (s.length === 0) return !0;
          const o = Hp.getRegExp(
            `(${s.map(m => (m === '?' ? '\\?' : m)).join('|')})`
          );
          let h = !o.test(r);
          if (!h) {
            const m = r.indexOf(f);
            m > 0 && !o.test(r.substring(0, m)) && (h = !0);
          }
          return h;
        },
        Jc = (r, u, f = '.') => {
          if (!r) return;
          if (r[u])
            return Object.prototype.hasOwnProperty.call(r, u) ? r[u] : void 0;
          const s = u.split(f);
          let o = r;
          for (let h = 0; h < s.length;) {
            if (!o || typeof o != 'object') return;
            let m,
              v = '';
            for (let y = h; y < s.length; ++y)
              if (
                (y !== h && (v += f), (v += s[y]), (m = o[v]), m !== void 0)
              ) {
                if (
                  ['string', 'number', 'boolean'].indexOf(typeof m) > -1 &&
                  y < s.length - 1
                )
                  continue;
                h += y - h + 1;
                break;
              }
            o = m;
          }
          return o;
        },
        Vn = r => r?.replace(/_/g, '-'),
        Kp = {
          type: 'logger',
          log(r) {
            this.output('log', r);
          },
          warn(r) {
            this.output('warn', r);
          },
          error(r) {
            this.output('error', r);
          },
          output(r, u) {
            console?.[r]?.apply?.(console, u);
          },
        };
      class du {
        constructor(u, f = {}) {
          this.init(u, f);
        }
        init(u, f = {}) {
          ((this.prefix = f.prefix || 'i18next:'),
            (this.logger = u || Kp),
            (this.options = f),
            (this.debug = f.debug));
        }
        log(...u) {
          return this.forward(u, 'log', '', !0);
        }
        warn(...u) {
          return this.forward(u, 'warn', '', !0);
        }
        error(...u) {
          return this.forward(u, 'error', '');
        }
        deprecate(...u) {
          return this.forward(u, 'warn', 'WARNING DEPRECATED: ', !0);
        }
        forward(u, f, s, o) {
          return o && !this.debug
            ? null
            : (J(u[0]) && (u[0] = `${s}${this.prefix} ${u[0]}`),
              this.logger[f](u));
        }
        create(u) {
          return new du(this.logger, {
            prefix: `${this.prefix}:${u}:`,
            ...this.options,
          });
        }
        clone(u) {
          return (
            (u = u || this.options),
            (u.prefix = u.prefix || this.prefix),
            new du(this.logger, u)
          );
        }
      }
      var wt = new du();
      class mu {
        constructor() {
          this.observers = {};
        }
        on(u, f) {
          return (
            u.split(' ').forEach(s => {
              this.observers[s] || (this.observers[s] = new Map());
              const o = this.observers[s].get(f) || 0;
              this.observers[s].set(f, o + 1);
            }),
            this
          );
        }
        off(u, f) {
          if (this.observers[u]) {
            if (!f) {
              delete this.observers[u];
              return;
            }
            this.observers[u].delete(f);
          }
        }
        emit(u, ...f) {
          (this.observers[u] &&
            Array.from(this.observers[u].entries()).forEach(([o, h]) => {
              for (let m = 0; m < h; m++) o(...f);
            }),
            this.observers['*'] &&
              Array.from(this.observers['*'].entries()).forEach(([o, h]) => {
                for (let m = 0; m < h; m++) o.apply(o, [u, ...f]);
              }));
        }
      }
      class vh extends mu {
        constructor(u, f = { ns: ['translation'], defaultNS: 'translation' }) {
          (super(),
            (this.data = u || {}),
            (this.options = f),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            this.options.ignoreJSONStructure === void 0 &&
              (this.options.ignoreJSONStructure = !0));
        }
        addNamespaces(u) {
          this.options.ns.indexOf(u) < 0 && this.options.ns.push(u);
        }
        removeNamespaces(u) {
          const f = this.options.ns.indexOf(u);
          f > -1 && this.options.ns.splice(f, 1);
        }
        getResource(u, f, s, o = {}) {
          const h =
              o.keySeparator !== void 0
                ? o.keySeparator
                : this.options.keySeparator,
            m =
              o.ignoreJSONStructure !== void 0
                ? o.ignoreJSONStructure
                : this.options.ignoreJSONStructure;
          let v;
          u.indexOf('.') > -1
            ? (v = u.split('.'))
            : ((v = [u, f]),
              s &&
                (Array.isArray(s)
                  ? v.push(...s)
                  : J(s) && h
                    ? v.push(...s.split(h))
                    : v.push(s)));
          const y = ru(this.data, v);
          return (
            !y &&
              !f &&
              !s &&
              u.indexOf('.') > -1 &&
              ((u = v[0]), (f = v[1]), (s = v.slice(2).join('.'))),
            y || !m || !J(s) ? y : Jc(this.data?.[u]?.[f], s, h)
          );
        }
        addResource(u, f, s, o, h = { silent: !1 }) {
          const m =
            h.keySeparator !== void 0
              ? h.keySeparator
              : this.options.keySeparator;
          let v = [u, f];
          (s && (v = v.concat(m ? s.split(m) : s)),
            u.indexOf('.') > -1 && ((v = u.split('.')), (o = f), (f = v[1])),
            this.addNamespaces(f),
            yh(this.data, v, o),
            h.silent || this.emit('added', u, f, s, o));
        }
        addResources(u, f, s, o = { silent: !1 }) {
          for (const h in s)
            (J(s[h]) || Array.isArray(s[h])) &&
              this.addResource(u, f, h, s[h], { silent: !0 });
          o.silent || this.emit('added', u, f, s);
        }
        addResourceBundle(u, f, s, o, h, m = { silent: !1, skipCopy: !1 }) {
          let v = [u, f];
          (u.indexOf('.') > -1 &&
            ((v = u.split('.')), (o = s), (s = f), (f = v[1])),
            this.addNamespaces(f));
          let y = ru(this.data, v) || {};
          (m.skipCopy || (s = JSON.parse(JSON.stringify(s))),
            o ? Bh(y, s, h) : (y = { ...y, ...s }),
            yh(this.data, v, y),
            m.silent || this.emit('added', u, f, s));
        }
        removeResourceBundle(u, f) {
          (this.hasResourceBundle(u, f) && delete this.data[u][f],
            this.removeNamespaces(f),
            this.emit('removed', u, f));
        }
        hasResourceBundle(u, f) {
          return this.getResource(u, f) !== void 0;
        }
        getResourceBundle(u, f) {
          return (f || (f = this.options.defaultNS), this.getResource(u, f));
        }
        getDataByLanguage(u) {
          return this.data[u];
        }
        hasLanguageSomeTranslations(u) {
          const f = this.getDataByLanguage(u);
          return !!((f && Object.keys(f)) || []).find(
            o => f[o] && Object.keys(f[o]).length > 0
          );
        }
        toJSON() {
          return this.data;
        }
      }
      var Kh = {
        processors: {},
        addPostProcessor(r) {
          this.processors[r.name] = r;
        },
        handle(r, u, f, s, o) {
          return (
            r.forEach(h => {
              u = this.processors[h]?.process(u, f, s, o) ?? u;
            }),
            u
          );
        },
      };
      const qh = Symbol('i18next/PATH_KEY');
      function qp() {
        const r = [],
          u = Object.create(null);
        let f;
        return (
          (u.get = (s, o) => (
            f?.revoke?.(),
            o === qh ? r : (r.push(o), (f = Proxy.revocable(s, u)), f.proxy)
          )),
          Proxy.revocable(Object.create(null), u).proxy
        );
      }
      function Vl(r, u) {
        const { [qh]: f } = r(qp()),
          s = u?.keySeparator ?? '.',
          o = u?.nsSeparator ?? ':';
        if (f.length > 1 && o) {
          const h = u?.ns,
            m = Array.isArray(h) ? h : null;
          if (m && m.length > 1 && m.slice(1).includes(f[0]))
            return `${f[0]}${o}${f.slice(1).join(s)}`;
        }
        return f.join(s);
      }
      const bh = {},
        Yc = r => !J(r) && typeof r != 'boolean' && typeof r != 'number';
      class hu extends mu {
        constructor(u, f = {}) {
          (super(),
            _p(
              [
                'resourceStore',
                'languageUtils',
                'pluralResolver',
                'interpolator',
                'backendConnector',
                'i18nFormat',
                'utils',
              ],
              u,
              this
            ),
            (this.options = f),
            this.options.keySeparator === void 0 &&
              (this.options.keySeparator = '.'),
            (this.logger = wt.create('translator')));
        }
        changeLanguage(u) {
          u && (this.language = u);
        }
        exists(u, f = { interpolation: {} }) {
          const s = { ...f };
          if (u == null) return !1;
          const o = this.resolve(u, s);
          if (o?.res === void 0) return !1;
          const h = Yc(o.res);
          return !(s.returnObjects === !1 && h);
        }
        extractFromKey(u, f) {
          let s =
            f.nsSeparator !== void 0 ? f.nsSeparator : this.options.nsSeparator;
          s === void 0 && (s = ':');
          const o =
            f.keySeparator !== void 0
              ? f.keySeparator
              : this.options.keySeparator;
          let h = f.ns || this.options.defaultNS || [];
          const m = s && u.indexOf(s) > -1,
            v =
              !this.options.userDefinedKeySeparator &&
              !f.keySeparator &&
              !this.options.userDefinedNsSeparator &&
              !f.nsSeparator &&
              !Bp(u, s, o);
          if (m && !v) {
            const y = u.match(this.interpolator.nestingRegexp);
            if (y && y.length > 0)
              return { key: u, namespaces: J(h) ? [h] : h };
            const g = u.split(s);
            ((s !== o || (s === o && this.options.ns.indexOf(g[0]) > -1)) &&
              (h = g.shift()),
              (u = g.join(o)));
          }
          return { key: u, namespaces: J(h) ? [h] : h };
        }
        translate(u, f, s) {
          let o = typeof f == 'object' ? { ...f } : f;
          if (
            (typeof o != 'object' &&
              this.options.overloadTranslationOptionHandler &&
              (o = this.options.overloadTranslationOptionHandler(arguments)),
            typeof o == 'object' && (o = { ...o }),
            o || (o = {}),
            u == null)
          )
            return '';
          (typeof u == 'function' && (u = Vl(u, { ...this.options, ...o })),
            Array.isArray(u) || (u = [String(u)]),
            (u = u.map(re =>
              typeof re == 'function'
                ? Vl(re, { ...this.options, ...o })
                : String(re)
            )));
          const h =
              o.returnDetails !== void 0
                ? o.returnDetails
                : this.options.returnDetails,
            m =
              o.keySeparator !== void 0
                ? o.keySeparator
                : this.options.keySeparator,
            { key: v, namespaces: y } = this.extractFromKey(u[u.length - 1], o),
            g = y[y.length - 1];
          let _ =
            o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
          _ === void 0 && (_ = ':');
          const E = o.lng || this.language,
            L =
              o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
          if (E?.toLowerCase() === 'cimode')
            return L
              ? h
                ? {
                    res: `${g}${_}${v}`,
                    usedKey: v,
                    exactUsedKey: v,
                    usedLng: E,
                    usedNS: g,
                    usedParams: this.getUsedParamsDetails(o),
                  }
                : `${g}${_}${v}`
              : h
                ? {
                    res: v,
                    usedKey: v,
                    exactUsedKey: v,
                    usedLng: E,
                    usedNS: g,
                    usedParams: this.getUsedParamsDetails(o),
                  }
                : v;
          const q = this.resolve(u, o);
          let K = q?.res;
          const B = q?.usedKey || v,
            te = q?.exactUsedKey || v,
            P = ['[object Number]', '[object Function]', '[object RegExp]'],
            ae =
              o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays,
            ge = !this.i18nFormat || this.i18nFormat.handleAsObject,
            ce = o.count !== void 0 && !J(o.count),
            Ne = hu.hasDefaultValue(o),
            Ae = ce ? this.pluralResolver.getSuffix(E, o.count, o) : '',
            X =
              o.ordinal && ce
                ? this.pluralResolver.getSuffix(E, o.count, { ordinal: !1 })
                : '',
            Ce = ce && !o.ordinal && o.count === 0,
            $ =
              (Ce && o[`defaultValue${this.options.pluralSeparator}zero`]) ||
              o[`defaultValue${Ae}`] ||
              o[`defaultValue${X}`] ||
              o.defaultValue;
          let F = K;
          ge && !K && Ne && (F = $);
          const fe = Yc(F),
            oe = Object.prototype.toString.apply(F);
          if (
            ge &&
            F &&
            fe &&
            P.indexOf(oe) < 0 &&
            !(J(ae) && Array.isArray(F))
          ) {
            if (!o.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler ||
                this.logger.warn(
                  'accessing an object - but returnObjects options is not enabled!'
                );
              const re = this.options.returnedObjectHandler
                ? this.options.returnedObjectHandler(B, F, { ...o, ns: y })
                : `key '${v} (${this.language})' returned an object instead of string.`;
              return h
                ? ((q.res = re),
                  (q.usedParams = this.getUsedParamsDetails(o)),
                  q)
                : re;
            }
            if (m) {
              const re = Array.isArray(F),
                ze = re ? [] : {},
                Xe = re ? te : B;
              for (const z in F)
                if (Object.prototype.hasOwnProperty.call(F, z)) {
                  const U = `${Xe}${m}${z}`;
                  (Ne && !K
                    ? (ze[z] = this.translate(U, {
                        ...o,
                        defaultValue: Yc($) ? $[z] : void 0,
                        joinArrays: !1,
                        ns: y,
                      }))
                    : (ze[z] = this.translate(U, {
                        ...o,
                        joinArrays: !1,
                        ns: y,
                      })),
                    ze[z] === U && (ze[z] = F[z]));
                }
              K = ze;
            }
          } else if (ge && J(ae) && Array.isArray(K))
            ((K = K.join(ae)), K && (K = this.extendTranslation(K, u, o, s)));
          else {
            let re = !1,
              ze = !1;
            (!this.isValidLookup(K) && Ne && ((re = !0), (K = $)),
              this.isValidLookup(K) || ((ze = !0), (K = v)));
            const z =
                (o.missingKeyNoValueFallbackToKey ||
                  this.options.missingKeyNoValueFallbackToKey) &&
                ze
                  ? void 0
                  : K,
              U = Ne && $ !== K && this.options.updateMissing;
            if (ze || re || U) {
              if (
                (this.logger.log(
                  U ? 'updateKey' : 'missingKey',
                  E,
                  g,
                  v,
                  U ? $ : K
                ),
                m)
              ) {
                const b = this.resolve(v, { ...o, keySeparator: !1 });
                b &&
                  b.res &&
                  this.logger.warn(
                    'Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.'
                  );
              }
              let Q = [];
              const me = this.languageUtils.getFallbackCodes(
                this.options.fallbackLng,
                o.lng || this.language
              );
              if (this.options.saveMissingTo === 'fallback' && me && me[0])
                for (let b = 0; b < me.length; b++) Q.push(me[b]);
              else
                this.options.saveMissingTo === 'all'
                  ? (Q = this.languageUtils.toResolveHierarchy(
                      o.lng || this.language
                    ))
                  : Q.push(o.lng || this.language);
              const be = (b, C, H) => {
                const G = Ne && H !== K ? H : z;
                (this.options.missingKeyHandler
                  ? this.options.missingKeyHandler(b, g, C, G, U, o)
                  : this.backendConnector?.saveMissing &&
                    this.backendConnector.saveMissing(b, g, C, G, U, o),
                  this.emit('missingKey', b, g, C, K));
              };
              this.options.saveMissing &&
                (this.options.saveMissingPlurals && ce
                  ? Q.forEach(b => {
                      const C = this.pluralResolver.getSuffixes(b, o);
                      (Ce &&
                        o[`defaultValue${this.options.pluralSeparator}zero`] &&
                        C.indexOf(`${this.options.pluralSeparator}zero`) < 0 &&
                        C.push(`${this.options.pluralSeparator}zero`),
                        C.forEach(H => {
                          be([b], v + H, o[`defaultValue${H}`] || $);
                        }));
                    })
                  : be(Q, v, $));
            }
            ((K = this.extendTranslation(K, u, o, q, s)),
              ze &&
                K === v &&
                this.options.appendNamespaceToMissingKey &&
                (K = `${g}${_}${v}`),
              (ze || re) &&
                this.options.parseMissingKeyHandler &&
                (K = this.options.parseMissingKeyHandler(
                  this.options.appendNamespaceToMissingKey ? `${g}${_}${v}` : v,
                  re ? K : void 0,
                  o
                )));
          }
          return h
            ? ((q.res = K), (q.usedParams = this.getUsedParamsDetails(o)), q)
            : K;
        }
        extendTranslation(u, f, s, o, h) {
          if (this.i18nFormat?.parse)
            u = this.i18nFormat.parse(
              u,
              { ...this.options.interpolation.defaultVariables, ...s },
              s.lng || this.language || o.usedLng,
              o.usedNS,
              o.usedKey,
              { resolved: o }
            );
          else if (!s.skipInterpolation) {
            s.interpolation &&
              this.interpolator.init({
                ...s,
                interpolation: {
                  ...this.options.interpolation,
                  ...s.interpolation,
                },
              });
            const y =
              J(u) &&
              (s?.interpolation?.skipOnVariables !== void 0
                ? s.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables);
            let g;
            if (y) {
              const E = u.match(this.interpolator.nestingRegexp);
              g = E && E.length;
            }
            let _ = s.replace && !J(s.replace) ? s.replace : s;
            if (
              (this.options.interpolation.defaultVariables &&
                (_ = { ...this.options.interpolation.defaultVariables, ..._ }),
              (u = this.interpolator.interpolate(
                u,
                _,
                s.lng || this.language || o.usedLng,
                s
              )),
              y)
            ) {
              const E = u.match(this.interpolator.nestingRegexp),
                L = E && E.length;
              g < L && (s.nest = !1);
            }
            (!s.lng && o && o.res && (s.lng = this.language || o.usedLng),
              s.nest !== !1 &&
                (u = this.interpolator.nest(
                  u,
                  (...E) =>
                    h?.[0] === E[0] && !s.context
                      ? (this.logger.warn(
                          `It seems you are nesting recursively key: ${E[0]} in key: ${f[0]}`
                        ),
                        null)
                      : this.translate(...E, f),
                  s
                )),
              s.interpolation && this.interpolator.reset());
          }
          const m = s.postProcess || this.options.postProcess,
            v = J(m) ? [m] : m;
          return (
            u != null &&
              v?.length &&
              s.applyPostProcessor !== !1 &&
              (u = Kh.handle(
                v,
                u,
                f,
                this.options && this.options.postProcessPassResolved
                  ? {
                      i18nResolved: {
                        ...o,
                        usedParams: this.getUsedParamsDetails(s),
                      },
                      ...s,
                    }
                  : s,
                this
              )),
            u
          );
        }
        resolve(u, f = {}) {
          let s, o, h, m, v;
          return (
            J(u) && (u = [u]),
            Array.isArray(u) &&
              (u = u.map(y =>
                typeof y == 'function' ? Vl(y, { ...this.options, ...f }) : y
              )),
            u.forEach(y => {
              if (this.isValidLookup(s)) return;
              const g = this.extractFromKey(y, f),
                _ = g.key;
              o = _;
              let E = g.namespaces;
              this.options.fallbackNS &&
                (E = E.concat(this.options.fallbackNS));
              const L = f.count !== void 0 && !J(f.count),
                q = L && !f.ordinal && f.count === 0,
                K =
                  f.context !== void 0 &&
                  (J(f.context) || typeof f.context == 'number') &&
                  f.context !== '',
                B = f.lngs
                  ? f.lngs
                  : this.languageUtils.toResolveHierarchy(
                      f.lng || this.language,
                      f.fallbackLng
                    );
              E.forEach(te => {
                this.isValidLookup(s) ||
                  ((v = te),
                  !bh[`${B[0]}-${te}`] &&
                    this.utils?.hasLoadedNamespace &&
                    !this.utils?.hasLoadedNamespace(v) &&
                    ((bh[`${B[0]}-${te}`] = !0),
                    this.logger.warn(
                      `key "${o}" for languages "${B.join(', ')}" won't get resolved as namespace "${v}" was not yet loaded`,
                      'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
                    )),
                  B.forEach(P => {
                    if (this.isValidLookup(s)) return;
                    m = P;
                    const ae = [_];
                    if (this.i18nFormat?.addLookupKeys)
                      this.i18nFormat.addLookupKeys(ae, _, P, te, f);
                    else {
                      let ce;
                      L && (ce = this.pluralResolver.getSuffix(P, f.count, f));
                      const Ne = `${this.options.pluralSeparator}zero`,
                        Ae = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                      if (
                        (L &&
                          (f.ordinal &&
                            ce.indexOf(Ae) === 0 &&
                            ae.push(
                              _ + ce.replace(Ae, this.options.pluralSeparator)
                            ),
                          ae.push(_ + ce),
                          q && ae.push(_ + Ne)),
                        K)
                      ) {
                        const X = `${_}${this.options.contextSeparator || '_'}${f.context}`;
                        (ae.push(X),
                          L &&
                            (f.ordinal &&
                              ce.indexOf(Ae) === 0 &&
                              ae.push(
                                X + ce.replace(Ae, this.options.pluralSeparator)
                              ),
                            ae.push(X + ce),
                            q && ae.push(X + Ne)));
                      }
                    }
                    let ge;
                    for (; (ge = ae.pop());)
                      this.isValidLookup(s) ||
                        ((h = ge), (s = this.getResource(P, te, ge, f)));
                  }));
              });
            }),
            { res: s, usedKey: o, exactUsedKey: h, usedLng: m, usedNS: v }
          );
        }
        isValidLookup(u) {
          return (
            u !== void 0 &&
            !(!this.options.returnNull && u === null) &&
            !(!this.options.returnEmptyString && u === '')
          );
        }
        getResource(u, f, s, o = {}) {
          return this.i18nFormat?.getResource
            ? this.i18nFormat.getResource(u, f, s, o)
            : this.resourceStore.getResource(u, f, s, o);
        }
        getUsedParamsDetails(u = {}) {
          const f = [
              'defaultValue',
              'ordinal',
              'context',
              'replace',
              'lng',
              'lngs',
              'fallbackLng',
              'ns',
              'keySeparator',
              'nsSeparator',
              'returnObjects',
              'returnDetails',
              'joinArrays',
              'postProcess',
              'interpolation',
            ],
            s = u.replace && !J(u.replace);
          let o = s ? u.replace : u;
          if (
            (s && typeof u.count < 'u' && (o.count = u.count),
            this.options.interpolation.defaultVariables &&
              (o = { ...this.options.interpolation.defaultVariables, ...o }),
            !s)
          ) {
            o = { ...o };
            for (const h of f) delete o[h];
          }
          return o;
        }
        static hasDefaultValue(u) {
          const f = 'defaultValue';
          for (const s in u)
            if (
              Object.prototype.hasOwnProperty.call(u, s) &&
              f === s.substring(0, f.length) &&
              u[s] !== void 0
            )
              return !0;
          return !1;
        }
      }
      class Sh {
        constructor(u) {
          ((this.options = u),
            (this.supportedLngs = this.options.supportedLngs || !1),
            (this.logger = wt.create('languageUtils')));
        }
        getScriptPartFromCode(u) {
          if (((u = Vn(u)), !u || u.indexOf('-') < 0)) return null;
          const f = u.split('-');
          return f.length === 2 ||
            (f.pop(), f[f.length - 1].toLowerCase() === 'x')
            ? null
            : this.formatLanguageCode(f.join('-'));
        }
        getLanguagePartFromCode(u) {
          if (((u = Vn(u)), !u || u.indexOf('-') < 0)) return u;
          const f = u.split('-');
          return this.formatLanguageCode(f[0]);
        }
        formatLanguageCode(u) {
          if (J(u) && u.indexOf('-') > -1) {
            let f;
            try {
              f = Intl.getCanonicalLocales(u)[0];
            } catch {}
            return (
              f && this.options.lowerCaseLng && (f = f.toLowerCase()),
              f || (this.options.lowerCaseLng ? u.toLowerCase() : u)
            );
          }
          return this.options.cleanCode || this.options.lowerCaseLng
            ? u.toLowerCase()
            : u;
        }
        isSupportedCode(u) {
          return (
            (this.options.load === 'languageOnly' ||
              this.options.nonExplicitSupportedLngs) &&
              (u = this.getLanguagePartFromCode(u)),
            !this.supportedLngs ||
              !this.supportedLngs.length ||
              this.supportedLngs.indexOf(u) > -1
          );
        }
        getBestMatchFromCodes(u) {
          if (!u) return null;
          let f;
          return (
            u.forEach(s => {
              if (f) return;
              const o = this.formatLanguageCode(s);
              (!this.options.supportedLngs || this.isSupportedCode(o)) &&
                (f = o);
            }),
            !f &&
              this.options.supportedLngs &&
              u.forEach(s => {
                if (f) return;
                const o = this.getScriptPartFromCode(s);
                if (this.isSupportedCode(o)) return (f = o);
                const h = this.getLanguagePartFromCode(s);
                if (this.isSupportedCode(h)) return (f = h);
                f = this.options.supportedLngs.find(m => {
                  if (m === h) return m;
                  if (
                    !(m.indexOf('-') < 0 && h.indexOf('-') < 0) &&
                    ((m.indexOf('-') > 0 &&
                      h.indexOf('-') < 0 &&
                      m.substring(0, m.indexOf('-')) === h) ||
                      (m.indexOf(h) === 0 && h.length > 1))
                  )
                    return m;
                });
              }),
            f || (f = this.getFallbackCodes(this.options.fallbackLng)[0]),
            f
          );
        }
        getFallbackCodes(u, f) {
          if (!u) return [];
          if (
            (typeof u == 'function' && (u = u(f)),
            J(u) && (u = [u]),
            Array.isArray(u))
          )
            return u;
          if (!f) return u.default || [];
          let s = u[f];
          return (
            s || (s = u[this.getScriptPartFromCode(f)]),
            s || (s = u[this.formatLanguageCode(f)]),
            s || (s = u[this.getLanguagePartFromCode(f)]),
            s || (s = u.default),
            s || []
          );
        }
        toResolveHierarchy(u, f) {
          const s = this.getFallbackCodes(
              (f === !1 ? [] : f) || this.options.fallbackLng || [],
              u
            ),
            o = [],
            h = m => {
              m &&
                (this.isSupportedCode(m)
                  ? o.push(m)
                  : this.logger.warn(
                      `rejecting language code not found in supportedLngs: ${m}`
                    ));
            };
          return (
            J(u) && (u.indexOf('-') > -1 || u.indexOf('_') > -1)
              ? (this.options.load !== 'languageOnly' &&
                  h(this.formatLanguageCode(u)),
                this.options.load !== 'languageOnly' &&
                  this.options.load !== 'currentOnly' &&
                  h(this.getScriptPartFromCode(u)),
                this.options.load !== 'currentOnly' &&
                  h(this.getLanguagePartFromCode(u)))
              : J(u) && h(this.formatLanguageCode(u)),
            s.forEach(m => {
              o.indexOf(m) < 0 && h(this.formatLanguageCode(m));
            }),
            o
          );
        }
      }
      const Ah = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        Eh = {
          select: r => (r === 1 ? 'one' : 'other'),
          resolvedOptions: () => ({ pluralCategories: ['one', 'other'] }),
        };
      class Gp {
        constructor(u, f = {}) {
          ((this.languageUtils = u),
            (this.options = f),
            (this.logger = wt.create('pluralResolver')),
            (this.pluralRulesCache = {}));
        }
        clearCache() {
          this.pluralRulesCache = {};
        }
        getRule(u, f = {}) {
          const s = Vn(u === 'dev' ? 'en' : u),
            o = f.ordinal ? 'ordinal' : 'cardinal',
            h = JSON.stringify({ cleanedCode: s, type: o });
          if (h in this.pluralRulesCache) return this.pluralRulesCache[h];
          let m;
          try {
            m = new Intl.PluralRules(s, { type: o });
          } catch {
            if (typeof Intl > 'u')
              return (
                this.logger.error(
                  'No Intl support, please use an Intl polyfill!'
                ),
                Eh
              );
            if (!u.match(/-|_/)) return Eh;
            const y = this.languageUtils.getLanguagePartFromCode(u);
            m = this.getRule(y, f);
          }
          return ((this.pluralRulesCache[h] = m), m);
        }
        needsPlural(u, f = {}) {
          let s = this.getRule(u, f);
          return (
            s || (s = this.getRule('dev', f)),
            s?.resolvedOptions().pluralCategories.length > 1
          );
        }
        getPluralFormsOfKey(u, f, s = {}) {
          return this.getSuffixes(u, s).map(o => `${f}${o}`);
        }
        getSuffixes(u, f = {}) {
          let s = this.getRule(u, f);
          return (
            s || (s = this.getRule('dev', f)),
            s
              ? s
                  .resolvedOptions()
                  .pluralCategories.sort((o, h) => Ah[o] - Ah[h])
                  .map(
                    o =>
                      `${this.options.prepend}${f.ordinal ? `ordinal${this.options.prepend}` : ''}${o}`
                  )
              : []
          );
        }
        getSuffix(u, f, s = {}) {
          const o = this.getRule(u, s);
          return o
            ? `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ''}${o.select(f)}`
            : (this.logger.warn(`no plural rule found for: ${u}`),
              this.getSuffix('dev', f, s));
        }
      }
      const Th = (r, u, f, s = '.', o = !0) => {
          let h = Dp(r, u, f);
          return (
            !h &&
              o &&
              J(f) &&
              ((h = Jc(r, f, s)), h === void 0 && (h = Jc(u, f, s))),
            h
          );
        },
        Vc = r => r.replace(/\$/g, '$$$$');
      class Oh {
        constructor(u = {}) {
          ((this.logger = wt.create('interpolator')),
            (this.options = u),
            (this.format = u?.interpolation?.format || (f => f)),
            this.init(u));
        }
        init(u = {}) {
          u.interpolation || (u.interpolation = { escapeValue: !0 });
          const {
            escape: f,
            escapeValue: s,
            useRawValueToEscape: o,
            prefix: h,
            prefixEscaped: m,
            suffix: v,
            suffixEscaped: y,
            formatSeparator: g,
            unescapeSuffix: _,
            unescapePrefix: E,
            nestingPrefix: L,
            nestingPrefixEscaped: q,
            nestingSuffix: K,
            nestingSuffixEscaped: B,
            nestingOptionsSeparator: te,
            maxReplaces: P,
            alwaysFormat: ae,
          } = u.interpolation;
          ((this.escape = f !== void 0 ? f : jp),
            (this.escapeValue = s !== void 0 ? s : !0),
            (this.useRawValueToEscape = o !== void 0 ? o : !1),
            (this.prefix = h ? Ia(h) : m || '{{'),
            (this.suffix = v ? Ia(v) : y || '}}'),
            (this.formatSeparator = g || ','),
            (this.unescapePrefix = _ ? '' : E || '-'),
            (this.unescapeSuffix = this.unescapePrefix ? '' : _ || ''),
            (this.nestingPrefix = L ? Ia(L) : q || Ia('$t(')),
            (this.nestingSuffix = K ? Ia(K) : B || Ia(')')),
            (this.nestingOptionsSeparator = te || ','),
            (this.maxReplaces = P || 1e3),
            (this.alwaysFormat = ae !== void 0 ? ae : !1),
            this.resetRegExp());
        }
        reset() {
          this.options && this.init(this.options);
        }
        resetRegExp() {
          const u = (f, s) =>
            f?.source === s ? ((f.lastIndex = 0), f) : new RegExp(s, 'g');
          ((this.regexp = u(this.regexp, `${this.prefix}(.+?)${this.suffix}`)),
            (this.regexpUnescape = u(
              this.regexpUnescape,
              `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`
            )),
            (this.nestingRegexp = u(
              this.nestingRegexp,
              `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`
            )));
        }
        interpolate(u, f, s, o) {
          let h, m, v;
          const y =
              (this.options &&
                this.options.interpolation &&
                this.options.interpolation.defaultVariables) ||
              {},
            g = q => {
              if (q.indexOf(this.formatSeparator) < 0) {
                const P = Th(
                  f,
                  y,
                  q,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                );
                return this.alwaysFormat
                  ? this.format(P, void 0, s, {
                      ...o,
                      ...f,
                      interpolationkey: q,
                    })
                  : P;
              }
              const K = q.split(this.formatSeparator),
                B = K.shift().trim(),
                te = K.join(this.formatSeparator).trim();
              return this.format(
                Th(
                  f,
                  y,
                  B,
                  this.options.keySeparator,
                  this.options.ignoreJSONStructure
                ),
                te,
                s,
                { ...o, ...f, interpolationkey: B }
              );
            };
          this.resetRegExp();
          const _ =
              o?.missingInterpolationHandler ||
              this.options.missingInterpolationHandler,
            E =
              o?.interpolation?.skipOnVariables !== void 0
                ? o.interpolation.skipOnVariables
                : this.options.interpolation.skipOnVariables;
          return (
            [
              { regex: this.regexpUnescape, safeValue: q => Vc(q) },
              {
                regex: this.regexp,
                safeValue: q => (this.escapeValue ? Vc(this.escape(q)) : Vc(q)),
              },
            ].forEach(q => {
              for (v = 0; (h = q.regex.exec(u));) {
                const K = h[1].trim();
                if (((m = g(K)), m === void 0))
                  if (typeof _ == 'function') {
                    const te = _(u, h, o);
                    m = J(te) ? te : '';
                  } else if (o && Object.prototype.hasOwnProperty.call(o, K))
                    m = '';
                  else if (E) {
                    m = h[0];
                    continue;
                  } else
                    (this.logger.warn(
                      `missed to pass in variable ${K} for interpolating ${u}`
                    ),
                      (m = ''));
                else !J(m) && !this.useRawValueToEscape && (m = gh(m));
                const B = q.safeValue(m);
                if (
                  ((u = u.replace(h[0], B)),
                  E
                    ? ((q.regex.lastIndex += m.length),
                      (q.regex.lastIndex -= h[0].length))
                    : (q.regex.lastIndex = 0),
                  v++,
                  v >= this.maxReplaces)
                )
                  break;
              }
            }),
            u
          );
        }
        nest(u, f, s = {}) {
          let o, h, m;
          const v = (y, g) => {
            const _ = this.nestingOptionsSeparator;
            if (y.indexOf(_) < 0) return y;
            const E = y.split(new RegExp(`${Ia(_)}[ ]*{`));
            let L = `{${E[1]}`;
            ((y = E[0]), (L = this.interpolate(L, m)));
            const q = L.match(/'/g),
              K = L.match(/"/g);
            (((q?.length ?? 0) % 2 === 0 && !K) ||
              (K?.length ?? 0) % 2 !== 0) &&
              (L = L.replace(/'/g, '"'));
            try {
              ((m = JSON.parse(L)), g && (m = { ...g, ...m }));
            } catch (B) {
              return (
                this.logger.warn(
                  `failed parsing options string in nesting for key ${y}`,
                  B
                ),
                `${y}${_}${L}`
              );
            }
            return (
              m.defaultValue &&
                m.defaultValue.indexOf(this.prefix) > -1 &&
                delete m.defaultValue,
              y
            );
          };
          for (; (o = this.nestingRegexp.exec(u));) {
            let y = [];
            ((m = { ...s }),
              (m = m.replace && !J(m.replace) ? m.replace : m),
              (m.applyPostProcessor = !1),
              delete m.defaultValue);
            const g = /{.*}/.test(o[1])
              ? o[1].lastIndexOf('}') + 1
              : o[1].indexOf(this.formatSeparator);
            if (
              (g !== -1 &&
                ((y = o[1]
                  .slice(g)
                  .split(this.formatSeparator)
                  .map(_ => _.trim())
                  .filter(Boolean)),
                (o[1] = o[1].slice(0, g))),
              (h = f(v.call(this, o[1].trim(), m), m)),
              h && o[0] === u && !J(h))
            )
              return h;
            (J(h) || (h = gh(h)),
              h ||
                (this.logger.warn(`missed to resolve ${o[1]} for nesting ${u}`),
                (h = '')),
              y.length &&
                (h = y.reduce(
                  (_, E) =>
                    this.format(_, E, s.lng, {
                      ...s,
                      interpolationkey: o[1].trim(),
                    }),
                  h.trim()
                )),
              (u = u.replace(o[0], h)),
              (this.regexp.lastIndex = 0));
          }
          return u;
        }
      }
      const Yp = r => {
          let u = r.toLowerCase().trim();
          const f = {};
          if (r.indexOf('(') > -1) {
            const s = r.split('(');
            u = s[0].toLowerCase().trim();
            const o = s[1].substring(0, s[1].length - 1);
            u === 'currency' && o.indexOf(':') < 0
              ? f.currency || (f.currency = o.trim())
              : u === 'relativetime' && o.indexOf(':') < 0
                ? f.range || (f.range = o.trim())
                : o.split(';').forEach(m => {
                    if (m) {
                      const [v, ...y] = m.split(':'),
                        g = y
                          .join(':')
                          .trim()
                          .replace(/^'+|'+$/g, ''),
                        _ = v.trim();
                      (f[_] || (f[_] = g),
                        g === 'false' && (f[_] = !1),
                        g === 'true' && (f[_] = !0),
                        isNaN(g) || (f[_] = parseInt(g, 10)));
                    }
                  });
          }
          return { formatName: u, formatOptions: f };
        },
        xh = r => {
          const u = {};
          return (f, s, o) => {
            let h = o;
            o &&
              o.interpolationkey &&
              o.formatParams &&
              o.formatParams[o.interpolationkey] &&
              o[o.interpolationkey] &&
              (h = { ...h, [o.interpolationkey]: void 0 });
            const m = s + JSON.stringify(h);
            let v = u[m];
            return (v || ((v = r(Vn(s), o)), (u[m] = v)), v(f));
          };
        },
        Vp = r => (u, f, s) => r(Vn(f), s)(u);
      class wp {
        constructor(u = {}) {
          ((this.logger = wt.create('formatter')),
            (this.options = u),
            this.init(u));
        }
        init(u, f = { interpolation: {} }) {
          this.formatSeparator = f.interpolation.formatSeparator || ',';
          const s = f.cacheInBuiltFormats ? xh : Vp;
          this.formats = {
            number: s((o, h) => {
              const m = new Intl.NumberFormat(o, { ...h });
              return v => m.format(v);
            }),
            currency: s((o, h) => {
              const m = new Intl.NumberFormat(o, { ...h, style: 'currency' });
              return v => m.format(v);
            }),
            datetime: s((o, h) => {
              const m = new Intl.DateTimeFormat(o, { ...h });
              return v => m.format(v);
            }),
            relativetime: s((o, h) => {
              const m = new Intl.RelativeTimeFormat(o, { ...h });
              return v => m.format(v, h.range || 'day');
            }),
            list: s((o, h) => {
              const m = new Intl.ListFormat(o, { ...h });
              return v => m.format(v);
            }),
          };
        }
        add(u, f) {
          this.formats[u.toLowerCase().trim()] = f;
        }
        addCached(u, f) {
          this.formats[u.toLowerCase().trim()] = xh(f);
        }
        format(u, f, s, o = {}) {
          const h = f.split(this.formatSeparator);
          if (
            h.length > 1 &&
            h[0].indexOf('(') > 1 &&
            h[0].indexOf(')') < 0 &&
            h.find(v => v.indexOf(')') > -1)
          ) {
            const v = h.findIndex(y => y.indexOf(')') > -1);
            h[0] = [h[0], ...h.splice(1, v)].join(this.formatSeparator);
          }
          return h.reduce((v, y) => {
            const { formatName: g, formatOptions: _ } = Yp(y);
            if (this.formats[g]) {
              let E = v;
              try {
                const L = o?.formatParams?.[o.interpolationkey] || {},
                  q = L.locale || L.lng || o.locale || o.lng || s;
                E = this.formats[g](v, q, { ..._, ...o, ...L });
              } catch (L) {
                this.logger.warn(L);
              }
              return E;
            } else this.logger.warn(`there was no format function for ${g}`);
            return v;
          }, u);
        }
      }
      const Qp = (r, u) => {
        r.pending[u] !== void 0 && (delete r.pending[u], r.pendingCount--);
      };
      class Xp extends mu {
        constructor(u, f, s, o = {}) {
          (super(),
            (this.backend = u),
            (this.store = f),
            (this.services = s),
            (this.languageUtils = s.languageUtils),
            (this.options = o),
            (this.logger = wt.create('backendConnector')),
            (this.waitingReads = []),
            (this.maxParallelReads = o.maxParallelReads || 10),
            (this.readingCalls = 0),
            (this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5),
            (this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350),
            (this.state = {}),
            (this.queue = []),
            this.backend?.init?.(s, o.backend, o));
        }
        queueLoad(u, f, s, o) {
          const h = {},
            m = {},
            v = {},
            y = {};
          return (
            u.forEach(g => {
              let _ = !0;
              (f.forEach(E => {
                const L = `${g}|${E}`;
                !s.reload && this.store.hasResourceBundle(g, E)
                  ? (this.state[L] = 2)
                  : this.state[L] < 0 ||
                    (this.state[L] === 1
                      ? m[L] === void 0 && (m[L] = !0)
                      : ((this.state[L] = 1),
                        (_ = !1),
                        m[L] === void 0 && (m[L] = !0),
                        h[L] === void 0 && (h[L] = !0),
                        y[E] === void 0 && (y[E] = !0)));
              }),
                _ || (v[g] = !0));
            }),
            (Object.keys(h).length || Object.keys(m).length) &&
              this.queue.push({
                pending: m,
                pendingCount: Object.keys(m).length,
                loaded: {},
                errors: [],
                callback: o,
              }),
            {
              toLoad: Object.keys(h),
              pending: Object.keys(m),
              toLoadLanguages: Object.keys(v),
              toLoadNamespaces: Object.keys(y),
            }
          );
        }
        loaded(u, f, s) {
          const o = u.split('|'),
            h = o[0],
            m = o[1];
          (f && this.emit('failedLoading', h, m, f),
            !f &&
              s &&
              this.store.addResourceBundle(h, m, s, void 0, void 0, {
                skipCopy: !0,
              }),
            (this.state[u] = f ? -1 : 2),
            f && s && (this.state[u] = 0));
          const v = {};
          (this.queue.forEach(y => {
            (Cp(y.loaded, [h], m),
              Qp(y, u),
              f && y.errors.push(f),
              y.pendingCount === 0 &&
                !y.done &&
                (Object.keys(y.loaded).forEach(g => {
                  v[g] || (v[g] = {});
                  const _ = y.loaded[g];
                  _.length &&
                    _.forEach(E => {
                      v[g][E] === void 0 && (v[g][E] = !0);
                    });
                }),
                (y.done = !0),
                y.errors.length ? y.callback(y.errors) : y.callback()));
          }),
            this.emit('loaded', v),
            (this.queue = this.queue.filter(y => !y.done)));
        }
        read(u, f, s, o = 0, h = this.retryTimeout, m) {
          if (!u.length) return m(null, {});
          if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
              lng: u,
              ns: f,
              fcName: s,
              tried: o,
              wait: h,
              callback: m,
            });
            return;
          }
          this.readingCalls++;
          const v = (g, _) => {
              if ((this.readingCalls--, this.waitingReads.length > 0)) {
                const E = this.waitingReads.shift();
                this.read(E.lng, E.ns, E.fcName, E.tried, E.wait, E.callback);
              }
              if (g && _ && o < this.maxRetries) {
                setTimeout(() => {
                  this.read.call(this, u, f, s, o + 1, h * 2, m);
                }, h);
                return;
              }
              m(g, _);
            },
            y = this.backend[s].bind(this.backend);
          if (y.length === 2) {
            try {
              const g = y(u, f);
              g && typeof g.then == 'function'
                ? g.then(_ => v(null, _)).catch(v)
                : v(null, g);
            } catch (g) {
              v(g);
            }
            return;
          }
          return y(u, f, v);
        }
        prepareLoading(u, f, s = {}, o) {
          if (!this.backend)
            return (
              this.logger.warn(
                'No backend was added via i18next.use. Will not load resources.'
              ),
              o && o()
            );
          (J(u) && (u = this.languageUtils.toResolveHierarchy(u)),
            J(f) && (f = [f]));
          const h = this.queueLoad(u, f, s, o);
          if (!h.toLoad.length) return (h.pending.length || o(), null);
          h.toLoad.forEach(m => {
            this.loadOne(m);
          });
        }
        load(u, f, s) {
          this.prepareLoading(u, f, {}, s);
        }
        reload(u, f, s) {
          this.prepareLoading(u, f, { reload: !0 }, s);
        }
        loadOne(u, f = '') {
          const s = u.split('|'),
            o = s[0],
            h = s[1];
          this.read(o, h, 'read', void 0, void 0, (m, v) => {
            (m &&
              this.logger.warn(
                `${f}loading namespace ${h} for language ${o} failed`,
                m
              ),
              !m &&
                v &&
                this.logger.log(
                  `${f}loaded namespace ${h} for language ${o}`,
                  v
                ),
              this.loaded(u, m, v));
          });
        }
        saveMissing(u, f, s, o, h, m = {}, v = () => {}) {
          if (
            this.services?.utils?.hasLoadedNamespace &&
            !this.services?.utils?.hasLoadedNamespace(f)
          ) {
            this.logger.warn(
              `did not save key "${s}" as the namespace "${f}" was not yet loaded`,
              'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!'
            );
            return;
          }
          if (!(s == null || s === '')) {
            if (this.backend?.create) {
              const y = { ...m, isUpdate: h },
                g = this.backend.create.bind(this.backend);
              if (g.length < 6)
                try {
                  let _;
                  (g.length === 5
                    ? (_ = g(u, f, s, o, y))
                    : (_ = g(u, f, s, o)),
                    _ && typeof _.then == 'function'
                      ? _.then(E => v(null, E)).catch(v)
                      : v(null, _));
                } catch (_) {
                  v(_);
                }
              else g(u, f, s, o, v, y);
            }
            !u || !u[0] || this.store.addResource(u[0], f, s, o);
          }
        }
      }
      const wc = () => ({
          debug: !1,
          initAsync: !0,
          ns: ['translation'],
          defaultNS: ['translation'],
          fallbackLng: ['dev'],
          fallbackNS: !1,
          supportedLngs: !1,
          nonExplicitSupportedLngs: !1,
          load: 'all',
          preload: !1,
          simplifyPluralSuffix: !0,
          keySeparator: '.',
          nsSeparator: ':',
          pluralSeparator: '_',
          contextSeparator: '_',
          partialBundledLanguages: !1,
          saveMissing: !1,
          updateMissing: !1,
          saveMissingTo: 'fallback',
          saveMissingPlurals: !0,
          missingKeyHandler: !1,
          missingInterpolationHandler: !1,
          postProcess: !1,
          postProcessPassResolved: !1,
          returnNull: !1,
          returnEmptyString: !0,
          returnObjects: !1,
          joinArrays: !1,
          returnedObjectHandler: !1,
          parseMissingKeyHandler: !1,
          appendNamespaceToMissingKey: !1,
          appendNamespaceToCIMode: !1,
          overloadTranslationOptionHandler: r => {
            let u = {};
            if (
              (typeof r[1] == 'object' && (u = r[1]),
              J(r[1]) && (u.defaultValue = r[1]),
              J(r[2]) && (u.tDescription = r[2]),
              typeof r[2] == 'object' || typeof r[3] == 'object')
            ) {
              const f = r[3] || r[2];
              Object.keys(f).forEach(s => {
                u[s] = f[s];
              });
            }
            return u;
          },
          interpolation: {
            escapeValue: !0,
            format: r => r,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1e3,
            skipOnVariables: !0,
          },
          cacheInBuiltFormats: !0,
        }),
        Mh = r => (
          J(r.ns) && (r.ns = [r.ns]),
          J(r.fallbackLng) && (r.fallbackLng = [r.fallbackLng]),
          J(r.fallbackNS) && (r.fallbackNS = [r.fallbackNS]),
          r.supportedLngs?.indexOf?.('cimode') < 0 &&
            (r.supportedLngs = r.supportedLngs.concat(['cimode'])),
          typeof r.initImmediate == 'boolean' &&
            (r.initAsync = r.initImmediate),
          r
        ),
        su = () => {},
        Zp = r => {
          Object.getOwnPropertyNames(Object.getPrototypeOf(r)).forEach(f => {
            typeof r[f] == 'function' && (r[f] = r[f].bind(r));
          });
        },
        Gh = '__i18next_supportNoticeShown',
        Jp = () =>
          !!(
            (typeof globalThis < 'u' && globalThis[Gh]) ||
            (typeof process < 'u' && Gc && Gc.I18NEXT_NO_SUPPORT_NOTICE) ||
            (typeof process < 'u' && Gc)
          ),
        $p = () => {
          typeof globalThis < 'u' && (globalThis[Gh] = !0);
        },
        kp = r =>
          !!(
            r?.modules?.backend?.name?.indexOf('Locize') > 0 ||
            r?.modules?.backend?.constructor?.name?.indexOf('Locize') > 0 ||
            (r?.options?.backend?.backends &&
              r.options.backend.backends.some(
                u =>
                  u?.name?.indexOf('Locize') > 0 ||
                  u?.constructor?.name?.indexOf('Locize') > 0
              )) ||
            r?.options?.backend?.projectId ||
            (r?.options?.backend?.backendOptions &&
              r.options.backend.backendOptions.some(u => u?.projectId))
          );
      class Yn extends mu {
        constructor(u = {}, f) {
          if (
            (super(),
            (this.options = Mh(u)),
            (this.services = {}),
            (this.logger = wt),
            (this.modules = { external: [] }),
            Zp(this),
            f && !this.isInitialized && !u.isClone)
          ) {
            if (!this.options.initAsync) return (this.init(u, f), this);
            setTimeout(() => {
              this.init(u, f);
            }, 0);
          }
        }
        init(u = {}, f) {
          ((this.isInitializing = !0),
            typeof u == 'function' && ((f = u), (u = {})),
            u.defaultNS == null &&
              u.ns &&
              (J(u.ns)
                ? (u.defaultNS = u.ns)
                : u.ns.indexOf('translation') < 0 && (u.defaultNS = u.ns[0])));
          const s = wc();
          ((this.options = { ...s, ...this.options, ...Mh(u) }),
            (this.options.interpolation = {
              ...s.interpolation,
              ...this.options.interpolation,
            }),
            u.keySeparator !== void 0 &&
              (this.options.userDefinedKeySeparator = u.keySeparator),
            u.nsSeparator !== void 0 &&
              (this.options.userDefinedNsSeparator = u.nsSeparator),
            typeof this.options.overloadTranslationOptionHandler !=
              'function' &&
              (this.options.overloadTranslationOptionHandler =
                s.overloadTranslationOptionHandler),
            this.options.showSupportNotice !== !1 &&
              !kp(this) &&
              !Jp() &&
              (typeof console < 'u' &&
                typeof console.info < 'u' &&
                console.info(
                  '🌐 i18next is made possible by our own product, Locize — consider powering your project with managed localization (AI, CDN, integrations): https://locize.com 💙'
                ),
              $p()));
          const o = g => (g ? (typeof g == 'function' ? new g() : g) : null);
          if (!this.options.isClone) {
            this.modules.logger
              ? wt.init(o(this.modules.logger), this.options)
              : wt.init(null, this.options);
            let g;
            this.modules.formatter ? (g = this.modules.formatter) : (g = wp);
            const _ = new Sh(this.options);
            this.store = new vh(this.options.resources, this.options);
            const E = this.services;
            ((E.logger = wt),
              (E.resourceStore = this.store),
              (E.languageUtils = _),
              (E.pluralResolver = new Gp(_, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix,
              })),
              this.options.interpolation.format &&
                this.options.interpolation.format !== s.interpolation.format &&
                this.logger.deprecate(
                  'init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting'
                ),
              g &&
                (!this.options.interpolation.format ||
                  this.options.interpolation.format ===
                    s.interpolation.format) &&
                ((E.formatter = o(g)),
                E.formatter.init && E.formatter.init(E, this.options),
                (this.options.interpolation.format = E.formatter.format.bind(
                  E.formatter
                ))),
              (E.interpolator = new Oh(this.options)),
              (E.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
              }),
              (E.backendConnector = new Xp(
                o(this.modules.backend),
                E.resourceStore,
                E,
                this.options
              )),
              E.backendConnector.on('*', (q, ...K) => {
                this.emit(q, ...K);
              }),
              this.modules.languageDetector &&
                ((E.languageDetector = o(this.modules.languageDetector)),
                E.languageDetector.init &&
                  E.languageDetector.init(
                    E,
                    this.options.detection,
                    this.options
                  )),
              this.modules.i18nFormat &&
                ((E.i18nFormat = o(this.modules.i18nFormat)),
                E.i18nFormat.init && E.i18nFormat.init(this)),
              (this.translator = new hu(this.services, this.options)),
              this.translator.on('*', (q, ...K) => {
                this.emit(q, ...K);
              }),
              this.modules.external.forEach(q => {
                q.init && q.init(this);
              }));
          }
          if (
            ((this.format = this.options.interpolation.format),
            f || (f = su),
            this.options.fallbackLng &&
              !this.services.languageDetector &&
              !this.options.lng)
          ) {
            const g = this.services.languageUtils.getFallbackCodes(
              this.options.fallbackLng
            );
            g.length > 0 && g[0] !== 'dev' && (this.options.lng = g[0]);
          }
          (!this.services.languageDetector &&
            !this.options.lng &&
            this.logger.warn(
              'init: no languageDetector is used and no lng is defined'
            ),
            [
              'getResource',
              'hasResourceBundle',
              'getResourceBundle',
              'getDataByLanguage',
            ].forEach(g => {
              this[g] = (..._) => this.store[g](..._);
            }),
            [
              'addResource',
              'addResources',
              'addResourceBundle',
              'removeResourceBundle',
            ].forEach(g => {
              this[g] = (..._) => (this.store[g](..._), this);
            }));
          const v = qn(),
            y = () => {
              const g = (_, E) => {
                ((this.isInitializing = !1),
                  this.isInitialized &&
                    !this.initializedStoreOnce &&
                    this.logger.warn(
                      'init: i18next is already initialized. You should call init just once!'
                    ),
                  (this.isInitialized = !0),
                  this.options.isClone ||
                    this.logger.log('initialized', this.options),
                  this.emit('initialized', this.options),
                  v.resolve(E),
                  f(_, E));
              };
              if (this.languages && !this.isInitialized)
                return g(null, this.t.bind(this));
              this.changeLanguage(this.options.lng, g);
            };
          return (
            this.options.resources || !this.options.initAsync
              ? y()
              : setTimeout(y, 0),
            v
          );
        }
        loadResources(u, f = su) {
          let s = f;
          const o = J(u) ? u : this.language;
          if (
            (typeof u == 'function' && (s = u),
            !this.options.resources || this.options.partialBundledLanguages)
          ) {
            if (
              o?.toLowerCase() === 'cimode' &&
              (!this.options.preload || this.options.preload.length === 0)
            )
              return s();
            const h = [],
              m = v => {
                if (!v || v === 'cimode') return;
                this.services.languageUtils.toResolveHierarchy(v).forEach(g => {
                  g !== 'cimode' && h.indexOf(g) < 0 && h.push(g);
                });
              };
            (o
              ? m(o)
              : this.services.languageUtils
                  .getFallbackCodes(this.options.fallbackLng)
                  .forEach(y => m(y)),
              this.options.preload?.forEach?.(v => m(v)),
              this.services.backendConnector.load(h, this.options.ns, v => {
                (!v &&
                  !this.resolvedLanguage &&
                  this.language &&
                  this.setResolvedLanguage(this.language),
                  s(v));
              }));
          } else s(null);
        }
        reloadResources(u, f, s) {
          const o = qn();
          return (
            typeof u == 'function' && ((s = u), (u = void 0)),
            typeof f == 'function' && ((s = f), (f = void 0)),
            u || (u = this.languages),
            f || (f = this.options.ns),
            s || (s = su),
            this.services.backendConnector.reload(u, f, h => {
              (o.resolve(), s(h));
            }),
            o
          );
        }
        use(u) {
          if (!u)
            throw new Error(
              'You are passing an undefined module! Please check the object you are passing to i18next.use()'
            );
          if (!u.type)
            throw new Error(
              'You are passing a wrong module! Please check the object you are passing to i18next.use()'
            );
          return (
            u.type === 'backend' && (this.modules.backend = u),
            (u.type === 'logger' || (u.log && u.warn && u.error)) &&
              (this.modules.logger = u),
            u.type === 'languageDetector' &&
              (this.modules.languageDetector = u),
            u.type === 'i18nFormat' && (this.modules.i18nFormat = u),
            u.type === 'postProcessor' && Kh.addPostProcessor(u),
            u.type === 'formatter' && (this.modules.formatter = u),
            u.type === '3rdParty' && this.modules.external.push(u),
            this
          );
        }
        setResolvedLanguage(u) {
          if (
            !(!u || !this.languages) &&
            !(['cimode', 'dev'].indexOf(u) > -1)
          ) {
            for (let f = 0; f < this.languages.length; f++) {
              const s = this.languages[f];
              if (
                !(['cimode', 'dev'].indexOf(s) > -1) &&
                this.store.hasLanguageSomeTranslations(s)
              ) {
                this.resolvedLanguage = s;
                break;
              }
            }
            !this.resolvedLanguage &&
              this.languages.indexOf(u) < 0 &&
              this.store.hasLanguageSomeTranslations(u) &&
              ((this.resolvedLanguage = u), this.languages.unshift(u));
          }
        }
        changeLanguage(u, f) {
          this.isLanguageChangingTo = u;
          const s = qn();
          this.emit('languageChanging', u);
          const o = v => {
              ((this.language = v),
                (this.languages =
                  this.services.languageUtils.toResolveHierarchy(v)),
                (this.resolvedLanguage = void 0),
                this.setResolvedLanguage(v));
            },
            h = (v, y) => {
              (y
                ? this.isLanguageChangingTo === u &&
                  (o(y),
                  this.translator.changeLanguage(y),
                  (this.isLanguageChangingTo = void 0),
                  this.emit('languageChanged', y),
                  this.logger.log('languageChanged', y))
                : (this.isLanguageChangingTo = void 0),
                s.resolve((...g) => this.t(...g)),
                f && f(v, (...g) => this.t(...g)));
            },
            m = v => {
              !u && !v && this.services.languageDetector && (v = []);
              const y = J(v) ? v : v && v[0],
                g = this.store.hasLanguageSomeTranslations(y)
                  ? y
                  : this.services.languageUtils.getBestMatchFromCodes(
                      J(v) ? [v] : v
                    );
              (g &&
                (this.language || o(g),
                this.translator.language || this.translator.changeLanguage(g),
                this.services.languageDetector?.cacheUserLanguage?.(g)),
                this.loadResources(g, _ => {
                  h(_, g);
                }));
            };
          return (
            !u &&
            this.services.languageDetector &&
            !this.services.languageDetector.async
              ? m(this.services.languageDetector.detect())
              : !u &&
                  this.services.languageDetector &&
                  this.services.languageDetector.async
                ? this.services.languageDetector.detect.length === 0
                  ? this.services.languageDetector.detect().then(m)
                  : this.services.languageDetector.detect(m)
                : m(u),
            s
          );
        }
        getFixedT(u, f, s) {
          const o = (h, m, ...v) => {
            let y;
            (typeof m != 'object'
              ? (y = this.options.overloadTranslationOptionHandler(
                  [h, m].concat(v)
                ))
              : (y = { ...m }),
              (y.lng = y.lng || o.lng),
              (y.lngs = y.lngs || o.lngs),
              (y.ns = y.ns || o.ns),
              y.keyPrefix !== '' &&
                (y.keyPrefix = y.keyPrefix || s || o.keyPrefix));
            const g = { ...this.options, ...y };
            typeof y.keyPrefix == 'function' &&
              (y.keyPrefix = Vl(y.keyPrefix, g));
            const _ = this.options.keySeparator || '.';
            let E;
            return (
              y.keyPrefix && Array.isArray(h)
                ? (E = h.map(
                    L => (
                      typeof L == 'function' && (L = Vl(L, g)),
                      `${y.keyPrefix}${_}${L}`
                    )
                  ))
                : (typeof h == 'function' && (h = Vl(h, g)),
                  (E = y.keyPrefix ? `${y.keyPrefix}${_}${h}` : h)),
              this.t(E, y)
            );
          };
          return (
            J(u) ? (o.lng = u) : (o.lngs = u),
            (o.ns = f),
            (o.keyPrefix = s),
            o
          );
        }
        t(...u) {
          return this.translator?.translate(...u);
        }
        exists(...u) {
          return this.translator?.exists(...u);
        }
        setDefaultNamespace(u) {
          this.options.defaultNS = u;
        }
        hasLoadedNamespace(u, f = {}) {
          if (!this.isInitialized)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18next was not initialized',
                this.languages
              ),
              !1
            );
          if (!this.languages || !this.languages.length)
            return (
              this.logger.warn(
                'hasLoadedNamespace: i18n.languages were undefined or empty',
                this.languages
              ),
              !1
            );
          const s = f.lng || this.resolvedLanguage || this.languages[0],
            o = this.options ? this.options.fallbackLng : !1,
            h = this.languages[this.languages.length - 1];
          if (s.toLowerCase() === 'cimode') return !0;
          const m = (v, y) => {
            const g = this.services.backendConnector.state[`${v}|${y}`];
            return g === -1 || g === 0 || g === 2;
          };
          if (f.precheck) {
            const v = f.precheck(this, m);
            if (v !== void 0) return v;
          }
          return !!(
            this.hasResourceBundle(s, u) ||
            !this.services.backendConnector.backend ||
            (this.options.resources && !this.options.partialBundledLanguages) ||
            (m(s, u) && (!o || m(h, u)))
          );
        }
        loadNamespaces(u, f) {
          const s = qn();
          return this.options.ns
            ? (J(u) && (u = [u]),
              u.forEach(o => {
                this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
              }),
              this.loadResources(o => {
                (s.resolve(), f && f(o));
              }),
              s)
            : (f && f(), Promise.resolve());
        }
        loadLanguages(u, f) {
          const s = qn();
          J(u) && (u = [u]);
          const o = this.options.preload || [],
            h = u.filter(
              m =>
                o.indexOf(m) < 0 &&
                this.services.languageUtils.isSupportedCode(m)
            );
          return h.length
            ? ((this.options.preload = o.concat(h)),
              this.loadResources(m => {
                (s.resolve(), f && f(m));
              }),
              s)
            : (f && f(), Promise.resolve());
        }
        dir(u) {
          if (
            (u ||
              (u =
                this.resolvedLanguage ||
                (this.languages?.length > 0
                  ? this.languages[0]
                  : this.language)),
            !u)
          )
            return 'rtl';
          try {
            const o = new Intl.Locale(u);
            if (o && o.getTextInfo) {
              const h = o.getTextInfo();
              if (h && h.direction) return h.direction;
            }
          } catch {}
          const f = [
              'ar',
              'shu',
              'sqr',
              'ssh',
              'xaa',
              'yhd',
              'yud',
              'aao',
              'abh',
              'abv',
              'acm',
              'acq',
              'acw',
              'acx',
              'acy',
              'adf',
              'ads',
              'aeb',
              'aec',
              'afb',
              'ajp',
              'apc',
              'apd',
              'arb',
              'arq',
              'ars',
              'ary',
              'arz',
              'auz',
              'avl',
              'ayh',
              'ayl',
              'ayn',
              'ayp',
              'bbz',
              'pga',
              'he',
              'iw',
              'ps',
              'pbt',
              'pbu',
              'pst',
              'prp',
              'prd',
              'ug',
              'ur',
              'ydd',
              'yds',
              'yih',
              'ji',
              'yi',
              'hbo',
              'men',
              'xmn',
              'fa',
              'jpr',
              'peo',
              'pes',
              'prs',
              'dv',
              'sam',
              'ckb',
            ],
            s = this.services?.languageUtils || new Sh(wc());
          return u.toLowerCase().indexOf('-latn') > 1
            ? 'ltr'
            : f.indexOf(s.getLanguagePartFromCode(u)) > -1 ||
                u.toLowerCase().indexOf('-arab') > 1
              ? 'rtl'
              : 'ltr';
        }
        static createInstance(u = {}, f) {
          const s = new Yn(u, f);
          return ((s.createInstance = Yn.createInstance), s);
        }
        cloneInstance(u = {}, f = su) {
          const s = u.forkResourceStore;
          s && delete u.forkResourceStore;
          const o = { ...this.options, ...u, isClone: !0 },
            h = new Yn(o);
          if (
            ((u.debug !== void 0 || u.prefix !== void 0) &&
              (h.logger = h.logger.clone(u)),
            ['store', 'services', 'language'].forEach(v => {
              h[v] = this[v];
            }),
            (h.services = { ...this.services }),
            (h.services.utils = {
              hasLoadedNamespace: h.hasLoadedNamespace.bind(h),
            }),
            s)
          ) {
            const v = Object.keys(this.store.data).reduce(
              (y, g) => (
                (y[g] = { ...this.store.data[g] }),
                (y[g] = Object.keys(y[g]).reduce(
                  (_, E) => ((_[E] = { ...y[g][E] }), _),
                  y[g]
                )),
                y
              ),
              {}
            );
            ((h.store = new vh(v, o)), (h.services.resourceStore = h.store));
          }
          if (u.interpolation) {
            const y = {
                ...wc().interpolation,
                ...this.options.interpolation,
                ...u.interpolation,
              },
              g = { ...o, interpolation: y };
            h.services.interpolator = new Oh(g);
          }
          return (
            (h.translator = new hu(h.services, o)),
            h.translator.on('*', (v, ...y) => {
              h.emit(v, ...y);
            }),
            h.init(o, f),
            (h.translator.options = o),
            (h.translator.backendConnector.services.utils = {
              hasLoadedNamespace: h.hasLoadedNamespace.bind(h),
            }),
            h
          );
        }
        toJSON() {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage,
          };
        }
      }
      const Yh = Yn.createInstance(),
        Fp = (r, u, f, s) => {
          const o = [f, { code: u, ...(s || {}) }];
          if (r?.services?.logger?.forward)
            return r.services.logger.forward(o, 'warn', 'react-i18next::', !0);
          (el(o[0]) && (o[0] = `react-i18next:: ${o[0]}`),
            r?.services?.logger?.warn
              ? r.services.logger.warn(...o)
              : console?.warn && console.warn(...o));
        },
        zh = {},
        $c = (r, u, f, s) => {
          (el(f) && zh[f]) || (el(f) && (zh[f] = new Date()), Fp(r, u, f, s));
        },
        Vh = (r, u) => () => {
          if (r.isInitialized) u();
          else {
            const f = () => {
              (setTimeout(() => {
                r.off('initialized', f);
              }, 0),
                u());
            };
            r.on('initialized', f);
          }
        },
        kc = (r, u, f) => {
          r.loadNamespaces(u, Vh(r, f));
        },
        _h = (r, u, f, s) => {
          if (
            (el(f) && (f = [f]),
            r.options.preload && r.options.preload.indexOf(u) > -1)
          )
            return kc(r, f, s);
          (f.forEach(o => {
            r.options.ns.indexOf(o) < 0 && r.options.ns.push(o);
          }),
            r.loadLanguages(u, Vh(r, s)));
        },
        Wp = (r, u, f = {}) =>
          !u.languages || !u.languages.length
            ? ($c(u, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
                languages: u.languages,
              }),
              !0)
            : u.hasLoadedNamespace(r, {
                lng: f.lng,
                precheck: (s, o) => {
                  if (
                    f.bindI18n &&
                    f.bindI18n.indexOf('languageChanging') > -1 &&
                    s.services.backendConnector.backend &&
                    s.isLanguageChangingTo &&
                    !o(s.isLanguageChangingTo, r)
                  )
                    return !1;
                },
              }),
        el = r => typeof r == 'string',
        Ip = r => typeof r == 'object' && r !== null,
        Pp =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        ey = {
          '&amp;': '&',
          '&#38;': '&',
          '&lt;': '<',
          '&#60;': '<',
          '&gt;': '>',
          '&#62;': '>',
          '&apos;': "'",
          '&#39;': "'",
          '&quot;': '"',
          '&#34;': '"',
          '&nbsp;': ' ',
          '&#160;': ' ',
          '&copy;': '©',
          '&#169;': '©',
          '&reg;': '®',
          '&#174;': '®',
          '&hellip;': '…',
          '&#8230;': '…',
          '&#x2F;': '/',
          '&#47;': '/',
        },
        ty = r => ey[r],
        ay = r => r.replace(Pp, ty);
      let Fc = {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: '',
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
        useSuspense: !0,
        unescape: ay,
        transDefaultProps: void 0,
      };
      const ly = (r = {}) => {
          Fc = { ...Fc, ...r };
        },
        ny = () => Fc;
      let wh;
      const iy = r => {
          wh = r;
        },
        uy = () => wh,
        sy = {
          type: '3rdParty',
          init(r) {
            (ly(r.options.react), iy(r));
          },
        },
        Qh = he.createContext();
      class cy {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(u) {
          u.forEach(f => {
            this.usedNamespaces[f] || (this.usedNamespaces[f] = !0);
          });
        }
        getUsedNamespaces() {
          return Object.keys(this.usedNamespaces);
        }
      }
      var Qc = { exports: {} },
        Xc = {};
      var Nh;
      function fy() {
        if (Nh) return Xc;
        Nh = 1;
        var r = gu();
        function u(E, L) {
          return (
            (E === L && (E !== 0 || 1 / E === 1 / L)) || (E !== E && L !== L)
          );
        }
        var f = typeof Object.is == 'function' ? Object.is : u,
          s = r.useState,
          o = r.useEffect,
          h = r.useLayoutEffect,
          m = r.useDebugValue;
        function v(E, L) {
          var q = L(),
            K = s({ inst: { value: q, getSnapshot: L } }),
            B = K[0].inst,
            te = K[1];
          return (
            h(
              function () {
                ((B.value = q), (B.getSnapshot = L), y(B) && te({ inst: B }));
              },
              [E, q, L]
            ),
            o(
              function () {
                return (
                  y(B) && te({ inst: B }),
                  E(function () {
                    y(B) && te({ inst: B });
                  })
                );
              },
              [E]
            ),
            m(q),
            q
          );
        }
        function y(E) {
          var L = E.getSnapshot;
          E = E.value;
          try {
            var q = L();
            return !f(E, q);
          } catch {
            return !0;
          }
        }
        function g(E, L) {
          return L();
        }
        var _ =
          typeof window > 'u' ||
          typeof window.document > 'u' ||
          typeof window.document.createElement > 'u'
            ? g
            : v;
        return (
          (Xc.useSyncExternalStore =
            r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : _),
          Xc
        );
      }
      var Ch;
      function oy() {
        return (Ch || ((Ch = 1), (Qc.exports = fy())), Qc.exports);
      }
      var ry = oy();
      const dy = (r, u) => {
          if (el(u)) return u;
          if (Ip(u) && el(u.defaultValue)) return u.defaultValue;
          if (typeof r == 'function') return '';
          if (Array.isArray(r)) {
            const f = r[r.length - 1];
            return typeof f == 'function' ? '' : f;
          }
          return r;
        },
        hy = { t: dy, ready: !1 },
        gy = () => () => {},
        rt = (r, u = {}) => {
          const { i18n: f } = u,
            { i18n: s, defaultNS: o } = he.useContext(Qh) || {},
            h = f || s || uy();
          (h && !h.reportNamespaces && (h.reportNamespaces = new cy()),
            h ||
              $c(
                h,
                'NO_I18NEXT_INSTANCE',
                'useTranslation: You will need to pass in an i18next instance by using initReactI18next'
              ));
          const m = he.useMemo(
              () => ({ ...ny(), ...h?.options?.react, ...u }),
              [h, u]
            ),
            { useSuspense: v, keyPrefix: y } = m,
            g = r || o || h?.options?.defaultNS,
            _ = el(g) ? [g] : g || ['translation'],
            E = he.useMemo(() => _, _);
          h?.reportNamespaces?.addUsedNamespaces?.(E);
          const L = he.useRef(0),
            q = he.useCallback(
              $ => {
                if (!h) return gy;
                const { bindI18n: F, bindI18nStore: fe } = m,
                  oe = () => {
                    ((L.current += 1), $());
                  };
                return (
                  F && h.on(F, oe),
                  fe && h.store.on(fe, oe),
                  () => {
                    (F && F.split(' ').forEach(re => h.off(re, oe)),
                      fe && fe.split(' ').forEach(re => h.store.off(re, oe)));
                  }
                );
              },
              [h, m]
            ),
            K = he.useRef(),
            B = he.useCallback(() => {
              if (!h) return hy;
              const $ =
                  !!(h.isInitialized || h.initializedStoreOnce) &&
                  E.every(Xe => Wp(Xe, h, m)),
                F = u.lng || h.language,
                fe = L.current,
                oe = K.current;
              if (
                oe &&
                oe.ready === $ &&
                oe.lng === F &&
                oe.keyPrefix === y &&
                oe.revision === fe
              )
                return oe;
              const ze = {
                t: h.getFixedT(F, m.nsMode === 'fallback' ? E : E[0], y),
                ready: $,
                lng: F,
                keyPrefix: y,
                revision: fe,
              };
              return ((K.current = ze), ze);
            }, [h, E, y, m, u.lng]),
            [te, P] = he.useState(0),
            { t: ae, ready: ge } = ry.useSyncExternalStore(q, B, B);
          he.useEffect(() => {
            if (h && !ge && !v) {
              const $ = () => P(F => F + 1);
              u.lng ? _h(h, u.lng, E, $) : kc(h, E, $);
            }
          }, [h, u.lng, E, ge, v, te]);
          const ce = h || {},
            Ne = he.useRef(null),
            Ae = he.useRef(),
            X = $ => {
              const F = Object.getOwnPropertyDescriptors($);
              F.__original && delete F.__original;
              const fe = Object.create(Object.getPrototypeOf($), F);
              if (!Object.prototype.hasOwnProperty.call(fe, '__original'))
                try {
                  Object.defineProperty(fe, '__original', {
                    value: $,
                    writable: !1,
                    enumerable: !1,
                    configurable: !1,
                  });
                } catch {}
              return fe;
            },
            Ce = he.useMemo(() => {
              const $ = ce,
                F = $?.language;
              let fe = $;
              $ &&
                (Ne.current && Ne.current.__original === $
                  ? Ae.current !== F
                    ? ((fe = X($)), (Ne.current = fe), (Ae.current = F))
                    : (fe = Ne.current)
                  : ((fe = X($)), (Ne.current = fe), (Ae.current = F)));
              const oe =
                  !ge && !v
                    ? (...ze) => (
                        $c(
                          h,
                          'USE_T_BEFORE_READY',
                          'useTranslation: t was called before ready. When using useSuspense: false, make sure to check the ready flag before using t.'
                        ),
                        ae(...ze)
                      )
                    : ae,
                re = [oe, fe, ge];
              return ((re.t = oe), (re.i18n = fe), (re.ready = ge), re);
            }, [ae, ce, ge, ce.resolvedLanguage, ce.language, ce.languages]);
          if (h && v && !ge)
            throw new Promise($ => {
              const F = () => $();
              u.lng ? _h(h, u.lng, E, F) : kc(h, E, F);
            });
          return Ce;
        };
      function my({ i18n: r, defaultNS: u, children: f }) {
        const s = he.useMemo(() => ({ i18n: r, defaultNS: u }), [r, u]);
        return he.createElement(Qh.Provider, { value: s }, f);
      }
      const py = 'page_x9M2h',
        yy = { page: py },
        vy = 'stack_gJsE8',
        by = { stack: vy };
      function Xh(r) {
        return r.replace(/\n/g, '<br />');
      }
      function lt({ html: r, as: u = 'p', ...f }) {
        return r
          ? j.jsx(u, { ...f, dangerouslySetInnerHTML: { __html: Xh(r) } })
          : null;
      }
      const Sy = typeof document < 'u' && document.documentMode,
        Ay = {
          rootMargin: '0px',
          threshold: 0,
          load(r) {
            if (r.nodeName.toLowerCase() === 'picture') {
              let f = r.querySelector('img'),
                s = !1;
              (f === null && ((f = document.createElement('img')), (s = !0)),
                Sy &&
                  r.getAttribute('data-iesrc') &&
                  (f.src = r.getAttribute('data-iesrc')),
                r.getAttribute('data-alt') &&
                  (f.alt = r.getAttribute('data-alt')),
                s && r.append(f));
            }
            if (
              r.nodeName.toLowerCase() === 'video' &&
              !r.getAttribute('data-src') &&
              r.children
            ) {
              const f = r.children;
              let s;
              for (let o = 0; o <= f.length - 1; o++)
                ((s = f[o].getAttribute('data-src')), s && (f[o].src = s));
              r.load();
            }
            (r.getAttribute('data-poster') &&
              (r.poster = r.getAttribute('data-poster')),
              r.getAttribute('data-src') &&
                (r.src = r.getAttribute('data-src')),
              r.getAttribute('data-srcset') &&
                r.setAttribute('srcset', r.getAttribute('data-srcset')));
            let u = ',';
            if (
              (r.getAttribute('data-background-delimiter') &&
                (u = r.getAttribute('data-background-delimiter')),
              r.getAttribute('data-background-image'))
            )
              r.style.backgroundImage = `url('${r.getAttribute('data-background-image').split(u).join("'),url('")}')`;
            else if (r.getAttribute('data-background-image-set')) {
              const f = r.getAttribute('data-background-image-set').split(u);
              let s = f[0].substr(0, f[0].indexOf(' ')) || f[0];
              ((s = s.indexOf('url(') === -1 ? `url(${s})` : s),
                f.length === 1
                  ? (r.style.backgroundImage = s)
                  : r.setAttribute(
                      'style',
                      (r.getAttribute('style') || '') +
                        `background-image: ${s}; background-image: -webkit-image-set(${f}); background-image: image-set(${f})`
                    ));
            }
            r.getAttribute('data-toggle-class') &&
              r.classList.toggle(r.getAttribute('data-toggle-class'));
          },
          loaded() {},
        };
      function Wc(r) {
        r.setAttribute('data-loaded', !0);
      }
      function Ey(r) {
        r.getAttribute('data-placeholder-background') &&
          (r.style.background = r.getAttribute('data-placeholder-background'));
      }
      const Ic = r => r.getAttribute('data-loaded') === 'true',
        Ty = (r, u) => (f, s) => {
          f.forEach(o => {
            (o.intersectionRatio > 0 || o.isIntersecting) &&
              (s.unobserve(o.target),
              Ic(o.target) || (r(o.target), Wc(o.target), u(o.target)));
          });
        },
        Dh = (r, u = document) =>
          r instanceof Element
            ? [r]
            : r instanceof NodeList
              ? r
              : u.querySelectorAll(r);
      function Oy(r = '.lozad', u = {}) {
        const {
          root: f,
          rootMargin: s,
          threshold: o,
          load: h,
          loaded: m,
        } = Object.assign({}, Ay, u);
        let v;
        typeof window < 'u' &&
          window.IntersectionObserver &&
          (v = new IntersectionObserver(Ty(h, m), {
            root: f,
            rootMargin: s,
            threshold: o,
          }));
        const y = Dh(r, f);
        for (let g = 0; g < y.length; g++) Ey(y[g]);
        return {
          observe() {
            const g = Dh(r, f);
            for (let _ = 0; _ < g.length; _++)
              if (!Ic(g[_])) {
                if (v) {
                  v.observe(g[_]);
                  continue;
                }
                (h(g[_]), Wc(g[_]), m(g[_]));
              }
          },
          triggerLoad(g) {
            Ic(g) || (h(g), Wc(g), m(g));
          },
          observer: v,
        };
      }
      const xy = ({ name: r, className: u = '', style: f, size: s, ...o }) => {
        const h = { lineHeight: '1', fontSize: s, ...f };
        return j.jsx('i', {
          className: `creality-product-info-iconfont ${r} ${u}`,
          style: h,
          ...o,
        });
      };
      function Zh(...r) {
        const u = [];
        for (const f of r)
          if (f) {
            if (typeof f == 'string' || typeof f == 'number') u.push(f);
            else if (Array.isArray(f)) {
              const s = Zh(...f);
              s && u.push(s);
            } else if (typeof f == 'object')
              for (const s in f) f.hasOwnProperty(s) && f[s] && u.push(s);
          }
        return u.join(' ');
      }
      const My = () => {
          if (typeof window > 'u') {
            const r = globalThis.__SSR_LANG__;
            if (r) return r;
          }
          return 'de';
        },
        zy = 'mediaPicture_GEnv7',
        _y = 'mediaImage_pGzlz',
        Rh = { mediaPicture: zy, mediaImage: _y },
        Zc = '(max-width: 768px)';
      function jh(r) {
        return r
          ? Object.entries(r)
              .filter(([, u]) => u != null && u !== '')
              .map(([u, f]) => {
                const s = u.startsWith('--')
                    ? u
                    : u.replace(/[A-Z]/g, h => `-${h.toLowerCase()}`),
                  o =
                    typeof f == 'number' &&
                    !/^(zIndex|opacity|flex|order|lineHeight|fontWeight|zoom)$/.test(
                      u
                    )
                      ? `${f}px`
                      : String(f);
                return `${s}:${o} !important;`;
              })
              .join('')
          : '';
      }
      function Lh(r) {
        if (typeof r != 'string') return;
        const u = r.trim();
        if (u !== '') return u.startsWith('//') ? `https:${u}` : u;
      }
      const Ny = ({
          pcSrc: r,
          mobileSrc: u,
          style: f,
          pcAspectRatio: s,
          mobileAspectRatio: o,
          pcClassName: h,
          mobileClassName: m,
          pcStyle: v,
          mobileStyle: y,
          fallback: g,
          showFallbackText: _ = !0,
          enableLazyLoad: E = !1,
          rootMargin: L = '400px',
          threshold: q = 0,
          alt: K = '',
          ...B
        }) => {
          const [te, P] = he.useState(!1),
            [ae, ge] = he.useState(!1),
            ce = he.useRef(null),
            Ae = `mediaImage-${he.useId().replace(/[^a-zA-Z0-9_-]/g, '')}`,
            X = Lh(r),
            Ce = Lh(u),
            $ = X ?? Ce;
          (he.useEffect(() => {
            ge(!0);
          }, []),
            he.useEffect(() => {
              P(!1);
            }, [X, Ce]),
            he.useEffect(() => {
              if (!E || !ae || !ce.current) return;
              Oy(ce.current, {
                rootMargin: L,
                threshold: q,
                loaded: Xe => Xe.classList.add('lozad-loaded'),
              }).observe();
            }, [ae, E, L, q, X, Ce]));
          const F = j.jsx('div', {
            style: {
              width: B.width || '100%',
              height: B.height || '100%',
              aspectRatio: s || o,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(243,244,246)',
              ...f,
            },
            children: j.jsx(xy, {
              name: 'icon-zhanweifu',
              style: {
                fontSize: '36px',
                lineHeight: '40px',
                color: 'rgba(156,163,175)',
                opacity: 0.2,
              },
            }),
          });
          if (!$) return g ? j.jsx(j.Fragment, { children: g }) : _ ? F : null;
          if (ae && te)
            return g ? j.jsx(j.Fragment, { children: g }) : _ ? F : null;
          const fe = jh({ ...(s ? { aspectRatio: s } : {}), ...v }),
            oe = jh({ ...(o ? { aspectRatio: o } : {}), ...y }),
            re = [
              fe ? `@media not all and ${Zc}{.${Ae}{${fe}}}` : '',
              oe ? `@media ${Zc}{.${Ae}{${oe}}}` : '',
            ]
              .filter(Boolean)
              .join('');
          return j.jsxs(j.Fragment, {
            children: [
              re && j.jsx('style', { dangerouslySetInnerHTML: { __html: re } }),
              j.jsxs('picture', {
                className: Rh.mediaPicture,
                children: [
                  Ce && j.jsx('source', { media: Zc, srcSet: Ce }),
                  X && j.jsx('source', { srcSet: X }),
                  j.jsx('img', {
                    loading: 'lazy',
                    ref: ce,
                    'data-src': E ? $ : void 0,
                    src: E ? void 0 : $,
                    alt: K,
                    onError: () => P(!0),
                    ...B,
                    className: Zh(
                      'lozad',
                      Rh.mediaImage,
                      Ae,
                      B.className,
                      h,
                      m
                    ),
                    style: {
                      ...(B.width ? { width: B.width } : {}),
                      ...(B.height ? { height: B.height } : {}),
                      objectFit: 'cover',
                      display: 'block',
                      ...f,
                    },
                  }),
                ],
              }),
            ],
          });
        },
        Jh = (r, u, f = `${u}M`) => {
          const s = r(u),
            o = r(f) || s;
          return { pcSrc: s, mobileSrc: o };
        },
        Cy = 'media_RBtPk',
        Dy = 'host_f219k',
        Ry = 'placeholder_HbeU5',
        Pc = { media: Cy, host: Dy, placeholder: Ry },
        jy = '1400px 0px',
        Ly = /\.(mp4|webm|ogg|mov)(\?|#|$)/i;
      function tl({
        imageKey: r,
        mobileImageKey: u,
        className: f,
        eager: s = !1,
        pcAspectRatio: o,
        mobileAspectRatio: h,
        alt: m = '',
        variant: v = 'pc',
        kind: y = 'image',
        active: g,
        loop: _ = !0,
        onEnded: E,
      }) {
        const { t: L } = rt('imageUrl'),
          { pcSrc: q, mobileSrc: K } = Jh(L, r, u),
          B = v === 'mb' ? K : q,
          te = `${Pc.media} ${f ?? ''}`,
          P = j.jsx('div', {
            className: `${te} ${Pc.placeholder}`,
            style: { '--t1-media-pc-ar': o, '--t1-media-mb-ar': h },
            'aria-hidden': 'true',
          });
        if (y === 'video') {
          if (!B) return P;
          if (Ly.test(B))
            return j.jsx(Uy, {
              src: B,
              eager: s,
              active: g,
              loop: _,
              onEnded: E,
              className: f,
              mediaClass: te,
              placeholder: P,
            });
        }
        return j.jsx(Ny, {
          className: te,
          fallback: P,
          pcSrc: q,
          mobileSrc: K,
          pcAspectRatio: o,
          mobileAspectRatio: h,
          alt: m,
          loading: s ? 'eager' : 'lazy',
          fetchPriority: s ? 'high' : void 0,
          enableLazyLoad: !1,
        });
      }
      function Uy({
        src: r,
        eager: u,
        active: f,
        loop: s,
        onEnded: o,
        className: h,
        mediaClass: m,
        placeholder: v,
      }) {
        const y = he.useRef(null),
          g = he.useRef(null),
          [_, E] = he.useState(u),
          [L, q] = he.useState(!1),
          K = L && f !== !1;
        return (
          he.useEffect(() => {
            const B = y.current;
            if (!B) return;
            const te = new IntersectionObserver(
                ([ae]) => {
                  ae?.isIntersecting && E(!0);
                },
                { rootMargin: jy }
              ),
              P = new IntersectionObserver(
                ([ae]) => {
                  ae?.target.isConnected && q(ae.isIntersecting);
                },
                { threshold: 0 }
              );
            return (
              te.observe(B),
              P.observe(B),
              () => {
                (te.disconnect(), P.disconnect());
              }
            );
          }, []),
          he.useEffect(() => {
            const B = g.current;
            if (B) {
              if (K) {
                B.play().catch(() => {});
                return;
              }
              B.pause();
            }
          }, [K, r]),
          he.useEffect(() => {
            if (s || f === !1) return;
            const B = g.current;
            if (
              !B ||
              !(
                B.ended ||
                (Number.isFinite(B.duration) &&
                  B.duration > 0 &&
                  B.currentTime >= B.duration - 0.05)
              )
            )
              return;
            const P = () => {
              (B.removeEventListener('seeked', P), B.play().catch(() => {}));
            };
            return (
              B.addEventListener('seeked', P),
              (B.currentTime = 0),
              () => B.removeEventListener('seeked', P)
            );
          }, [f, s, r]),
          j.jsx('div', {
            ref: y,
            className: `${Pc.host} ${h ?? ''}`,
            children: _
              ? j.jsx(
                  'video',
                  {
                    ref: g,
                    className: m,
                    src: r,
                    muted: !0,
                    loop: s,
                    playsInline: !0,
                    preload: 'auto',
                    onEnded: o,
                  },
                  r
                )
              : v,
          })
        );
      }
      const Hy = 'section_w49O3',
        By = 'mbSection_Twnhv',
        Ky = 'bg_I7HYj',
        qy = 'content_PrSV9',
        Gy = 'title_QFwtU',
        Yy = 'subtitle_5L3ZH',
        Gl = {
          section: Hy,
          mbSection: By,
          bg: Ky,
          content: qy,
          title: Gy,
          subtitle: Yy,
        };
      function Vy({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          f = r === 'mb';
        return j.jsxs('section', {
          className: `${Gl.section} ${f ? Gl.mbSection : ''}`,
          children: [
            j.jsx(tl, {
              className: Gl.bg,
              imageKey: 'section1Bg',
              pcAspectRatio: '2560/1442',
              mobileAspectRatio: '750/1000',
              eager: !0,
            }),
            j.jsxs('div', {
              className: Gl.content,
              children: [
                j.jsx(lt, {
                  as: 'h1',
                  className: Gl.title,
                  html: u('section1.title'),
                }),
                j.jsx(lt, {
                  className: Gl.subtitle,
                  html: u('section1.subtitle'),
                }),
              ],
            }),
          ],
        });
      }
      function wy(r) {
        return `calc(${r} / 2560 * 100 * var(--t1-pc-vw, 1vw))`;
      }
      function Qy(r) {
        return `calc(${r} / 750 * 100vw)`;
      }
      const Xy = 'section_-kEmh',
        Zy = 'mbSection_AWxtG',
        Jy = 'inner_0ADwR',
        $y = 'title_3s4PF',
        ky = 'grid_ahSKY',
        Fy = 'micron_pXqTw',
        Wy = 'galvoSpeed_rbV2W',
        Iy = 'fiveLasers_-xEOi',
        Py = 'autoFocus_92xy-',
        e0 = 'touch_81etm',
        t0 = 'galvoLight_R1Dad',
        a0 = 'conveyor_TTvJD',
        l0 = 'ai_vrYhm',
        n0 = 'class1_EwNDz',
        i0 = 'card_P-1vE',
        u0 = 'cardMedia_KAjGW',
        s0 = 'cardText_MJBq8',
        c0 = 'mbList_APdFl',
        f0 = 'mbCard_weYHu',
        qe = {
          section: Xy,
          mbSection: Zy,
          inner: Jy,
          title: $y,
          grid: ky,
          micron: Fy,
          galvoSpeed: Wy,
          fiveLasers: Iy,
          autoFocus: Py,
          touch: e0,
          galvoLight: t0,
          conveyor: a0,
          ai: l0,
          class1: n0,
          card: i0,
          cardMedia: u0,
          cardText: s0,
          mbList: c0,
          mbCard: f0,
        },
        cu = (r, u, f) => {
          const s = `rgba(0, 0, 0, ${r})`;
          return `linear-gradient(180deg, ${u > 0 ? `${s} 0%, ${s} ${u}%` : `${s} 0%`}, rgba(0, 0, 0, 0) ${f}%)`;
        },
        $e = {
          fiveLasers: {
            id: 'fiveLasers',
            textKey: 'fiveLasers',
            imageKey: 'section2FiveLasers',
            kind: 'video',
            textTop: 20,
            textTopMb: 29,
            mask: 'rgba(11, 11, 11, 0.71)',
            maskMb:
              'linear-gradient(180deg, #0b0b0b 0%, rgba(11, 11, 11, 0) 34%), rgba(11, 11, 11, 0.19)',
          },
          micron: {
            id: 'micron',
            textKey: 'micron',
            imageKey: 'section2Micron',
            textTop: 16,
            textTopMb: 67,
            mask: cu(1, 2, 45),
          },
          galvoSpeed: {
            id: 'galvoSpeed',
            textKey: 'galvoSpeed',
            imageKey: 'section2GalvoSpeed',
            textTop: 16,
            textTopMb: 58,
            mask: cu(1, 14, 54),
          },
          autoFocus: {
            id: 'autoFocus',
            textKey: 'autoFocus',
            mbTextKey: 'autoFocusMb',
            imageKey: 'section2AutoFocus',
            textTop: 16,
            textTopMb: 60,
            mask: `${cu(0.88, 0, 63)}, linear-gradient(0deg, rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0) 37%)`,
          },
          touch: {
            id: 'touch',
            textKey: 'touch',
            imageKey: 'section2Touch',
            textTop: 16,
            textTopMb: 58,
          },
          galvoLight: {
            id: 'galvoLight',
            textKey: 'galvoLight',
            imageKey: 'section2GalvoLight',
            kind: 'video',
            textTop: 20,
            textTopMb: 39,
            mask: 'rgba(0, 0, 0, 0.64)',
          },
          class1: {
            id: 'class1',
            textKey: 'class1',
            imageKey: 'section2Class1',
            kind: 'video',
            textTop: 20,
            textTopMb: 39,
            mask: 'rgba(0, 0, 0, 0.65)',
          },
          conveyor: {
            id: 'conveyor',
            textKey: 'conveyor',
            imageKey: 'section2Conveyor',
            textTop: 16,
            textTopMb: 56,
          },
          ai: {
            id: 'ai',
            textKey: 'ai',
            imageKey: 'section2Ai',
            textTop: 16,
            textTopMb: 39,
            mask: cu(0.91, 0, 63),
          },
        },
        o0 = [
          { card: $e.micron, className: qe.micron },
          { card: $e.fiveLasers, className: qe.fiveLasers },
          { card: $e.autoFocus, className: qe.autoFocus },
          { card: $e.galvoSpeed, className: qe.galvoSpeed },
          { card: $e.touch, className: qe.touch },
          { card: $e.galvoLight, className: qe.galvoLight },
          { card: $e.conveyor, className: qe.conveyor },
          { card: $e.class1, className: qe.class1 },
          { card: $e.ai, className: qe.ai },
        ],
        r0 = [
          $e.galvoSpeed,
          $e.micron,
          $e.fiveLasers,
          $e.autoFocus,
          $e.touch,
          $e.galvoLight,
          $e.class1,
          $e.conveyor,
          $e.ai,
        ];
      function $h({ card: r, className: u, mb: f = !1 }) {
        const { t: s } = rt(),
          o = f && r.mbTextKey ? r.mbTextKey : r.textKey;
        return j.jsxs('div', {
          className: `${qe.card} ${u ?? ''}`,
          children: [
            j.jsx(tl, {
              className: qe.cardMedia,
              imageKey: r.imageKey,
              variant: f ? 'mb' : 'pc',
              kind: r.kind,
            }),
            j.jsx(lt, {
              className: qe.cardText,
              style: {
                '--t1-card-text-top': f ? Qy(r.textTopMb) : wy(r.textTop),
              },
              html: s(`section2.${o}`),
            }),
          ],
        });
      }
      function d0() {
        const { t: r } = rt();
        return j.jsx('section', {
          className: qe.section,
          children: j.jsxs('div', {
            className: qe.inner,
            children: [
              j.jsx(lt, {
                as: 'h2',
                className: qe.title,
                html: r('section2.title'),
              }),
              j.jsx('div', {
                className: qe.grid,
                children: o0.map(({ card: u, className: f }) =>
                  j.jsx($h, { card: u, className: f }, u.id)
                ),
              }),
            ],
          }),
        });
      }
      function h0() {
        const { t: r } = rt();
        return j.jsxs('section', {
          className: `${qe.section} ${qe.mbSection}`,
          children: [
            j.jsx(lt, {
              as: 'h2',
              className: qe.title,
              html: r('section2.title'),
            }),
            j.jsx('div', {
              className: qe.mbList,
              children: r0.map(u =>
                j.jsx($h, { card: u, className: qe.mbCard, mb: !0 }, u.id)
              ),
            }),
          ],
        });
      }
      function g0({ variant: r = 'pc' }) {
        return r === 'mb' ? j.jsx(h0, {}) : j.jsx(d0, {});
      }
      const m0 = 'section_CRs3B',
        p0 = 'mbSection_UKmBi',
        y0 = 'content_0XWB3',
        v0 = 'title_pAFeH',
        b0 = 'media_vXYqs',
        S0 = 'video_2jZlU',
        Yl = {
          section: m0,
          mbSection: p0,
          content: y0,
          title: v0,
          media: b0,
          video: S0,
        };
      function A0({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          f = r === 'mb';
        return j.jsxs('section', {
          className: `${Yl.section} ${f ? Yl.mbSection : ''}`,
          children: [
            j.jsx('div', {
              className: Yl.content,
              children: j.jsx(lt, {
                as: 'h2',
                className: Yl.title,
                html: u('section3.title'),
              }),
            }),
            j.jsx('div', {
              className: Yl.media,
              children: j.jsx(tl, {
                className: Yl.video,
                imageKey: 'section3Bg',
                variant: r,
                kind: 'video',
                pcAspectRatio: '2560/1200',
                mobileAspectRatio: '750/1000',
              }),
            }),
          ],
        });
      }
      const E0 = 'section_S21VC',
        T0 = 'mbSection_qqsSF',
        O0 = 'head_fNwBL',
        x0 = 'title_WNUR6',
        M0 = 'list_IGW-S',
        z0 = 'row_b9r-G',
        _0 = 'rowReversed_kSp34',
        N0 = 'card_eX1Qh',
        C0 = 'cardMedia_ZUH1j',
        D0 = 'copy_ERZJY',
        R0 = 'name_b2eBA',
        j0 = 'body_d2CeT',
        Rt = {
          section: E0,
          mbSection: T0,
          head: O0,
          title: x0,
          list: M0,
          row: z0,
          rowReversed: _0,
          card: N0,
          cardMedia: C0,
          copy: D0,
          name: R0,
          body: j0,
        },
        L0 = [
          'section4Slide1',
          'section4Slide2',
          'section4Slide3',
          'section4Slide4',
          'section4Slide5',
        ];
      function U0({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          f = r === 'mb',
          s = u('section4.slides', { returnObjects: !0 }) ?? [];
        return j.jsxs('section', {
          className: `${Rt.section} ${f ? Rt.mbSection : ''}`,
          children: [
            j.jsx('div', {
              className: Rt.head,
              children: j.jsx(lt, {
                as: 'h2',
                className: Rt.title,
                html: u('section4.title'),
              }),
            }),
            j.jsx('div', {
              className: Rt.list,
              children: L0.map((o, h) => {
                const m = Array.isArray(s) ? s[h] : void 0;
                return j.jsxs(
                  'div',
                  {
                    className: `${Rt.row} ${h % 2 === 1 ? Rt.rowReversed : ''}`,
                    children: [
                      j.jsx('div', {
                        className: Rt.card,
                        children: j.jsx(tl, {
                          className: Rt.cardMedia,
                          imageKey: o,
                          variant: r,
                          kind: 'video',
                          pcAspectRatio: '16/10',
                          mobileAspectRatio: '16/10',
                        }),
                      }),
                      j.jsxs('div', {
                        className: Rt.copy,
                        children: [
                          j.jsx(lt, { className: Rt.name, html: m?.name }),
                          j.jsx(lt, { className: Rt.body, html: m?.body }),
                        ],
                      }),
                    ],
                  },
                  o
                );
              }),
            }),
          ],
        });
      }
      const H0 = 'section_TKGPN',
        B0 = 'mbSection_YIZZk',
        K0 = 'inner_xAVlY',
        q0 = 'title_kEO-c',
        G0 = 'gallery_L4Su7',
        Y0 = 'media_ZwE3i',
        V0 = 'tabs_98heV',
        w0 = 'indicator_nFI8A',
        Q0 = 'tab_hQHtz',
        X0 = 'cta_LoX1V',
        Kt = {
          section: H0,
          mbSection: B0,
          inner: K0,
          title: q0,
          gallery: G0,
          media: Y0,
          tabs: V0,
          indicator: w0,
          tab: Q0,
          cta: X0,
        },
        fu = [
          { id: 'wood', imageKey: 'section5Wood' },
          { id: 'leather', imageKey: 'section5Leather' },
          { id: 'glass', imageKey: 'section5Glass' },
          { id: 'metal', imageKey: 'section5Metal' },
          { id: 'ceramics', imageKey: 'section5Ceramics' },
        ];
      function Z0({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          [f, s] = he.useState('wood'),
          o = r === 'mb',
          h = fu.find(m => m.id === f) ?? fu[0];
        return j.jsx('section', {
          className: `${Kt.section} ${o ? Kt.mbSection : ''}`,
          children: j.jsxs('div', {
            className: Kt.inner,
            children: [
              j.jsx(lt, {
                as: 'h2',
                className: Kt.title,
                html: u('section5.title'),
              }),
              j.jsx('div', {
                className: Kt.gallery,
                children: j.jsx(tl, {
                  className: Kt.media,
                  imageKey: h.imageKey,
                  variant: r,
                  alt: u(`section5.tabs.${h.id}`),
                }),
              }),
              j.jsxs('div', {
                className: Kt.tabs,
                role: 'tablist',
                style: { '--tab-index': fu.findIndex(m => m.id === f) },
                children: [
                  j.jsx('span', { className: Kt.indicator, 'aria-hidden': !0 }),
                  fu.map(m =>
                    j.jsx(
                      'button',
                      {
                        type: 'button',
                        role: 'tab',
                        'aria-selected': m.id === f,
                        className: `${Kt.tab} ${m.id === f ? Kt.tabActive : ''}`,
                        onClick: () => s(m.id),
                        children: u(`section5.tabs.${m.id}`),
                      },
                      m.id
                    )
                  ),
                ],
              }),
              j.jsx('a', {
                className: Kt.cta,
                href: u('section5.learnLink'),
                target: '_blank',
                children: u('section5.learnMore'),
              }),
            ],
          }),
        });
      }
      const J0 = 'section_hUyDe',
        $0 = 'mbSection_L9aes',
        k0 = 'inner_NbjJG',
        F0 = 'title_RPSUc',
        W0 = 'grid_XZ62J',
        I0 = 'card_N-2Er',
        P0 = 'cardVertical_-iNUk',
        ev = 'copy_oJesj',
        tv = 'name_IyTqB',
        av = 'body_DFLjy',
        lv = 'mediaWrap_SH6-X',
        nv = 'media_SRJxy',
        jt = {
          section: J0,
          mbSection: $0,
          inner: k0,
          title: F0,
          grid: W0,
          card: I0,
          cardVertical: P0,
          copy: ev,
          name: tv,
          body: av,
          mediaWrap: lv,
          media: nv,
        },
        iv = [
          { id: 'purifier', imageKey: 'section6Purifier' },
          { id: 'rotary', imageKey: 'section6Rotary' },
          { id: 'riser', imageKey: 'section6Riser' },
          { id: 'blade', imageKey: 'section6Blade' },
          { id: 'conveyor', imageKey: 'section6Conveyor', vertical: !0 },
          { id: 'fixture', imageKey: 'section6Fixture', vertical: !0 },
          { id: 'module', imageKey: 'section6Module', vertical: !0 },
        ];
      function uv({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          f = r === 'mb',
          s = u('section6.cards', { returnObjects: !0 }) ?? [];
        return j.jsx('section', {
          className: `${jt.section} ${f ? jt.mbSection : ''}`,
          children: j.jsxs('div', {
            className: jt.inner,
            children: [
              j.jsx(lt, {
                as: 'h2',
                className: jt.title,
                html: u('section6.title'),
              }),
              j.jsx('div', {
                className: jt.grid,
                children: iv.map((o, h) => {
                  const m = Array.isArray(s) ? s[h] : void 0;
                  return j.jsxs(
                    'article',
                    {
                      className: `${jt.card} ${o.vertical ? jt.cardVertical : ''}`,
                      children: [
                        j.jsxs('div', {
                          className: jt.copy,
                          children: [
                            j.jsx(lt, {
                              as: 'h3',
                              className: jt.name,
                              html: m?.name,
                            }),
                            j.jsx(lt, { className: jt.body, html: m?.body }),
                          ],
                        }),
                        j.jsx('div', {
                          className: jt.mediaWrap,
                          children: j.jsx(tl, {
                            className: jt.media,
                            imageKey: o.imageKey,
                            variant: r,
                            alt: m?.name ?? '',
                          }),
                        }),
                      ],
                    },
                    o.id
                  );
                }),
              }),
            ],
          }),
        });
      }
      const sv = 'section_6fGkV',
        cv = 'mbSection_pC6A9',
        fv = 'inner_nXZyt',
        ov = 'toggle_2-8AH',
        rv = 'toggleText_htRHk',
        dv = 'chevron_tMWz2',
        hv = 'chevronOpen_K6svG',
        gv = 'grid_-tvf9',
        mv = 'item_06OJ8',
        pv = 'mediaWrap_H3oHW',
        yv = 'media_WxrNN',
        vv = 'label_163ix',
        Lt = {
          section: sv,
          mbSection: cv,
          inner: fv,
          toggle: ov,
          toggleText: rv,
          chevron: dv,
          chevronOpen: hv,
          grid: gv,
          item: mv,
          mediaWrap: pv,
          media: yv,
          label: vv,
        },
        Uh = [
          { id: 'cutter', imageKey: 'section7Cutter' },
          { id: 'module', imageKey: 'section7Module' },
          { id: 'screen', imageKey: 'section7Screen' },
          { id: 'adapter', imageKey: 'section7Adapter' },
          { id: 'cord', imageKey: 'section7Cord' },
          { id: 'exhaust', imageKey: 'section7Exhaust' },
          { id: 'cable', imageKey: 'section7Cable' },
          { id: 'panel', imageKey: 'section7Panel' },
          { id: 'block', imageKey: 'section7Block' },
          { id: 'hexKey', imageKey: 'section7HexKey' },
          { id: 'wrench', imageKey: 'section7Wrench' },
          { id: 'usbAdapter', imageKey: 'section7UsbAdapter' },
          { id: 'laserCard', imageKey: 'section7LaserCard' },
          { id: 'cameraCard', imageKey: 'section7CameraCard' },
          { id: 'clamp', imageKey: 'section7Clamp' },
          { id: 'lensCard', imageKey: 'section7LensCard' },
          { id: 'safetyKey', imageKey: 'section7SafetyKey' },
          { id: 'blower', imageKey: 'section7Blower' },
          { id: 'pack', imageKey: 'section7Pack' },
          { id: 'cloth', imageKey: 'section7Cloth' },
          { id: 'brush', imageKey: 'section7Brush' },
          { id: 'guide', imageKey: 'section7Guide' },
          { id: 'safety', imageKey: 'section7Safety' },
          { id: 'ftheta', imageKey: 'section7Ftheta' },
          { id: 'stand', imageKey: 'section7Stand' },
        ];
      function bv({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          [f, s] = he.useState(!1),
          o = r === 'mb',
          h = u('section7.items', { returnObjects: !0 }) ?? [],
          m = o ? 3 : 5,
          v = f ? Uh : Uh.slice(0, m);
        return j.jsx('section', {
          className: `${Lt.section} ${o ? Lt.mbSection : ''}`,
          children: j.jsxs('div', {
            className: Lt.inner,
            children: [
              j.jsxs('button', {
                type: 'button',
                className: Lt.toggle,
                'aria-expanded': f,
                onClick: () => s(y => !y),
                children: [
                  j.jsx('span', {
                    className: Lt.toggleText,
                    children: u('section7.title'),
                  }),
                  j.jsx('svg', {
                    xmlns: 'http://www.w3.org/2000/svg',
                    className: `${Lt.chevron} ${f ? Lt.chevronOpen : ''}`,
                    width: '53',
                    height: '33',
                    viewBox: '0 0 53 33',
                    fill: 'none',
                    'aria-hidden': 'true',
                    children: j.jsx('path', {
                      d: 'M1.85156 1.67969L26.3516 28.6797L50.8516 1.67969',
                      stroke: 'black',
                      strokeWidth: '5',
                    }),
                  }),
                ],
              }),
              j.jsx('div', {
                className: Lt.grid,
                children: v.map((y, g) => {
                  const _ = Array.isArray(h) ? h[g] : void 0;
                  return j.jsxs(
                    'article',
                    {
                      className: Lt.item,
                      children: [
                        j.jsx('div', {
                          className: Lt.mediaWrap,
                          children: j.jsx(tl, {
                            className: Lt.media,
                            imageKey: y.imageKey,
                            variant: r,
                            alt: _ ?? '',
                          }),
                        }),
                        _
                          ? j.jsx('span', { className: Lt.label, children: _ })
                          : null,
                      ],
                    },
                    y.id
                  );
                }),
              }),
            ],
          }),
        });
      }
      const Sv = 'section_-KKQo',
        Av = 'mbSection_POzSB',
        Ev = 'inner_JNqvc',
        Tv = 'title_iiNfK',
        Ov = 'tableWrap_8k2Tz',
        xv = 'table_5vsab',
        Mv = 'colLabel_VIFi7',
        Pa = {
          section: Sv,
          mbSection: Av,
          inner: Ev,
          title: Tv,
          tableWrap: Ov,
          table: xv,
          colLabel: Mv,
        };
      function zv(r) {
        return r <= 1
          ? [5]
          : r === 2
            ? [4, 1]
            : Array.from({ length: r }, () => 1);
      }
      function _v({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          f = r === 'mb',
          s = u('section8.headers', { returnObjects: !0 }) ?? [],
          o = u('section8.rows', { returnObjects: !0 }) ?? [];
        return j.jsx('section', {
          className: `${Pa.section} ${f ? Pa.mbSection : ''}`,
          children: j.jsxs('div', {
            className: Pa.inner,
            children: [
              j.jsx(lt, {
                as: 'h2',
                className: Pa.title,
                html: u('section8.title'),
              }),
              j.jsx('div', {
                className: Pa.tableWrap,
                children: j.jsxs('table', {
                  className: Pa.table,
                  children: [
                    j.jsxs('colgroup', {
                      children: [
                        j.jsx('col', { className: Pa.colLabel }),
                        j.jsx('col', {}),
                        j.jsx('col', {}),
                        j.jsx('col', {}),
                        j.jsx('col', {}),
                        j.jsx('col', {}),
                      ],
                    }),
                    j.jsx('thead', {
                      children: j.jsx('tr', {
                        children: (Array.isArray(s) ? s : []).map(h =>
                          j.jsx('th', { children: h }, h)
                        ),
                      }),
                    }),
                    j.jsx('tbody', {
                      children: (Array.isArray(o) ? o : []).map(h => {
                        const m = h.values ?? [],
                          v = zv(m.length);
                        return j.jsxs(
                          'tr',
                          {
                            children: [
                              j.jsx('th', { children: h.label }),
                              m.map((y, g) =>
                                j.jsx(
                                  'td',
                                  {
                                    colSpan: v[g],
                                    dangerouslySetInnerHTML: { __html: Xh(y) },
                                  },
                                  `${h.label}-${g}`
                                )
                              ),
                            ],
                          },
                          h.label
                        );
                      }),
                    }),
                  ],
                }),
              }),
            ],
          }),
        });
      }
      const Nv = 'section_ocqJv',
        Cv = 'mbSection_uyfZ0',
        Dv = 'list_-pqry',
        Rv = 'item_G4djm',
        ou = { section: Nv, mbSection: Cv, list: Dv, item: Rv };
      function jv({ variant: r = 'pc' }) {
        const { t: u } = rt(),
          f = r === 'mb',
          s = u('section9.items', { returnObjects: !0 }) ?? [];
        return j.jsx('section', {
          className: `${ou.section} ${f ? ou.mbSection : ''}`,
          children: j.jsx('div', {
            className: ou.list,
            children: (Array.isArray(s) ? s : []).map((o, h) =>
              j.jsx(lt, { className: ou.item, html: o }, h)
            ),
          }),
        });
      }
      const Lv = [Vy, g0, A0, U0, Z0, uv, bv, _v, jv];
      function Uv({ variant: r = 'pc' }) {
        return j.jsx('div', {
          className: by.stack,
          children: Lv.map((u, f) => j.jsx(u, { variant: r }, f)),
        });
      }
      const ef = '(max-width: 768px)';
      function Hv() {
        const [r, u] = he.useState(null);
        return (
          he.useLayoutEffect(() => {
            const f = window.matchMedia(ef),
              s = () => u(f.matches ? 'mb' : 'pc');
            return (
              s(),
              f.addEventListener('change', s),
              () => f.removeEventListener('change', s)
            );
          }, []),
          r
        );
      }
      const Bv = `not all and ${ef}`;
      function Kv() {
        const { i18n: r } = rt(),
          { t: u } = rt('imageUrl'),
          s = Hv() ?? 'pc',
          { pcSrc: o, mobileSrc: h } = Jh(u, 'section1Bg'),
          m = he.useRef(null);
        return (
          he.useLayoutEffect(() => {
            const v = m.current;
            if (!v) return;
            const y = () => {
              v.style.setProperty('--t1-pc-vw', `${v.clientWidth / 100}px`);
            };
            y();
            const g = new ResizeObserver(y);
            return (
              g.observe(v),
              window.addEventListener('resize', y),
              () => {
                (g.disconnect(), window.removeEventListener('resize', y));
              }
            );
          }, []),
          j.jsxs('div', {
            ref: m,
            className: `t1-page ${yy.page}`,
            'data-lang': r.language,
            children: [
              o
                ? j.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: o,
                    media: Bv,
                    fetchPriority: 'high',
                  })
                : null,
              h
                ? j.jsx('link', {
                    rel: 'preload',
                    as: 'image',
                    href: h,
                    media: ef,
                    fetchPriority: 'high',
                  })
                : null,
              j.jsx(Uv, { variant: s }),
            ],
          })
        );
      }
      const qv = {
          title: 'Creality Falcon T1',
          description: 'Five Lasers.Create Faster, Smarter. Grow Further.',
          section1: {
            title: 'Creality Falcon T1',
            subtitle: 'Five Lasers.Create Faster, Smarter. Grow Further.',
            shopNow: 'Shop Now',
          },
          section2: {
            title: 'Why Choose Creality Falcon T1',
            fiveLasers:
              '<em class="blue">Five Laser Modules </em><br />Infinite Possibilities<sup class="fn">[1]</sup>',
            micron: 'Micron Precision Fine Detail',
            galvoSpeed:
              '<em class="blue">High-Speed</em> Galvo Faster Creation',
            autoFocus:
              '<em class="blue">3-Second</em> Autofocus<sup class="fn">[2]</sup>',
            autoFocusMb:
              '<em class="blue">3-Second</em> Autofocus<sup class="fn">[2]</sup>',
            touch: 'Touch. Control. Create',
            galvoLight:
              '<em class="blue">Galvo-Controlled</em> Light<br />Precision in Motion',
            class1:
              '<em class="blue">Class 1</em> Protection<br />Create with Confidence',
            conveyor: 'Continuous Batch Processing',
            ai: '<em class="blue">AI-Assisted</em> Creation<sup class="fn">[3]</sup>',
          },
          section3: {
            title:
              'How seamless can switching <br class="br_pc" />between modules be?',
          },
          section4: {
            title: 'Five Moduless <sup class="fn">[1]</sup> Endless Horizons',
            body: 'Unlock wood, leather, metal, crystal, and vibrant steel coloring. Recombine 5 professional <br class="br_pc" />light sources to switchwavelengths and redefine your making boundaries.',
            slides: [
              {
                name: 'Diode 20W',
                body: 'Cut and deep-engrave wood, leather, and acrylic in a single pass.',
              },
              {
                name: 'Diode 40W',
                body: 'Double the power for fast, efficient cutting through thick materials.',
              },
              {
                name: 'Fiber 20W',
                body: 'High-precision marking on metals and plastics with razor-sharp details.',
              },
              {
                name: 'MOPA 60W',
                body: 'Smart, multi-color engraving on stainless steel and titanium—no post-coloring required.<sup class="fn">[5]</sup>',
              },
              {
                name: 'UV 5W',
                body: 'Precise 3D internal engraving in compatible crystal and glass.<sup class="fn">[6]</sup>',
              },
            ],
          },
          section5: {
            title: 'More Materials, One Machine<sup class="fn">[7]</sup>',
            tabs: {
              wood: 'Wood',
              leather: 'Leather',
              glass: 'Glass',
              metal: 'Metal',
              ceramics: 'Ceramics',
            },
            learnMore: 'Learn more',
            learnLink:
              'https://www.crealityfalcon.com/pages/creality-falcon-t1-launch',
          },
          section6: {
            title:
              'Adapt to Every Job. Master Every Object.<sup class="fn">[8]</sup>',
            cards: [
              {
                name: 'Creality Purifier AP1 Mini',
                body: 'Perfect for homes, studios, and shops, allowing you to engrave anytime with clean, safe air.',
              },
              {
                name: 'Rotary Attachment Kit',
                body: 'Featuring an innovative 4-in-1 rotary axis, T1 supports engraving on most common cylindrical and spherical objects - including tumblers, mugs, ornamentballs, rings, and more with ease⁴.',
              },
              {
                name: 'UV Inner-Engraving Riser',
                body: 'Provides extended focal distance for UV engraving, compatible with taller and thicker glass, crystal, and transparent materials.',
              },
              {
                name: 'Falcon T1 Knife Blade Bed',
                body: 'Knife strip design improves airflow, for cleaner, smoother cutting edges.',
              },
              {
                name: 'Falcon Conveyor TC1',
                body: 'Precision Batch Processing with Smart Fill Tech Larger working area ensures stable, continuous, and repeatable automated production⁴.',
              },
              {
                name: 'Flexible Fixture',
                body: 'Adapts to irregular shapes and secures objects at any angle.',
              },
              {
                name: 'Falcon T1 Module',
                body: 'Five optional modules: 20W diode module, 40W diode module, 20W fiber module, 60W MOPA module, and 5W UV module.',
              },
            ],
          },
          section7: {
            title: 'In the Box',
            items: [
              'Laser Cutter and Engraver',
              'Laser Module',
              'Interactive Screen',
              'Power Adapter',
              'Power Cord',
              'Exhaust Pipe',
              'Type-A to Type-C Cable',
              'Slotted Panel',
              'L-shaped Locating Block',
              'Hex Key',
              'Hex Cross Wrench',
              'Type-A to Type-C Adapter',
              'Laser Calibration Card',
              'Camera Calibration Card',
              'Hose Clamp',
              'Field Lens Calibration Card',
              'Safety Key',
              'Rubber Air Blower',
              'Materials Pack',
              'Dust-free Cloth',
              'Lint-free Brush',
              'Quick Start Guide',
              'Safety Instructions',
              'Internal Engraving F-Theta Lens³',
              'Internal Engraved Stand³',
            ],
          },
          section8: {
            title: 'T1 Specs',
            headers: [
              'Category',
              'Blue Laser (Diode) 20W',
              'Blue Laser (Diode) 40W',
              'Infrared Laser (Fiber) 20W',
              'MOPA 60W',
              'UV Laser 5W',
            ],
            rows: [
              {
                label: 'Wavelength',
                values: [
                  '445nm±15nm',
                  '445nm±15nm',
                  '1064nm±5nm',
                  '1064nm±5nm',
                  '355nm±2nm',
                ],
              },
              {
                label: 'Compatible Materials',
                values: [
                  'Wood, acrylic, PU leather, MDF, dark glass, ceramics, coated metals, stainless steel, bamboo',
                  'Wood, acrylic, PU leather, MDF, dark glass, ceramics, coated metals, stainless steel, bamboo',
                  'Stainless steel, titanium alloy, gold, silver, brass, copper, iron, aluminum, plastic, shale',
                  'Stainless steel, titanium alloy, gold, silver, brass, copper, iron, aluminum, plastic, shale',
                  'Acrylic, plastic, glass, ceramics, crystal, PU leather, cardboard',
                ],
              },
              {
                label: 'Engraving Modes',
                values: [
                  'Flat engraving, relief, deep engraving, 3D curved engraving',
                  'Flat engraving, relief, deep engraving, 3D internal engraving, internal engraving',
                ],
              },
              {
                label: 'Working Area',
                values: [
                  '175*175mm',
                  '175*175mm<br>(Internal engraving area: 70 × 70 mm)',
                ],
              },
              {
                label: 'Spot Size',
                values: [
                  '0.12mm×0.14mm',
                  '0.14mm×0.18mm',
                  '0.05mm',
                  '0.05mm',
                  '0.014mm',
                ],
              },
              { label: 'Processing Accuracy', values: ['≤ 0.01mm'] },
              { label: 'Positioning Accuracy', values: ['±0.01mm'] },
              { label: 'Max Working Speed', values: ['10000 mm/s'] },
              { label: 'Product Dimensions', values: ['464×312×509mm'] },
              {
                label: 'Software Support',
                values: ['Falcon Design Space、（LightBurn）'],
              },
              { label: 'Operating System', values: ['Windows/MacOS'] },
              {
                label: 'Supported File Formats',
                values: [
                  'jpeg,jpg, png, bmp, svg, dxf,pdf,etc.<br>3D: glb obj fbx stl ply',
                ],
              },
              { label: 'Safety Class', values: ['class 1'] },
              { label: 'Input Voltage', values: ['100-240V~ 50-60Hz'] },
            ],
          },
          section9: {
            items: [
              '1. The five laser modules are Diode 20W, Diode 40W, Fiber 20W, MOPA 60W, and UV 5W. Module configurations, sales options, and regional availability may vary. Refer to the local sales page for details.',
              '2. The 3-second autofocus figure is based on internal testing under controlled conditions. Actual focusing time may vary with the laser module, material height, calibration status, and operating environment.',
              '3. AI feature availability may vary by software or app version, device configuration, laser module, and region. Some features may require an internet connection and account sign-in. AI-generated or processed results may vary with the source content.',
              '4. Class 1 applies when the machine is fully enclosed, the lid is properly closed, and the product is operated as instructed. In specific open-cover workflows, including conveyor and rotary modes, the product does not meet Class 1 requirements. Follow the safety instructions, use additional safeguards, and wear appropriate personal protective equipment. The protective window is designed for the product’s 355 nm, 455 nm, and 1064 nm laser wavelengths.',
              '5. Metal color engraving requires the MOPA 60W module. Colors and effects vary with metal type, surface condition, processing parameters, and operating environment. Actual results may differ by material.',
              '6. 3D internal engraving requires the UV 5W module, the matching internal-engraving F-theta lens, and the 3D Engraving Riser. It is intended for compatible transparent materials. Refer to the actual package list for included components.',
              '7.  Material compatibility and processing results vary with composition, color, surface finish, thickness, moisture content, and parameter settings. Project images and videos are for illustrative purposes only, and actual results may vary. Test the material before processing.',
              '8. The automatic conveyor, flexible fixture, rotary kit, 3D Engraving Riser, knife blade bed, and air purifier are sold separately unless expressly included in the selected bundle. Compatibility and availability may vary by module, processing method, and region.',
            ],
          },
        },
        Gv = {
          title: 'Creality Falcon T1',
          description:
            'Fünf Laser. Schneller und intelligenter gestalten. Weiter wachsen.',
          section1: {
            title: 'Creality Falcon T1',
            subtitle:
              'Fünf Laser. Schneller und intelligenter gestalten. Weiter wachsen.',
            shopNow: 'Shop Now',
          },
          section2: {
            title: 'Warum du sich für Creality Falcon T1 entscheiden solltest',
            fiveLasers:
              '<em class="blue">Fünf </em><br />austauschbare Module<sup class="fn">[1]</sup>',
            micron: 'Mikrometerpräzision für feine Details',
            galvoSpeed:
              '<em class="blue">Hochgeschwindigkeits</em> - Galvo Schnellere Gestaltungn',
            autoFocus:
              'Autofokus in Sekunden</em><sup class="fn">[2]</sup>',
            autoFocusMb:
              'Autofokus in Sekunden</em><sup class="fn">[2]</sup>',
            touch: 'Berühren. Steuern. Gestalten',
            galvoLight:
              '<em class="blue">Galvo-gesteuerte</em> Light<br />Lichtpräzision in Bewegung',
            class1:
              '<em class="blue">Schutzklasse 1</em> <br />Sicher gestalten',
            conveyor: 'Kontinuierliche Stapelverarbeitung',
            ai: '<em class="blue">KI-gestützte</em> Gestaltung<sup class="fn">[3]</sup>',
          },
          section3: {
            title:
              'Wie nahtlos kann der Wechsel zwischen<br class="br_pc" />den Modulen sein?',
          },
          section4: {
            title:
              'Fünf Module.<sup class="fn">[1]</sup> Unendliche Möglichkeiten.',
            body: 'Unlock wood, leather, metal, crystal, and vibrant steel coloring. Recombine 5 professional <br class="br_pc" />light sources to switchwavelengths and redefine your making boundaries.',
            slides: [
              {
                name: 'Diode 20W',
                body: 'Schneiden und tiefgravieren Sie Holz, Leder und Acryl in einem Einzeldurchgang.',
              },
              {
                name: 'Diode 40W',
                body: 'Doppelte Leistung für schnelles, effizientes Schneiden durch dicke Materialien.',
              },
              {
                name: 'Faser 20W',
                body: 'Hochpräzise Markierung auf Metallen und Kunststoffen mit messerscharfen Details.',
              },
              {
                name: 'MOPA 60W',
                body: 'Intelligente mehrfarbige Gravur auf Edelstahl und Titan – kein Nachfärben erforderlich.<sup class="fn">[5]</sup>',
              },
              {
                name: 'UV 5W',
                body: 'Präzise 3D-Innengravur in kompatiblem Kristall und Glas.<sup class="fn">[6]</sup>',
              },
            ],
          },
          section5: {
            title: 'Mehr Materialien, ein Gerät.<sup class="fn">[7]</sup>',
            tabs: {
              wood: 'Holz',
              leather: 'Leder',
              glass: 'Glas',
              metal: 'Metall',
              ceramics: 'Keramik',
            },
            learnMore: 'Mehr erfahren',
            learnLink:
              'https://de.crealityfalcon.com/pages/creality-falcon-t1-launch',
          },
          section6: {
            title:
              'An jeden Auftrag anpassbar. Jedes Objekt meistern.<sup class="fn">[8]</sup>',
            cards: [
              {
                name: 'Creality Purifier AP1 Mini',
                body: 'Perfekt für Zuhause, Studios und Geschäfte – gravieren Sie jederzeit mit sauberer, sicherer Luft.',
              },
              {
                name: 'Rotationsaufsatz-Kit',
                body: 'Mit einer innovativen 4-in-1-Rotationsachse unterstützt der T1 die Gravur auf den gängigsten zylindrischen und kugelförmigen Objekten – einschließlich Thermobecher, Tassen, Zierbälle, Ringe und mehr – mit Leichtigkeit.<sup class="fn">[4]</sup>',
              },
              {
                name: 'UV-Innengravur-Riser',
                body: 'Ermöglicht einen größeren Fokusabstand für die UV-Gravur, eignet sich für höhere und dickere Materialien aus Glas, Kristall und anderen transparenten Werkstoffen.',
              },
              {
                name: 'Falcon T1 Messerklingenbett',
                body: 'Das Messerstreifendesign verbessert den Luftstrom für sauberere, glattere Schnittkanten.',
              },
              {
                name: 'Falcon Förderer TC1',
                body: 'Präzise Chargenverarbeitung mit Smart-Fill-Technologie. Der größere Arbeitsbereich gewährleistet eine stabile, kontinuierliche und wiederholbare automatisierte Produktion.',
              },
              {
                name: 'Flexible Halterung',
                body: 'Passt sich unregelmäßigen Formen anund fixiert Objekte in jedem Winkel.',
              },
              {
                name: 'Falcon T1-Module',
                body: 'Es stehen fünf optionale Modulezur Verfügung: das 20-W-Diodenmodul, das 40-W-Diodenmodul, das 20-W-Fasermodul, das 60-W-MOPA-Modul und das 5-W-UV-Modul.',
              },
            ],
          },
          section7: {
            title: 'Im Lieferumfang',
            items: [
              'Laserschneider und -gravierer',
              'Lasermodul',
              'Interaktiver Bildschirm',
              'Netzteil',
              'Netzkabel',
              'Abluftschlauch',
              'Typ-A-auf-Typ-C-Kabel',
              'Lamellenplatte',
              'L-förmiger Positionierblock',
              'Inbusschlüssel',
              'Inbus-Kreuzschlüssel',
              'Typ-A-auf-Typ-C-Adapter',
              'Laserkalibrierungskarte',
              'Kamerakalibrierungskarte',
              'Schlauchklemme',
              'Feldlinsenkalibrierungskarte',
              'Sicherheitsschlüssel',
              'Gummi-Blasebalg',
              'Materialpaket',
              'Staubfreies Tuch',
              'Fusselfreie Bürste',
              'Schnellstartanleitung',
              'Sicherheitshinweise',
              'F-Theta-Objektiv für Innengravur³',
              'Ständer für Innengravur³',
            ],
          },
          section8: {
            title: 'T1-Spezifikationen',
            headers: [
              'Kategorie',
              'Blaulaser (Diode) 20 W',
              'Blaulaser (Diode) 40 W',
              'Infrarotlaser (Fiber) 20 W',
              'MOPA 60 W',
              'UV-Laser 5 W',
            ],
            rows: [
              {
                label: 'Wellenlänge',
                values: [
                  '445 nm ± 15 nm',
                  '445 nm ± 15 nm',
                  '1064 nm ± 5 nm',
                  '1064 nm ± 5 nm',
                  '355 nm ± 2 nm',
                ],
              },
              {
                label: 'Kompatible Materialien',
                values: [
                  'Holz, Acryl, PU-Leder, MDF, dunkles Glas, Keramik, beschichtete Metalle, Edelstahl, Bambus',
                  'Holz, Acryl, PU-Leder, MDF, dunkles Glas, Keramik, beschichtete Metalle, Edelstahl, Bambus',
                  'Edelstahl, Titanlegierung, Gold, Silber, Messing, Kupfer, Eisen, Aluminium, Kunststoff, Schiefer',
                  'Edelstahl, Titanlegierung, Gold, Silber, Messing, Kupfer, Eisen, Aluminium, Kunststoff, Schiefer',
                  'Acryl, Kunststoff, Glas, Keramik, Kristall, PU-Leder, Karton',
                ],
              },
              {
                label: 'Gravurmodi',
                values: [
                  'Flachgravur, Relief, Tiefengravur, 3D-Kurvengravur',
                  'Flachgravur, Relief, Tiefengravur, 3D-Innengravur, Innengravur',
                ],
              },
              {
                label: 'Arbeitsbereich',
                values: [
                  '175 × 175 mm',
                  '175 × 175 mm<br>(Innengravierfläche: 70 × 70 mm)',
                ],
              },
              {
                label: 'Spotgröße',
                values: [
                  '0,12 mm × 0,14 mm',
                  '0,14 mm × 0,18 mm',
                  '0,05 mm',
                  '0,05 mm',
                  '0,014 mm',
                ],
              },
              { label: 'Verarbeitungsgenauigkeit', values: ['≤0,01 mm'] },
              { label: 'Positioniergenauigkeit', values: ['±0,01 mm'] },
              { label: 'Max. Arbeitsgeschwindigkeit', values: ['10000 mm/s'] },
              { label: 'Produktabmessungen', values: ['464 × 312 × 509 mm'] },
              {
                label: 'Softwareunterstützung',
                values: ['Falcon Design Space、（LightBurn）'],
              },
              { label: 'Betriebssystem', values: ['Windows/MacOS'] },
              {
                label: 'Unterstützte Dateiformate',
                values: [
                  'jpeg, jpg, png, bmp, svg, dxf, pdf, usw.<br>3D: glb obj fbx stl ply',
                ],
              },
              { label: 'Sicherheitsklasse', values: ['Klasse 1'] },
              { label: 'Eingangsspannung', values: ['100–240 V~ 50–60 Hz'] },
            ],
          },
          section9: {
            items: [
              '1. Die fünf Lasermodule sind: Diode 20 W, Diode 40 W, Faser 20 W, MOPA 60 W und UV 5 W. Modulkonfigurationen, Verkaufsoptionen und regionale Verfügbarkeit können variieren. Einzelheiten finden Sie auf der lokalen Verkaufsseite.',
              '2. Der Wert der Autofokussierung in Sekunden basiert auf internen Tests mit Produktionshardware, der endgültigen Firmware und dem Standardtestverfahren. Die tatsächliche Fokussierungszeit kann je nach Lasermodul, Materialhöhe, Kalibrierungsstatus und Betriebsumgebung variieren.',
              '3. Die Verfügbarkeit von KI-Funktionen kann je nach Software- oder App-Version, Gerätekonfiguration, Lasermodul und Region variieren. Für einige Funktionen sind möglicherweise eine Internetverbindung und die Anmeldung bei einem Konto erforderlich. KI-generierte oder -verarbeitete Ergebnisse können je nach Quellinhalt variieren.',
              '4. Klasse 1 gilt, wenn das Gerät vollständig abgeschlossen ist, der Deckel ordnungsgemäß verschlossen ist und das Produkt gemäß den Anweisungen betrieben wird. Bei bestimmten Arbeitsabläufen mit offenem Deckel, einschließlich Förder- und Rotationsmodus, erfüllt das Produkt nicht die Anforderungen der Klasse 1. Befolgen Sie die Sicherheitshinweise, treffen Sie zusätzliche Sicherheitsvorkehrungen und tragen Sie geeignete persönliche Schutzausrüstung. Das Schutzfenster ist für die Laserwellenlängen des Produkts von 355 nm, 455 nm und 1064 nm ausgelegt.',
              '5. Für die Farbgravur auf Metall ist das MOPA-60-W-Modul erforderlich. Farben und Effekte variieren je nach Metallart, Oberflächenbeschaffenheit, Bearbeitungsparametern und Betriebsumgebung. Die tatsächlichen Ergebnisse können je nach Material abweichen',
              '6. Für die 3D-Innengravur sind das UV-5-W-Modul, das passende F-Theta-Objektiv für die Innengravur sowie der 3D-Gravur-Riser erforderlich. Dies ist für kompatible transparente Materialien vorgesehen. Die im Lieferumfang enthaltenen Komponenten entnehmen Sie bitte der jeweiligen Packliste.',
              '7. Die Materialkompatibilität und die Bearbeitungsergebnisse variieren je nach Zusammensetzung, Farbe, Oberflächenbeschaffenheit, Dicke, Feuchtigkeitsgehalt und Parametereinstellungen. Projektbilder und -videos dienen lediglich der Veranschaulichung; die tatsächlichen Ergebnisse können variieren. Testen Sie das Material vor der Bearbeitung.',
              '8. Material compatibility and processing results vary with composition, color, surface finish, thickness, moisture content, and parameter settings. Project images and videos are for reference only. Test the material before processing.',
            ],
          },
        },
        Hh = {
          section1Bg:
            'https://compress-file.creality.com/images/Agent/ec98c2ff-09e9-45d4-874a-40f1cf1711f4.webp',
          section1BgM:
            'https://compress-file.creality.com/images/Agent/0477228c-aad9-4062-9ff9-6fa5e32598ca.webp',
          section2FiveLasers:
            'https://cdn.creality.com/ow/t1-page/52bc0212-0731-4a9b-a11c-1f0b8d176039.mp4',
          section2FiveLasersM: '',
          section2Micron:
            'https://compress-file.creality.com/images/Agent/0b2051b3-ccc9-4447-b77b-ca8267d904f7.webp',
          section2MicronM:
            'https://compress-file.creality.com/images/Agent/371f95ee-8f06-41b9-aa1b-27e7efc92f2d.webp',
          section2GalvoSpeed:
            'https://compress-file.creality.com/images/Agent/187178dc-6c5b-4d9e-8f73-d1992558a0ae.webp',
          section2GalvoSpeedM: '',
          section2AutoFocus:
            'https://compress-file.creality.com/images/Agent/f5c6ebad-faf2-4e3a-852d-4de1a9ae6f86.webp',
          section2AutoFocusM:
            'https://cdn.creality.com/ow/official/b1ad696c-b754-4d0b-ba12-3ac24d35881a.png',
          section2Touch:
            'https://cdn.creality.com/ow/official/26d6126a-88e3-40b6-9fe3-381c786d68fa.png',
          section2TouchM:
            'https://cdn.creality.com/ow/official/56841b60-e22d-4aab-be4d-1a0b63dd2345.png',
          section2GalvoLight:
            'https://compress-file.creality.com/videos/Agent/e9a92d27-b577-4b88-84ed-afa6a416589d.mp4',
          section2GalvoLightM: '',
          section2Class1:
            'https://compress-file.creality.com/videos/Agent/07741208-3b16-4b3e-9e00-ad20d4e544c5.mp4',
          section2Class1M: '',
          section2Conveyor:
            'https://compress-file.creality.com/images/Agent/bab58d7e-7afc-4844-8f74-6d1cb67fb5a4.webp',
          section2ConveyorM:
            'https://cdn.creality.com/ow/official/b430d735-d9ff-4c8b-8aa3-4a2f689f33cc.png',
          section2Ai:
            'https://compress-file.creality.com/images/Agent/b66022c9-2cdd-4d3d-9883-0f4191b24518.webp',
          section2AiM:
            'https://cdn.creality.com/ow/official/ed15ab97-df8e-4d77-962e-e4e8b0d0b657.png',
          section3Bg:
            'https://compress-file.creality.com/videos/suwei/b6fd86fa-9d34-4923-860f-3baf30b40446.mp4',
          section3BgM: '',
          section4Slide1:
            'https://compress-file.creality.com/videos/suwei/5b80920b-8ea7-436f-a43e-92b4fcbe55a1.mp4',
          section4Slide1M: '',
          section4Slide2:
            'https://compress-file.creality.com/videos/suwei/42f0c10b-7feb-4d6f-bffa-83c7f16a45b3.mp4',
          section4Slide2M: '',
          section4Slide3:
            'https://compress-file.creality.com/videos/suwei/09c6bc22-0d7d-42bb-8aee-0ff3bb5f5842.mp4',
          section4Slide3M: '',
          section4Slide4:
            'https://compress-file.creality.com/videos/suwei/f8d1ce23-a99c-45ca-88b2-8c84b77920a7.mp4',
          section4Slide4M: '',
          section4Slide5:
            'https://compress-file.creality.com/videos/suwei/79a94179-96d5-47cd-97a1-2ab4e1a70524.mp4',
          section4Slide5M: '',
          section5Wood:
            'https://compress-file.creality.com/images/Agent/50716ce7-ca9d-4c62-80a8-fe195b7db1e5.webp',
          section5WoodM:
            'https://compress-file.creality.com/images/Agent/09094a4d-8201-4168-bc34-f74eaf9899ad.webp',
          section5Leather:
            'https://compress-file.creality.com/images/Agent/ac9bdb92-6b81-40cb-997a-5e130b6119d3.webp',
          section5LeatherM:
            'https://compress-file.creality.com/images/Agent/c4be9a64-78e3-4ea2-aa20-dd5f457f73c1.webp',
          section5Glass:
            'https://compress-file.creality.com/images/Agent/b2811c7e-0e2f-496c-962e-504b7c9ce0fc.webp',
          section5GlassM:
            'https://compress-file.creality.com/images/Agent/ae9b95eb-1dcb-4e43-95a7-29738465a20c.webp',
          section5Metal:
            'https://compress-file.creality.com/images/Agent/86152b71-8ae0-4c56-847f-a3d45b49cdab.webp',
          section5MetalM:
            'https://compress-file.creality.com/images/Agent/abbaabc7-0410-4e43-9d6b-6cb64f968f10.webp',
          section5Ceramics:
            'https://compress-file.creality.com/images/Agent/593e69b3-da67-415e-b201-c9282f359b23.webp',
          section5CeramicsM:
            'https://compress-file.creality.com/images/Agent/0aee961a-29bb-47e9-b453-62746e63851b.webp',
          section6Purifier:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_2_c1b70ba7-df6a-49b2-94bc-4fc7b6ecc8a7.png?v=1776152780',
          section6PurifierM: '',
          section6Rotary:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/CMF01.png?v=1776152780',
          section6RotaryM: '',
          section6Riser:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/874.png?v=1776152780',
          section6RiserM: '',
          section6Blade:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/813.png?v=1776152780',
          section6BladeM: '',
          section6Conveyor:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_34f36611-5ab4-417d-9f06-8c220f7b6d87.png?v=1776326057',
          section6ConveyorM: '',
          section6Fixture:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_a61bbadc-1338-4ee7-a214-facba55acaeb.png?v=1776326058',
          section6FixtureM: '',
          section6Module:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/818_4.png?v=1776326057',
          section6ModuleM: '',
          section7Cutter:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1-1.png?v=1777286772',
          section7CutterM: '',
          section7Module:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/img_v3_02tp_eaae26f0-4414-4169-a636-d3639ead9c5g-1.png?v=1776154578',
          section7ModuleM: '',
          section7Screen:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/815-1.png?v=1776154578',
          section7ScreenM: '',
          section7Adapter:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/2_e84d27e6-bee6-422e-961c-95acb6f6e9c8.png?v=1776154578',
          section7AdapterM: '',
          section7Cord:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/784-2.png?v=1776154578',
          section7CordM: '',
          section7Exhaust:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/865-1.png?v=1776154578',
          section7ExhaustM: '',
          section7Cable:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/784-3.png?v=1776154578',
          section7CableM: '',
          section7Panel:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/1_3-1.png?v=1776154578',
          section7PanelM: '',
          section7Block:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785-3.png?v=1776154578',
          section7BlockM: '',
          section7HexKey:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/890-1.png?v=1776154578',
          section7HexKeyM: '',
          section7Wrench:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/3_a2ce5260-3c89-4fe2-91bd-cb0bd6df80c5.png?v=1776154578',
          section7WrenchM: '',
          section7UsbAdapter:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785-4.png?v=1776154578',
          section7UsbAdapterM: '',
          section7LaserCard:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785_-1.png?v=1776154578',
          section7LaserCardM: '',
          section7CameraCard:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/783-3.png?v=1776154578',
          section7CameraCardM: '',
          section7Clamp:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/867-1.png?v=1776154578',
          section7ClampM: '',
          section7LensCard:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/785-5.png?v=1776154578',
          section7LensCardM: '',
          section7SafetyKey:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/814-2.png?v=1776154578',
          section7SafetyKeyM: '',
          section7Blower:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/783-4.png?v=1776154578',
          section7BlowerM: '',
          section7Pack:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/783-5.png?v=1776154578',
          section7PackM: '',
          section7Cloth:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/812-1.png?v=1776154578',
          section7ClothM: '',
          section7Brush:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/817-1.png?v=1776154578',
          section7BrushM: '',
          section7Guide:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/782-2.png?v=1776154578',
          section7GuideM: '',
          section7Safety:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/782-3.png?v=1776154578',
          section7SafetyM: '',
          section7Ftheta:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/821.png?v=1776854953',
          section7FthetaM: '',
          section7Stand:
            'https://cdn.shopify.com/s/files/1/0850/5776/5681/files/822.png?v=1776854953',
          section7StandM: '',
        },
        Yv = {
          en: { translation: qv, imageUrl: Hh },
          de: { translation: Gv, imageUrl: Hh },
        };
      Yh.use(sy).init({
        resources: Yv,
        lng: My(),
        fallbackLng: 'en',
        interpolation: { escapeValue: !1 },
        initImmediate: !1,
      });
      const Vv = document.getElementById('product-detail-buy-t1-page'),
        wv = j.jsx(my, { i18n: Yh, children: j.jsx(Kv, {}) });
      zp.createRoot(Vv).render(wv);

  })();
